/* ============================================================
   LMM Ratgeber-Module — Interaktion (LMM Draft-Theme, Blog 'ratgeber' only)
   VOLLPORT aus content/ratgeber-migration-pilot/shared/ratgeber-modules.js (2026-06-26).
   Enthaelt ALLE Ratgeber-Module; jede IIFE ist element-gegated (No-op ohne Element).
   Interne ../<slug>/preview.html-Links -> /blogs/ratgeber/<slug> transformiert.
   Quelle der Wahrheit bleibt shared/ratgeber-modules.js; Aenderungen dort neu porten.
   ============================================================ */

/* ============================================================
   LMM Ratgeber-Module — Vanilla-JS für die lokale Vorschau.
   In Shopify später als Theme-Snippet/Section-Asset umzusetzen.
   Keine externen Abhängigkeiten, kein Tracking, rein clientseitig.

   Datengrundlage Watt→Lumen: Äquivalenzangaben der EU-Verordnung
   (EG) Nr. 244/2009 (Mindestlichtstrom, damit ein Leuchtmittel als
   Ersatz für eine X-Watt-Glühlampe beworben werden darf) sowie die
   dort tabellierten typischen Glühlampen-Lichtströme.
   Sekundär verifiziert 2026-06-12 (ledtipps.net/lumen-watt-umrechnung).
   Vor Livegang gegen Verordnungstext (Anhang II) gegenprüfen.
   ============================================================ */
(function () {
  'use strict';

  var fmt = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });

  /* --- Watt→Lumen-Orientierung (Slider) --- */
  // [Glühlampen-Watt, typischer Glühlampen-Lichtstrom lm, LED-Ersatz Mindestlichtstrom lm]
  var WL = [
    [25, 230, 249],
    [40, 430, 470],
    [60, 730, 806],
    [75, 970, 1055],
    [100, 1380, 1521]
  ];

  var slider = document.getElementById('ws-range');
  if (slider) {
    var outWatt = document.getElementById('ws-watt');
    var outGluh = document.getElementById('ws-gluehlampe');
    var outLed = document.getElementById('ws-led');
    var render = function () {
      var row = WL[parseInt(slider.value, 10)];
      outWatt.textContent = row[0] + ' W';
      outGluh.textContent = '~' + fmt.format(row[1]) + ' lm';
      outLed.textContent = 'mind. ' + fmt.format(row[2]) + ' lm';
      slider.setAttribute('aria-valuetext',
        row[0] + ' Watt Glühlampe, typisch ' + row[1] + ' Lumen, LED-Ersatz mindestens ' + row[2] + ' Lumen');
    };
    slider.addEventListener('input', render);
    render();
  }

  /* --- Lichtausbeute-Rechner: lm/W = Lumen ÷ Watt --- */
  var lmInput = document.getElementById('calc-lm');
  var wInput = document.getElementById('calc-w');
  var effOut = document.getElementById('calc-eff-result');
  if (lmInput && wInput && effOut) {
    var calcEff = function () {
      var lm = parseFloat(lmInput.value);
      var w = parseFloat(wInput.value);
      if (isFinite(lm) && isFinite(w) && lm > 0 && w > 0) {
        effOut.innerHTML = 'Lichtausbeute: <strong>' + fmt.format(lm / w) + ' lm/W</strong>';
      } else {
        effOut.textContent = 'Bitte Lumen und Watt eingeben — beide Werte stehen auf der Verpackung bzw. im Datenblatt.';
      }
    };
    lmInput.addEventListener('input', calcEff);
    wInput.addEventListener('input', calcEff);
    calcEff();
  }

  /* --- Planungsrechner: benötigte Gesamt-Lumen ≈ Beleuchtungsstärke (lx) × Fläche (m²) ---
     Vereinfachte Durchschnittsrechnung (E = Φ / A) für eine erste Orientierung.
     Reflexion, Abstrahlwinkel, Möblierung und Lichtverteilung bleiben unberücksichtigt. */
  var luxSel = document.getElementById('calc-lux');
  var areaInput = document.getElementById('calc-area');
  var planOut = document.getElementById('calc-plan-result');
  if (luxSel && areaInput && planOut) {
    var calcPlan = function () {
      var lux = parseFloat(luxSel.value);
      var area = parseFloat(areaInput.value);
      if (isFinite(lux) && isFinite(area) && lux > 0 && area > 0) {
        planOut.innerHTML = 'Grobe Orientierung: <strong>' + fmt.format(lux * area) +
          ' lm</strong> Gesamtlichtstrom für ' + fmt.format(area) + ' m² bei ' + fmt.format(lux) + ' lx';
      } else {
        planOut.textContent = 'Bitte Zielwert und Raumfläche angeben.';
      }
    };
    luxSel.addEventListener('change', calcPlan);
    areaInput.addEventListener('input', calcPlan);
    calcPlan();
  }

  /* --- Lux↔Lumen-Rechner mit zwei Auswahlkarten (Artikel umrechnung-lumen-lux) ---
     Vereinfachte Durchschnittsrechnung (E = Φ / A) in beide Richtungen.
     Modus 1 „raum“: Lux + Fläche → benötigte Lumen.
     Modus 2 „lampe“: Lumen + Fläche → ungefähr erreichte Lux. */
  var llcRadios = document.querySelectorAll('input[name="llc-mode"]');
  var llcValue = document.getElementById('llc-value');
  var llcValueLabel = document.getElementById('llc-value-label');
  var llcArea = document.getElementById('llc-area');
  var llcOut = document.getElementById('llc-result');
  var llcHint = document.getElementById('llc-hint');
  if (llcRadios.length && llcValue && llcArea && llcOut) {
    var llcGetMode = function () {
      var m = 'raum';
      llcRadios.forEach(function (r) { if (r.checked) m = r.value; });
      return m;
    };
    var calcLlc = function (modeChanged) {
      var modeRaum = llcGetMode() === 'raum';
      if (llcValueLabel) {
        llcValueLabel.textContent = modeRaum ? 'Gewünschte Helligkeit (Lux)' : 'Lichtstrom der Lampe (Lumen)';
      }
      if (llcHint) {
        llcHint.textContent = modeRaum
          ? 'Sie wissen, wie hell es auf der Fläche sein soll. Der Rechner sagt, wie viel Lichtstrom dafür ungefähr nötig ist.'
          : 'Sie wissen, wie viel Licht die Lampe abgibt. Der Rechner zeigt, wie hell es ungefähr auf der Fläche ankommt.';
      }
      if (modeChanged === true) {
        llcValue.value = modeRaum ? '300' : '806';
        llcValue.placeholder = modeRaum ? 'z. B. 300' : 'z. B. 806';
      }
      var v = parseFloat(llcValue.value);
      var a = parseFloat(llcArea.value);
      if (isFinite(v) && isFinite(a) && v > 0 && a > 0) {
        if (modeRaum) {
          llcOut.innerHTML = 'Für <strong>' + fmt.format(a) + ' m²</strong> bei <strong>' + fmt.format(v) +
            ' Lux</strong> brauchen Sie ungefähr <strong>' + fmt.format(v * a) + ' Lumen</strong> Gesamtlichtstrom.';
        } else {
          llcOut.innerHTML = 'Eine Lampe mit <strong>' + fmt.format(v) + ' Lumen</strong> erreicht auf <strong>' +
            fmt.format(a) + ' m²</strong> ungefähr <strong>' + fmt.format(v / a) + ' Lux</strong>.';
        }
      } else {
        llcOut.textContent = 'Bitte beide Werte eingeben.';
      }
    };
    llcRadios.forEach(function (r) { r.addEventListener('change', function () { calcLlc(true); }); });
    llcValue.addEventListener('input', calcLlc);
    llcArea.addEventListener('input', calcLlc);
    calcLlc();
  }

  /* --- Lichtkegel-/Abstrahlwinkel-Rechner (Artikel umrechnung-lumen-lux) ---
     Vereinfachte Kegel-Näherung (klar als Orientierung gekennzeichnet):
       Durchmesser ≈ 2 × Abstand × tan(Winkel/2)
       Fläche     ≈ π × (Durchmesser/2)²
       Lux (grob) ≈ Lumen ÷ Fläche
     Annahme: gesamter Lichtstrom fällt gleichmäßig in den Kegel — reale Spots
     verteilen das Licht ungleichmäßig (Definition des Abstrahlwinkels: Bereich
     bis 50 % der maximalen Lichtstärke). Werte daher nur grobe Orientierung. */
  var beamLm = document.getElementById('beam-lm');
  var beamDist = document.getElementById('beam-dist');
  var beamAngle = document.getElementById('beam-angle');
  if (beamLm && beamDist && beamAngle) {
    var outLm = document.getElementById('beam-lm-out');
    var outDist = document.getElementById('beam-dist-out');
    var outAngle = document.getElementById('beam-angle-out');
    var outDia = document.getElementById('beam-dia');
    var outArea = document.getElementById('beam-area');
    var outLux = document.getElementById('beam-lux');
    var vizCone = document.getElementById('beam-cone');
    var vizSpot = document.getElementById('beam-spot');
    var vizLampBody = document.getElementById('beam-lamp-body');
    var vizLamp = document.getElementById('beam-lamp');
    var vizHalo = document.getElementById('beam-halo');
    var vizDiaLabel = document.getElementById('beam-dia-label');
    var vizDistLine = document.getElementById('beam-dist-line');
    var vizDistLabel = document.getElementById('beam-dist-label');
    /* Szene in „Metern“ mit FESTEM Maßstab (35 px/m), ViewBox 280×250:
       - Boden fix bei y=218; die Lampenhöhe hängt AUSSCHLIESSLICH vom
         Abstands-Regler ab (gleicher Abstand = gleiche Lampenhöhe).
       - Der Abstrahlwinkel verändert nur die Kegelbreite. Wird der Kegel
         breiter als der Kasten, wird er per clipPath am Bildrand beschnitten —
         er läuft sichtbar über den Rand hinaus, und die ⌀-Beschriftung zeigt
         die echte Breite in Metern.
       - Helligkeit: Kegel/Spot koppeln an Lux (logarithmisch, damit sichtbar),
         der Halo um die Lampe koppelt an Lumen (Gesamtlichtmenge). */
    var renderBeam = function () {
      var lm = parseFloat(beamLm.value);
      var d = parseFloat(beamDist.value);
      var ang = parseFloat(beamAngle.value);
      var rad = (ang / 2) * Math.PI / 180;
      var dia = 2 * d * Math.tan(rad);
      var area = Math.PI * Math.pow(dia / 2, 2);
      var lux = area > 0 ? lm / area : 0;
      outLm.textContent = fmt.format(lm) + ' lm';
      outDist.textContent = fmt.format(d) + ' m';
      outAngle.textContent = fmt.format(ang) + '°';
      outDia.textContent = '≈ ' + fmt.format(dia) + ' m';
      outArea.textContent = '≈ ' + fmt.format(area) + ' m²';
      outLux.textContent = '≈ ' + fmt.format(Math.round(lux)) + ' lx';
      if (vizCone) {
        var cx = 148, floorY = 218, baseScale = 35, minLampY = 30;
        var halfM = d * Math.tan(rad);
        /* Maßstab hängt NUR vom Abstand ab — nie vom Winkel (sonst würde die
           Lampe beim Winkel-Ändern springen). Der Guard greift erst, falls der
           Slider-Maximalwert je über ~5,3 m hinaus erweitert wird. */
        var scale = Math.min(baseScale, (floorY - minLampY) / d);
        var lampY = floorY - d * scale;
        var halfPx = halfM * scale; /* darf über den Kasten hinauslaufen — clipPath schneidet ab */
        /* Helligkeit: Lux logarithmisch auf 0.15–0.95 (10 lx … ~3000 lx) */
        var luxNorm = Math.max(0, Math.min(1, (Math.log10(Math.max(lux, 1)) - 1) / 2.5));
        var coneOpacity = 0.15 + 0.8 * luxNorm;
        /* Halo: Gesamtlichtmenge (Lumen) — wächst und leuchtet mit mehr Lumen */
        var lmNorm = (lm - 100) / 1900;
        vizCone.setAttribute('points', cx + ',' + (lampY + 6) + ' ' + (cx - halfPx) + ',' + floorY + ' ' + (cx + halfPx) + ',' + floorY);
        vizCone.setAttribute('fill-opacity', coneOpacity.toFixed(2));
        if (vizSpot) {
          vizSpot.setAttribute('cx', cx);
          vizSpot.setAttribute('cy', floorY);
          vizSpot.setAttribute('rx', Math.max(halfPx, 4));
          vizSpot.setAttribute('ry', Math.max(halfPx * 0.14, 2.5));
          vizSpot.setAttribute('fill-opacity', Math.min(0.95, coneOpacity + 0.15).toFixed(2));
        }
        if (vizLamp) { vizLamp.setAttribute('cx', cx); vizLamp.setAttribute('cy', lampY); }
        if (vizLampBody) { vizLampBody.setAttribute('x', cx - 7); vizLampBody.setAttribute('y', lampY - 16); }
        if (vizHalo) {
          vizHalo.setAttribute('cx', cx);
          vizHalo.setAttribute('cy', lampY);
          vizHalo.setAttribute('r', (10 + 14 * lmNorm).toFixed(1));
          vizHalo.setAttribute('fill-opacity', (0.25 + 0.45 * lmNorm).toFixed(2));
        }
        if (vizDistLine) {
          vizDistLine.setAttribute('x1', 22); vizDistLine.setAttribute('x2', 22);
          vizDistLine.setAttribute('y1', lampY); vizDistLine.setAttribute('y2', floorY);
        }
        if (vizDistLabel) {
          vizDistLabel.setAttribute('x', 28);
          vizDistLabel.setAttribute('y', ((lampY + floorY) / 2 + 4).toFixed(0));
          vizDistLabel.textContent = fmt.format(d) + ' m';
        }
        if (vizDiaLabel) {
          vizDiaLabel.setAttribute('x', cx);
          vizDiaLabel.textContent = '⌀ ≈ ' + fmt.format(dia) + ' m';
        }
      }
      beamAngle.setAttribute('aria-valuetext', ang + ' Grad Abstrahlwinkel, Lichtkegel etwa ' +
        fmt.format(dia) + ' Meter Durchmesser, etwa ' + fmt.format(Math.round(lux)) + ' Lux');
    };
    [beamLm, beamDist, beamAngle].forEach(function (el) { el.addEventListener('input', renderBeam); });
    renderBeam();
  }
})();

/* --- Umrüst-Player (Schritt-für-Schritt-Vorschau, ersetzt Fremd-Video) ---
   Ohne JS: alle Schritte als Liste (Fallback). Mit JS: ein Schritt zur Zeit,
   Tabs + Zurück/Abspielen/Weiter, optionaler Auto-Ablauf. ID-gekoppelt, sonst No-op. */
(function () {
  'use strict';
  var player = document.getElementById('umruest-player');
  if (!player) return;
  var steps = [].slice.call(player.querySelectorAll('.up-step'));
  if (steps.length < 2) return;
  var tabsWrap = player.querySelector('.up-tabs');
  var prev = player.querySelector('.up-prev');
  var next = player.querySelector('.up-next');
  var play = player.querySelector('.up-play');
  if (!tabsWrap || !prev || !next || !play) return;

  var STEP_MS = 7000; // ~7 s pro Schritt (7 Schritte ≈ 49 s) — genug Zeit zum Lesen
  var bar = player.querySelector('.up-progress-bar');
  player.classList.add('is-player');
  var i = 0, timer = null;

  var tabs = steps.map(function (s, idx) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'up-tab';
    b.textContent = String(idx + 1);
    b.setAttribute('aria-label', 'Schritt ' + (idx + 1));
    b.addEventListener('click', function () { stop(); show(idx); }); // manuell: kein Auto-Sprung
    tabsWrap.appendChild(b);
    return b;
  });

  // Fortschrittsbalken: füllt sich linear über STEP_MS, wenn die Wiedergabe läuft.
  function resetBar(running) {
    if (!bar) return;
    bar.style.transition = 'none';
    bar.style.width = '0%';
    if (running) {
      void bar.offsetWidth; // Reflow erzwingen, damit die Transition neu startet
      bar.style.transition = 'width ' + STEP_MS + 'ms linear';
      bar.style.width = '100%';
    }
  }

  function show(n) {
    i = (n + steps.length) % steps.length;
    steps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    tabs.forEach(function (b, idx) {
      b.classList.toggle('is-on', idx === i);
      b.setAttribute('aria-current', idx === i ? 'true' : 'false');
    });
    resetBar(timer !== null); // bei laufender Wiedergabe Balken für den neuen Schritt neu starten
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
    play.textContent = '▶ Abspielen';
    play.setAttribute('aria-pressed', 'false');
    resetBar(false);
  }
  function start() {
    timer = setInterval(function () { show(i + 1); }, STEP_MS);
    play.textContent = '❚❚ Pause';
    play.setAttribute('aria-pressed', 'true');
    resetBar(true);
  }
  prev.addEventListener('click', function () { stop(); show(i - 1); });
  next.addEventListener('click', function () { stop(); show(i + 1); });
  play.addEventListener('click', function () { timer ? stop() : start(); });

  show(0);
})();

/* --- Watt <-> Lumen Rechner (bidirektional, Artikel umrechnung-watt-lumen) ---
   Glühlampen-Werte = beanspruchte Äquivalenz nach EU-Verordnung (EG) Nr. 244/2009
   (Anhang II / Tabelle 6: Stützstellen + lineare Interpolation, wie in der VO vorgesehen).
   Halogen/Energiesparlampe = typische Lichtausbeute (Orientierung).
   LED bewusst als BEREICH: heutige Markt-Spanne je Lichtstrom (LEDREF, größere Leuchtmittel
   laufen tendenziell etwas effizienter); sehr effiziente Modelle liegen darunter. Damit
   stimmen Rechner, Tabelle und Fließtext überein (60 W ≈ 806 lm → ~7–9 W, 100 W ≈ 1.521 lm → ~11–14 W).
   Maßgeblich bleibt die Lumen-Angabe auf der Verpackung. Gleiche EU-Basis wie der ws-Slider. */
(function () {
  'use strict';
  var box = document.getElementById('wl-calc');
  if (!box) return;
  var value = document.getElementById('wl-value');
  var valueLabel = document.getElementById('wl-value-label');
  var typeSel = document.getElementById('wl-type');
  var out = document.getElementById('wl-result');
  var modeRadios = box.querySelectorAll('input[name="wl-mode"]');
  if (!value || !typeSel || !out || !modeRadios.length) return;

  // EU 244/2009: [Glühlampen-Watt, beanspruchter Lichtstrom in Lumen]
  var GLUEH = [[15,136],[25,249],[40,470],[60,806],[75,1055],[100,1521],[150,2452],[200,3452]];
  // Heutige LED: [Lumen, Watt niedrig (effizient), Watt hoch (typisch)] — Markt-Spanne, keine feste Wahrheit.
  var LEDREF = [[136,1,2],[249,2,3],[470,4,5],[806,7,9],[1055,9,12],[1521,11,14],[2452,18,23],[3452,25,32]];
  var HALOGEN_LMW = 19, ESL_LMW = 60; // lm/W (Orientierung)
  var NAME = { gluehbirne: 'Glühbirne', halogen: 'Halogenlampe', esl: 'Energiesparlampe', led: 'LED-Lampe' };
  var fmtN = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  var fmt1 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });
  var r10 = function (x) { return Math.round(x / 10) * 10; };

  // lineare Interpolation auf einer aufsteigend sortierten Stützstellentabelle;
  // außerhalb proportional zur Rand-Stützstelle. src/dst = Spaltenindizes.
  function interp(table, x, src, dst) {
    var n = table.length;
    if (x <= table[0][src]) return table[0][dst] / table[0][src] * x;
    for (var i = 0; i < n - 1; i++) {
      if (x <= table[i + 1][src]) {
        var t = (x - table[i][src]) / (table[i + 1][src] - table[i][src]);
        return table[i][dst] + t * (table[i + 1][dst] - table[i][dst]);
      }
    }
    return table[n - 1][dst] / table[n - 1][src] * x;
  }
  var gluehToLm = function (w) { return interp(GLUEH, w, 0, 1); };
  var lmToGlueh = function (lm) { return interp(GLUEH, lm, 1, 0); };
  var ledWattLo = function (lm) { return interp(LEDREF, lm, 0, 1); }; // effizient
  var ledWattHi = function (lm) { return interp(LEDREF, lm, 0, 2); }; // typisch
  var ledRange = function (lm) { return fmt1.format(ledWattLo(lm)) + ' – ' + fmt1.format(ledWattHi(lm)) + ' W'; };

  // Alle Äquivalente auf einen Blick für einen gegebenen Lichtstrom (Orientierung)
  function equivLine(lm) {
    return '<span class="calc-equiv">Bei rund ' + fmtN.format(Math.round(lm)) + ' lm entspricht das etwa: ' +
      '<strong>Glühbirne ' + fmtN.format(Math.round(lmToGlueh(lm))) + ' W</strong> · ' +
      '<strong>Halogen ' + fmtN.format(Math.round(lm / HALOGEN_LMW)) + ' W</strong> · ' +
      '<strong>Energiesparlampe ' + fmtN.format(Math.round(lm / ESL_LMW)) + ' W</strong> · ' +
      '<strong>LED ' + ledRange(lm) + '</strong>.</span>';
  }

  function mode() {
    var m = 'wl';
    modeRadios.forEach(function (r) { if (r.checked) m = r.value; });
    return m;
  }
  function render(modeChanged) {
    var m = mode();
    if (valueLabel) valueLabel.textContent = (m === 'wl') ? 'Wattzahl (W)' : 'Gewünschte Helligkeit (Lumen)';
    if (modeChanged === true) {
      value.value = (m === 'wl') ? '60' : '800';
      value.placeholder = (m === 'wl') ? 'z. B. 60' : 'z. B. 800';
      typeSel.value = (m === 'wl') ? 'gluehbirne' : 'led';
    }
    var t = typeSel.value;
    var v = parseFloat(value.value);
    if (!isFinite(v) || v <= 0) {
      out.textContent = (m === 'wl') ? 'Bitte eine Wattzahl eingeben.' : 'Bitte eine Lumen-Zahl eingeben.';
      return;
    }
    if (m === 'wl') {
      // Watt -> Lumen
      if (t === 'led') {
        // LED-Watt -> Lumen-Spanne (typische bis effiziente Modelle)
        out.innerHTML = 'Eine <strong>' + fmt1.format(v) + '-W-LED-Lampe</strong> erzeugt heute je nach Effizienz rund <strong>' +
          fmtN.format(r10(interp(LEDREF, v, 2, 0))) + ' – ' + fmtN.format(r10(interp(LEDREF, v, 1, 0))) + ' Lumen</strong>.' + equivLine(interp(LEDREF, v, 1, 0));
      } else {
        var lm = (t === 'gluehbirne') ? gluehToLm(v) : v * (t === 'halogen' ? HALOGEN_LMW : ESL_LMW);
        out.innerHTML = 'Eine <strong>' + fmt1.format(v) + '-W-' + NAME[t] + '</strong> erzeugt rund <strong>' +
          fmtN.format(Math.round(lm)) + ' Lumen</strong>. Als LED brauchen Sie dafür heute nur etwa <strong>' +
          ledRange(lm) + '</strong> (sehr effiziente Modelle weniger).' + equivLine(lm);
      }
    } else {
      // Lumen -> Watt
      if (t === 'led') {
        out.innerHTML = 'Für <strong>' + fmtN.format(v) + ' Lumen</strong> brauchen Sie heute als <strong>LED-Lampe</strong> ungefähr <strong>' +
          ledRange(v) + '</strong> (sehr effiziente Modelle weniger).' + equivLine(v);
      } else {
        var w = (t === 'gluehbirne') ? lmToGlueh(v) : v / (t === 'halogen' ? HALOGEN_LMW : ESL_LMW);
        out.innerHTML = 'Für <strong>' + fmtN.format(v) + ' Lumen</strong> brauchen Sie als <strong>' + NAME[t] +
          '</strong> ungefähr <strong>' + fmt1.format(w) + ' W</strong>.' +
          (t !== 'gluehbirne' ? ' Eine klassische Glühbirne hätte dafür ca. <strong>' + fmt1.format(lmToGlueh(v)) + ' W</strong> gebraucht.' : '') + equivLine(v);
      }
    }
  }
  modeRadios.forEach(function (r) { r.addEventListener('change', function () { render(true); }); });
  value.addEventListener('input', function () { render(false); });
  typeSel.addEventListener('change', function () { render(false); });
  render(false);
})();

/* --- Ratgeber UX-Layer: Skip-Link, Scrollspy-TOC, Back-to-top (alle Ratgeber-Seiten) --- */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var main = document.querySelector('main.article-shell') || document.querySelector('main');

  // Skip-Link-Injektion entfernt (2026-07-26): Das Theme rendert bereits einen
  // Skip-Link in layout/theme.liquid (snippets/skip-to-content-link.liquid, sichtbar
  // nur bei :focus-visible). Der hier frueher injizierte zweite Link lag ausserhalb
  // von .lmm-rg — sein Versteck-CSS (.lmm-rg .skip-link) griff nie, der Link stand
  // dauerhaft sichtbar oben links und loeste den unsauberen Scrollsprung aus.

  // Back-to-top
  var toTop = document.createElement('button');
  toTop.type = 'button';
  toTop.className = 'to-top';
  toTop.setAttribute('aria-label', 'Nach oben');
  toTop.innerHTML = '↑';
  document.body.appendChild(toTop);
  toTop.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
  var onScroll = function () {
    if (window.scrollY > 600) toTop.classList.add('is-shown'); else toTop.classList.remove('is-shown');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Scrollspy: TOC-Links mit #-Anker hervorheben
  var links = [].slice.call(document.querySelectorAll('.toc a[href^="#"]'));
  if (links.length && 'IntersectionObserver' in window) {
    var map = {}, targets = [];
    links.forEach(function (a) {
      var el = document.getElementById(a.getAttribute('href').slice(1));
      if (el) { map[el.id] = a; targets.push(el); }
    });
    var setActive = function (id) {
      links.forEach(function (a) { a.classList.remove('is-active'); a.removeAttribute('aria-current'); });
      if (map[id]) { map[id].classList.add('is-active'); map[id].setAttribute('aria-current', 'true'); }
    };
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) setActive(e.target.id); });
    }, { rootMargin: '-90px 0px -70% 0px', threshold: 0 });
    targets.forEach(function (t) { obs.observe(t); });
  }
})();

/* --- Stromkosten-/Ersparnis-Rechner (Artikel umrechnung-watt-lumen) ---
   Reine Arithmetik: kWh = (W_alt - W_LED) × Stunden/Tag × 365 ÷ 1000; € = kWh × Strompreis.
   Strompreis & Stunden sind ANNAHMEN (vom Nutzer einstellbar). Keine erfundenen Herstellerwerte. */
(function () {
  'use strict';
  var box = document.getElementById('kosten-calc');
  if (!box) return;
  var oldW = document.getElementById('kc-old'), ledW = document.getElementById('kc-led');
  var hours = document.getElementById('kc-hours'), price = document.getElementById('kc-price');
  var hoursO = document.getElementById('kc-hours-o'), priceO = document.getElementById('kc-price-o');
  var out = document.getElementById('kc-result');
  if (!oldW || !ledW || !hours || !price || !out) return;
  var fmt0 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  var fmtE = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function render() {
    var o = parseFloat(oldW.value), l = parseFloat(ledW.value);
    var h = parseFloat(hours.value), p = parseFloat(price.value); // p in ct/kWh
    if (hoursO) hoursO.textContent = fmt0.format(h) + ' h/Tag';
    if (priceO) priceO.textContent = fmt0.format(p) + ' ct/kWh';
    if (!isFinite(o) || !isFinite(l) || o < 0 || l < 0) { out.textContent = 'Bitte beide Wattzahlen eingeben.'; return; }
    var deltaW = Math.max(0, o - l);
    var kwh = deltaW * h * 365 / 1000;
    var eur = kwh * (p / 100);
    out.innerHTML = 'Ersparnis: <strong>' + fmt0.format(kwh) + ' kWh/Jahr</strong> &asymp; <strong>' + fmtE.format(eur) + ' &euro;/Jahr</strong> pro Lampe.' +
      '<span class="calc-equiv">Bei 5 Lampen rund <strong>' + fmtE.format(eur * 5) + ' &euro;/Jahr</strong>; über 15 Jahre LED-Lebensdauer ca. <strong>' + fmt0.format(eur * 15) + ' &euro;</strong> pro Lampe (Annahme).</span>';
  }
  [oldW, ledW, hours, price].forEach(function (el) { el.addEventListener('input', render); });
  render();
})();

/* --- LED-Röhren: Strom-/Amortisations-Rechner (Artikel led-roehren-leuchtstoffroehren) ---
   Arithmetik: kWh = (W_alt - W_LED) × Stunden/Tag × 365 ÷ 1000 × Anzahl; € = kWh × Strompreis.
   Amortisation = (Anzahl × LED-Stückpreis) ÷ €-Ersparnis/Jahr.
   Stunden, Strompreis und LED-Stückpreis sind ANNAHMEN (einstellbar). W-Werte aus der
   Stromverbrauchstabelle des Artikels (Leuchtmittel ohne Vorschaltgerät; mit KVG/VVG real höher).
   Keine erfundenen Herstellerwerte. */
(function () {
  'use strict';
  var box = document.getElementById('lr-calc');
  if (!box) return;
  var typeSel = document.getElementById('lr-type');
  var qty = document.getElementById('lr-qty');
  var hours = document.getElementById('lr-hours'), price = document.getElementById('lr-price');
  var ppt = document.getElementById('lr-ppt');
  var hoursO = document.getElementById('lr-hours-o'), priceO = document.getElementById('lr-price-o');
  var outKwh = document.getElementById('lr-kwh'), outEur = document.getElementById('lr-eur'), outAmort = document.getElementById('lr-amort');
  var note = document.getElementById('lr-note');
  if (!typeSel || !qty || !hours || !price || !ppt || !outKwh || !outEur || !outAmort) return;
  // Röhren-Länge -> [W_alt Leuchtstoffröhre, W_LED] aus der Stromverbrauchstabelle des Artikels
  var TUBES = {
    '600': [18, 7], '900': [30, 11], '1200': [36, 16], '1500': [58, 19],
    // T5 (G5): W_LED = herstellertypischer Richtwert (LEDVANCE SubstiTUBE / Philips MASTER LEDtube T5, Datenblaetter)
    't5-288-8': [8, 4], 't5-549-14': [14, 7], 't5-549-24': [24, 10.5],
    't5-849-21': [21, 11.5], 't5-849-39': [39, 18.5],
    't5-1149-28': [28, 17], 't5-1149-54': [54, 26],
    't5-1449-35': [35, 20], 't5-1449-49': [49, 26], 't5-1449-80': [80, 36]
  };
  var f0 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  var f1 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });
  var fE = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function render() {
    var t = TUBES[typeSel.value] || TUBES['1500'];
    var n = Math.max(1, parseInt(qty.value, 10) || 1);
    var h = parseFloat(hours.value), p = parseFloat(price.value); // ct/kWh
    var price1 = parseFloat(ppt.value);
    if (hoursO) hoursO.textContent = f0.format(h) + ' h/Tag';
    if (priceO) priceO.textContent = f0.format(p) + ' ct/kWh';
    var deltaW = Math.max(0, t[0] - t[1]);
    var kwh = deltaW * h * 365 / 1000 * n;
    var eur = kwh * (p / 100);
    outKwh.textContent = f0.format(kwh) + ' kWh';
    outEur.textContent = fE.format(eur) + ' €';
    if (isFinite(price1) && price1 > 0 && eur > 0) {
      var months = (n * price1) / eur * 12;
      outAmort.textContent = months < 12 ? f0.format(Math.round(months)) + ' Mon.' : f1.format(months / 12) + ' Jahre';
    } else {
      outAmort.textContent = '–';
    }
    if (note) {
      var isT5 = /^t5-/.test(typeSel.value);
      note.innerHTML = 'Über 10 Jahre rund <strong>' + fE.format(eur * 10) + ' €</strong> Stromersparnis (' + n + ' Röhren). ' +
        'Annahmen: ' + f0.format(h) + ' h/Tag, ' + f0.format(p) + ' ct/kWh, ' + (isFinite(price1) ? fE.format(price1) + ' €' : '–') + ' je LED-Röhre — alles anpassbar. ' +
        (isT5
          ? 'T5 läuft immer am EVG; die Werte gelten ohne Vorschaltgerät. LED-Ersatzwerte sind herstellertypische Richtwerte.'
          : 'Verbrauch ohne Vorschaltgerät; bei T8 mit KVG/VVG ist die reale Ersparnis höher.');
    }
  }
  [qty, hours, price, ppt].forEach(function (el) { el.addEventListener('input', render); });
  typeSel.addEventListener('change', render);
  render();
})();

/* --- LED-Röhren-Finder: „Welche LED-Röhre passt?“ (Vorschaltgerät + Bauform/Länge) ---
   Reine Entscheidungslogik, clientseitig. Ohne JS bleibt die vorbefüllte Empfehlung
   (Standardtext im #rf-result) als Fallback sichtbar. Collection-Links = data-todo
   (Ziele in ../link-map-ratgeber.csv, vor Livegang scharfschalten). */
(function () {
  'use strict';
  var box = document.getElementById('roehren-finder');
  if (!box) return;
  var vgRadios = box.querySelectorAll('input[name="rf-vg"]');
  var lenSel = document.getElementById('rf-len');
  var out = document.getElementById('rf-result');
  if (!vgRadios.length || !lenSel || !out) return;
  // Länge -> [Collection-Handle, Label]
  var LEN = {
    '600': ['/collections/t8-led-roehren-60-cm', '600 mm (T8, ersetzt 18 W)'],
    '900': ['/collections/t8-led-roehren-90-cm', '900 mm (T8, ersetzt 30 W)'],
    '1200': ['/collections/t8-led-roehren-120-cm', '1200 mm (T8, ersetzt 36 W)'],
    '1500': ['/collections/t8-led-roehren-150-cm', '1500 mm (T8, ersetzt 58 W)'],
    't5-288-8': ['/collections/t5-led-kurzroehren', '288 mm (T5, ersetzt 8 W)'],
    't5-517-13': ['/collections/t5-led-kurzroehren', '517 mm (T5, ersetzt 13 W)'],
    't5-549-14': ['/collections/t5-led-roehren-549mm', '549 mm (T5, ersetzt 14 W)'],
    't5-549-24': ['/collections/t5-led-roehren-549mm', '549 mm (T5, ersetzt 24 W)'],
    't5-849-21': ['/collections/t5-led-roehren-849mm', '849 mm (T5, ersetzt 21 W)'],
    't5-849-39': ['/collections/t5-led-roehren-849mm', '849 mm (T5, ersetzt 39 W)'],
    't5-1149-28': ['/collections/t5-led-roehren-1149mm', '1149 mm (T5, ersetzt 28 W)'],
    't5-1149-54': ['/collections/t5-led-roehren-1149mm', '1149 mm (T5, ersetzt 54 W)'],
    't5-1449-35': ['/collections/t5-led-roehren-1449mm', '1449 mm (T5, ersetzt 35 W)'],
    't5-1449-49': ['/collections/t5-led-roehren-1449mm', '1449 mm (T5, ersetzt 49 W)'],
    't5-1449-80': ['/collections/t5-led-roehren-1449mm', '1449 mm (T5, ersetzt 80 W)'],
    't5-1149': ['/collections/t5-led-roehren-1149mm', '1149 mm (T5, ersetzt 28/54 W)'],
    't5-1449': ['/collections/t5-led-roehren-1449mm', '1449 mm (T5, ersetzt 35/49/80 W)'],
    't5': ['/collections/t5-led-roehren', 'alle T5-LED-Röhren'],
    '': ['/collections/led-roehren', 'alle LED-Röhren']
  };
  function vg() { var v = ''; vgRadios.forEach(function (r) { if (r.checked) v = r.value; }); return v; }
  function esc(s) { return s; }
  function render() {
    var v = vg();
    var len = LEN[lenSel.value] || LEN[''];
    var html, cta;
    if (v === 'kvg') {
      html = '<strong>Direkter Tausch möglich.</strong> Bei konventionellem/verlustarmem Vorschaltgerät (sichtbarer weißer Starter) setzen Sie eine passende LED-Röhre ein und ersetzen den Starter durch den mitgelieferten <strong>Dummy-Starter</strong>. Kein Eingriff in die Leuchte — die Zulassung bleibt erhalten.';
      cta = len[0];
    } else if (v === 'evg') {
      html = '<strong>EVG-geeignete LED-Röhre wählen.</strong> Ohne sichtbaren Starter läuft die Leuchte über ein elektronisches Vorschaltgerät. Verwenden Sie eine ausdrücklich <strong>EVG-kompatible</strong> LED-Röhre (T5/T8) — oder lassen Sie das Vorschaltgerät fachgerecht überbrücken (Achtung: Zulassung und Garantie der Leuchte erlöschen).';
      cta = len[0];
    } else {
      html = '<strong>So erkennen Sie es:</strong> Sitzt an der Fassung ein kleiner weißer <strong>Starter</strong> zum Aufstecken oder Schrauben, ist es ein KVG/VVG → LED-Röhre + Dummy-Starter genügt. Fehlt der Starter, läuft die Leuchte per EVG → EVG-geeignete LED-Röhre wählen.';
      cta = '/collections/led-roehren';
    }
    out.innerHTML = '<p>' + html + '</p>' +
      '<a class="cr-cta" href="' + cta + '" data-todo="link-pruefen">Passende LED-Röhren ansehen: ' + esc(len[1]) + ' <span aria-hidden="true">→</span></a>';
  }
  vgRadios.forEach(function (r) { r.addEventListener('change', render); });
  lenSel.addEventListener('change', render);
  render();
})();

/* --- Lichtfarben-/Farbwiedergabe-Code-Decoder (farbwiedergabeindex-erklaert) ---
   3-stelliger Code: 1. Ziffer x10 = Farbwiedergabe Ra, letzte zwei x100 = Farbtemperatur (K). */
(function () {
  'use strict';
  var input = document.getElementById('cri-code-input');
  if (!input) return;
  var out = document.getElementById('cri-decode');
  if (!out) return;

  function lichtfarbe(k) {
    if (k < 3300) return 'warmweiß';
    if (k <= 5300) return 'neutralweiß';
    return 'tageslicht-/kaltweiß';
  }
  function raQuality(d) {
    if (d >= 9) return 'sehr hohe Farbwiedergabe';
    if (d >= 8) return 'gute Farbwiedergabe (Standard)';
    if (d >= 7) return 'mäßige Farbwiedergabe';
    return 'geringe Farbwiedergabe';
  }
  function row(label, value) {
    return '<div class="cri-out-row"><span>' + label + '</span><strong>' + value + '</strong></div>';
  }
  function decode() {
    var v = (input.value || '').replace(/[^0-9]/g, '');
    if (v.length !== 3) {
      out.innerHTML = '<p class="cri-hint">Bitte eine 3-stellige Zahl eingeben, z. B. <strong>827</strong>.</p>';
      return;
    }
    var d1 = parseInt(v.charAt(0), 10);
    var kelvin = parseInt(v.slice(1), 10) * 100;
    out.innerHTML =
      row('Farbwiedergabe', 'Ra ' + (d1 * 10) + '–' + (d1 * 10 + 9) + ' · ' + raQuality(d1)) +
      row('Lichtfarbe', kelvin + ' K · ' + lichtfarbe(kelvin));
  }
  // nur Ziffern zulassen
  input.addEventListener('input', function () {
    var clean = (input.value || '').replace(/[^0-9]/g, '').slice(0, 3);
    if (clean !== input.value) input.value = clean;
    decode();
  });
  decode();
})();

/* --- Kelvin-Schieberegler (lichtfarbe) --- Kelvin -> Lichtfarbe + Farb-Swatch (angenähert). */
(function () {
  'use strict';
  var range = document.getElementById('kf-range');
  if (!range) return;
  var swatch = document.getElementById('kf-swatch');
  var elLabel = document.getElementById('kf-label');
  var elK = document.getElementById('kf-k');
  var elUse = document.getElementById('kf-use');

  // Stützstellen warm -> kühl (angenäherte Schwarzkörper-Optik)
  var STOPS = [
    [2200, [255, 138, 42]], [2700, [255, 177, 90]], [3300, [255, 217, 168]],
    [4000, [253, 241, 220]], [5000, [238, 244, 255]], [5500, [219, 232, 255]], [6500, [188, 208, 255]]
  ];
  function lerp(a, b, t) { return Math.round(a + (b - a) * t); }
  function colorFor(k) {
    if (k <= STOPS[0][0]) return STOPS[0][1];
    if (k >= STOPS[STOPS.length - 1][0]) return STOPS[STOPS.length - 1][1];
    for (var i = 0; i < STOPS.length - 1; i++) {
      var lo = STOPS[i], hi = STOPS[i + 1];
      if (k >= lo[0] && k <= hi[0]) {
        var t = (k - lo[0]) / (hi[0] - lo[0]);
        return [lerp(lo[1][0], hi[1][0], t), lerp(lo[1][1], hi[1][1], t), lerp(lo[1][2], hi[1][2], t)];
      }
    }
    return STOPS[STOPS.length - 1][1];
  }
  function band(k) {
    if (k < 3300) return ['warmweiß', 'Gemütliches Licht für Wohn-, Schlaf- und Essräume.'];
    if (k <= 5300) return ['neutralweiß', 'Sachlich-klares Licht für Küche, Bad, Flur und Büro.'];
    return ['tageslichtweiß (kaltweiß)', 'Kühles, tageslichtähnliches Licht für Werkstatt, Lager, Labor und Farbprüfung.'];
  }
  function render() {
    var k = parseInt(range.value, 10);
    var c = colorFor(k);
    if (swatch) swatch.style.background = 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')';
    var b = band(k);
    if (elLabel) elLabel.textContent = b[0];
    if (elK) elK.textContent = k + ' K';
    if (elUse) elUse.textContent = b[1];
  }
  range.addEventListener('input', render);
  render();
})();

/* --- IP-Code-Decoder (Artikel schutzart-schutzklassen) ---
   Bedeutung der beiden IP-Kennziffern nach DIN EN 60529. Reiner Lookup,
   keine erfundenen Werte; die Eignung ist eine grobe Orientierung. */
(function () {
  'use strict';
  var d1 = document.getElementById('ip-d1');
  var d2 = document.getElementById('ip-d2');
  if (!d1 || !d2) return;
  var d1out = document.getElementById('ip-d1-out');
  var d2out = document.getElementById('ip-d2-out');
  var code = document.getElementById('ip-code');
  var solid = document.getElementById('ip-solid');
  var water = document.getElementById('ip-water');
  var use = document.getElementById('ip-use');
  var SOLID = [
    'kein Schutz gegen feste Fremdkörper',
    'Schutz gegen große Fremdkörper ab 50 mm (z. B. Handrücken)',
    'Schutz gegen Fremdkörper ab 12,5 mm (Finger)',
    'Schutz gegen Fremdkörper ab 2,5 mm (Werkzeug, dicke Drähte)',
    'Schutz gegen Fremdkörper ab 1 mm (Draht)',
    'staubgeschützt — Staub dringt nicht in schädlicher Menge ein',
    'staubdicht — kein Staubeintritt'
  ];
  var WATER = [
    'kein Schutz gegen Wasser',
    'Schutz gegen senkrecht fallendes Tropfwasser',
    'Schutz gegen fallendes Tropfwasser bei bis zu 15° Neigung',
    'Schutz gegen Sprühwasser bis 60° zur Senkrechten',
    'Schutz gegen allseitiges Spritzwasser',
    'Schutz gegen Strahlwasser aus beliebigem Winkel',
    'Schutz gegen starkes Strahlwasser',
    'Schutz gegen zeitweiliges Untertauchen',
    'Schutz gegen dauerndes Untertauchen',
    'Schutz gegen Hochdruck-/Dampfstrahlreinigung (IPx9/IPx9K)'
  ];
  function eignung(a, b) {
    var w;
    if (b === 0) w = 'nur trockene Innenräume';
    else if (b <= 3) w = 'Innenräume und geschützte Bereiche, kein direktes Spritzwasser';
    else if (b === 4) w = 'Feuchträume und überdachter Außenbereich (Spritzwasser)';
    else if (b <= 6) w = 'Außenbereich, auch direkter Wasserstrahl (z. B. Reinigung)';
    else if (b <= 8) w = 'zeitweiliges oder dauerndes Untertauchen';
    else w = 'Hochdruck-/Dampfstrahlreinigung (Industrie, Großküche)';
    if (a < 5 && b >= 4) w += ' — beachten: kein vollständiger Staubschutz';
    return w;
  }
  function render() {
    var a = parseInt(d1.value, 10), b = parseInt(d2.value, 10);
    if (d1out) d1out.textContent = a;
    if (d2out) d2out.textContent = b;
    if (code) code.textContent = 'IP' + a + b;
    if (solid) solid.textContent = SOLID[a];
    if (water) water.textContent = WATER[b];
    if (use) use.textContent = eignung(a, b);
    d1.setAttribute('aria-valuetext', a + ': ' + SOLID[a]);
    d2.setAttribute('aria-valuetext', b + ': ' + WATER[b]);
  }
  // Höhe einmal auf den längstmöglichen Inhalt fixieren, damit die Box beim
  // Schieben nicht springt (Umbruch ändert sonst die Zeilenzahl). Bei Resize neu.
  var result = document.querySelector('.ip-result');
  function longest(arr) { return arr.reduce(function (m, s) { return s.length > m.length ? s : m; }, ''); }
  var maxSolid = longest(SOLID), maxWater = longest(WATER), maxUse = '';
  for (var ia = 0; ia <= 6; ia++) { for (var ib = 0; ib <= 9; ib++) { var e = eignung(ia, ib); if (e.length > maxUse.length) maxUse = e; } }
  function lockHeight() {
    if (!result) return;
    var s = solid.textContent, w = water.textContent, u = use.textContent;
    result.style.minHeight = '';
    solid.textContent = maxSolid; water.textContent = maxWater; use.textContent = maxUse;
    result.style.minHeight = result.offsetHeight + 'px';
    solid.textContent = s; water.textContent = w; use.textContent = u;
  }
  d1.addEventListener('input', render);
  d2.addEventListener('input', render);
  render();
  lockHeight();
  var ipT; window.addEventListener('resize', function () { clearTimeout(ipT); ipT = setTimeout(lockHeight, 150); });
})();

/* --- LED-Anatomie zum Anklicken (Artikel aufbau-led-lampe) ---
   Klick/Tap auf ein Bauteil (Button oder SVG-Gruppe) hebt es hervor und zeigt die
   Erklärung. Reiner Erklär-Inhalt aus dem Artikel, keine technischen Messwerte. */
(function () {
  'use strict';
  var box = document.getElementById('led-anatomy');
  if (!box) return;
  var titleEl = document.getElementById('anatomy-title');
  var textEl = document.getElementById('anatomy-text');
  var btns = [].slice.call(box.querySelectorAll('.apart-btn'));
  if (!btns.length || !titleEl || !textEl) return;
  var DATA = {
    kolben: ['Kolben / Diffusor', 'Die äußere Hülle streut das Licht gleichmäßig und schützt die Elektronik. Meist mattiert für weiches Licht; bei Filament-LEDs ist der Kolben klar.'],
    platine: ['Platine & LED-Chips', 'Hier sitzen die eigentlichen Leuchtdioden — einzelne SMD-Chips oder ein COB-Modul. Am Halbleiter-Übergang wird Strom direkt in Licht umgewandelt (Elektrolumineszenz).'],
    phosphor: ['Phosphor-/Konverterschicht', 'Eine dünne Leuchtstoffschicht wandelt das blaue Licht der LED in warm- bis tageslichtweißes Licht um. Sie bestimmt Lichtfarbe (Kelvin) und Farbwiedergabe (Ra/CRI).'],
    kuehlkoerper: ['Kühlkörper', 'Leitet die Abwärme vom Chip ab. Gute Kühlung verlängert die Lebensdauer — deshalb oft Metall/Aluminium. Bei Filament-Lampen übernimmt der gasgefüllte Glaskolben die Kühlung.'],
    treiber: ['Treiber / Vorschaltgerät', 'Macht aus der 230-V-Netzspannung den passenden Gleichstrom für die LEDs und hält ihn konstant — das sorgt für gleichmäßiges, flimmerarmes Licht. Sitzt meist im Sockel.'],
    sockel: ['Sockel', 'Sorgt für mechanischen Halt und elektrischen Kontakt in der Fassung. Die Bauform (z. B. E27, GU10, G9) bestimmt, in welche Leuchte die Lampe passt.']
  };
  var groups = {};
  Object.keys(DATA).forEach(function (k) { groups[k] = box.querySelector('#part-' + k); });
  function select(k) {
    if (!DATA[k]) return;
    btns.forEach(function (b) {
      var on = b.getAttribute('data-part') === k;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    Object.keys(groups).forEach(function (id) {
      if (groups[id]) groups[id].classList.toggle('is-active', id === k);
    });
    box.classList.add('has-active');
    titleEl.textContent = DATA[k][0];
    textEl.textContent = DATA[k][1];
  }
  btns.forEach(function (b) { b.addEventListener('click', function () { select(b.getAttribute('data-part')); }); });
  Object.keys(groups).forEach(function (id) {
    if (groups[id]) groups[id].addEventListener('click', function () { select(id); });
  });
  // Detail-Box auf die höchste Bauteil-Beschreibung fixieren -> kein Springen beim Wechsel.
  var detail = box.querySelector('.anatomy-detail');
  function lockHeight() {
    if (!detail) return;
    var ct = titleEl.textContent, cx = textEl.textContent, max = 0;
    detail.style.minHeight = '';
    Object.keys(DATA).forEach(function (k) {
      titleEl.textContent = DATA[k][0]; textEl.textContent = DATA[k][1];
      if (detail.offsetHeight > max) max = detail.offsetHeight;
    });
    titleEl.textContent = ct; textEl.textContent = cx;
    detail.style.minHeight = max + 'px';
  }
  select('platine');
  lockHeight();
  var anT; window.addEventListener('resize', function () { clearTimeout(anT); anT = setTimeout(lockHeight, 150); });
})();

/* --- UV-Spektrum-Explorer (Artikel uva/uvb/uvc) ---
   Wellenlaenge -> UV-Band (CIE: UV-C 100-280, UV-B 280-315, UV-A 315-400 nm) +
   Anwendung + Sicherheitshinweis. Standard-Baender, keine erfundenen Werte. */
(function () {
  'use strict';
  var nm = document.getElementById('uv-nm');
  if (!nm) return;
  var out = document.getElementById('uv-nm-out');
  var band = document.getElementById('uv-band');
  var range = document.getElementById('uv-range');
  var use = document.getElementById('uv-use');
  var safe = document.getElementById('uv-safe');
  var marker = document.getElementById('uv-marker');
  function info(v) {
    if (v < 280) return ['UV-C', '100–280 nm', 'Entkeimung & Desinfektion von Luft, Oberflächen und Wasser (z. B. 254 nm)', 'Sehr energiereich — schädlich für Augen und Haut; nur ohne Personen oder Tiere im Raum betreiben.'];
    if (v < 315) return ['UV-B', '280–315 nm', 'Medizinische Lichttherapie und Vitamin-D-Bildung (z. B. Schmalband 311 nm)', 'Nur unter ärztlicher bzw. fachlicher Aufsicht; Haut- und Augenschutz beachten.'];
    return ['UV-A', '315–400 nm', 'Schwarzlicht, Insektenfallen, UV-Aushärtung und Materialprüfung', 'Schwächer energiereich, aber nicht direkt in die Quelle blicken; Herstellerhinweise beachten.'];
  }
  function render() {
    var v = parseInt(nm.value, 10);
    var i = info(v);
    if (out) out.textContent = v + ' nm';
    if (band) band.textContent = i[0] + ' · ' + v + ' nm';
    if (range) range.textContent = i[1];
    if (use) use.textContent = i[2];
    if (safe) safe.textContent = i[3];
    if (marker) marker.style.left = ((v - 100) / 300 * 100) + '%';
    nm.setAttribute('aria-valuetext', v + ' Nanometer, ' + i[0] + ', ' + i[2]);
  }
  var result = document.querySelector('.uv-result');
  function lock() {
    if (!result) return;
    var b = band.textContent, r = range.textContent, u = use.textContent, s = safe.textContent, max = 0;
    result.style.minHeight = '';
    [254, 300, 365].forEach(function (v) {
      var i = info(v);
      band.textContent = i[0] + ' · ' + v + ' nm'; range.textContent = i[1]; use.textContent = i[2]; safe.textContent = i[3];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    band.textContent = b; range.textContent = r; use.textContent = u; safe.textContent = s;
    result.style.minHeight = max + 'px';
  }
  nm.addEventListener('input', render);
  render();
  lock();
  var uvT; window.addEventListener('resize', function () { clearTimeout(uvT); uvT = setTimeout(lock, 150); });
})();

/* --- UGR-Richtwert-Finder (Artikel ugr19) ---
   Taetigkeit -> UGR-Hoechstwert (Lookup nach DIN EN 12464-1, korrigierte Tabelle). */
(function () {
  'use strict';
  var box = document.getElementById('ugr-finder');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.ugr-btn'));
  var val = document.getElementById('ugr-val'), note = document.getElementById('ugr-note');
  if (!btns.length || !val || !note) return;
  var DATA = [
    ['UGR ≤ 16', 'Technisches Zeichnen, CAD und sehr feine Sehaufgaben — strengster Blendschutz.'],
    ['UGR ≤ 19', 'Standard für Büro, Bildschirmarbeit, Konferenz und Klassenzimmer — Blendung am Bildschirm vermeiden.'],
    ['UGR ≤ 22', 'Labor, Kantine und mittlere Sehaufgaben.'],
    ['UGR ≤ 25', 'Lager, Lagerhallen und gröbere Tätigkeiten.'],
    ['UGR ≤ 28', 'Verkehrszonen, Treppen und Sportstätten.']
  ];
  function select(i) {
    btns.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.textContent = DATA[i][0]; note.textContent = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(1);
  var result = box.querySelector('.ugr-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.textContent, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.textContent = d[0]; note.textContent = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.textContent = v; note.textContent = n; result.style.minHeight = max + 'px';
  }
  lock();
  var ugrT; window.addEventListener('resize', function () { clearTimeout(ugrT); ugrT = setTimeout(lock, 150); });
})();

/* --- IP-Finder nach Einbauort (Artikel feuchtraumleuchten) ---
   Einbauort -> empfohlene Mindest-Schutzart (Lookup, grobe Orientierung). */
(function () {
  'use strict';
  var box = document.getElementById('ipf-finder');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.ipf-btn'));
  var val = document.getElementById('ipf-val'), note = document.getElementById('ipf-note');
  if (!btns.length || !val || !note) return;
  var DATA = [
    ['IP20', 'Trockener Wohnraum — kein besonderer Feuchteschutz nötig.'],
    ['mind. IP44', 'Feuchte Innenräume wie Keller, Garage oder Hauswirtschaftsraum — Schutz gegen Spritzwasser.'],
    ['mind. IP44', 'Badezimmer im Spritzwasserbereich um Wanne/Dusche; im direkten Strahlbereich eher IPX5 — Zonen und Elektrofachkraft beachten.'],
    ['mind. IP44', 'Überdachter Außenbereich (Carport, Balkon) — geschützt vor direktem Regen.'],
    ['mind. IP65', 'Frei bewitterter Außenbereich — Regen und Strahlwasser aus jeder Richtung.'],
    ['IP65 und höher', 'Bereiche mit Reinigung per Wasserstrahl oder Hochdruck — z. B. Industrie, Großküche, Stall.']
  ];
  function select(i) {
    btns.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.textContent = DATA[i][0]; note.textContent = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(1);
  var result = box.querySelector('.ipf-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.textContent, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.textContent = d[0]; note.textContent = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.textContent = v; note.textContent = n; result.style.minHeight = max + 'px';
  }
  lock();
  var ipfT; window.addEventListener('resize', function () { clearTimeout(ipfT); ipfT = setTimeout(lock, 150); });
})();

/* --- Dimmer-Finder (Artikel dimmer-fur-leuchtmittel) ---
   Leuchtmittel/Last -> passende Dimmer-Art (Phasenab-/anschnitt, C/L/R). Lookup nach
   diesem Ratgeber; konkrete Lastbereiche vor dem Kauf gegen Herstellerdoku bestaetigen. */
(function () {
  'use strict';
  var box = document.getElementById('dim-finder');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.dim-btn'));
  var val = document.getElementById('dim-val'), note = document.getElementById('dim-note');
  if (!btns.length || !val || !note) return;
  var DATA = [
    ['Phasenabschnitt · Symbol C', 'Nur als „dimmbar“ gekennzeichnete LED verwenden; auf die Mindestlast des Dimmers achten.'],
    ['Phasenabschnitt · Symbol C', 'Der Trafo bzw. LED-Treiber muss dimmbar sein und zum Dimmer passen (elektronischer Trafo = Phasenabschnitt).'],
    ['Phasenanschnitt · Symbol L', 'Gilt für konventionelle (gewickelte) Trafos; elektronische Trafos brauchen stattdessen Phasenabschnitt.'],
    ['Phasenanschnitt / Universal · Symbol R', 'Klassische ohmsche Last — nahezu jeder Dimmer ist geeignet.'],
    ['Nur mit dimmbarem Vorschaltgerät', 'Leuchtstofflampen und -röhren haben ein externes Vorschaltgerät — dimmbar nur mit einem dimmbaren EVG (z. B. 1–10 V oder DALI), nicht über einen normalen Wand-Dimmer.'],
    ['Nur wenn als „dimmbar“ gekennzeichnet', 'Bei Energiesparlampen (E27/E14) ist das Vorschaltgerät eingebaut — die meisten sind nicht dimmbar; es gehen nur ausdrücklich als „dimmbar“ deklarierte Modelle mit passendem Dimmer.']
  ];
  function select(i) {
    btns.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.textContent = DATA[i][0]; note.textContent = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0);
  var result = box.querySelector('.dim-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.textContent, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.textContent = d[0]; note.textContent = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.textContent = v; note.textContent = n; result.style.minHeight = max + 'px';
  }
  lock();
  var dimT; window.addEventListener('resize', function () { clearTimeout(dimT); dimT = setTimeout(lock, 150); });
})();

/* --- Sockel-Finder nach Maß (Artikel lampensockel-uebersicht) ---
   Bauart + gemessenes Maß -> Sockel + Spannung + Detail-Link. Masse aus dem Artikel. */
(function () {
  'use strict';
  var box = document.getElementById('sock-finder');
  if (!box) return;
  var arts = [].slice.call(box.querySelectorAll('.sock-art'));
  var sel = document.getElementById('sock-size');
  var label = document.getElementById('sock-size-label');
  var val = document.getElementById('sock-val');
  var note = document.getElementById('sock-note');
  if (!arts.length || !sel || !val || !note) return;
  var DATA = {
    schraub: { label: 'Durchmesser des Gewindes', opts: [
      ['14 mm', 'E14', 'Schraubsockel Ø 14 mm · 230 V — Kerzenfassung, Kronleuchter', '#e14'],
      ['27 mm', 'E27', 'Schraubsockel Ø 27 mm · 230 V — Standard-Leuchten', '#e27'],
      ['40 mm', 'E40', 'Schraubsockel Ø 40 mm · 230 V — Industrie/Hallen', '#e40'] ] },
    stift: { label: 'Abstand der Kontaktstifte', opts: [
      ['4 mm', 'G4 / GU4 (MR11)', 'Stiftsockel 4 mm · 12 V (Trafo) — Stiftsockellampen, MR11-Spots', '#g4'],
      ['5,3 mm', 'GU5.3 (MR16)', 'Stiftsockel 5,3 mm · 12 V (Trafo) — Reflektorspots MR16', '#gu53'],
      ['6,35 mm', 'GY6.35', 'Stiftsockel 6,35 mm · 12 V (Trafo) — Stiftsockellampen', '#gy635'],
      ['9 mm', 'G9', 'Stiftsockel 9 mm · 230 V — kompakte Stiftsockellampen', '#g9'],
      ['10 mm', 'GU10', 'Stiftsockel 10 mm · 230 V (Drehverschluss) — Reflektorspots', '#gu10'],
      ['53 mm', 'G53 (AR111)', 'Stiftsockel 53 mm · 12 V (Trafo) — AR111-Reflektorlampen', '#g53'] ] },
    spezial: { label: 'Bauform wählen', opts: [
      ['Stab (zweiseitig)', 'R7s', 'Stabsockel, zweiseitig · 230 V — Stab-/Linienlampen (z. B. 78/118 mm)', '#r7s'],
      ['Bajonett', 'B15', 'Bajonettsockel Ø 15 mm · 230 V — drücken & drehen', '#b15'],
      ['Röhre T8', 'G13', 'Röhrensockel G13 · 230 V — T8-Leuchtstoff-/LED-Röhre (Pin-Abstand 13 mm)', '#roehren'],
      ['Röhre T5', 'G5', 'Röhrensockel G5 · 230 V — T5-Leuchtstoff-/LED-Röhre (Pin-Abstand 5 mm)', '#roehren'] ] }
  };
  function art() { var a = 'schraub'; arts.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') a = b.getAttribute('data-art'); }); return a; }
  function fill(a) {
    var d = DATA[a]; label.textContent = d.label; sel.innerHTML = '';
    d.opts.forEach(function (o, i) { var op = document.createElement('option'); op.value = String(i); op.textContent = o[0]; sel.appendChild(op); });
  }
  function render() {
    var d = DATA[art()]; var o = d.opts[parseInt(sel.value, 10) || 0];
    val.textContent = o[1];
    note.innerHTML = o[2] + ' <a href="' + o[3] + '" class="sock-link">Details →</a>';
  }
  arts.forEach(function (b) { b.addEventListener('click', function () {
    arts.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
    b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
    fill(b.getAttribute('data-art')); render();
  }); });
  sel.addEventListener('change', render);
  arts.forEach(function (b) { if (b.getAttribute('data-art') === 'schraub') b.classList.add('is-on'); });
  fill('schraub'); render();
  var result = box.querySelector('.sock-result');
  function lock() {
    if (!result) return;
    var cv = val.textContent, cn = note.innerHTML, max = 0;
    result.style.minHeight = '';
    ['schraub', 'stift'].forEach(function (a) { DATA[a].opts.forEach(function (o) {
      val.textContent = o[1]; note.innerHTML = o[2] + ' <a href="' + o[3] + '" class="sock-link">Details →</a>';
      if (result.offsetHeight > max) max = result.offsetHeight;
    }); });
    val.textContent = cv; note.innerHTML = cn; result.style.minHeight = max + 'px';
  }
  lock();
  var sockT; window.addEventListener('resize', function () { clearTimeout(sockT); sockT = setTimeout(lock, 150); });
})();

/* --- Flacker-Diagnose (Artikel warum-flackern-led) ---
   Symptom -> wahrscheinliche Ursache + Loesung. Reine Entscheidungslogik nach diesem
   Ratgeber; keine erfundenen Werte (Mindestlast/Trafo-Last lt. Datenblatt). Ohne JS bleibt
   das vorbefuellte Standardergebnis (#flack-val/#flack-note) als Fallback sichtbar; im
   body.html ersetzt eine statische Symptom->Loesung-Liste das Modul. Buttons = echte
   <button>-Elemente (tastaturbedienbar), Ergebnis in aria-live="polite". */
(function () {
  'use strict';
  var box = document.getElementById('flack-finder');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.flack-btn'));
  var val = document.getElementById('flack-val'), note = document.getElementById('flack-note');
  if (!btns.length || !val || !note) return;
  // Reihenfolge identisch zu den Buttons in preview.html
  var DATA = [
    ['Nicht dimmbare LED oder inkompatibler Dimmer', 'Als „dimmbar“ gekennzeichnete LED an einem LED-tauglichen Dimmer verwenden; Mindestlast laut Datenblatt beachten.'],
    ['Schalter mit Glimmlampe oder Reststrom', 'Glimmlampe/Orientierungslicht im Schalter entfernen, Schaltung der Phase prüfen, ggf. Grundlast/Ableitkondensator — im Zweifel Elektrofachkraft.'],
    ['Anlauf von Treiber/Trafo — meist normal', 'Ein kurzes Flackern beim Einschalten ist bei kalter Lampe oft normal. Hält es an, Treiber bzw. Trafo und den Sitz der Lampe prüfen.'],
    ['Spannungseinbruch im Stromkreis oder Wackelkontakt', 'Sitz der Lampe prüfen; Last auf mehrere Stromkreise verteilen und die Elektrik prüfen lassen (Elektrofachkraft).'],
    ['Einfacher Treiber / PWM ohne ausreichende Glättung', 'Hochwertige, ausdrücklich als „flickerfrei“ beworbene LED wählen — verbindlich sind die Herstellerangaben.'],
    ['Elektronischer Trafo erreicht die Mindestlast nicht', 'LED-tauglichen Trafo bzw. Konverter einsetzen, dessen Lastbereich zur Anzahl und Leistung der LED-Spots passt.'],
    ['Fest verbautes LED-Modul — nicht tauschbar', 'Treiber bzw. Vorschaltgerät der Leuchte prüfen lassen; lässt sich der Fehler nicht beheben, die Leuchte tauschen.']
  ];
  function select(i) {
    btns.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.textContent = DATA[i][0]; note.textContent = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0);
  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Symptomwechsel.
  var result = box.querySelector('.flack-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.textContent, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.textContent = d[0]; note.textContent = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.textContent = v; note.textContent = n; result.style.minHeight = max + 'px';
  }
  lock();
  var flackT; window.addEventListener('resize', function () { clearTimeout(flackT); flackT = setTimeout(lock, 150); });
})();

/* --- Halogen-Umrüst-Finder (Artikel halogen-durch-led-ersetzen) ---
   Halogen-Sockel -> Spannung (230 V/12 V) + ob 1:1 tauschbar + worauf achten + wohin
   (interner Link, data-todo). Reine Entscheidungslogik nach diesem Ratgeber; KEINE
   erfundenen Watt-/Lumen-/Mindestlast-Werte (Trafo-Mindestlast lt. Datenblatt). Ohne JS
   bleibt das vorbefuellte Standardergebnis (#hled-val/#hled-note) als Fallback sichtbar; im
   body.html ersetzt eine statische Sockel->Hinweis-Liste das Modul. Buttons = echte
   <button>-Elemente (tastaturbedienbar), Ergebnis in aria-live="polite". Gleiche
   Button->Ergebnis-Optik wie Flacker-/Sockel-Finder (.calc-module/.apart-btn/.ip-code/.finder-note). */
(function () {
  'use strict';
  var box = document.getElementById('hled-finder');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.hled-btn'));
  var val = document.getElementById('hled-val'), note = document.getElementById('hled-note');
  if (!btns.length || !val || !note) return;
  // Reihenfolge identisch zu den Buttons in preview.html.
  // [Ergebnis-Kennzahl (Sockel · Spannung · 1:1?), Hinweis-HTML inkl. internem Link (data-todo)]
  var DATA = [
    ['GU10 · 230 V · direkt 1:1 tauschbar',
     'Kein Trafo nötig — GU10 läuft direkt am 230-V-Netz. Auf Abstrahlwinkel und Lumen statt Watt achten; dimmen nur mit dimmbarer LED und LED-tauglichem Dimmer. <a href="/collections/gu10-led-lampen" class="sock-link" data-todo="link-pruefen">GU10-LED-Spots ansehen →</a>'],
    ['G9 · 230 V · direkt 1:1 tauschbar',
     'Kein Trafo nötig. Sehr kompakte Bauform — in kleinen, geschlossenen Leuchten auf Baugröße und Wärmestau achten. <a href="/collections/g9-led-leuchtmittel" class="sock-link">G9-LED ansehen →</a>'],
    ['R7s-Stab · 230 V · direkt, aber Länge prüfen',
     'Länge exakt passend wählen — meist 78 mm oder 118 mm. Sehr hohe Halogen-Leistungen (Klasse um 300 W) haben oft noch keinen vollwertigen LED-Ersatz; ein vorhandenes Hitzeschild lässt sich je nach Leuchte entfernen. <a href="/collections/r7s-led-leuchtmittel" class="sock-link">R7s-LED-Stäbe ansehen →</a>'],
    ['E27 / E14 · 230 V · direkt 1:1 tauschbar',
     'Halogen-Lampen in Glühlampenform werden wie eine Glühlampe getauscht — kein Trafo. Helligkeit über Lumen vergleichen. <a href="/blogs/ratgeber/led-statt-gluhlampe" class="sock-link" data-todo="link-pruefen">LED statt Glühlampe →</a>'],
    ['GU5.3 / MR16 · 12 V · Trafo entscheidet',
     'Niedervolt über Trafo: Ein elektronischer Halogen-Trafo braucht eine Mindestlast (Wert laut Datenblatt) und liefert Wechselstrom — sparsame LED können dann flackern. Lösung: LED-tauglicher Konverter oder ein Ringkerntrafo. <a href="/blogs/ratgeber/warum-flackern-led" class="sock-link" data-todo="link-pruefen">Warum LED flackern →</a>'],
    ['GU4 / MR11 · 12 V · Trafo entscheidet',
     'Kleiner Reflektor, Niedervolt über Trafo. Trafo wie bei GU5.3 prüfen (Mindestlast/Wechselstrom) und gegebenenfalls auf einen LED-Konverter wechseln. <a href="/collections/gu4-led-leuchtmittel" class="sock-link" data-todo="link-pruefen">MR11-/GU4-LED ansehen →</a>'],
    ['G4 · 12 V · Trafo entscheidet',
     'Sehr kompakter Stiftsockel, Niedervolt über Trafo. Trafo wie bei GU5.3 prüfen; beim Einsetzen die feinen Stifte vorsichtig führen. <a href="/collections/g4-led-leuchtmittel" class="sock-link">G4-LED ansehen →</a>'],
    ['G53 / AR111 · meist 12 V · Trafo entscheidet',
     'Großer 111-mm-Reflektor, meist Niedervolt. Trafo bzw. Konverter wie bei GU5.3 prüfen; bei Netzbetrieb die Angaben der konkreten Lampe beachten. <a href="/collections/g53-led-leuchtmittel" class="sock-link" data-todo="link-pruefen">AR111-/G53-LED ansehen →</a>']
  ];
  function select(i) {
    btns.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.textContent = DATA[i][0]; note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0);
  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Sockelwechsel.
  var result = box.querySelector('.hled-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.textContent = d[0]; note.innerHTML = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var hledT; window.addEventListener('resize', function () { clearTimeout(hledT); hledT = setTimeout(lock, 150); });
})();

/* --- LED-Ersatz-Finder (Artikel led-ersatzprodukt-finden) ---
   Was möchten Sie ersetzen? -> kurze Einordnung + Link zum passenden Tiefen-Ratgeber.
   Reiner Routing-Hub (Anti-Kannibalisierung): KEINE Watt-/Lumen-/Sockel-Details hier,
   sondern Verweis auf die rankende Zielseite. Reine Entscheidungslogik, clientseitig.
   Ohne JS bleibt das vorbefuellte Standardergebnis (#eref-val/#eref-note) als Fallback
   sichtbar; im body.html ersetzt eine statische Routing-Liste das Modul. Buttons = echte
   <button>-Elemente (tastaturbedienbar), Ergebnis in aria-live="polite". Gleiche
   Button->Ergebnis-Optik wie Halogen-/Flacker-/Sockel-Finder (.calc-module/.apart-btn/
   .ip-code/.finder-note). Interne Ratgeber-Links relativ; Collection-Link data-todo. */
(function () {
  'use strict';
  var box = document.getElementById('eref-finder');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.eref-btn'));
  var val = document.getElementById('eref-val'), note = document.getElementById('eref-note');
  if (!btns.length || !val || !note) return;
  // Reihenfolge identisch zu den Buttons in preview.html.
  // [Ergebnis-Kennzahl (was ersetzen -> wohin), Hinweis-HTML inkl. internem Link (data-todo)]
  var DATA = [
    ['Glühlampe (E27/E14) → LED statt Glühlampe',
     'Klassische Glühbirne mit Schraubsockel: direkt gegen eine LED mit gleichem Sockel tauschen, Helligkeit über die Lumen wählen. Der ganze Wechsel Schritt für Schritt steht im Ratgeber. <a href="/blogs/ratgeber/led-statt-gluhlampe" class="sock-link" data-todo="link-pruefen">LED statt Glühlampe →</a>'],
    ['Halogen-Spot (GU10/GU5.3/G9) → Halogen durch LED ersetzen',
     'Bei Halogen entscheidet die Spannung: 230 V (GU10, G9) tauschen Sie direkt, bei 12 V (GU5.3) kommt der Trafo ins Spiel. Sockel, Spannung und Trafo-Frage klärt der Halogen-Ratgeber. <a href="/blogs/ratgeber/halogen-durch-led-ersetzen" class="sock-link" data-todo="link-pruefen">Halogen durch LED ersetzen →</a>'],
    ['Leuchtstoff-/Neonröhre (T8/T5) → Röhren ersetzen',
     'Bei Röhren hängt der LED-Umbau am Vorschaltgerät (KVG/VVG oder EVG) und am Starter. Die ausführliche Umrüst-Anleitung mit Längen und Sockeln steht im Röhren-Ratgeber. <a href="/blogs/ratgeber/leuchtstoffroehren-durch-led-roehren-ersetzen" class="sock-link" data-todo="link-pruefen">Leuchtstoffröhren durch LED ersetzen →</a>'],
    ['Energiesparlampe / Kompaktleuchtstofflampe → LED-Ersatz',
     'Energiesparlampen (Kompaktleuchtstofflampen) gibt es als Schraubsockel (E27/E14) oder mit Stecksockel (z. B. G23, 2G11). Den richtigen LED-Ersatz finden Sie über den Sockel. <a href="/collections/led-ersatz-kompaktleuchtstofflampen" class="sock-link">LED-Ersatz für Kompaktleuchtstofflampen →</a>'],
    ['Niedervolt-Spot 12 V (GU5.3/G4/MR16) → Halogen-Ratgeber (Trafo!)',
     'Niedervolt-Spots laufen über einen Trafo. Ein alter elektronischer Halogen-Trafo passt oft nicht zur sparsamen LED — dann hilft ein LED-Konverter. Details im Halogen-Ratgeber. <a href="/blogs/ratgeber/halogen-durch-led-ersetzen" class="sock-link" data-todo="link-pruefen">12-V-Spots auf LED umrüsten →</a>'],
    ['Halogenstab R7s → Halogen durch LED ersetzen (Länge!)',
     'Beim R7s-Stab muss die Länge exakt passen — meist 78 mm oder 118 mm. Ein R7s-Stab läuft mit 230 V, ein Trafo ist nicht nötig. Worauf es ankommt, steht im Halogen-Ratgeber. <a href="/blogs/ratgeber/halogen-durch-led-ersetzen" class="sock-link" data-todo="link-pruefen">R7s-Stab auf LED umrüsten →</a>']
  ];
  function select(i) {
    btns.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.textContent = DATA[i][0]; note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0);
  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.eref-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.textContent = d[0]; note.innerHTML = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var erefT; window.addEventListener('resize', function () { clearTimeout(erefT); erefT = setTimeout(lock, 150); });
})();

/* --- LED-Art-Finder (Artikel welche-led-arten) ---
   Anwendungsfall -> typischer LED-CHIP-Typ + kurze Begruendung (+ interner Link wo
   sinnvoll, data-todo). Reine Entscheidungslogik nach diesem Ratgeber; KEINE erfundenen
   Werte (lm/W, CRI, Lebensdauer) — qualitativ. Ohne JS bleibt das vorbefuellte
   Standardergebnis (#lart-val/#lart-note) als Fallback sichtbar; im body.html ersetzt eine
   statische Zweck->Typ-Liste das Modul. Buttons = echte <button>-Elemente (tastaturbedienbar),
   Ergebnis in aria-live="polite". Gleiche Button->Ergebnis-Optik wie Halogen-/LED-Ersatz-/
   Flacker-/Sockel-Finder (.calc-module/.apart-btn/.ip-code/.finder-note). */
(function () {
  'use strict';
  var box = document.getElementById('lart-finder');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.lart-btn'));
  var val = document.getElementById('lart-val'), note = document.getElementById('lart-note');
  if (!btns.length || !val || !note) return;
  // Reihenfolge identisch zu den Buttons in preview.html.
  // [Ergebnis-Kennzahl (Zweck -> Typ), Hinweis-HTML inkl. internem Link (data-todo)]
  var DATA = [
    ['Helle Decken-/Allgemeinbeleuchtung → SMD',
     'SMD ist der Standard-Chip in den meisten LED-Lampen und -Modulen: viele kleine Dioden auf der Platine, flexibel einsetzbar und gut für eine gleichmäßige Raumausleuchtung. <a href="/collections/led-lampen" class="sock-link" data-todo="link-pruefen">LED-Lampen ansehen →</a>'],
    ['Spot / Strahler (gerichtet, homogen) → COB',
     'COB bündelt viele Dioden zu einer kompakten Leuchtfläche. Das ergibt einen homogenen, gerichteten Lichtpunkt ohne sichtbare Einzel-LEDs — typisch für Spots und Strahler. <a href="/collections/led-reflektorlampen" class="sock-link" data-todo="link-pruefen">LED-Spots & Strahler →</a>'],
    ['LED-Streifen / indirektes Licht → SMD',
     'Auf einem flexiblen Band sitzen viele SMD-Dioden in Reihe. Das eignet sich für indirektes Licht, Lichtkanten und Akzente.'],
    ['Retrofit-Glühbirne / Vintage-Optik → Filament',
     'Filament-LEDs sind Leuchtfäden im klaren Glaskolben — sie sehen aus wie eine klassische Glühbirne und strahlen rundum. Gut für sichtbare Leuchten und Vintage-Optik. <a href="/collections/led-filaments" class="sock-link" data-todo="link-pruefen">Filament-LEDs ansehen →</a>'],
    ['Farbwechsel / Ambiente / Smart Home → RGB(W)',
     'RGB(W)-LEDs mischen rotes, grünes und blaues (plus weißes) Licht zu vielen Farben. Sinnvoll für Ambiente, Effektlicht und Smart-Home-Steuerung. <a href="/collections/led-smart-home" class="sock-link">Smart-Home-Beleuchtung →</a>'],
    ['Desinfektion / Entkeimung → UV-C',
     'UV-C arbeitet im kurzwelligen UV-Bereich (100–280 nm) und wird zur Entkeimung von Luft, Oberflächen und Wasser eingesetzt. Anwendung und Sicherheit erklärt der eigene Ratgeber. <a href="/blogs/ratgeber/uvc-lampen-desinfektion" class="sock-link" data-todo="link-pruefen">UV-C zur Desinfektion →</a>'],
    ['Fernbedienung / Sensorik / Nachtsicht → Infrarot (IR)',
     'Infrarot-LEDs (ab etwa 700 nm) strahlen für das Auge unsichtbares Licht ab. Typisch in Fernbedienungen, Bewegungssensorik und Nachtsicht-Kameras.']
  ];
  function select(i) {
    btns.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.textContent = DATA[i][0]; note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0);
  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.lart-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.textContent = d[0]; note.innerHTML = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var lartT; window.addEventListener('resize', function () { clearTimeout(lartT); lartT = setTimeout(lock, 150); });
})();

/* --- Begriffs-Filter (Artikel leuchtmittel-wiki) ---
   TEXT-Filter (kein Button-Finder): das Eingabefeld #wiki-search filtert die statischen
   Glossar-Eintraege (.wiki-term mit data-term="begriff synonyme"). Treffer bleiben sichtbar,
   Nicht-Treffer werden ausgeblendet (hidden); Gruppen-Ueberschriften (.wiki-group-h) werden
   ausgeblendet, wenn in ihrer Gruppe kein Eintrag mehr sichtbar ist. Trefferzahl in der
   aria-live-Region #wiki-count; bei 0 Treffern erscheint der Hinweis #wiki-empty. Suche ist
   case- und umlaut-/akzent-tolerant (NFD + ae/oe/ue/ss-Ersatz). Guard: ohne #wiki-search
   oder ohne #wiki-list passiert nichts (No-op auf anderen Seiten). Das Glossar selbst bleibt
   reiner HTML-Inhalt und ist auch OHNE JS vollstaendig sichtbar (Filterfeld = Theme-Modul). */
(function () {
  'use strict';
  var input = document.getElementById('wiki-search');
  var list = document.getElementById('wiki-list');
  if (!input || !list) return;
  var terms = [].slice.call(list.querySelectorAll('.wiki-term'));
  if (!terms.length) return;
  var count = document.getElementById('wiki-count');
  var empty = document.getElementById('wiki-empty');
  var groups = [].slice.call(list.querySelectorAll('.wiki-group-h'));

  // Normalisierung: Kleinschreibung, deutsche Umlaute/ß ausschreiben, restliche
  // Diakritika via NFD entfernen, Mehrfach-Whitespace glaetten.
  function norm(s) {
    s = (s || '').toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
    // restliche Diakritika (z. B. é, ñ) entfernen: NFD spaltet sie in Basiszeichen +
    // kombinierende Marks (U+0300–U+036F), die hier weggeschnitten werden.
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/\s+/g, ' ').trim();
  }

  // Suchindex je Eintrag einmal vorberechnen: data-term + sichtbarer Begriff (h3).
  terms.forEach(function (t) {
    var head = t.querySelector('h3');
    t._wikiIndex = norm((t.getAttribute('data-term') || '') + ' ' + (head ? head.textContent : ''));
  });

  var fmt = new Intl.NumberFormat('de-DE');
  var total = terms.length;

  function apply() {
    var q = norm(input.value);
    var hits = 0;
    terms.forEach(function (t) {
      var match = q === '' || t._wikiIndex.indexOf(q) !== -1;
      t.hidden = !match;
      if (match) hits++;
    });
    // Gruppen-Ueberschrift nur zeigen, wenn ihr ein sichtbarer Eintrag folgt
    // (bis zur naechsten Ueberschrift).
    groups.forEach(function (h) {
      var visible = false;
      var node = h.nextElementSibling;
      while (node && !node.classList.contains('wiki-group-h')) {
        if (node.classList.contains('wiki-term') && !node.hidden) { visible = true; break; }
        node = node.nextElementSibling;
      }
      h.hidden = !visible;
    });
    if (empty) empty.hidden = hits !== 0;
    if (count) {
      if (q === '') {
        count.textContent = 'Alle Begriffe werden angezeigt.';
      } else if (hits === 0) {
        count.textContent = 'Kein Begriff gefunden.';
      } else {
        count.textContent = hits === 1
          ? '1 Begriff gefunden.'
          : fmt.format(hits) + ' von ' + fmt.format(total) + ' Begriffen.';
      }
    }
  }
  input.addEventListener('input', apply);
  // Enter im Suchfeld nicht das (Vorschau-)Formular absenden lassen.
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
  apply();
})();

/* --- Pflanzenlicht-Finder (Artikel led-pflanzenlicht) ---
   Anwendung/Phase -> empfohlenes Licht (Vollspektrum/weisse Grow-LED + Blau-/Rot-Betonung)
   + kurze Begruendung (+ interner/Collection-Link, data-todo). Reine Entscheidungslogik nach
   diesem Ratgeber; KEINE erfundenen Werte (PPFD/µmol/Lux/Stunden/Abstand) — qualitativ, Datenluecke
   benannt. Belegt/qualitativ: PAR ~400–700 nm, Blau ~400–500 nm, Rot ~600–700 nm. Ohne JS bleibt das
   vorbefuellte Standardergebnis (#pfl-val/#pfl-note) als Fallback sichtbar; im body.html ersetzt eine
   statische Fall->Licht-Liste das Modul. Buttons = echte <button>-Elemente (tastaturbedienbar),
   Ergebnis in aria-live="polite". Gleiche Button->Ergebnis-Optik wie LED-Art-/Halogen-/LED-Ersatz-/
   Flacker-/Sockel-Finder (.calc-module/.apart-btn/.ip-code/.finder-note). */
(function () {
  'use strict';
  var box = document.getElementById('pfl-finder');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.pfl-btn'));
  var val = document.getElementById('pfl-val'), note = document.getElementById('pfl-note');
  if (!btns.length || !val || !note) return;
  // Reihenfolge identisch zu den Buttons in preview.html.
  // [Ergebnis-Kennzahl (Fall -> Licht), Hinweis-HTML inkl. Link (data-todo)]
  var DATA = [
    ['Zimmerpflanzen (Erhaltung) → Vollspektrum / weiße Grow-LED',
     'Eine weiße Vollspektrum-Grow-LED deckt Blau und Rot ab und ist die unkomplizierte Wahl, um fehlendes Tageslicht zu ergänzen. Auf ausreichende Helligkeit und mehrere Stunden Betrieb am Tag achten. <a href="/collections/led-lampen" class="sock-link" data-todo="link-pruefen">LED-Lampen ansehen →</a>'],
    ['Anzucht / Sämlinge → Vollspektrum mit höherem Blauanteil',
     'In der Anzucht hält ein höherer Blauanteil (ca. 400–500 nm) den Wuchs kompakt, damit Sämlinge nicht vergeilen. Die Lampe nah genug positionieren. Was Vollspektrum bedeutet, vertieft der eigene Ratgeber. <a href="/blogs/ratgeber/vollspektrum-led" class="sock-link" data-todo="link-pruefen">Vollspektrum-LED →</a>'],
    ['Blüte / Fruchtbildung → Vollspektrum mit höherem Rotanteil',
     'Beim Übergang in die Blüte unterstützt ein höherer Rotanteil (ca. 600–700 nm) Blüten- und Fruchtbildung. Ein Vollspektrum mit kräftigem Rot deckt das ab, ohne dass Sie die Lampe wechseln müssen. <a href="/collections/led-lampen" class="sock-link" data-todo="link-pruefen">LED-Lampen ansehen →</a>'],
    ['Aquariumpflanzen → Vollspektrum, ausdrücklich aquariengeeignet',
     'Auch hier ist ein Vollspektrum sinnvoll — entscheidend ist aber eine ausdrücklich für Aquarien geeignete Leuchte (Feuchtigkeit, Abdeckung, Bauform). Details im eigenen Aquarium-Ratgeber. <a href="#" class="sock-link" data-todo="link-pruefen-aquarium-ratgeber-shopware-blog-noch-nicht-migriert">LED-Beleuchtung im Aquarium →</a>'],
    ['Gewächshaus / lichtarmer Standort → leistungsfähige Vollspektrum-Grow-LED',
     'Für größere Flächen oder dunkle Standorte zählt zusätzlich die Lichtleistung pro Fläche: je größer die Fläche, desto leistungsfähiger die Grow-LED. Abstand und Beleuchtungsdauer beachten.']
  ];
  function select(i) {
    btns.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.textContent = DATA[i][0]; note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0);
  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.pfl-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.textContent = d[0]; note.innerHTML = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var pflT; window.addEventListener('resize', function () { clearTimeout(pflT); pflT = setTimeout(lock, 150); });
})();

/* --- Vollspektrum-Berater (Artikel vollspektrum-led) ---
   Anwendungsfall -> ob Vollspektrum sinnvoll + CRI/Ra-Richtwert + kurze Begruendung (+ interner
   Link, data-todo). Reine Entscheidungslogik nach diesem Ratgeber; ANTI-KANNIBALISIERUNG: routet
   CRI-Tiefe -> farbwiedergabeindex-erklaert, Kelvin/tageslichtweiss -> lichtfarbe, Pflanzen ->
   led-pflanzenlicht (NICHT hier nachbauen). YMYL: KEINE Gesundheits-/Vitamin-D-/Wirkungsversprechen —
   nur Farbwiedergabe. KEINE erfundenen Werte ausser dem Ra-Richtwert (>=90/95; Standard-LED ~80;
   Sonne Ra 100 = belegte Skala). Ohne JS bleibt das vorbefuellte Standardergebnis (#vsf-val/#vsf-note)
   als Fallback sichtbar; im body.html ersetzt eine statische Fall->Empfehlung-Liste das Modul.
   Buttons = echte <button>-Elemente (tastaturbedienbar), Ergebnis in aria-live="polite". Gleiche
   Button->Ergebnis-Optik wie Pflanzenlicht-/LED-Art-/Halogen-/Flacker-/Sockel-Finder
   (.calc-module/.apart-btn/.ip-code/.finder-note). */
(function () {
  'use strict';
  var box = document.getElementById('vsf-finder');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.vsf-btn'));
  var val = document.getElementById('vsf-val'), note = document.getElementById('vsf-note');
  if (!btns.length || !val || !note) return;
  // Reihenfolge identisch zu den Buttons in preview.html.
  // [Ergebnis-Kennzahl (Fall -> Empfehlung + Ra), Hinweis-HTML inkl. Link (data-todo)]
  var DATA = [
    ['Verkauf / Textil / Mode → Vollspektrum, Ra ≥ 90',
     'Farben sollen am Point of Sale echt wirken. Hier lohnt eine Vollspektrum-LED mit hoher Farbwiedergabe (Ra ≥ 90). Was der Ra-Wert genau aussagt, vertieft der CRI-Ratgeber. <a href="/blogs/ratgeber/farbwiedergabeindex-erklaert" class="sock-link" data-todo="link-pruefen">Farbwiedergabeindex erklärt →</a>'],
    ['Kosmetik / Schminkspiegel / Bad → Vollspektrum, Ra hoch',
     'Hauttöne und Make-up lassen sich nur unter farbtreuem Licht zuverlässig beurteilen. Eine Vollspektrum-LED mit hoher Farbwiedergabe ist hier die richtige Wahl. <a href="/collections/led-lampen" class="sock-link" data-todo="link-pruefen">LED-Lampen ansehen →</a>'],
    ['Kunst / Hobby / Basteln → Vollspektrum, Ra ≥ 90',
     'Beim Malen, Nähen oder Modellbau hilft eine naturgetreue Farbwiedergabe, Töne richtig einzuschätzen. Achten Sie auf Ra ≥ 90. <a href="/collections/led-lampen" class="sock-link" data-todo="link-pruefen">LED-Lampen ansehen →</a>'],
    ['Arbeitsplatz mit Farbbeurteilung → Vollspektrum, hoher Ra',
     'Grafik, Druck, Labor oder Werkstatt: Wo Farben fachlich bewertet werden, ist ein hoher Ra-Wert von Vorteil. Den Richtwert und die Hintergründe liefert der CRI-Ratgeber. <a href="/blogs/ratgeber/farbwiedergabeindex-erklaert" class="sock-link" data-todo="link-pruefen">Farbwiedergabeindex erklärt →</a>'],
    ['Normale Wohnraum-/Flurbeleuchtung → reicht meist normale LED (Ra ~80)',
     'Für allgemeine Beleuchtung genügt in der Regel eine gute Standard-LED (etwa Ra 80). Wichtiger ist hier die Lichtfarbe nach Geschmack — warm- bis tageslichtweiß. <a href="/blogs/ratgeber/lichtfarbe" class="sock-link" data-todo="link-pruefen">Lichtfarbe wählen →</a>'],
    ['Pflanzen → kein „Vollspektrum“-Marketing nötig, eigenes Thema',
     'Für Pflanzen zählt nicht die Farbwiedergabe fürs Auge, sondern das nutzbare Spektrum (PAR). Das ist ein eigenes Thema — der Pflanzenlicht-Ratgeber ordnet es ein. <a href="/blogs/ratgeber/led-pflanzenlicht" class="sock-link" data-todo="link-pruefen">LED-Licht für Pflanzen →</a>']
  ];
  function select(i) {
    btns.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.textContent = DATA[i][0]; note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0);
  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.vsf-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.textContent = d[0]; note.innerHTML = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var vsfT; window.addEventListener('resize', function () { clearTimeout(vsfT); vsfT = setTimeout(lock, 150); });
})();

/* --- Lebensdauer-Rechner: Stunden -> Jahre (Artikel lebensdauer-led-lampen) ---
   Reine Division, datenehrlich: Jahre = Nennlebensdauer (h) ÷ (Brenndauer/Tag × 365).
   KEIN erfundener Wert — die Nennlebensdauer gibt der Nutzer ein (steht laut Datenblatt
   auf der Verpackung). Defaults (25.000 h, 3 h/Tag) sind ein klar gekennzeichnetes
   Beispiel. ID-gekoppelt, sonst No-op. */
(function () {
  'use strict';
  var box = document.getElementById('ld-calc');
  if (!box) return;
  var hoursTotal = document.getElementById('ld-hours');   // Nennlebensdauer in Stunden
  var perDay = document.getElementById('ld-perday');       // Brenndauer pro Tag in Stunden
  var out = document.getElementById('ld-result');
  if (!hoursTotal || !perDay || !out) return;
  var f0 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  var f1 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });
  function render() {
    var h = parseFloat(hoursTotal.value);
    var d = parseFloat(perDay.value);
    if (!isFinite(h) || h <= 0 || !isFinite(d) || d <= 0) {
      out.textContent = 'Bitte Nennlebensdauer (Stunden) und Brenndauer pro Tag eingeben — die Nennlebensdauer steht laut Datenblatt auf der Verpackung.';
      return;
    }
    var hPerYear = d * 365;
    var years = h / hPerYear;
    var yearsTxt = years >= 10 ? f0.format(years) : f1.format(years);
    out.innerHTML = 'Rechnerisch hält die Lampe etwa <strong>' + yearsTxt + ' Jahre</strong>.' +
      '<span class="calc-equiv">' + f0.format(h) + ' Stunden &divide; (' + f1.format(d) + ' h/Tag &times; 365 Tage) &asymp; ' +
      f0.format(Math.round(hPerYear)) + ' h pro Jahr. Reine Rechnung aus Ihren Werten — die reale Lebensdauer h&auml;ngt von W&auml;rme, Qualit&auml;t, Schaltzyklen und Einbau ab.</span>';
  }
  [hoursTotal, perDay].forEach(function (el) { el.addEventListener('input', render); });
  render();
})();

/* --- Wärme-Check „Wird meine LED zu heiß?“ (Artikel led-waermeentwicklung) ---
   Situation -> Einordnung (normal vs. prüfen) + ggf. interner Link (data-todo). Reine
   Entscheidungslogik nach diesem Ratgeber; DATENEHRLICH: nur Richtwerte (Gehäuse ~30–60 °C,
   Kühlkörper bis ~80 °C, > ~85 °C/zu heiß = Problem) — KEINE erfundenen festen Grenzwerte je
   Produkt. Ohne JS bleibt das vorbefüllte Standardergebnis (#heat-val/#heat-note) als Fallback
   sichtbar; im body.html ersetzt eine statische Situation->Einordnung-Liste das Modul. Buttons =
   echte <button>-Elemente (tastaturbedienbar), Ergebnis in aria-live="polite". Gleiche
   Button->Ergebnis-Optik wie Vollspektrum-/Pflanzenlicht-/Halogen-/Flacker-/Sockel-Finder
   (.calc-module/.apart-btn/.ip-code/.finder-note). */
(function () {
  'use strict';
  var box = document.getElementById('heat-finder');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.heat-btn'));
  var val = document.getElementById('heat-val'), note = document.getElementById('heat-note');
  if (!btns.length || !val || !note) return;
  // Reihenfolge identisch zu den Buttons in preview.html.
  // [Ergebnis-Kennzahl (Situation -> Einordnung), Hinweis-HTML inkl. ggf. internem Link (data-todo)]
  var DATA = [
    ['Handwarm (30–60 °C) → normal',
     'Eine handwarme LED ist im Normalbetrieb völlig in Ordnung — die Wärme entsteht am Sockel und wird über den Kühlkörper abgeführt. Kein Grund zur Sorge.'],
    ['Kühlkörper deutlich warm → je nach Bauart meist ok',
     'Gerade bei leistungsstärkeren Lampen und Spots wird der metallene Kühlkörper merklich warm (Richtwert bis etwa 80 °C) — das ist gewollt. Solange die Lampe stabil leuchtet, achten Sie nur auf freie Belüftung und die richtige Einbausituation.'],
    ['Zu heiß zum Anfassen / Geruch / Verfärbung → Problem',
     'Das ist ein Warnsignal: vermutlich gestaute Wärme, zu hohe Leistung für die Leuchte oder ein Treiber-/Qualitätsproblem. Lampe ausschalten und vom Netz trennen, Einbausituation und Eignung prüfen — im Zweifel eine Elektrofachkraft hinzuziehen.'],
    ['Wird heiß und schaltet ab / flackert → Schutz/Treiber',
     'Viele LED haben einen thermischen Überhitzungsschutz, der bei Überlast oder Wärmestau abregelt. Für freie Wärmeabfuhr sorgen und eine für die Leuchte geeignete LED wählen. Flackert die Lampe eher, als dass sie abschaltet, hilft die Ursachensuche im Flacker-Ratgeber. <a href="/blogs/ratgeber/warum-flackern-led" class="sock-link" data-todo="link-pruefen">Warum flackern LED-Lampen? →</a>'],
    ['In geschlossener/gedämmter Leuchte → Wärmestau möglich',
     'In einer geschlossenen oder gedämmten Leuchte kann die Wärme nicht entweichen und staut sich. Verwenden Sie eine ausdrücklich „für geschlossene Leuchten geeignete“ LED (Angabe auf der Verpackung). Wie sich Wärme auf die Lebensdauer auswirkt, erklärt der Lebensdauer-Ratgeber. <a href="/blogs/ratgeber/lebensdauer-led-lampen" class="sock-link" data-todo="link-pruefen">Wie lange halten LED-Lampen? →</a>']
  ];
  function select(i) {
    btns.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.textContent = DATA[i][0]; note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0);
  // Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.heat-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.textContent = d[0]; note.innerHTML = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var heatT; window.addEventListener('resize', function () { clearTimeout(heatT); heatT = setTimeout(lock, 150); });
})();

/* --- Energielabel-Erklärer „Welchen Teil des Labels verstehen?“ (Artikel energieeffizienzklassen-led) ---
   Label-Bereich -> Bedeutung. Rein erklärend, KEINE erfundenen Werte; belegte EU-Angaben mit Stand-Hinweis
   (Label A–G seit 1.9.2021, A++/A+ abgeschafft, QR-Code -> EPREL). Ohne JS bleibt das vorbefüllte
   Standardergebnis (#enl-val/#enl-note) als Fallback sichtbar; im body.html ersetzt eine statische
   Bereich->Bedeutung-Liste das Modul. Buttons = echte <button>-Elemente (tastaturbedienbar), Ergebnis in
   aria-live="polite". Gleiche Button->Ergebnis-Optik wie Wärme-/Vollspektrum-/Pflanzenlicht-/Flacker-/Sockel-
   Finder (.calc-module/.apart-btn/.ip-code/.finder-note). */
(function () {
  'use strict';
  var box = document.getElementById('enl-finder');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.enl-btn'));
  var val = document.getElementById('enl-val'), note = document.getElementById('enl-note');
  if (!btns.length || !val || !note) return;
  // Reihenfolge identisch zu den Buttons in preview.html.
  // [Ergebnis-Kennzahl (Label-Bereich), Hinweis-HTML — nur belegte EU-Angaben, keine erfundenen Werte]
  var DATA = [
    ['Effizienzklasse (Pfeil A–G)',
     'Die farbige Skala von Grün (A) bis Rot (G) mit dem Pfeil zeigt, wie effizient die Lampe ist — nach der seit 2021 strengeren Messung. A ist bewusst sehr streng angesetzt, sehr gute LED stehen heute oft bei D–F. Eine niedrigere Klasse ist deshalb kein Qualitätsmangel.'],
    ['Energieverbrauch (kWh/1000 h)',
     'Der gewichtete Stromverbrauch über 1000 Betriebsstunden. Dieser Wert macht zwei Lampen direkt in Kilowattstunden vergleichbar und ist oft aussagekräftiger als die Klasse allein.'],
    ['QR-Code',
     'Jedes neue Label trägt einen QR-Code. Er führt in die EU-Datenbank EPREL mit den offiziellen Produktdaten zum Energielabel — mit dem Smartphone scannen, um Angaben nachzuschlagen und Produkte zu vergleichen.'],
    ['Lichtquellen-Piktogramm / Modell',
     'Ein Symbol weist das Produkt als Lichtquelle aus; Hersteller- und Modellbezeichnung ordnen das Label eindeutig dem Produkt zu.'],
    ['Alte Klassen (A++, A+)',
     'Die alten Klassen mit Plus sind seit dem 1. September 2021 abgeschafft und nicht mit dem neuen A–G vergleichbar. Ein früheres „A++“ lässt sich nicht 1:1 in eine neue Klasse umrechnen — maßgeblich ist das aktuelle Label des Produkts.']
  ];
  function select(i) {
    btns.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.textContent = DATA[i][0]; note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0);
  // Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.enl-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.textContent = d[0]; note.innerHTML = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var enlT; window.addEventListener('resize', function () { clearTimeout(enlT); enlT = setTimeout(lock, 150); });
})();

/* --- Watt-Check „Passt diese LED in meine Leuchte?“ (Artikel kann-man-eine-led-mit-hoeheren-wattzahl) ---
   ZWEI Schieberegler (bewusst KEIN Klick-Finder — Variation): 1) gewünschte Helligkeit als
   Glühlampen-Äquivalent (25/40/60/75/100 W → EU-Lichtstrom), 2) max. Watt der Leuchte/Fassung.
   Ergebnis = reale LED-Leistungsaufnahme (Bereich) vs. Leuchten-Limit → grün/amber/rot.
   DATENEHRLICH: Lumen aus EU-Äquivalenz (VO 244/2009, identisch zur WL-Tabelle oben, LED-Ersatz-
   Spalte); reale Aufnahme = Lumen ÷ Wirkungsgrad mit heutigem Bereich 90–120 lm/W → bewusst ein
   BEREICH, kein erfundener Festwert. Kernbotschaft: fürs Leuchten-Limit zählt die reale Aufnahme,
   nicht die Glühlampen-Vergleichszahl. Ohne JS bleibt der vorbefüllte Verdikt-Text als Fallback;
   im body.html ersetzt eine statische Beispiel-Liste das Modul. ID-gekoppelt, sonst No-op. */
(function () {
  'use strict';
  var box = document.getElementById('wc-check');
  if (!box) return;
  var equiv = document.getElementById('wc-equiv');
  var fixture = document.getElementById('wc-fixture');
  var equivOut = document.getElementById('wc-equiv-out');
  var fixtureOut = document.getElementById('wc-fixture-out');
  var lumenOut = document.getElementById('wc-lumen');
  var drawOut = document.getElementById('wc-draw');
  var verdict = document.getElementById('wc-verdict');
  if (!equiv || !fixture || !equivOut || !fixtureOut || !lumenOut || !drawOut || !verdict) return;
  var fmt = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  // [Glühlampen-Watt, LED-Ersatz-Lichtstrom in lm] — EU VO 244/2009 (= WL-Tabelle, LED-min-Spalte).
  var EQ = [[25, 249], [40, 470], [60, 806], [75, 1055], [100, 1521]];
  var EFF_HI = 120, EFF_LO = 90; // heutiger LED-Wirkungsgrad-Bereich (effizient → typisch) in lm/W
  function calc(idx, max) {
    var row = EQ[idx] || EQ[2];
    var lm = row[1];
    var drawLo = Math.round(lm / EFF_HI); // effiziente LED (120 lm/W) = wenig Watt; runden → deckt sich mit der Orientierungstabelle (z. B. 25 W → ~2 W statt ceil 3)
    var drawHi = Math.ceil(lm / EFF_LO);  // typische LED (90 lm/W) = etwas mehr Watt; aufrunden (Obergrenze)
    var draws = '~' + drawLo + '–' + drawHi + ' W';
    var cls, html;
    if (drawHi <= max) {
      cls = 'is-ok';
      html = '<strong>Passt problemlos.</strong> Ein „' + row[0] + '-W-Ersatz“ leuchtet so hell wie eine ' +
        row[0] + '-W-Glühlampe (~' + fmt.format(lm) + ' lm), zieht real aber nur etwa ' + drawLo + '–' + drawHi +
        ' W — deutlich unter den erlaubten ' + max + ' W. Mit LED kommen Sie kaum je an das Watt-Limit Ihrer Leuchte.';
    } else if (drawLo <= max) {
      cls = 'is-warn';
      html = '<strong>Im Grenzbereich.</strong> Die reale Leistungsaufnahme (' + draws + ') liegt nahe an den ' +
        'erlaubten ' + max + ' W. Bei LED ist das meist unkritisch (wenig Abwärme) — beachten Sie aber die ' +
        'Herstellerangabe der Leuchte, vor allem in geschlossenen Leuchten.';
    } else {
      cls = 'is-stop';
      html = '<strong>Genauer hinsehen.</strong> Schon die reale LED-Aufnahme (' + draws + ') übersteigt die ' +
        'zugelassenen ' + max + ' W. So niedrig limitierte Leuchten sind selten — prüfen Sie die Herstellerangabe ' +
        'und wählen Sie im Zweifel eine lichtschwächere LED oder eine Leuchte mit höherem Limit.';
    }
    return { gw: row[0], lm: lm, drawLo: drawLo, drawHi: drawHi, cls: cls, html: html };
  }
  function render() {
    var idx = parseInt(equiv.value, 10);
    var max = parseFloat(fixture.value);
    var r = calc(idx, max);
    equivOut.textContent = r.gw + ' W';
    fixtureOut.textContent = max + ' W';
    lumenOut.textContent = '~' + fmt.format(r.lm) + ' lm';
    drawOut.textContent = '~' + r.drawLo + '–' + r.drawHi + ' W';
    equiv.setAttribute('aria-valuetext', 'Helligkeit wie ' + r.gw + ' Watt Glühlampe, etwa ' + r.lm + ' Lumen');
    fixture.setAttribute('aria-valuetext', 'Leuchte erlaubt maximal ' + max + ' Watt');
    verdict.className = 'calc-result wc-verdict ' + r.cls;
    verdict.innerHTML = r.html;
  }
  [equiv, fixture].forEach(function (el) {
    el.addEventListener('input', render);
    el.addEventListener('change', render);
  });
  render();
  // Höhen-Lock: Verdikt-Box auf den längstmöglichen Inhalt fixieren -> kein Springen beim Schieben.
  function lock() {
    var savedCls = verdict.className, savedHtml = verdict.innerHTML, max = 0;
    verdict.style.minHeight = '';
    for (var i = 0; i < EQ.length; i++) {
      [10, 40, 100].forEach(function (fx) {
        var r = calc(i, fx);
        verdict.className = 'calc-result wc-verdict ' + r.cls;
        verdict.innerHTML = r.html;
        if (verdict.offsetHeight > max) max = verdict.offsetHeight;
      });
    }
    verdict.className = savedCls;
    verdict.innerHTML = savedHtml;
    verdict.style.minHeight = max + 'px';
  }
  lock();
  var wcT; window.addEventListener('resize', function () { clearTimeout(wcT); wcT = setTimeout(lock, 150); });
})();

/* --- Niedervolt-System-Klickgrafik „Worauf kommt es beim 12-V-Wechsel an?“ (Artikel wechsel-osram-halostar-g4-gy635) ---
   Variation = KLICK-GRAFIK (kein Slider/Standard-Finder): ein SVG-Diagramm Trafo → Sockel → Lampe mit drei
   anklickbaren Hotspots (.nv-hot, role=button, tastaturbedienbar). Klick/Enter/Space → Erklärung in #nv-val/#nv-note
   (aria-live). DATENEHRLICH: Sockel-Maße G4=4 mm / GY6.35=6,35 mm (IEC), 12 V vs. G9=230 V; Trafo-Mindestlast nur
   qualitativ + „laut Datenblatt/Herstellerangabe“; belegte Osram-Halostar-Lumen (10 W≈145 / 14 W≈230 / 20 W≈375 lm),
   35/50 W bewusst als Datenlücke. Ohne JS bleibt das vorbefüllte Standardergebnis als Fallback; im body.html ersetzt
   eine statische Liste das Modul. ID-gekoppelt, sonst No-op. */
(function () {
  'use strict';
  var box = document.getElementById('nv-system');
  if (!box) return;
  var hots = [].slice.call(box.querySelectorAll('.nv-hot'));
  var val = document.getElementById('nv-val'), note = document.getElementById('nv-note');
  if (!hots.length || !val || !note) return;
  // Reihenfolge identisch zu den Hotspots im SVG (preview.html).
  // [Ergebnis-Überschrift, Hinweis-HTML inkl. interner Links (data-todo)]
  var DATA = [
    ['Trafo / Konverter (12 V)',
     'G4 und GY6.35 laufen mit 12 V — die Spannung liefert ein Trafo (Konverter). <strong>Häufigster Stolperstein:</strong> Viele <em>elektronische</em> Trafos haben eine Mindestlast. Eine sparsame LED zieht oft zu wenig, um sie zu erreichen → die Lampe flackert oder der Trafo brummt. Lösungen: ein <strong>LED-geeigneter Konverter</strong> (ohne/mit geringer Mindestlast), übergangsweise <strong>Mischbetrieb</strong> aus Halogen und LED, oder prüfen, ob der vorhandene Trafo die geringe Last verträgt. <em>Magnetische</em> (konventionelle) Trafos haben in der Regel keine Mindestlast. Welche Mindestlast gilt, steht im Datenblatt des Trafos — im Zweifel eine Elektrofachkraft fragen. <a href="/blogs/ratgeber/warum-flackern-led" class="sock-link" data-todo="link-pruefen">Warum flackern LED? →</a>'],
    ['Stiftsockel — G4 oder GY6.35?',
     'Beide sind 12-V-Stiftsockel mit zwei Pins — der Unterschied ist der <strong>Pin-Abstand</strong>: <strong>G4 = 4 mm</strong>, <strong>GY6.35 = 6,35 mm</strong> (daher der Name). Die LED muss denselben Sockel haben wie die alte Halogenlampe. <strong>Nicht mit G9 verwechseln:</strong> G9 sieht ähnlich aus, läuft aber mit <strong>230 V</strong> direkt am Netz (kein Trafo) — eine 12-V-Lampe gehört nicht in eine 230-V-Fassung und umgekehrt. Details im Sockel-Ratgeber. <a href="/blogs/ratgeber/lampensockel-uebersicht" class="sock-link" data-todo="link-pruefen">Lampensockel-Übersicht →</a>'],
    ['LED-Lampe — Helligkeit &amp; Lichtfarbe',
     'Wählen Sie die LED nach <strong>Lumen</strong>, nicht nach Watt. Orientierung laut Osram-Halostar-Datenblatt: 10 W ≈ 145 lm, 14 W ≈ 230 lm, 20 W ≈ 375 lm — je nach Helligkeit zieht eine passende LED dafür real nur etwa 1–4 W. Für stärkere Halogenlampen (z. B. 35/50 W) den Lumenwert auf der alten Packung bzw. im Datenblatt ablesen (kein pauschaler Wert). Für gewohntes Licht eine <strong>warmweiße</strong> LED (~2700 K) wie die Halogenlampe; soll gedimmt werden, eine ausdrücklich dimmbare LED plus passenden Dimmer/Trafo. <a href="/blogs/ratgeber/umrechnung-watt-lumen" class="sock-link" data-todo="link-pruefen">Watt in Lumen umrechnen →</a> <a href="/collections/g4-led-leuchtmittel" class="sock-link" data-todo="link-pruefen">G4-LED ansehen →</a>']
  ];
  function select(i) {
    hots.forEach(function (h, j) { h.classList.toggle('is-on', j === i); h.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    val.innerHTML = DATA[i][0]; note.innerHTML = DATA[i][1];
  }
  hots.forEach(function (h, i) {
    h.addEventListener('click', function () { select(i); });
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); select(i); }
    });
  });
  select(0);
  // Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.nv-result');
  function lock() {
    if (!result) return;
    var v = val.innerHTML, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { val.innerHTML = d[0]; note.innerHTML = d[1]; if (result.offsetHeight > max) max = result.offsetHeight; });
    val.innerHTML = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var nvT; window.addEventListener('resize', function () { clearTimeout(nvT); nvT = setTimeout(lock, 150); });
})();


/* ============================================================
   WECHSEL-SERIE 2026-06-18 — 5 neue Module (folder-lokal gebaut, hier integriert):
   g9toggle (Halopin G9 Umschalter) · r7slen (Haloline R7s Slider) ·
   nvload (Decostar GU4/GU5.3 Rechner) · vgpath (PL-L 2G11 Klick-Finder) ·
   g23parts (PL-S G23 Klick-Grafik). Jede ID-gekoppelt + No-op sonst.
   ============================================================ */
/* --- Spannungs-Umschalter „230 Volt oder 12 Volt? G9 ist nicht G4.“ (Artikel wechsel-osram-halopin-g9) ---
   Variation = UMSCHALTER/TOGGLE (kein Slider/Klick-Grafik): zwei echte <button>-Umschalter
   [G9 · 230 V] und [G4/GY6.35 · 12 V]. Klick/Enter/Space schaltet den Zustand und schreibt die
   Erklärung in #g9t-val/#g9t-note (aria-live). DATENEHRLICH: nur Sockel-/Spannungsfakten + Routing,
   KEINE erfundenen Zahlen. G9 = Bi-Pin, ~9 mm Stiftabstand, 230 V direkt am Netz (kein Trafo, das ist
   die Halopin → dieser Ratgeber). G4/GY6.35 = 12 V Niedervolt, braucht Trafo → Halostar-Ratgeber.
   Default = G9-Zustand (= statischer Fallback ohne JS). Ohne JS bleibt der vorbefüllte G9-Text als
   Fallback; im body.html ersetzt eine statische Tabelle das Modul. ID-gekoppelt, sonst No-op.
   Muster wie nv-system / enl-finder: select(i)/aria-pressed + Höhen-Lock auf die Ergebnisbox. */
(function () {
  'use strict';
  var box = document.getElementById('g9toggle');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.g9t-btn'));
  var val = document.getElementById('g9t-val'), note = document.getElementById('g9t-note');
  if (!btns.length || !val || !note) return;
  // Reihenfolge identisch zu den Buttons in preview.html.
  // [Ergebnis-Überschrift, Hinweis-HTML inkl. interner Links (data-todo)]
  var DATA = [
    ['G9 · 230 Volt — das ist die Halopin',
     'Ein <strong>G9</strong>-Sockel hat zwei flache Drahtbügel (Bi-Pin) mit rund <strong>9 mm</strong> Abstand und läuft mit <strong>230 Volt direkt am Netz</strong> — <strong>ohne Trafo</strong>. Genau das ist die Osram <strong>Halopin</strong>: Sie tauschen sie 1:1 gegen eine G9-LED, deren Treiber bereits eingebaut ist. <strong>Das ist Ihr Fall — lesen Sie hier weiter.</strong> Achten Sie nur auf den Sockel (G9), die Bauform/den Platz und die Helligkeit (Lumen). Steht auf der Lampe oder Leuchte dagegen „12 V“, ist es eine Niedervolt-Lampe — dann den anderen Zustand wählen.'],
    ['G4 / GY6.35 · 12 Volt — das ist die Halostar',
     'Ein <strong>G4</strong>- oder <strong>GY6.35</strong>-Sockel sieht ähnlich aus, läuft aber mit <strong>12 Volt</strong> (Niedervolt) und hängt an einem <strong>Trafo</strong> (Konverter). Das ist <strong>nicht</strong> die Halopin, sondern die Osram <strong>Halostar</strong> — und beim LED-Wechsel zählt dort vor allem der Trafo (Mindestlast). Eine 12-V-Lampe gehört nie in eine 230-V-Fassung und umgekehrt. Den passenden Wechsel beschreibt der eigene Ratgeber. <a href="/blogs/ratgeber/wechsel-osram-halostar-g4-gy635" class="sock-link" data-todo="link-pruefen">Osram Halostar G4/GY6.35 auf LED wechseln →</a>']
  ];
  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.innerHTML = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) {
    b.addEventListener('click', function () { select(i); });
  });
  select(0); // Default = G9 · 230 V (statischer Fallback)
  // Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Umschalten.
  var result = box.querySelector('.g9t-result');
  function lock() {
    if (!result) return;
    var v = val.innerHTML, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.innerHTML = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.innerHTML = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var g9tT; window.addEventListener('resize', function () { clearTimeout(g9tT); g9tT = setTimeout(lock, 150); });
})();
/* --- R7s-Längen-Finder „Welche LED-R7s-Länge brauche ich?“ (Artikel wechsel-osram-haloline-r7s) ---
   Variation = EIN range-Slider über die drei R7s-Standardlängen 78 / 118 / 189 mm (Schritte 0/1/2,
   Default 118 mm = häufigste). Ausgabe: gewählte Länge + typische Leuchte + die Regel, dass die LED-R7s
   exakt dieselbe Länge wie die alte Lampe bzw. die Fassung haben muss (Kontakte sind längenabhängig).
   DATENEHRLICH: nur Geometrie + Einsatz-Hinweis, KEINE erfundenen Watt/Lumen je Länge. aria-valuetext +
   Höhen-Lock auf die Ergebnisbox. Ohne JS bleibt das vorbefüllte Ergebnis (Default 118 mm) als Fallback;
   im body.html ersetzt eine statische Längen-Tabelle das Modul. ID-gekoppelt, sonst No-op.
   (Als Theme-Snippet/Section-Asset zu übernehmen — kein externes Skript, rein clientseitig.) */
(function () {
  'use strict';
  var box = document.getElementById('r7slen');
  if (!box) return;
  var slider = document.getElementById('r7slen-range');
  if (!slider) return;
  var lenOut = document.getElementById('r7slen-len');
  var fixtureOut = document.getElementById('r7slen-fixture');
  var note = document.getElementById('r7slen-note');
  var result = document.getElementById('r7slen-result');
  if (!lenOut || !fixtureOut || !note || !result) return;

  // Index 0/1/2 -> [Länge mm, typische Leuchte/Einsatz, Ergänzungshinweis] — nur Geometrie + Einsatz,
  // bewusst OHNE Watt/Lumen (die hängen am konkreten Produkt -> Datenblatt/Packung).
  var LEN = [
    ['78 mm',
     'Kürzere R7s-Lampe — oft in kompakten Wand- und Deckenstrahlern, kleinen Außen- und Sicherheitsstrahlern sowie in flachen Einbau- und Möbelleuchten.',
     'Es gibt LED-R7s in genau dieser Länge. Wichtig: Die LED muss die <strong>78 mm exakt treffen</strong> — eine längere Lampe passt nicht zwischen die Kontakte, eine kürzere bekommt keinen Halt.'],
    ['118 mm',
     'Häufigste R7s-Länge — typisch für Decken- und Stehfluter („Halogenfluter“), Halogen- und Baustrahler sowie viele Außenstrahler.',
     'Die meisten LED-R7s gibt es in dieser Länge. Sehr starke 118-mm-Halogenstäbe (frühere Fluter) haben einen hohen Lichtstrom — prüfen Sie den <strong>Lumenwert der LED im Datenblatt</strong>, ob er die alte Helligkeit erreicht.'],
    ['189 mm',
     'Lange R7s-Lampe — vor allem in großen Decken- und Standflutern sowie in größeren Strahlern mit entsprechend langer Fassung.',
     'Auch in 189 mm erhältlich, aber seltener im Sortiment als 78 und 118 mm. Auch hier gilt: <strong>exakt diese Länge</strong> wählen, sonst passt die Lampe nicht in die Fassung.']
  ];

  function render() {
    var i = parseInt(slider.value, 10);
    if (isNaN(i) || i < 0 || i > 2) i = 1;
    var row = LEN[i];
    lenOut.textContent = row[0];
    fixtureOut.textContent = row[1];
    note.innerHTML = row[2];
    slider.setAttribute('aria-valuetext',
      'R7s-Länge ' + row[0] + ' — ' + row[1] + ' Die LED-R7s muss genau diese Länge haben.');
  }
  slider.addEventListener('input', render);
  slider.addEventListener('change', render);
  render();

  // Höhen-Lock: Ergebnisbox auf den längstmöglichen Inhalt fixieren -> kein Springen beim Schieben.
  function lock() {
    var savedLen = lenOut.textContent, savedFix = fixtureOut.textContent, savedNote = note.innerHTML, max = 0;
    result.style.minHeight = '';
    for (var i = 0; i < LEN.length; i++) {
      lenOut.textContent = LEN[i][0];
      fixtureOut.textContent = LEN[i][1];
      note.innerHTML = LEN[i][2];
      if (result.offsetHeight > max) max = result.offsetHeight;
    }
    lenOut.textContent = savedLen;
    fixtureOut.textContent = savedFix;
    note.innerHTML = savedNote;
    result.style.minHeight = max + 'px';
  }
  lock();
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(lock, 150); });
})();
/* --- Niedervolt-Spot-Rechner „Macht der Trafo mit?“ (Artikel wechsel-osram-decostar-gu4-gu53) ---
   FORM = RECHNER/CALCULATOR. Zwei Eingaben:
     (a) Halogen-Watt je Spot — Slider ueber die drei Decostar-Stufen 20 / 35 / 50 W (Schritte 0/1/2),
     (b) Anzahl Spots am SELBEN Trafo — Slider 1..10.
   Ausgabe:
     - alte Gesamtlast = Anzahl x Watt  -> FAKTISCHE Rechnung (belegt, reine Arithmetik),
     - neue LED-Gesamtlast ~ Anzahl x (qualitativer Bereich ~3-6 W, „laut Datenblatt“) -> als Spanne,
     - Verdikt QUALITATIV: je weniger Spots und je sparsamer die LED, desto eher wird eine
       Trafo-Mindestlast unterschritten -> eher LED-Konverter noetig. KEINE erfundene Mindestlast-Zahl.
   Hoehen-Lock auf die Ergebnisbox (kein Springen beim Schieben). ID-gekoppelt (#nvload), sonst No-op.
   Rein clientseitig, kein externes Skript — in Shopify spaeter als Theme-Section/Snippet zu uebernehmen.
   DATENEHRLICH: 20/35/50 W = belegte Decostar-Wattstufen; LED-Bereich ~3-6 W ist Orientierung „laut
   Datenblatt“; die Mindestlast des Trafos wird NICHT beziffert (steht im Trafo-Datenblatt). */
(function () {
  'use strict';
  var box = document.getElementById('nvload');
  if (!box) return;
  var wattRange = document.getElementById('nv-watt');
  var qtyRange = document.getElementById('nv-qty');
  var wattOut = document.getElementById('nv-watt-o');
  var qtyOut = document.getElementById('nv-qty-o');
  var oldOut = document.getElementById('nv-old');
  var ledOut = document.getElementById('nv-led');
  var verdictOut = document.getElementById('nv-verdict');
  var result = document.getElementById('nv-result');
  if (!wattRange || !qtyRange || !oldOut || !ledOut || !verdictOut || !result) return;

  var fmt = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  // Slider-Index 0/1/2 -> belegte Decostar-Halogen-Wattstufe
  var WATT = [20, 35, 50];
  // LED-Orientierungsbereich je Spot in Watt (qualitativ, „laut Datenblatt“) — bewusst eine Spanne,
  // KEINE Festwerte je Wattstufe. Eine 20-W- bis 50-W-Halogen wird typ. durch eine LED im einstelligen
  // Wattbereich ersetzt; maßgeblich bleibt das Produkt-Datenblatt.
  var LED_LO = 3, LED_HI = 6;

  function wattFor() {
    var i = parseInt(wattRange.value, 10);
    if (isNaN(i) || i < 0 || i > 2) i = 1;
    return WATT[i];
  }
  function qtyFor() {
    var n = parseInt(qtyRange.value, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > 10) n = 10;
    return n;
  }

  // Qualitatives Verdikt: Risiko, die Trafo-Mindestlast zu unterschreiten, steigt, je kleiner die neue
  // LED-Gesamtlast ist (wenige Spots, sparsame LED). KEINE Zahlenschwelle — die steht im Trafo-Datenblatt.
  function verdict(n, ledTotalHi) {
    if (ledTotalHi <= 12) {
      return '<strong>Mindestlast genau prüfen.</strong> Die neue LED-Gesamtlast ist sehr klein. ' +
        'Je weniger Spots und je sparsamer die LED, desto eher wird eine Trafo-Mindestlast ' +
        'unterschritten &mdash; dann flackert oder brummt es. Hier ist ein <strong>LED-geeigneter ' +
        'Konverter</strong> am wahrscheinlichsten nötig. Die Mindestlast steht im Datenblatt des Trafos.';
    }
    if (ledTotalHi <= 24) {
      return '<strong>Mindestlast im Blick behalten.</strong> Ob die neue LED-Gesamtlast die Mindestlast ' +
        'Ihres Trafos erreicht, hängt vom konkreten Trafo ab &mdash; die Schwelle steht in dessen ' +
        'Datenblatt. Bei elektronischen Trafos hilft im Zweifel ein <strong>LED-geeigneter Konverter</strong>; ' +
        'magnetische Trafos sind meist unkritisch.';
    }
    return '<strong>Eher unkritisch &mdash; aber Datenblatt entscheidet.</strong> Mit mehreren Spots ' +
      'kommt einiges an LED-Gesamtlast zusammen, sodass eine Trafo-Mindestlast eher erreicht wird. ' +
      'Sicher ist das erst, wenn die LED-Gesamtlast die im <strong>Trafo-Datenblatt</strong> genannte ' +
      'Mindestlast erreicht. Bleibt es beim Flackern, hilft ein LED-geeigneter Konverter.';
  }

  function render() {
    var w = wattFor();
    var n = qtyFor();
    var oldTotal = n * w;            // faktische Rechnung
    var ledLo = n * LED_LO;
    var ledHi = n * LED_HI;
    if (wattOut) wattOut.textContent = fmt.format(w) + ' W';
    if (qtyOut) qtyOut.textContent = (n === 1) ? '1 Spot' : (fmt.format(n) + ' Spots');
    oldOut.textContent = fmt.format(oldTotal) + ' W';
    ledOut.textContent = '~ ' + fmt.format(ledLo) + '–' + fmt.format(ledHi) + ' W';
    verdictOut.innerHTML = verdict(n, ledHi);
    wattRange.setAttribute('aria-valuetext', w + ' Watt je Spot');
    qtyRange.setAttribute('aria-valuetext', n + (n === 1 ? ' Spot' : ' Spots') + ' am selben Trafo');
  }
  wattRange.addEventListener('input', render);
  wattRange.addEventListener('change', render);
  qtyRange.addEventListener('input', render);
  qtyRange.addEventListener('change', render);
  render();

  // Hoehen-Lock: Ergebnisbox auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Schieben.
  // Wir messen alle drei Verdikt-Varianten (das laengste Verdikt bestimmt die Hoehe).
  function lock() {
    var savedOld = oldOut.textContent, savedLed = ledOut.textContent, savedV = verdictOut.innerHTML, max = 0;
    result.style.minHeight = '';
    var samples = [verdict(1, 6), verdict(3, 18), verdict(8, 48)];
    for (var i = 0; i < samples.length; i++) {
      verdictOut.innerHTML = samples[i];
      if (result.offsetHeight > max) max = result.offsetHeight;
    }
    oldOut.textContent = savedOld;
    ledOut.textContent = savedLed;
    verdictOut.innerHTML = savedV;
    result.style.minHeight = max + 'px';
  }
  lock();
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(lock, 150); });
})();
/* ============================================================
   LMM Ratgeber-Modul — „Umrüst-Weg-Finder 2G11“ (id=vgpath)
   Artikel: wechsel-pl-l-2g11

   Eigenständiger Klick-Finder NUR für diesen Ratgeber (nicht in
   shared/ratgeber-modules.js, damit die geteilte Datei unberührt bleibt).
   Im Shopify-Theme später als Section-Asset/Snippet übernehmen.

   Muster identisch zum Flacker-/Halogen-Finder: echte <button>-Elemente
   (tastaturbedienbar), select(i) schaltet aria-pressed, Ergebnis in
   aria-live="polite", Höhen-Lock gegen Springen. Default = erster Button
   (= statischer Fallback ohne JS). No-op, wenn #vgpath fehlt.

   DATENEHRLICH (KLL/Betriebsgerät — höchste Vorsicht): KEINE pauschale
   Kompatibilität, KEINE erfundenen Schwellen. Der EVG-Weg gilt nur mit
   herstellerseitiger Freigabe (Kompatibilitätsliste/Datenblatt); KVG/VVG
   führen i. d. R. über Umverdrahtung auf 230 V durch eine Elektrofachkraft.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('vgpath');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.vgpath-btn'));
  var val = document.getElementById('vgpath-val');
  var note = document.getElementById('vgpath-note');
  if (!btns.length || !val || !note) return;

  // Reihenfolge identisch zu den Buttons in preview.html.
  // [Ergebnis-Kennzahl, Hinweis-HTML inkl. internem Link (data-todo)]
  var DATA = [
    ['Konventionell (KVG/VVG) → meist Umverdrahtung auf 230 V',
     'Mit separatem Starter im Stromkreis läuft die Lampe über ein konventionelles bzw. verlustarmes Vorschaltgerät (KVG/VVG). Hier ist meist eine <strong>Konversions-LED</strong> nötig: Das Vorschaltgerät wird überbrückt und die Lampe läuft direkt an 230 V; der Starter entfällt dann. Diese <strong>Neuverdrahtung gehört in die Hand einer Elektrofachkraft</strong>. Welche LED dafür freigegeben ist, steht im Datenblatt. <a href="/collections/2g11-led-leuchtmittel" class="sock-link">2G11-LED ansehen →</a>'],
    ['Elektronisch (EVG) → ggf. Plug-and-Play, nur mit Freigabe',
     'Ohne separaten Starter steckt meist ein elektronisches Vorschaltgerät (EVG) dahinter. Dann kommt eventuell eine <strong>EVG-kompatible Plug-and-Play-LED</strong> infrage, die am vorhandenen Vorschaltgerät läuft — <strong>aber nur, wenn die LED für genau diesen VG-Typ herstellerseitig freigegeben ist</strong> (Kompatibilitätsliste/Datenblatt). Das ist nicht universell; ohne Freigabe nicht darauf verlassen. <a href="/collections/2g11-led-leuchtmittel" class="sock-link">2G11-LED ansehen →</a>'],
    ['Unsicher → so erkennen Sie den VG-Typ',
     'Schauen Sie nach einem <strong>separaten Starter</strong> im Stromkreis und auf den <strong>Aufdruck am Vorschaltgerät</strong> („KVG“, „VVG“ oder „EVG“). Starter vorhanden bzw. Aufdruck KVG/VVG → konventionell. Kein Starter bzw. Aufdruck EVG → elektronisch. Im Zweifel hilft das <strong>Datenblatt der Leuchte</strong> oder eine <strong>Elektrofachkraft</strong> — und das entscheidet, welcher Umrüst-Weg passt. <a href="/blogs/ratgeber/leuchtstoffroehren-durch-led-roehren-ersetzen" class="sock-link" data-todo="link-pruefen">VG-Typ erkennen (Röhren-Ratgeber) →</a>']
  ];

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.textContent = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0); // Default = erster Button (= statischer Fallback)

  // Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.vgpath-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.textContent = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var vgT;
  window.addEventListener('resize', function () { clearTimeout(vgT); vgT = setTimeout(lock, 150); });
})();
/* ============================================================
   LMM Ratgeber-Modul — Klick-Grafik „Die G23-Lampe von innen“ (id=g23parts)
   Artikel: wechsel-pl-s-g23

   Eigenstaendige Klick-Grafik NUR fuer diesen Ratgeber (nicht in
   shared/ratgeber-modules.js, damit die geteilte Datei unberuehrt bleibt).
   Im Shopify-Theme spaeter als Section-Asset/Snippet uebernehmen.

   Form = KLICK-GRAFIK (analog nv-system im Halostar-Ratgeber): ein SVG der
   PL-S-Lampe mit drei anklickbaren Hotspots (.nv-hot, role=button,
   tabindex=0, tastaturbedienbar). Klick/Enter/Space -> select(i) schaltet
   aria-pressed + .is-on und schreibt Ueberschrift/Erklaerung in
   #g23parts-val / #g23parts-note (aria-live="polite"). Default = Hotspot 1
   (= statischer Fallback ohne JS). Hoehen-Lock gegen Springen der
   Ergebnisbox. No-op, wenn #g23parts fehlt.

   DATENEHRLICH (KLL/Betriebsgeraet — hoechste Vorsicht): Sockel-/Starter-
   Fakten sind belegt (G23 = 2 Pins, 23 mm Stiftabstand, IEC 60061-1;
   Starter im Sockelfuss integriert; PL-S laeuft typischerweise am KVG).
   KOMPATIBILITAET BLEIBT QUALITATIV: keine pauschale Plug-and-play-Zusage,
   keine erfundenen Schwellen — „laut Herstellerangaben/Datenblatt; im
   Zweifel Elektrofachkraft“.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('g23parts');
  if (!box) return;
  var hots = [].slice.call(box.querySelectorAll('.nv-hot'));
  var val = document.getElementById('g23parts-val');
  var note = document.getElementById('g23parts-note');
  if (!hots.length || !val || !note) return;

  // Reihenfolge identisch zu den Hotspots im SVG (preview.html):
  // 0 = G23-Sockel (2 Pins) · 1 = integrierter Starter · 2 = Vorschaltgeraet in der Leuchte (typ. KVG)
  // [Ergebnis-Ueberschrift (HTML erlaubt), Hinweis-HTML inkl. interner Links mit data-todo]
  var DATA = [
    ['G23-Sockel — zwei Pins',
     'G23 ist ein <strong>Stecksockel mit zwei Pins</strong>; der Pin-Abstand beträgt <strong>23 mm</strong> (genormt nach IEC&nbsp;60061-1) — daher der Name. Dieselbe Bauform tragen die Handelsbezeichnungen <strong>PL-S</strong> (Philips) und <strong>Dulux&nbsp;S</strong> (Osram). Eine G23-LED muss exakt diesen Sockel haben wie die alte Lampe. <strong>Nicht mit der 4-Pin-PL-L (2G11) verwechseln</strong> — das ist eine andere Bauform. Wo welcher Sockel sitzt, zeigt die Sockel-Übersicht. <a href="/blogs/ratgeber/lampensockel-uebersicht" class="sock-link" data-todo="link-pruefen">Lampensockel-Übersicht &#8594;</a>'],
    ['Integrierter Starter — der 2-Pin-Grund',
     'Bei der G23-Lampe sitzt der <strong>Starter im Sockelfuß</strong> (im Kunststoffblock zwischen den Pins) — er ist <strong>in die Lampe integriert</strong> und wird beim Lampentausch automatisch mit ersetzt. Genau deshalb hat die PL-S nur <strong>zwei Pins</strong>. Das ist der Kern-Unterschied zur <strong>4-Pin-PL-L (2G11)</strong>, die <em>keinen</em> integrierten Starter hat. Für den LED-Wechsel heißt das: Anders als bei der T8-Röhre brauchen Sie hier <strong>keinen Dummy-Starter</strong> — der alte Starter geht mit der alten Lampe.'],
    ['Vorschaltgerät in der Leuchte — meist KVG',
     'Die G23-Lampe läuft <strong>nicht direkt am Netz</strong>, sondern über ein <strong>Vorschaltgerät</strong> in der Leuchte — bei PL-S typischerweise ein <strong>konventionelles (KVG)</strong>. Dieses Gerät bestimmt den Umrüst-Weg. Es gibt G23-Retrofit-LEDs, die <strong>am vorhandenen KVG/VVG</strong> laufen (z.&nbsp;B. die als „EM &amp; AC MAINS“ gekennzeichneten Typen) — <strong>aber nur, wenn die LED für diesen Betrieb herstellerseitig freigegeben ist</strong> (Datenblatt). Alternativ wird das Vorschaltgerät überbrückt, die Lampe läuft dann an 230&nbsp;V — dieser Eingriff gehört in die Hand einer <strong>Elektrofachkraft</strong>. <a href="/collections/g23-led-leuchtmittel" class="sock-link">G23-LED ansehen &#8594;</a>']
  ];

  function select(i) {
    hots.forEach(function (h, j) {
      h.classList.toggle('is-on', j === i);
      h.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.innerHTML = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  hots.forEach(function (h, i) {
    h.addEventListener('click', function () { select(i); });
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); select(i); }
    });
  });
  select(0); // Default = Hotspot 1 (= statischer Fallback ohne JS)

  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.nv-result');
  function lock() {
    if (!result) return;
    var v = val.innerHTML, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.innerHTML = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.innerHTML = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(lock, 150); });
})();


/* ============================================================
   LEVERAGE-BLOCK 2026-06-18 — 5 neue Module (folder-lokal gebaut, hier integriert):
   lumzahl (Lumen-Zahl Slider) · erslampe (Welche-Ersatz Klick-Finder) ·
   wechselsockel (LED wechseln Klick-Grafik) · aqualight (Aquarium Umschalter) ·
   garlife (Garantie/Lebensdauer Rechner). Jede ID-gekoppelt + No-op sonst.
   ============================================================ */
/* --- Lumen-Zahl-Slider (Artikel was-sagt-mir-die-lumen-zahl-bei-einer-led-genau) ---
   FORM: ein range-Slider über belegte Lumen-Stützpunkte. Ausgabe je Stufe:
   Lumenwert + EU-Äquivalenz (welche alte Glühlampe) + qualitative Anwendung.
   ID-gekoppelt an #lumzahl, sonst No-op. Höhen-Lock auf die Ergebnisbox,
   damit die Karte beim Schieben nicht springt (gleiche Technik wie ws-Slider).

   Datengrundlage:
   - Lumen↔Glühlampen-Watt = beanspruchte Äquivalenz nach EU-Verordnung (EG)
     Nr. 244/2009 (25 W≈249 lm, 40 W≈470 lm, 60 W≈806 lm, 75 W≈1055 lm,
     100 W≈1521 lm). Kerze ~10–15 lm = grobe Orientierung (kein Verordnungswert).
   - Anwendung NUR qualitativ (keine erfundenen lm/m²-Festwerte).
   - LED-Watt als Spanne (heutige Markt-Effizienz, ~90–120 lm/W), Orientierung. */
(function () {
  'use strict';
  var box = document.getElementById('lumzahl');
  if (!box) return;

  var slider = box.querySelector('#lz-range');
  var out = box.querySelector('#lz-result');
  if (!slider || !out) return;

  var fmt = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

  // [Lumen, Glühlampen-Watt (EU 244/2009; null = nicht aus VO), LED-Watt-Spanne, Vergleichsbild, qualitative Anwendung]
  var STOPS = [
    [15,   null, '< 1 W',  'etwa eine Kerzenflamme',          'Stimmungs- und Deko-Licht; zum Sehen oder Arbeiten zu wenig.'],
    [250,  25,   '2–3 W',  'wie eine 25-W-Glühlampe',         'Akzent- und Orientierungslicht, kleine Nachttisch- oder Dekoleuchte.'],
    [470,  40,   '4–5 W',  'wie eine 40-W-Glühlampe',         'Leselampe oder zweite Lichtquelle; für die Grundbeleuchtung eines Raumes meist zu schwach.'],
    [806,  60,   '7–9 W',  'wie eine 60-W-Glühlampe',         'Klassische Wohnraumhelligkeit — die häufigste Wahl für eine einzelne Lampe.'],
    [1055, 75,   '9–12 W', 'wie eine 75-W-Glühlampe',         'Hellere Wohnraum- oder Arbeitsleuchte, etwa über Esstisch oder Schreibtisch.'],
    [1521, 100,  '11–14 W','wie eine 100-W-Glühlampe',        'Helles Licht für größere Räume, Küche oder als kräftige Deckenleuchte.']
  ];

  // Höhen-Lock: höchste Ergebnis-Variante einmal messen, Mindesthöhe fixieren.
  function lockHeight() {
    var prev = slider.value;
    var maxH = 0;
    for (var i = 0; i < STOPS.length; i++) {
      slider.value = i;
      paint(i);
      if (out.offsetHeight > maxH) maxH = out.offsetHeight;
    }
    if (maxH > 0) out.style.minHeight = maxH + 'px';
    slider.value = prev;
    paint(parseInt(prev, 10));
  }

  function paint(i) {
    var s = STOPS[i];
    var lm = s[0], gw = s[1], ledW = s[2], bild = s[3], use = s[4];
    var equiv = (gw === null)
      ? 'so hell wie ' + bild
      : 'so hell wie etwa eine <strong>' + gw + '-W-Glühlampe</strong>';
    out.innerHTML =
      '<span class="lz-big">' + fmt.format(lm) + ' lm</span>' +
      '<span class="lz-equiv">' + equiv + '</span>' +
      '<span class="lz-led">LED dafür heute ca. ' + ledW + '</span>' +
      '<span class="lz-use">' + use + '</span>';
    var ariaGw = (gw === null) ? bild : 'etwa eine ' + gw + ' Watt Glühlampe';
    slider.setAttribute('aria-valuetext',
      fmt.format(lm) + ' Lumen, ' + ariaGw + ', als LED heute etwa ' + ledW + '. ' + use);
  }

  slider.addEventListener('input', function () { paint(parseInt(slider.value, 10)); });
  slider.addEventListener('change', function () { paint(parseInt(slider.value, 10)); });

  // erst Höhe locken (misst alle Stufen), dann auf Default zeichnen
  lockHeight();
})();
/* ============================================================
   LMM Ratgeber-Modul — Klick-Finder „Welche Ersatz-LED brauche ich?“ (id=erslampe)
   Artikel: welche-ersatz-led-brauche-ich-fuer-meine-gluehbirne

   Eigenständiger Klick-Finder NUR für diesen Ratgeber (NICHT in
   shared/ratgeber-modules.js, damit die geteilte Datei unberührt bleibt).
   Im Shopify-Theme später als Section-Asset/Snippet übernehmen.

   ABGRENZUNG zum eref-finder (led-ersatzprodukt-finden, Routing-HUB): Dort
   ordnet der Finder breit nach Lampen-GATTUNG ein und ROUTET zu Tiefenseiten.
   HIER ist der Fokus die GLÜHBIRNE und ihr SOCKEL: pro alter Lampenart steht
   sofort „worauf achten“ (gleicher Sockel · Lumen statt Watt · warmweiß für
   gewohntes Licht · Bauform · dimmbar nur ausgewiesen) — als konkrete
   Auswahlhilfe, nicht als Weiterleitungs-Stub.

   Muster identisch zum eref-/flack-/hled-Finder: echte <button>-Elemente
   (tastaturbedienbar), select(i) schaltet aria-pressed + .is-on, Ergebnis in
   aria-live="polite", Höhen-Lock gegen Springen. Default = erster Button
   (= statischer Fallback ohne JS). No-op, wenn #erslampe fehlt.

   DATENEHRLICH: keine erfundenen Watt-/Lumen-/Kelvin-/Maß-Werte. Belegte
   EU-Äquivalenz (VO 244/2009) nur grob als Orientierung; konkrete Sockelmaße/
   Lumen je Produkt -> Datenblatt. „Lumen statt Watt“ konsequent. Collection-
   Links = data-todo (Ziele in ../link-map-ratgeber.csv, Pass B gegen den
   echten Shopware-Baum). Interne Ratgeber-Links relativ.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('erslampe');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.erslampe-btn'));
  var val = document.getElementById('erslampe-val');
  var note = document.getElementById('erslampe-note');
  if (!btns.length || !val || !note) return;

  // Reihenfolge identisch zu den Buttons in preview.html / body.html.
  // [Ergebnis-Kennzahl (alte Lampe -> passende LED), Hinweis-HTML „worauf achten“ + Collection-Link (data-todo)]
  var DATA = [
    ['Glühbirne E27 → LED mit E27-Sockel',
     '<strong>Worauf achten:</strong> gleicher <strong>E27-Schraubsockel</strong> (großes Gewinde, 230 V). Helligkeit über die <strong>Lumen</strong> wählen, nicht über Watt — eine alte 60-Watt-Birne entspricht grob rund 806 Lumen. Für gewohntes, warmes Licht <strong>warmweiß</strong> (rund 2700 K). Bauform meist Birne (A60) oder Globe. Dimmen nur mit ausdrücklich dimmbarer LED. <a href="/collections/e27-led-leuchtmittel" class="sock-link">E27-LED ansehen →</a>'],
    ['Kerze oder Tropfen E14 → LED mit E14-Sockel',
     '<strong>Worauf achten:</strong> kleiner <strong>E14-Schraubsockel</strong> (230 V), typisch für Kerzen- und Tropfenform in Kronleuchtern, Wand- und Tischleuchten. Helligkeit nach <strong>Lumen</strong> wählen, für gewohntes Licht <strong>warmweiß</strong>. Achten Sie auf eine schlanke Bauform, damit die LED unter den Schirm passt. Dimmen nur mit ausgewiesener LED. <a href="/collections/e14-led-leuchtmittel" class="sock-link">E14-LED ansehen →</a>'],
    ['Bajonett-Birne B22 → LED mit B22-Sockel',
     '<strong>Worauf achten:</strong> <strong>B22-Bajonettsockel</strong> (Stecken und Drehen statt Schrauben, 230 V) — in Deutschland seltener, häufiger in Altbauten und auf Importleuchten. Sockel muss exakt passen: B22 lässt sich nicht in eine E27-Fassung schrauben. Sonst gilt dasselbe: <strong>Lumen statt Watt</strong>, warmweiß für gewohntes Licht. <a href="/collections/led-lampen" class="sock-link" data-todo="link-pruefen">LED-Lampen ansehen →</a>'],
    ['Halogen-Spot GU10 → LED mit GU10-Sockel',
     '<strong>Worauf achten:</strong> <strong>GU10-Dreh-Stiftsockel</strong> läuft mit 230 V und wird <strong>1:1 gegen eine GU10-LED</strong> getauscht — kein Trafo nötig. Bei Spots zählt zusätzlich der <strong>Abstrahlwinkel</strong> (eng für Akzente, breit für Flächen). Helligkeit nach <strong>Lumen</strong>, Lichtfarbe nach Bedarf. Tiefer dazu: <a href="/blogs/ratgeber/halogen-durch-led-ersetzen" class="sock-link" data-todo="link-pruefen">Halogen durch LED ersetzen →</a> · <a href="/collections/gu10-led-lampen" class="sock-link" data-todo="link-pruefen">GU10-LED ansehen →</a>'],
    ['Niedervolt-Spot GU5.3 (12 V) → LED + Trafo prüfen',
     '<strong>Worauf achten:</strong> <strong>GU5.3</strong> (MR16) ist ein <strong>12-Volt-Stiftsockel</strong> und braucht einen Trafo. Der häufigste Stolperstein: ein alter elektronischer Halogen-Trafo hat oft eine Mindestlast, die eine sparsame LED unterschreitet — dann flackert es. Lösung: LED-geeigneter Konverter. Die Trafo-Frage klärt <a href="/blogs/ratgeber/halogen-durch-led-ersetzen" class="sock-link" data-todo="link-pruefen">Halogen durch LED ersetzen →</a>'],
    ['Halogenstift G9 (230 V) → LED mit G9-Sockel',
     '<strong>Worauf achten:</strong> <strong>G9</strong> ist ein Stiftsockel, der <strong>direkt mit 230 V</strong> läuft (kein Trafo) — nicht mit dem 12-V-Sockel G4 verwechseln. Tauschen Sie gegen eine G9-LED mit passender <strong>Lumen</strong>-Zahl und Lichtfarbe; in geschlossenen Leuchten auf die Wärmeabfuhr achten. <a href="/collections/g9-led-leuchtmittel" class="sock-link">G9-LED ansehen →</a>'],
    ['Sockel unbekannt → so erkennen Sie ihn',
     '<strong>So finden Sie es heraus:</strong> Schauen Sie auf den Sockel der alten Lampe oder auf den Aufdruck der Leuchte. <strong>Schraubgewinde</strong> = E27 (groß) oder E14 (klein). <strong>Zwei runde Stifte zum Drehen</strong> = GU10 (230 V) oder GU5.3 (12 V, am Trafo). <strong>Dünne Drahtbügel</strong> = G9 (230 V). Steht „12 V“ an der Leuchte, ist ein Trafo im Spiel. Maße und Verwechslungen zeigt die <a href="/blogs/ratgeber/lampensockel-uebersicht" class="sock-link" data-todo="link-pruefen">Lampensockel-Übersicht →</a>']
  ];

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.textContent = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0); // Default = erster Button (= statischer Fallback ohne JS)

  // Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.erslampe-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.textContent = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var erslT;
  window.addEventListener('resize', function () { clearTimeout(erslT); erslT = setTimeout(lock, 150); });
})();
/* ============================================================
   Modul-JS — Klick-Grafik „So lösen Sie Ihren Sockel“ (#wechselsockel)
   Artikel: led-leuchtmittel-wechseln (Ziel-Handle wie-wechsle-ich-ein-led-leuchtmittel-aus)

   Form = KLICK-GRAFIK (analog nv-system / g23parts in der Wechsel-Serie): ein
   SVG mit vier anklickbaren Sockel-Typ-Hotspots (.nv-hot, role=button,
   tabindex=0, tastaturbedienbar). Klick / Enter / Space -> select(i) schaltet
   aria-pressed + .is-on und schreibt Überschrift/Erklärung in
   #wechselsockel-val / #wechselsockel-note (aria-live="polite"). Default =
   Hotspot 1 (= statischer Fallback ohne JS). Höhen-Lock gegen Springen der
   Ergebnisbox. No-op, wenn #wechselsockel fehlt.

   DATENEHRLICH: Es werden nur die BELEGTEN Entfern-/Einsetz-Mechaniken je
   Sockel beschrieben (Schraube = drehen, Bajonett/GU10 = drücken + Vierteldrehung,
   Stift = gerade ziehen) plus „am Sockel anfassen, nicht am Glas“ und „heiße
   Halogenlampe abkühlen lassen“. KEINE erfundenen Maße/Werte; lampentyp-/leuchten-
   spezifische Besonderheiten -> Hersteller-/Leuchtenanleitung (als Datenlücke
   benannt). Im body.html ersetzt eine statische Liste das Modul.

   Im Shopify-Theme später als Section-Asset/Snippet übernehmen. Keine externen
   Abhängigkeiten, rein clientseitig.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('wechselsockel');
  if (!box) return;
  var hots = [].slice.call(box.querySelectorAll('.nv-hot'));
  var val = document.getElementById('wechselsockel-val');
  var note = document.getElementById('wechselsockel-note');
  if (!hots.length || !val || !note) return;

  // Reihenfolge identisch zu den Hotspots im SVG (preview.html):
  // 0 = Schraubsockel E27/E14 · 1 = Bajonett B22 · 2 = Dreh-/Bajonett GU10 · 3 = Stift-/Stecksockel G4/G9/GU5.3
  // [Ergebnis-Überschrift (HTML erlaubt), Hinweis-HTML inkl. Lösen+Einsetzen (data-todo bei Links)]
  var DATA = [
    ['Schraubsockel — E27 oder E14',
     '<strong>Lösen:</strong> die alte Lampe <strong>gegen den Uhrzeigersinn</strong> (nach links) herausdrehen. ' +
     '<span class="ws-do"><strong>Einsetzen:</strong> die neue Lampe <strong>im Uhrzeigersinn handfest</strong> eindrehen — fest genug für sicheren Kontakt, aber nicht überdrehen.</span> ' +
     'Fassen Sie die Lampe am <strong>Sockel</strong> an, nicht am Glas. So sitzen die gängigen Schraubsockel E27 (groß) und E14 (klein). ' +
     '<a href="/blogs/ratgeber/lampensockel-uebersicht" class="sock-link" data-todo="link-pruefen">Lampensockel-Übersicht &#8594;</a>'],
    ['Bajonettsockel — B22',
     '<strong>Lösen:</strong> die Lampe leicht <strong>hineindrücken</strong>, eine <strong>Vierteldrehung gegen den Uhrzeigersinn</strong> machen und dann gerade <strong>herausziehen</strong>. ' +
     '<span class="ws-do"><strong>Einsetzen:</strong> die neue Lampe mit den beiden seitlichen Stiften ansetzen, hineindrücken und eine Vierteldrehung <strong>im Uhrzeigersinn</strong> einrasten lassen.</span> ' +
     'Der B22 (Bajonett, zwei seitliche Nasen) wird also nicht geschraubt, sondern gedrückt und gedreht. Am Sockel anfassen, nicht am Glas.'],
    ['Dreh-/Reflektorsockel — GU10',
     '<strong>Lösen:</strong> den Spot leicht <strong>hineindrücken</strong>, eine <strong>Vierteldrehung gegen den Uhrzeigersinn</strong> machen und gerade <strong>herausziehen</strong>. ' +
     '<span class="ws-do"><strong>Einsetzen:</strong> die beiden Stifte in die Fassung führen, hineindrücken und eine Vierteldrehung <strong>im Uhrzeigersinn</strong> bis zum Einrasten.</span> ' +
     'GU10 läuft mit <strong>230 V</strong> direkt am Netz (kein Trafo). Sitzt der Spot tief oder fest, gibt ein Gummihandschuh Halt. Am Sockel anfassen, nicht am Glas. ' +
     '<a href="/collections/gu10-led-lampen" class="sock-link" data-todo="link-pruefen">GU10-LED ansehen &#8594;</a>'],
    ['Stift-/Stecksockel — G4, G9, GU5.3',
     '<strong>Lösen:</strong> die Lampe <strong>gerade aus der Fassung ziehen</strong> — nicht drehen. ' +
     '<span class="ws-do"><strong>Einsetzen:</strong> die neue Lampe mit beiden Pins gerade in die Fassung stecken.</span> ' +
     'Halten Sie die Lampe dabei am <strong>Sockel</strong>, nicht am Glaskolben. G4, GU5.3 und GU4 sind Niedervolt (12 V, am Trafo), G9 läuft mit 230 V am Netz — der Handgriff (gerade ziehen/stecken) ist bei allen gleich. ' +
     '<a href="/blogs/ratgeber/wechsel-osram-halostar-g4-gy635" class="sock-link" data-todo="link-pruefen">G4/GY6.35 auf LED umrüsten &#8594;</a>']
  ];

  function select(i) {
    hots.forEach(function (h, j) {
      h.classList.toggle('is-on', j === i);
      h.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.innerHTML = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  hots.forEach(function (h, i) {
    h.addEventListener('click', function () { select(i); });
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); select(i); }
    });
  });
  select(0); // Default = Hotspot 1 (= statischer Fallback ohne JS)

  // Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.nv-result');
  function lock() {
    if (!result) return;
    var v = val.innerHTML, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.innerHTML = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.innerHTML = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(lock, 150); });
})();
/* ============================================================
   LMM Ratgeber-Modul „aqualight“ — Becken-Typ-Umschalter (Aquarium-Ratgeber).
   Folder-lokal gebaut (led-aquarium-beleuchtung). In Shopify später als
   Theme-Snippet/Section-Asset zu übernehmen — kein externes Skript, rein
   clientseitig, keine Abhängigkeiten, kein Tracking.

   Variation = UMSCHALTER/TOGGLE (analog zum g9toggle der Wechsel-Serie): zwei
   echte <button>-Umschalter [Süßwasser-/Pflanzenbecken] / [Meerwasser-/Riffbecken].
   Klick/Enter/Space schaltet den Zustand und schreibt den QUALITATIVEN Licht-Fokus
   in #aql-val/#aql-note (aria-live). Default = Süßwasser (= statischer Fallback ohne JS).

   DATENEHRLICH: nur qualitative Licht-Tendenz + Hinweis, dass konkrete Werte
   becken-/besatzabhängig sind (Fachquelle/Datenblatt). KEINE erfundenen
   Kelvin-/Lux-/µmol-/Watt-pro-Liter-/Stunden-Werte.
   ID-gekoppelt (getElementById('aqualight')), sonst No-op.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('aqualight');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.aql-btn'));
  var val = document.getElementById('aql-val'), note = document.getElementById('aql-note');
  if (!btns.length || !val || !note) return;

  // Reihenfolge identisch zu den Buttons in preview.html.
  // [Ergebnis-Überschrift, Hinweis-HTML inkl. internem Link (data-todo)]
  // Bewusst OHNE konkrete Zahlen — nur qualitative Tendenz + Datenlücken-Hinweis.
  var DATA = [
    ['Süßwasser-/Pflanzenbecken — ausgewogenes Spektrum',
     'Für ein bepflanztes Süßwasserbecken ist ein <strong>ausgewogenes Vollspektrum</strong> mit kräftigen <strong>Blau- und Rotanteilen</strong> und einer eher natürlichen, tageslichtähnlichen Lichtfarbe sinnvoll — Wasserpflanzen nutzen vor allem Blau und Rot. Die <strong>tägliche Beleuchtungsdauer</strong> wird hier eher begrenzt, weil zu langes oder zu starkes Licht Algen begünstigt. <strong>Konkrete Werte (Lichtfarbe in Kelvin, Lichtmenge, Stunden pro Tag) hängen von Becken, Bepflanzung und Besatz ab</strong> — maßgeblich sind das Datenblatt der Leuchte und eine Aquaristik-Fachquelle. Spektrum-Grundlagen: <a href="/blogs/ratgeber/led-pflanzenlicht" class="sock-link" data-todo="link-pruefen">LED-Licht für Pflanzen →</a>'],
    ['Meerwasser-/Riffbecken — höherer Blau-/Aktinik-Anteil',
     'In einem <strong>Meerwasser-/Riffbecken</strong> steht ein <strong>höherer Blau- beziehungsweise „Aktinik“-Anteil</strong> im Vordergrund: Korallen und ihre symbiotischen Algen (Zooxanthellen) nutzen vor allem kurzwelliges, blaues Licht, das im Wasser zudem tiefer eindringt. Riffbecken brauchen tendenziell mehr Licht als ein reines Pflanzenbecken. <strong>Wie viel Blau, welche Intensität und welche Lichtfarbe genau passen, ist stark vom Besatz abhängig</strong> (Weich- oder Steinkorallen, Beckentiefe) — richten Sie sich nach dem Datenblatt der Leuchte und einer Aquaristik-/Meerwasser-Fachquelle.']
  ];

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.innerHTML = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) {
    b.addEventListener('click', function () { select(i); });
  });
  select(0); // Default = Süßwasser-/Pflanzenbecken (statischer Fallback)

  // Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Umschalten.
  var result = box.querySelector('.aql-result');
  function lock() {
    if (!result) return;
    var v = val.innerHTML, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.innerHTML = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.innerHTML = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var aqlT; window.addEventListener('resize', function () { clearTimeout(aqlT); aqlT = setTimeout(lock, 150); });
})();
/* =====================================================================
   Ratgeber-Modul „Lebensdauer-Jahre-Rechner“ (Artikel led-lampen-garantie)
   ---------------------------------------------------------------------
   Modul-ID: garlife · Form: RECHNER/CALCULATOR (Zahlen-Eingabe, reine Division)
   Frage: „Wie viele Jahre hält die Lampe — und reicht das für die Garantie?“

   Eingaben (Nutzer):
     - garlife-perday : Nutzung in Stunden pro Tag
     - garlife-hours  : Lebensdauer in Stunden (laut Datenblatt)
   Ergebnis (garlife-result, aria-live):
     - grobe Jahre = h ÷ (h/Tag × 365)  [REINE DIVISION, kein erfundener Wert]
     - Einordnung: Garantie ≠ Gewährleistung ≠ Lebensdauer (je 1 Satz).

   Datenehrlichkeit: Beide Werte gibt der Nutzer ein (Lebensdauer steht laut
   Datenblatt auf der Verpackung). Defaults 3 h/Tag / 25.000 h sind ein klar
   gekennzeichnetes Beispiel. Es wird KEINE Garantiezeit berechnet oder behauptet —
   der Rechner zeigt nur die technische Lebensdauer in Jahren und ordnet sie ein.

   Muster: ld-calc / wl-calc aus shared/ratgeber-modules.js (Zahlen-Eingabe +
   Ergebnis + Höhen-Lock). ID-gekoppelt: ohne #garlife No-op. Diese Datei wird beim
   Livegang an shared/ratgeber-modules.js angehängt (bestehende Module unverändert).
   ===================================================================== */
(function () {
  'use strict';
  var box = document.getElementById('garlife');
  if (!box) return;
  var perDay = document.getElementById('garlife-perday'); // Nutzung in Stunden/Tag
  var hours = document.getElementById('garlife-hours');   // Lebensdauer in Stunden (Datenblatt)
  var out = document.getElementById('garlife-result');
  if (!perDay || !hours || !out) return;

  var f0 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  var f1 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });

  // Fester Einordnungs-Satz (Garantie ≠ Gewährleistung ≠ Lebensdauer) — je 1 Satz,
  // immer gleich, damit die Box nicht je nach Eingabe springt.
  var EINORDNUNG =
    '<span class="calc-equiv">Dieser Wert ist die <strong>technische Lebensdauer</strong> &mdash; nicht Ihre Garantie. ' +
    'Die <strong>Garantie</strong> ist eine freiwillige Hersteller-/H&auml;ndlerzusage (Dauer laut Garantiebedingungen). ' +
    'Die <strong>gesetzliche Gew&auml;hrleistung</strong> betr&auml;gt in Deutschland i.&nbsp;d.&nbsp;R. 2 Jahre ab Kauf. ' +
    'Reine Rechnung aus Ihren Werten &mdash; reale Lebensdauer h&auml;ngt von W&auml;rme, Qualit&auml;t, Schaltzyklen und Einbau ab.</span>';

  function render() {
    var d = parseFloat(perDay.value);
    var h = parseFloat(hours.value);
    if (!isFinite(d) || d <= 0 || !isFinite(h) || h <= 0) {
      out.innerHTML = 'Bitte Nutzung (Stunden pro Tag) und Lebensdauer (Stunden) eingeben &mdash; die Lebensdauer steht laut Datenblatt auf der Verpackung.';
      return;
    }
    var hPerYear = d * 365;
    var years = h / hPerYear;
    var yearsTxt = years >= 10 ? f0.format(years) : f1.format(years);
    out.innerHTML = 'Rechnerisch h&auml;lt die Lampe etwa <strong>' + yearsTxt + ' Jahre</strong>.' +
      '<span class="calc-equiv">' + f0.format(h) + ' Stunden &divide; (' + f1.format(d) + ' h/Tag &times; 365 Tage) &asymp; ' +
      f0.format(Math.round(hPerYear)) + ' h pro Jahr.</span>' +
      EINORDNUNG;
  }

  // Höhen-Lock: Ergebnis-Box auf den höchstmöglichen Inhalt fixieren, damit sie beim
  // Tippen nicht springt (längster Zustand = gültiges Ergebnis inkl. fester Einordnung).
  function lockHeight() {
    var saved = out.innerHTML;
    out.style.minHeight = '';
    out.innerHTML = 'Rechnerisch h&auml;lt die Lampe etwa <strong>00,0 Jahre</strong>.' +
      '<span class="calc-equiv">000.000 Stunden &divide; (00,0 h/Tag &times; 365 Tage) &asymp; 00.000 h pro Jahr.</span>' +
      EINORDNUNG;
    out.style.minHeight = out.offsetHeight + 'px';
    out.innerHTML = saved;
  }

  [perDay, hours].forEach(function (el) { el.addEventListener('input', render); });
  render();
  lockHeight();
  var glT;
  window.addEventListener('resize', function () { clearTimeout(glT); glT = setTimeout(lockHeight, 150); });
})();


/* ===== BATCH 2326-2330 / Wechsel-Serie Tier 2 (2026-06-18) :: cflcode :: Text-Filter Kompaktleuchtstoff-/Dulux-Code-Entschluessler :: aus wechsel-pl-c-g24d ===== */
/* === LMM Ratgeber-Modul: Kompaktleuchtstofflampen-/Dulux-Code-Entschlüssler (id cflcode) ===
   Artikel: wechsel-pl-c-g24d ("Wie wechsle ich eine PL-C / Dulux D G24d auf LED?")

   TEXT-Filter (kein Button-Finder): Das Eingabefeld #cflcode-input filtert die statische
   Nachschlagetabelle. Nutzer tippt eine Bezeichnung oder einen Sockel (z. B. "PL-C",
   "Dulux D", "G24d", "G24q", "PL-L", "2G11", "G23", "PL-T", "GX24", "PL-S") — Treffer
   bleiben sichtbar (.cflcode-row), Nicht-Treffer werden ausgeblendet (hidden). Trefferzahl
   in der aria-live-Region #cflcode-count; bei 0 Treffern erscheint der Hinweis #cflcode-empty.
   Suche ist case- und umlaut-/akzent-tolerant (NFD + ae/oe/ue/ss-Ersatz).

   GUARD: Ohne #cflcode (Wrapper) bzw. ohne #cflcode-input / #cflcode-list passiert nichts
   (No-op auf anderen Seiten / kein Doppel-Load über shared). Die Tabelle selbst bleibt reiner
   HTML-Inhalt und ist auch OHNE JS vollständig sichtbar (Filterfeld = Theme-Modul). Enter
   sendet das (Vorschau-)Formular nicht ab. prefers-reduced-motion wird respektiert (es gibt
   ohnehin keine bewegten Übergänge; das hidden-Umschalten ist instantan).

   DATENEHRLICH: nur belegte Sockel-/Pin-/Codierungs-Fakten (IEC 60061 + Osram-Dulux-/Philips-
   PL-Nomenklatur). KEINE erfundenen Lumen-/Watt-Werte; Wattstufen sind als "typisch"
   gekennzeichnet, der LED-Weg qualitativ ("laut Datenblatt"). */
(function () {
  'use strict';
  var root = document.getElementById('cflcode');
  if (!root) return;
  var input = document.getElementById('cflcode-input');
  var list = document.getElementById('cflcode-list');
  if (!input || !list) return;
  var rows = [].slice.call(list.querySelectorAll('.cflcode-row'));
  if (!rows.length) return;
  var count = document.getElementById('cflcode-count');
  var empty = document.getElementById('cflcode-empty');

  // Normalisierung: Kleinschreibung, deutsche Umlaute/ß ausschreiben, restliche
  // Diakritika via NFD entfernen, Mehrfach-Whitespace glätten. So trifft "röhre"
  // auch "roehre" und umgekehrt; "G24D" trifft "g24d".
  function norm(s) {
    s = (s || '').toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/\s+/g, ' ').trim();
  }

  // Suchindex je Zeile einmal vorberechnen: data-key (Synonyme/Codes) + sichtbarer
  // Name (.cflcode-name) + Sockel (.cflcode-base). data-key trägt die Tippvarianten
  // (z. B. "pl-c plc dulux d g24d kompaktleuchtstofflampe 2 pin zwei pin").
  rows.forEach(function (r) {
    var nameEl = r.querySelector('.cflcode-name');
    var baseEl = r.querySelector('.cflcode-base');
    r._idx = norm((r.getAttribute('data-key') || '') + ' '
      + (nameEl ? nameEl.textContent : '') + ' '
      + (baseEl ? baseEl.textContent : ''));
  });

  var fmt = (window.Intl && Intl.NumberFormat) ? new Intl.NumberFormat('de-DE') : null;
  function num(n) { return fmt ? fmt.format(n) : String(n); }
  var total = rows.length;

  function apply() {
    var q = norm(input.value);
    var hits = 0;
    rows.forEach(function (r) {
      var match = q === '' || r._idx.indexOf(q) !== -1;
      r.hidden = !match;
      if (match) hits++;
    });
    if (empty) empty.hidden = hits !== 0;
    if (count) {
      if (q === '') {
        count.textContent = 'Alle ' + num(total) + ' Sockel werden angezeigt.';
      } else if (hits === 0) {
        count.textContent = 'Kein passender Sockel gefunden.';
      } else {
        count.textContent = hits === 1
          ? '1 Sockel gefunden.'
          : num(hits) + ' von ' + num(total) + ' Sockeln.';
      }
    }
  }

  input.addEventListener('input', apply);
  // Enter im Suchfeld nicht das (Vorschau-)Formular absenden lassen.
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
  apply();
})();


/* ===== BATCH 2326-2330 / Wechsel-Serie Tier 2 (2026-06-18) :: gu10watt :: Slider Halogen-GU10-Watt -> LED-Aequivalent :: aus wechsel-osram-halopar-gu10 ===== */
/* ============================================================
   LMM Ratgeber-Modul — Watt-Slider „GU10-Halogen → LED-Äquivalent“ (id=gu10watt)
   Artikel: wie-wechsle-ich-eine-osram-halopar-gu10-mit-einem-led-ersatz

   FOLDER-LOKAL gebaut (jetzt in shared/ratgeber-modules.js), damit die geteilte
   Datei unberührt bleibt. Wird später von mir in shared/ integriert; im Theme
   als Section-Asset/Snippet übernehmen. ID-gekoppelt an #gu10watt, sonst No-op.

   FORM: ein range-Slider über typische Halogen-GU10-Wattstufen (20/35/50 W).
   Ausgabe je Stufe: ungefähres LED-Watt-Äquivalent (Bereich) + Lumen-Orientierung
   + kurzer Ersparnis-Hinweis. Höhen-Lock auf die Ergebnisbox (alle Stufen messen),
   damit die Karte beim Schieben nicht springt (gleiche Technik wie ws-/lumzahl-Slider).

   DATENEHRLICH (höchste Vorsicht — Reflektorlampe):
   - Halopar 16 (GU10, 230 V) wird im Osram-Datenblatt als LICHTSTÄRKE (cd) im
     35°-Kegel geführt (35 W ≈ 570 cd, 50 W ≈ 950 cd, ~230 lm @ 90°, 2700 K, Ra 100,
     ~2.000 h). Ein omnidirektionaler Lumen-Wert ist NICHT direkt vergleichbar.
   - Lumen-Spalte daher bewusst als BEREICH/ORIENTIERUNG (gerichtete EU-Äquivalenz
     nach VO (EG) Nr. 244/2009 + Marktspanne), NICHT als Scheinpräzision. Maßgeblich
     bleibt die Lumen-Angabe auf der Packung / im Datenblatt.
   - LED-Watt als BEREICH (LED-Effizienz ~90–120 lm/W; reflektorabhängig).
   - prefers-reduced-motion respektiert (Slider hat ohnehin keine Animation; CSS
     deaktiviert Transitions zusätzlich).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('gu10watt');
  if (!box) return;

  var slider = box.querySelector('#gu10watt-range');
  var outW = box.querySelector('#gu10watt-out');   // Halogen-Watt (Eingangswert)
  var outLed = box.querySelector('#gu10watt-led');  // LED-Watt-Äquivalent (Bereich)
  var note = box.querySelector('#gu10watt-note');   // Lumen-Orientierung + Ersparnis
  if (!slider || !outW || !outLed || !note) return;

  // [Halogen-Watt, LED-Watt-Äquivalent (Bereich, Orientierung), Lumen-Orientierung-Text, Ersparnis-/Hinweistext]
  // Werte = Orientierung (EU-Äquivalenz VO 244/2009 + Marktspanne); Lumen reflektorabhängig.
  var STOPS = [
    [20, 'ca. 2–3 W',
     'rund 130–200 Lumen (Orientierung)',
     'Die schwächste GU10-Halogenstufe — meist für Akzent- und Stimmungslicht. Eine LED zieht hier nur einen kleinen Bruchteil der Leistung.'],
    [28, 'ca. 3–4 W',
     'rund 200–300 Lumen (Orientierung)',
     'Eine seltenere Zwischenstufe. Wählen Sie die LED nach dem Lumenwert auf der Packung der alten Lampe.'],
    [35, 'ca. 3,5–5 W',
     'rund 230–400 Lumen (Orientierung)',
     'Die meistverkaufte GU10-Halogenstufe (z. B. Osram Halopar 16 64820, 35°). Eine LED mit gleichem Lumenwert spart rund 85–90 % Strom.'],
    [50, 'ca. 5–8 W',
     'rund 350–600 Lumen (Orientierung)',
     'Die hellste gängige GU10-Stufe (z. B. Osram Halopar 16 64824, 35°). Hier ist der Spareffekt am größten — und die Wärmeentwicklung sinkt deutlich.']
  ];

  // Höhen-Lock: höchste Ergebnis-Variante einmal messen, Mindesthöhe fixieren.
  function lockHeight() {
    var prev = slider.value;
    var maxH = 0;
    for (var i = 0; i < STOPS.length; i++) {
      slider.value = i;
      paint(i);
      if (note.offsetHeight > maxH) maxH = note.offsetHeight;
    }
    if (maxH > 0) note.style.minHeight = maxH + 'px';
    slider.value = prev;
    paint(parseInt(prev, 10) || 0);
  }

  function paint(i) {
    var s = STOPS[i];
    if (!s) return;
    var halogenW = s[0], ledW = s[1], lumen = s[2], hint = s[3];
    outW.textContent = halogenW + ' W';
    outLed.textContent = ledW;
    note.innerHTML =
      '<strong>' + lumen + '</strong> — als LED heute etwa <strong>' + ledW + '</strong>. ' + hint;
    slider.setAttribute('aria-valuetext',
      halogenW + ' Watt GU10-Halogen, als LED heute etwa ' + ledW +
      ', Helligkeit ' + lumen + '. ' + hint.replace(/<[^>]+>/g, ''));
  }

  slider.addEventListener('input', function () { paint(parseInt(slider.value, 10)); });
  slider.addEventListener('change', function () { paint(parseInt(slider.value, 10)); });

  // erst Höhe locken (misst alle Stufen), dann auf Default zeichnen
  lockHeight();

  // bei Resize neu messen (wie die Schwester-Module hidsystem/pinmode/s14calc)
  var gu10T;
  window.addEventListener('resize', function () { clearTimeout(gu10T); gu10T = setTimeout(lockHeight, 150); });
})();


/* ===== BATCH 2326-2330 / Wechsel-Serie Tier 2 (2026-06-18) :: hidsystem :: Klick-Grafik HID-System (Drossel/KVG + Lampe) :: aus wechsel-hql-hpl-quecksilberdampf ===== */
/* ============================================================
   HID-System-Klickgrafik „Was steckt im HQL/HPL-System?“ (Artikel wechsel-hql-hpl-quecksilberdampf)
   FOLDER-LOKALES MODUL — zunächst folder-lokal, jetzt in shared/ratgeber-modules.js,
   damit die geteilte Datei unberuehrt bleibt. Im Shopify-Theme spaeter
   als Section-Asset/Snippet uebernehmen.

   Form = KLICK-GRAFIK (analog nv-system / g23parts in der Wechsel-Serie):
   ein SVG der HID-Installation Netz -> Drossel/KVG -> Lampe (E27/E40) mit
   drei anklickbaren Hotspots (.hidsystem-hot, role=button, tabindex=0,
   tastaturbedienbar). Klick/Enter/Space -> select(i) schaltet aria-pressed
   + .is-on und schreibt Ueberschrift/Erklaerung in
   #hidsystem-val / #hidsystem-note (aria-live="polite"). Default = Hotspot 1
   (= statischer Fallback ohne JS). Hoehen-Lock gegen Springen der
   Ergebnisbox. No-op, wenn #hidsystem fehlt.

   Eigenstaendige IDs/Klassen mit Praefix `hidsystem-` -> KEIN Konflikt mit
   nv-system / g23parts / wechselsockel im shared-JS/-CSS.

   DATENEHRLICH (HID/Hochvolt/Hochdruck — hoechste Vorsicht, YMYL):
   rein ERKLAEREND, KEINE erfundenen Watt/Lumen, keine pauschale
   Kompatibilitaet. Belegte Fakten: HQL (Osram) = HPL (Philips) =
   Quecksilberdampf-Hochdrucklampe (HID), Sockel meist E27/E40; Betrieb an
   magnetischer Drossel/KVG OHNE separates Zuendgeraet (zuendet selbst — im
   Gegensatz zu NAV/SON). Zwei LED-Wege, beide herstellerabhaengig:
   (1) drossel-/vorschaltgeraetkompatible Retrofit-LED nur mit Freigabe;
   (2) Drossel ueberbruecken, LED an 230 V -> Elektrofachkraft, spannungsfrei.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('hidsystem');
  if (!box) return;
  var hots = [].slice.call(box.querySelectorAll('.hidsystem-hot'));
  var val = document.getElementById('hidsystem-val');
  var note = document.getElementById('hidsystem-note');
  if (!hots.length || !val || !note) return;

  // Reihenfolge identisch zu den Hotspots im SVG (preview.html):
  // 0 = Drossel/KVG (vorhandenes magnetisches Vorschaltgeraet)
  // 1 = zwei LED-Wege (kompatible Retrofit-LED am VG vs. Drossel ueberbruecken/direkt 230 V)
  // 2 = Sockel E27/E40
  // [Ergebnis-Ueberschrift (HTML erlaubt), Hinweis-HTML inkl. interner Links mit data-todo]
  var DATA = [
    ['Drossel / KVG &#8212; das vorhandene Vorschaltger&#228;t',
     'Eine HQL/HPL-Lampe l&#228;uft <strong>nicht direkt am Netz</strong>, sondern &#252;ber eine <strong>Drossel</strong> &#8211; ein magnetisches Vorschaltger&#228;t (KVG). Anders als bei der Natriumdampflampe (NAV/SON) ist <strong>kein separates Z&#252;ndger&#228;t</strong> n&#246;tig: Die Quecksilberdampflampe z&#252;ndet an der Drossel selbst. Genau dieses vorhandene Ger&#228;t entscheidet beim LED-Umstieg &#252;ber den Weg &#8211; eine Drossel, die f&#252;r die Quecksilberdampflampe gebaut wurde, passt nicht automatisch zu einer LED. <a href="/blogs/ratgeber/leuchtstoffroehren-durch-led-roehren-ersetzen" class="sock-link" data-todo="link-pruefen">Vorschaltger&#228;t-Logik (R&#246;hren-Ratgeber) &#8594;</a>'],
    ['Zwei LED-Wege &#8212; beide h&#228;ngen vom Hersteller ab',
     'F&#252;r den Umstieg gibt es <strong>zwei Wege</strong>. <strong>Weg 1:</strong> eine <strong>drossel-/vorschaltger&#228;tkompatible Retrofit-LED</strong>, die an der vorhandenen Drossel l&#228;uft &#8211; <strong>nur, wenn der Hersteller sie daf&#252;r freigegeben hat</strong> (Datenblatt/Kompatibilit&#228;tsliste), nicht universell. <strong>Weg 2:</strong> die <strong>Drossel wird &#252;berbr&#252;ckt</strong>, die LED l&#228;uft danach direkt an <strong>230 V</strong>. Diese Umverdrahtung ist ein Eingriff in die feste Installation und geh&#246;rt in die Hand einer <strong>Elektrofachkraft</strong> (Stromkreis spannungsfrei). Eine pauschale Kompatibilit&#228;t gibt es nicht. <a href="/collections/e40-led-leuchtmittel" class="sock-link">E40-LED ansehen &#8594;</a>'],
    ['Sockel &#8212; meist E27 oder E40',
     'HQL- und HPL-Lampen haben in der Regel einen <strong>Schraubsockel E27 oder E40</strong> &#8211; kleinere Wattstufen oft E27, gr&#246;&#223;ere E40. Die LED muss denselben Sockel haben wie die alte Lampe. Achten Sie zus&#228;tzlich auf <strong>Bauform und Bauh&#246;he</strong>, damit die LED in die Leuchte passt, und auf die <strong>Helligkeit (Lumen)</strong> &#8211; den Wert lesen Sie auf der alten Packung oder im Datenblatt ab, denn er h&#228;ngt von der konkreten Lampe ab. <a href="/blogs/ratgeber/lampensockel-uebersicht" class="sock-link" data-todo="link-pruefen">Lampensockel-&#220;bersicht &#8594;</a> <a href="/collections/e27-led-leuchtmittel" class="sock-link">E27-LED ansehen &#8594;</a>']
  ];

  function select(i) {
    hots.forEach(function (h, j) {
      h.classList.toggle('is-on', j === i);
      h.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.innerHTML = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  hots.forEach(function (h, i) {
    h.addEventListener('click', function () { select(i); });
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); select(i); }
    });
  });
  select(0); // Default = Hotspot 1 (= statischer Fallback ohne JS)

  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.hidsystem-result');
  function lock() {
    if (!result) return;
    var v = val.innerHTML, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.innerHTML = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.innerHTML = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(lock, 150); });
})();


/* ===== BATCH 2326-2330 / Wechsel-Serie Tier 2 (2026-06-18) :: pinmode :: Umschalter 2-Pin G24d <-> 4-Pin G24q :: aus wechsel-pl-c-g24q ===== */
/* ============================================================
   LMM Ratgeber-Modul — Umschalter „2-Pin (G24d) ↔ 4-Pin (G24q)“ (id=pinmode)
   Artikel: wechsel-pl-c-g24q

   Eigenstaendiges Snippet NUR fuer diesen Ratgeber. shared/ratgeber-modules.js
   bleibt unberuehrt; preview.html laedt dieses Snippet ZUSAETZLICH zur Basis.
   Im Shopify-Theme spaeter als Section-Asset/Snippet uebernehmen.

   Form = TOGGLE (zwei echte <button>): „2-Pin (G24d)“ / „4-Pin (G24q)“.
   Je Modus erscheint der Vorschaltgeraet-Kontext + LED-Weg in einer
   aria-live="polite"-Box. aria-pressed markiert den gedrueckten Zustand.
   Hoehen-Lock (beide Modi messen -> minHeight) gegen Springen der Box.
   Default = 4-Pin (= dieser Artikel; = statischer Fallback ohne JS).
   No-op, wenn #pinmode fehlt.

   DATENEHRLICH (KLL/Betriebsgeraet — hoechste Vorsicht): KEINE pauschale
   Kompatibilitaet, KEINE erfundenen Schwellen. 2-Pin G24d = integrierter
   Starter, magnetisches VG (KVG/VVG). 4-Pin G24q = kein Starter, EVG. Der
   EVG-Weg gilt nur mit herstellerseitiger Freigabe (Kompatibilitaetsliste/
   Datenblatt); Umverdrahtung -> Elektrofachkraft.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('pinmode');
  if (!box) return;
  var btn2 = document.getElementById('pinmode-2pin');
  var btn4 = document.getElementById('pinmode-4pin');
  var out = document.getElementById('pinmode-out');
  if (!btn2 || !btn4 || !out) return;

  var btns = [btn2, btn4];

  // Reihenfolge: 0 = 2-Pin (G24d) · 1 = 4-Pin (G24q). Index 1 ist Default (dieser Artikel).
  // [Ergebnis-Kennzeile, Hinweis-HTML inkl. interner Links (data-todo)]
  var DATA = [
    ['2-Pin G24d (Dulux D) → integrierter Starter, magnetisches VG (KVG/VVG)',
     'Die <strong>2-Pin-Variante mit G24d-Sockel</strong> (Osram <strong>Dulux D</strong>) hat einen <strong>im Sockel integrierten Starter</strong> und läuft typischerweise an einem <strong>konventionellen, magnetischen Vorschaltgerät</strong> (KVG/VVG). Für den LED-Wechsel ist das ein anderer Fall als hier — er wird im Schwester-Ratgeber behandelt. <a href="/blogs/ratgeber/wechsel-pl-c-g24d" class="sock-link" data-todo="link-pruefen">Zum 2-Pin-Ratgeber (G24d) &#8594;</a>'],
    ['4-Pin G24q (Dulux D/E) → kein Starter, elektronisches VG (EVG)',
     'Die <strong>4-Pin-Variante mit G24q-Sockel</strong> (Osram <strong>Dulux D/E</strong>, Philips <strong>PL-C 4-Pin</strong>) hat <strong>keinen integrierten Starter</strong> und ist für den Betrieb an einem <strong>elektronischen Vorschaltgerät (EVG)</strong> gebaut. Beim LED-Wechsel gibt es zwei Wege: eine <strong>EVG-kompatible LED</strong> am vorhandenen Gerät (nur mit herstellerseitiger Freigabe) oder das <strong>Überbrücken des EVG</strong> und Betrieb an 230 V durch eine Elektrofachkraft. <a href="/collections/g24q-led-leuchtmittel" class="sock-link">G24q-LED ansehen &#8594;</a>']
  ];

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    out.innerHTML =
      '<span class="pinmode-code">' + DATA[i][0] + '</span>' +
      '<p class="finder-note">' + DATA[i][1] + '</p>';
  }
  btn2.addEventListener('click', function () { select(0); });
  btn4.addEventListener('click', function () { select(1); });
  select(1); // Default = 4-Pin (= dieser Artikel = statischer Fallback)

  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Umschalten.
  function lock() {
    var cur = out.innerHTML, max = 0;
    out.style.minHeight = '';
    [0, 1].forEach(function (i) {
      out.innerHTML =
        '<span class="pinmode-code">' + DATA[i][0] + '</span>' +
        '<p class="finder-note">' + DATA[i][1] + '</p>';
      if (out.offsetHeight > max) max = out.offsetHeight;
    });
    out.innerHTML = cur;
    out.style.minHeight = max + 'px';
  }
  lock();
  var pmT;
  window.addEventListener('resize', function () { clearTimeout(pmT); pmT = setTimeout(lock, 150); });
})();


/* ===== BATCH 2326-2330 / Wechsel-Serie Tier 2 (2026-06-18) :: s14calc :: Rechner Linestra -> LED Stromkosten :: aus wechsel-osram-linestra-s14 ===== */
/* ============================================================
   LMM Ratgeber-Modul — Stromkosten-Rechner „Linestra → LED“ (id=s14calc)
   Artikel: wie-wechsle-ich-eine-osram-linestra-s14d-s14s-mit-einem-led-ersatz

   FOLDER-LOKAL gebaut (jetzt in shared/ratgeber-modules.js), damit die geteilte
   Datei unberührt bleibt. Wird später in shared/ integriert; im Theme als
   Section-Asset/Snippet übernehmen. ID-gekoppelt an #s14calc, sonst No-op.

   FORM: zwei Eingaben — alte Linestra-Leistung (Slider über typische Stufen
   35/60/120 W als Orientierung; Datenblatt maßgeblich) und Betriebsstunden/Tag.
   Ausgabe: grobe Stromkosten/Jahr ALT vs. LED + Ersparnis. Reine, transparente
   Arithmetik: kWh = W × h × 365 ÷ 1000; € = kWh × Strompreis.

   DATENEHRLICH (höchste Vorsicht):
   - Strompreis-Annahme 0,40 €/kWh wird sichtbar ausgewiesen (in #s14calc-note).
   - Alte Watt-Stufen 35/60/120 W = Orientierung (alle drei als reale GSC-Money-
     Queries belegt; je Lampe auf Packung/Datenblatt ablesen).
   - LED-Aufnahme als BEREICH, KEIN erfundener Fixwert: aus realen LEDVANCE-
     Ledinestra-Daten (S14d 300 mm ~3 W, S14d 500 mm ~5 W, S14s 1000 mm ~10 W;
     ex 40/75 W). Die LED-Spalte ist Orientierung/Lumen-Matching, maßgeblich bleibt
     das Datenblatt — deshalb als Spanne „~lo–hi W“ dargestellt.
   - prefers-reduced-motion respektiert (Slider ohne Animation; CSS deaktiviert
     Transitions zusätzlich).
   - Höhen-Lock auf #s14calc-note (längste Stufe messen), damit die Karte beim
     Schieben/Tippen nicht springt.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('s14calc');
  if (!box) return;

  var wattRange = box.querySelector('#s14calc-watt');
  var hours = box.querySelector('#s14calc-hours');
  var oldOut = box.querySelector('#s14calc-old');   // €/Jahr alt
  var ledOut = box.querySelector('#s14calc-led');   // €/Jahr LED (Bereich)
  var saveOut = box.querySelector('#s14calc-save');  // Ersparnis €/Jahr (Bereich)
  var note = box.querySelector('#s14calc-note');   // Annahmen + Lumen-/Datenblatt-Hinweis
  // optionale Live-Anzeigen der Eingabewerte (nicht zwingend im Markup)
  var wattO = box.querySelector('#s14calc-watt-o');
  var hoursO = box.querySelector('#s14calc-hours-o');
  if (!wattRange || !hours || !oldOut || !ledOut || !saveOut || !note) return;

  var PRICE = 0.40; // €/kWh — sichtbare Annahme (siehe Hinweistext)

  // Alte Linestra-Leistung -> [Watt, LED-Aufnahme lo (W), LED-Aufnahme hi (W), Längen-/Sockel-Orientierung]
  // LED-Bereiche aus realen LEDVANCE-Ledinestra-Daten (Orientierung, kein Fixwert je Produkt).
  var STOPS = [
    [35, 3, 5, 'meist die kürzeren Linienlampen (rund 300–500 mm), oft mit Mittelsockel S14d'],
    [60, 4, 7, 'die häufigste Stufe (rund 500 mm), je nach Leuchte S14s an den Enden oder S14d mittig'],
    [120, 8, 11, 'die langen Linienlampen (rund 1000 mm), häufig S14s an beiden Enden']
  ];

  var fE = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var f0 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

  function stop() {
    var i = parseInt(wattRange.value, 10);
    return STOPS[i] || STOPS[1];
  }

  function eurPerYear(watt, h) {
    var kwh = watt * h * 365 / 1000;
    return kwh * PRICE;
  }

  function noteHtml(s, h) {
    var w = s[0], lo = s[1], hi = s[2], where = s[3];
    return 'Annahmen: <strong>' + f0.format(h) + ' h/Tag</strong>, Strompreis <strong>0,40 €/kWh</strong> — ' +
      'beides anpassbar. Die alte Linestra mit <strong>' + w + ' W</strong> steht für ' + where + '. ' +
      'Als LED reichen grob <strong>~' + lo + '–' + hi + ' W</strong> (Orientierung) — wählen Sie nach dem ' +
      '<strong>Lumenwert</strong> der alten Lampe, nicht nach Watt. Der genaue LED-Wert steht im Datenblatt.';
  }

  function render() {
    var s = stop();
    var w = s[0], lo = s[1], hi = s[2];
    var h = parseFloat(hours.value);
    if (!isFinite(h) || h < 0) h = 0;
    if (h > 24) h = 24; // HTML-max=24 auch bei manueller Eingabe durchsetzen

    if (wattO) wattO.textContent = w + ' W';
    if (hoursO) hoursO.textContent = f0.format(h) + ' h/Tag';

    var eOld = eurPerYear(w, h);
    var eLedLo = eurPerYear(lo, h);
    var eLedHi = eurPerYear(hi, h);
    // Ersparnis = alt minus LED; größere Ersparnis bei kleinerer LED-Aufnahme
    var saveHi = Math.max(0, eOld - eLedLo);
    var saveLo = Math.max(0, eOld - eLedHi);

    oldOut.textContent = fE.format(eOld) + ' €';
    ledOut.textContent = '~ ' + fE.format(eLedLo) + '–' + fE.format(eLedHi) + ' €';
    saveOut.textContent = '~ ' + fE.format(saveLo) + '–' + fE.format(saveHi) + ' €';

    note.innerHTML = noteHtml(s, h);

    wattRange.setAttribute('aria-valuetext',
      w + ' Watt alte Linestra. Stromkosten rund ' + fE.format(eOld) + ' Euro pro Jahr, als LED etwa ' +
      fE.format(eLedLo) + ' bis ' + fE.format(eLedHi) + ' Euro, Ersparnis rund ' +
      fE.format(saveLo) + ' bis ' + fE.format(saveHi) + ' Euro pro Jahr.');
  }

  // Höhen-Lock: längste Note-Variante über alle Watt-Stufen messen, Mindesthöhe fixieren.
  function lockHeight() {
    var prevW = wattRange.value, prevH = hours.value, maxH = 0;
    note.style.minHeight = '';
    for (var i = 0; i < STOPS.length; i++) {
      note.innerHTML = noteHtml(STOPS[i], parseFloat(prevH) || 4);
      if (note.offsetHeight > maxH) maxH = note.offsetHeight;
    }
    if (maxH > 0) note.style.minHeight = maxH + 'px';
    wattRange.value = prevW;
    hours.value = prevH;
    render();
  }

  wattRange.addEventListener('input', render);
  wattRange.addEventListener('change', render);
  hours.addEventListener('input', render);
  hours.addEventListener('change', render);

  // erst Höhe locken (misst alle Stufen), dann auf Default zeichnen
  lockHeight();

  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(lockHeight, 150); });
})();

/* ===== BATCH 2331-2335 / Wechsel-Serie (2026-06-18) :: eslweg :: Entscheidungs-Wegweiser Energiesparlampe -> LED :: aus wechsel-energiesparlampe ===== */
/* ============================================================
   LMM Ratgeber-Modul — Entscheidungs-Wegweiser „Welcher LED-Weg?“ (id=eslweg)
   Artikel: wie-wechsle-ich-eine-energiesparlampe-mit-einem-led-ersatz

   Eigenstaendiges Snippet NUR fuer diesen Ratgeber. shared/ratgeber-modules.js
   bleibt unberuehrt; preview.html laedt dieses Snippet ZUSAETZLICH zur Basis.
   Im Shopify-Theme spaeter als Section-Asset/Snippet uebernehmen (NICHT in shared/).

   Form = VERZWEIGTER WEGWEISER (neu in der Serie). Frage 1 (Sockel) verzweigt;
   im Schraubsockel-Zweig folgt Frage 2 (Dimmer):
     Schritt 1 — „Welcher Sockel?“
       a) Schraubsockel E27/E14 (Retrofit-Energiesparlampe, integriertes VG)
          -> Schritt 2 „Dimmer vorhanden?“ (ja/nein) -> Ergebnis: direkter
             1:1-LED-Tausch (Lumen matchen); bei Dimmer dimmbare LED noetig.
       b) Stiftsockel G23/G24/2G11 ... (Stecksockel-KLL, EXTERNES VG)
          -> Ergebnis: kein direkter Tausch -> Stecksockel-Guides (zwei Wege:
             EVG-LED mit Freigabe / Umverdrahtung durch Fachkraft). Querlinks data-todo.

   Technik wie pinmode/erslampe: ID-gekoppelte IIFE, Guard if(!box)return; echte
   <button>+aria-pressed, Ergebnis in aria-live="polite"-Box, Hoehen-Lock (laengsten
   Zustand messen -> minHeight; bei resize debounced ~150 ms neu locken),
   prefers-reduced-motion via CSS. Alle IDs/Klassen Praefix eslweg-. Default-Zustand
   = Sockel-Schritt sichtbar (statischer Fallback ohne JS sinnvoll).

   WICHTIG (Code-Review-Lektion): Wrapper-ID #eslweg != Ueberschriften-/Anker-ID.
   Die zugehoerige H2 hat id="eslweg-section", der TOC-Link zeigt auf #eslweg-section.

   DATENEHRLICH (KLL/Betriebsgeraet — hoechste Vorsicht): KEINE pauschale
   Kompatibilitaet, KEINE erfundenen Watt-/Lumen-Festwerte. Retrofit-ESL (E27/E14)
   = integriertes VG, 230 V -> direkter Tausch, Lumen matchen. Stecksockel-KLL
   (Stiftsockel) = externes VG -> NICHT direkt, eigener Weg (Schwester-Guides).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('eslweg');
  if (!box) return;

  // Schritt-1-Buttons (Sockel) und optionale Schritt-2-Buttons (Dimmer).
  var btnScrew = document.getElementById('eslweg-screw');
  var btnPin = document.getElementById('eslweg-pin');
  var step2 = document.getElementById('eslweg-step2');     // Dimmer-Folgefrage (nur Schraub-Zweig)
  var btnDimYes = document.getElementById('eslweg-dim-yes');
  var btnDimNo = document.getElementById('eslweg-dim-no');
  var out = document.getElementById('eslweg-out');
  if (!btnScrew || !btnPin || !out) return;

  var sockBtns = [btnScrew, btnPin];
  var dimBtns = (btnDimYes && btnDimNo) ? [btnDimYes, btnDimNo] : [];

  // Ergebnis-Texte. [Kennzeile, Hinweis-HTML inkl. interner Links (data-todo)].
  // KEINE erfundenen Festwerte; „Lumen matchen“ konsequent. Stecksockel routet in die Schwester-Guides.
  var RES = {
    screwBase: ['Schraubsockel E27/E14 (Retrofit-Energiesparlampe) → direkter LED-Tausch',
      'Eine <strong>Energiesparlampe mit Schraubsockel E27 oder E14</strong> hat ihr <strong>Vorschaltgerät bereits eingebaut</strong> und läuft an 230 V. Der LED-Ersatz ist deshalb in der Regel ein <strong>direkter 1:1-Tausch ohne Umbau</strong>: alte Lampe heraus, passende LED hinein. Entscheidend ist die <strong>Helligkeit in Lumen</strong> (auf der Packung), nicht die Wattzahl. Eine letzte Frage noch — wird die Lampe über einen <strong>Dimmer</strong> betrieben?'],
    screwDimNo: ['Schraubsockel, kein Dimmer → LED nach Lumen wählen, fertig',
      'Ohne Dimmer ist der Wechsel unkompliziert: Wählen Sie eine <strong>E27- bzw. E14-LED</strong> mit der <strong>gewohnten Helligkeit (Lumen)</strong> und der gewünschten Lichtfarbe — warmweiß (rund 2700 K) entspricht dem gewohnten Energiesparlampen-Licht. Dann LED einsetzen und einschalten. <a href="/collections/led-lampen" class="sock-link" data-todo="link-pruefen">E27-/E14-LED ansehen →</a>'],
    screwDimYes: ['Schraubsockel mit Dimmer → ausdrücklich dimmbare LED wählen',
      'Am Dimmer brauchen Sie eine <strong>ausdrücklich als dimmbar gekennzeichnete LED</strong> — eine nicht dimmbare LED am Dimmer flackert oder fällt aus. Achten Sie auf den Hinweis „dimmbar“ auf der Packung und darauf, dass LED und Dimmer zusammenpassen; sonst gelten dieselben Punkte (E27/E14, Lumen statt Watt). <a href="/collections/dimmbare-led-lampen" class="sock-link" data-todo="link-pruefen">Dimmbare LED ansehen →</a>'],
    pin: ['Stiftsockel (G23/G24/2G11 …) → externes Vorschaltgerät, kein direkter Tausch',
      'Hat die Lampe statt eines Schraubgewindes <strong>Stifte</strong> (z. B. G23, G24, 2G11), ist das <strong>keine</strong> Retrofit-Energiesparlampe, sondern eine <strong>Stecksockel-Kompaktleuchtstofflampe mit externem Vorschaltgerät</strong> (PL-C, PL-S, PL-L). Sie läuft <strong>nicht</strong> direkt an 230 V. Beim LED-Wechsel gibt es zwei Wege — eine EVG-kompatible LED nur mit Hersteller-Freigabe oder das Umverdrahten durch eine Elektrofachkraft. Die passende Anleitung steht in den Stecksockel-Ratgebern: <a href="/blogs/ratgeber/wechsel-pl-c-g24d" class="sock-link" data-todo="link-pruefen">PL-C / Dulux D (G24d) →</a> · <a href="/blogs/ratgeber/wechsel-pl-l-2g11" class="sock-link" data-todo="link-pruefen">PL-L / Dulux L (2G11) →</a>']
  };

  function render(key) {
    out.innerHTML =
      '<span class="eslweg-code">' + RES[key][0] + '</span>' +
      '<p class="finder-note">' + RES[key][1] + '</p>';
  }

  function pressSock(i) {
    sockBtns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
  }
  function clearDim() {
    dimBtns.forEach(function (b) {
      b.classList.remove('is-on');
      b.setAttribute('aria-pressed', 'false');
    });
  }
  function showStep2(show) {
    if (!step2) return;
    step2.hidden = !show;
  }

  // Schritt 1 — Sockel
  btnScrew.addEventListener('click', function () {
    pressSock(0);
    clearDim();
    showStep2(true);          // Dimmer-Folgefrage einblenden
    render('screwBase');      // Zwischenergebnis: direkter Tausch + Dimmerfrage
  });
  btnPin.addEventListener('click', function () {
    pressSock(1);
    clearDim();
    showStep2(false);         // Stiftsockel -> keine Dimmerfrage
    render('pin');
  });

  // Schritt 2 — Dimmer (nur Schraub-Zweig)
  if (dimBtns.length) {
    btnDimYes.addEventListener('click', function () {
      dimBtns[0].classList.add('is-on'); dimBtns[0].setAttribute('aria-pressed', 'true');
      dimBtns[1].classList.remove('is-on'); dimBtns[1].setAttribute('aria-pressed', 'false');
      render('screwDimYes');
    });
    btnDimNo.addEventListener('click', function () {
      dimBtns[1].classList.add('is-on'); dimBtns[1].setAttribute('aria-pressed', 'true');
      dimBtns[0].classList.remove('is-on'); dimBtns[0].setAttribute('aria-pressed', 'false');
      render('screwDimNo');
    });
  }

  // Startzustand = Schraubsockel-Zweig mit Dimmerfrage (haeufigster Fall; = statischer Fallback).
  pressSock(0);
  showStep2(true);
  render('screwBase');

  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Umschalten.
  function lock() {
    var cur = out.innerHTML, max = 0;
    out.style.minHeight = '';
    Object.keys(RES).forEach(function (k) {
      out.innerHTML =
        '<span class="eslweg-code">' + RES[k][0] + '</span>' +
        '<p class="finder-note">' + RES[k][1] + '</p>';
      if (out.offsetHeight > max) max = out.offsetHeight;
    });
    out.innerHTML = cur;
    out.style.minHeight = max + 'px';
  }
  lock();
  var ewT;
  window.addEventListener('resize', function () { clearTimeout(ewT); ewT = setTimeout(lock, 150); });
})();

/* ===== BATCH 2331-2335 / Wechsel-Serie (2026-06-18) :: f2calc :: Stromkosten-/Amortisations-Rechner Dulux F 2G10 -> LED :: aus wechsel-osram-dulux-f-2g10 ===== */
/* ============================================================
   LMM Ratgeber-Modul — Stromkosten-/Amortisations-Rechner „Dulux F (2G10) → LED“ (id=f2calc)
   Artikel: wie-wechsle-ich-eine-osram-dulux-f-2g10-4pin-mit-einem-led-ersatz

   FOLDER-LOKAL gebaut (module.snippet.js). shared/ratgeber-modules.js bleibt
   UNBERUEHRT. Wird spaeter dort integriert; im Theme als Section-Asset/Snippet
   uebernehmen. ID-gekoppelt an #f2calc, sonst No-op (Guard if(!box)return;).

   FORM: zwei Eingaben — alte Dulux-F-Leistung (Slider ueber die belegten Stufen
   18/24/36 W ODER freie Watt-Eingabe) und Betriebsstunden/Tag (Default 8 h, Buero).
   Ausgabe: grobe Stromkosten/Jahr ALT vs. LED (Bereich) + Ersparnis/Jahr (Bereich).
   Reine, transparente Arithmetik: kWh = W x h x 365 / 1000; EUR = kWh x Strompreis.

   DATENEHRLICH (hoechste Vorsicht, KLL/Betriebsgeraet):
   - Strompreis-Annahme 0,40 EUR/kWh wird sichtbar ausgewiesen (in #f2calc-note).
   - Alte Watt-Stufen 18/24/36 W = belegt (eigene Osram-Dulux-F-PDP-Slugs + GSC-
     Money-Queries 2g10 36w / 2g10 24w / osram dulux f 36w/840). Freie Eingabe
     erlaubt; in JS auf 5..80 W geclampt (auch bei manueller Eingabe).
   - LED-Aufnahme als BEREICH, KEIN erfundener Fixwert: aus realen LEDVANCE/Osram-
     Dulux-LED-F-Daten (LED 20 W ersetzt 36 W KLL; LED 12 W ersetzt 24 W KLL;
     8-W-Varianten existieren). LED-Spalte ist Orientierung/Lumen-Matching,
     maszgeblich bleibt das Datenblatt — deshalb als Spanne „~lo-hi W“.
   - Bei freier Watt-Eingabe ohne belegte Stufe: LED-Bereich grob ueber Faktor
     interpoliert (lo ~ alt/3.2, hi ~ alt/1.8), klar als grobe Schaetzung markiert.
   - LED bei Dulux F = „EM & AC MAINS“ (KVG/VVG ODER Netzspannung), NICHT fuer EVG
     — Hinweis im Notiztext, aber der Rechner rechnet nur Energie/Kosten.
   - VG-Verlust der alten KLL nur QUALITATIV erwaehnt (nicht in die Zahl gerechnet,
     da produktabhaengig) — macht die echte Ersparnis eher noch groeszer.
   - prefers-reduced-motion respektiert (Slider ohne Animation; CSS deaktiviert
     Transitions zusaetzlich).
   - Hoehen-Lock auf #f2calc-note (laengste Variante messen), damit die Karte beim
     Schieben/Tippen nicht springt; bei resize debounced neu locken.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('f2calc');
  if (!box) return;

  var wattRange = box.querySelector('#f2calc-watt');
  var wattNum = box.querySelector('#f2calc-watt-num'); // freie Watt-Eingabe (optional)
  var hours = box.querySelector('#f2calc-hours');
  var oldOut = box.querySelector('#f2calc-old');   // EUR/Jahr alt
  var ledOut = box.querySelector('#f2calc-led');   // EUR/Jahr LED (Bereich)
  var saveOut = box.querySelector('#f2calc-save');  // Ersparnis EUR/Jahr (Bereich)
  var note = box.querySelector('#f2calc-note');   // Annahmen + Lumen-/Datenblatt-Hinweis
  var wattO = box.querySelector('#f2calc-watt-o'); // Live-Anzeige Watt (optional)
  if (!wattRange || !hours || !oldOut || !ledOut || !saveOut || !note) return;

  var PRICE = 0.40; // EUR/kWh — sichtbare Annahme (siehe Hinweistext)
  var W_MIN = 5, W_MAX = 80; // Watt-Clamp (auch bei manueller Eingabe)

  // Belegte Dulux-F-Stufen -> [Watt, LED-Aufnahme lo (W), LED-Aufnahme hi (W), Einordnung]
  // LED-Bereiche an belegten LEDVANCE/Osram-Aequivalenzen orientiert (24 W KLL ~ 12 W LED,
  // 36 W KLL ~ 20 W LED); konservativ gewaehlt (untere Enden angehoben), Orientierung —
  // kein Fixwert je Produkt. Codex-Review 2026-06-19.
  var STOPS = [
    [18, 9, 12, 'die kleinste gängige Dulux F — häufig in flachen Wand-, Decken- und Spiegelleuchten'],
    [24, 11, 14, 'die mittlere Stufe — oft in Bad-, Flur- und Büroleuchten'],
    [36, 18, 22, 'die größte gängige Dulux F — typisch in Büros und größeren Flachleuchten']
  ];

  var fE = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var f0 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

  function clampW(w) {
    if (!isFinite(w)) return 24;
    if (w < W_MIN) return W_MIN;
    if (w > W_MAX) return W_MAX;
    return w;
  }

  // LED-Bereich fuer eine beliebige alte Leistung:
  // - exakte belegte Stufe -> belegter Bereich
  // - sonst grobe Interpolation ueber Faktor (klar als Schaetzung markiert)
  function ledRange(w, exact) {
    if (exact) return [exact[1], exact[2], true];
    var lo = Math.max(3, Math.round(w / 2.0));
    var hi = Math.max(lo + 1, Math.round(w / 1.6));
    return [lo, hi, false];
  }

  // aktuelle alte Leistung + (falls vorhanden) belegte Stufe
  function current() {
    var w, exact = null;
    // freie Eingabe hat Vorrang, falls genutzt und gueltig
    if (wattNum && wattNum.value !== '' && isFinite(parseFloat(wattNum.value))) {
      w = clampW(parseFloat(wattNum.value));
    } else {
      var i = parseInt(wattRange.value, 10);
      if (isNaN(i) || i < 0 || i >= STOPS.length) i = 2; // Default 36 W (groesste belegte Stufe)
      exact = STOPS[i];
      w = exact[0];
    }
    // belegte Stufe auch bei freier Eingabe erkennen (Punktlandung 18/24/36)
    if (!exact) {
      for (var k = 0; k < STOPS.length; k++) { if (STOPS[k][0] === w) { exact = STOPS[k]; break; } }
    }
    return { w: w, exact: exact };
  }

  function eurPerYear(watt, h) {
    var kwh = watt * h * 365 / 1000;
    return kwh * PRICE;
  }

  function noteHtml(w, lo, hi, isExact, where, h) {
    var ledClause = isExact
      ? 'Als LED reichen grob <strong>~' + lo + '-' + hi + ' W</strong> (Orientierung aus typischen Dulux-LED-F-Daten)'
      : 'Als LED grob <strong>~' + lo + '-' + hi + ' W</strong> (sehr grobe Schätzung für ' + w + ' W — belegt sind 18/24/36 W)';
    var whereClause = where ? (' Die alte Dulux F mit <strong>' + w + ' W</strong> ist ' + where + '.') : '';
    return 'Annahmen: <strong>' + f0.format(h) + ' h/Tag</strong>, Strompreis <strong>0,40 EUR/kWh</strong> — ' +
      'beides anpassbar.' + whereClause + ' ' + ledClause + ' — wählen Sie nach dem ' +
      '<strong>Lumenwert</strong> der alten Lampe, nicht nach Watt. Der genaue LED-Wert steht im Datenblatt; ' +
      'das Vorschaltgerät der alten KLL verbraucht zusätzlich Strom, sodass die echte Ersparnis eher noch größer ausfällt.';
  }

  function render() {
    var c = current();
    var w = c.w;
    var r = ledRange(w, c.exact);
    var lo = r[0], hi = r[1], isExact = r[2];
    var where = c.exact ? c.exact[3] : '';

    var h = parseFloat(hours.value);
    if (!isFinite(h) || h < 0) h = 0;
    if (h > 24) h = 24; // HTML-max=24 auch bei manueller Eingabe durchsetzen

    if (wattO) wattO.textContent = w + ' W';

    var eOld = eurPerYear(w, h);
    var eLedLo = eurPerYear(lo, h);
    var eLedHi = eurPerYear(hi, h);
    // Ersparnis = alt minus LED; groeszere Ersparnis bei kleinerer LED-Aufnahme
    var saveHi = Math.max(0, eOld - eLedLo);
    var saveLo = Math.max(0, eOld - eLedHi);

    oldOut.textContent = fE.format(eOld) + ' EUR';
    ledOut.textContent = '~ ' + fE.format(eLedLo) + '-' + fE.format(eLedHi) + ' EUR';
    saveOut.textContent = '~ ' + fE.format(saveLo) + '-' + fE.format(saveHi) + ' EUR';

    note.innerHTML = noteHtml(w, lo, hi, isExact, where, h);

    wattRange.setAttribute('aria-valuetext',
      w + ' Watt alte Dulux F. Stromkosten rund ' + fE.format(eOld) + ' Euro pro Jahr, als LED etwa ' +
      fE.format(eLedLo) + ' bis ' + fE.format(eLedHi) + ' Euro, Ersparnis rund ' +
      fE.format(saveLo) + ' bis ' + fE.format(saveHi) + ' Euro pro Jahr.');
  }

  // Hoehen-Lock: laengste Note-Variante ueber alle Stufen + eine Schaetz-Variante messen.
  function lockHeight() {
    var prevRange = wattRange.value, prevNum = wattNum ? wattNum.value : '', prevH = hours.value;
    var hMeas = parseFloat(prevH) || 8, maxH = 0;
    note.style.minHeight = '';
    // belegte Stufen messen
    for (var i = 0; i < STOPS.length; i++) {
      var s = STOPS[i];
      note.innerHTML = noteHtml(s[0], s[1], s[2], true, s[3], hMeas);
      if (note.offsetHeight > maxH) maxH = note.offsetHeight;
    }
    // eine Schaetz-Variante (freie Eingabe, laengster Text) mitmessen
    note.innerHTML = noteHtml(40, 20, 25, false, '', hMeas);
    if (note.offsetHeight > maxH) maxH = note.offsetHeight;
    if (maxH > 0) note.style.minHeight = maxH + 'px';
    wattRange.value = prevRange;
    if (wattNum) wattNum.value = prevNum;
    hours.value = prevH;
    render();
  }

  // Slider und freie Eingabe schliessen sich gegenseitig „weich“ aus:
  // Slider-Bewegung leert das freie Feld (Slider gewinnt); Tippen ins Feld gewinnt beim naechsten render.
  wattRange.addEventListener('input', function () { if (wattNum) wattNum.value = ''; render(); });
  wattRange.addEventListener('change', function () { if (wattNum) wattNum.value = ''; render(); });
  if (wattNum) {
    wattNum.addEventListener('input', render);
    wattNum.addEventListener('change', function () {
      if (wattNum.value !== '' && isFinite(parseFloat(wattNum.value))) {
        wattNum.value = clampW(parseFloat(wattNum.value)); // sichtbar clampen
      }
      render();
    });
  }
  hours.addEventListener('input', render);
  hours.addEventListener('change', render);

  // erst Hoehe locken (misst alle Varianten), dann auf Default zeichnen
  lockHeight();

  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(lockHeight, 150); });
})();

/* ===== BATCH 2331-2335 / Wechsel-Serie (2026-06-18) :: ringsel :: Ringgroessen-Selektor Ringform G10q -> LED :: aus wechsel-ringform-g10q ===== */
/* ============================================================
   LMM Ratgeber-Modul — Ringgrößen-Selektor „Welche Ringform habe ich?“ (id=ringsel)
   Artikel: wie-wechsle-ich-eine-philips-osram-l-c-ringform-g10q-4pin-mit-einem-led-ersatz

   Eigenstaendiges Snippet NUR fuer diesen Ratgeber. shared/ratgeber-modules.js
   bleibt unberuehrt; preview.html laedt dieses Snippet ZUSAETZLICH zur Basis.
   Im Shopify-Theme spaeter als Section-Asset/Snippet uebernehmen.

   Form = GROESSEN-SELEKTOR (mehrere echte <button>, analog erslampe/pinmode):
   „22 W / Ø 212 mm“ / „32 W / Ø 300 mm“ / „40 W / Ø 400 mm“. Je Auswahl erscheint
   die belegte LED-Ring-Orientierung (LED-Watt-Bereich, Lumen laut Datenblatt,
   Kompatibilitaet herstellerabhaengig) in einer aria-live="polite"-Box, plus eine
   rein DEKORATIVE SVG-Ring-Illustration, die mit der Auswahl skaliert/hervorhebt
   (kein massstabsgetreues Mass — aria-hidden).

   Technik identisch zum erslampe-/pinmode-Muster: echte <button> (tastaturbedienbar),
   select(i) schaltet aria-pressed + .is-on und schreibt Ergebnis + Ring-Skalierung.
   Default = erster Button (= statischer Fallback ohne JS). Hoehen-Lock gegen
   Springen der Box (laengster Zustand gemessen, resize debounced). No-op, wenn
   #ringsel fehlt. prefers-reduced-motion: Ring-Transition wird per CSS abgeschaltet.

   DATENEHRLICH (KLL/Betriebsgeraet — hoechste Vorsicht): KEINE pauschale
   Kompatibilitaet, KEINE erfundenen Schwellen. Ringform laeuft am externen VG
   (klassisch KVG/VVG mit Starter -> LED-Starter-Tausch; EVG -> ueberbruecken/
   entfernen, Elektrofachkraft). Belegte Werte (Original + LEDVANCE/Osram T9C-
   Datenblatt): 22 W ca. Ø 212 mm / LED ~11 W / 1320 lm; 32 W ca. Ø 300 mm /
   LED ~18 W / 2200 lm; 40 W ca. Ø 400 mm / LED ~24 W / 2900 lm. Ring-Ø-Toleranz
   je Hersteller; Lumen der alten KLL = Datenluecke (Datenblatt). Exakte Eignung
   je Produkt -> Datenblatt. Collection-Links = data-todo.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('ringsel');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.ringsel-btn'));
  var val = document.getElementById('ringsel-val');
  var note = document.getElementById('ringsel-note');
  var ring = document.getElementById('ringsel-ring'); // dekoratives SVG-<circle> (optional)
  if (!btns.length || !val || !note) return;

  // Reihenfolge identisch zu den Buttons in preview.html / body.html.
  // [Ergebnis-Kennzeile (alte Ringform -> LED-Orientierung), Hinweis-HTML, relative Ring-Skalierung 0..1]
  var DATA = [
    ['22 W · Ø ca. 216 mm (T9-C) → LED-Ring ca. 11 W',
     'Die kleine Ringform (Osram <strong>L 22 W C</strong>, Philips <strong>TL-E 22 W</strong>) hat einen <strong>Außendurchmesser von rund 216 mm</strong> (Rohr T9, Ø 29 mm) und den <strong>4-Pin-Sockel G10q</strong>. Als LED-Ring-Retrofit führt LEDVANCE hier den Typ um <strong>11 W</strong> mit rund <strong>1320 lm</strong> (laut Datenblatt). Wählen Sie nach <strong>Durchmesser und Lumen</strong>, nicht nach Watt — und passend zu Ihrem Vorschaltgerät. <a href="/collections/t9-led-roehren-ringform" class="sock-link">Ring-LED ansehen →</a>',
     0.62],
    ['32 W · Ø ca. 305 mm (T9-C) → LED-Ring ca. 18 W',
     'Die mittlere Ringform (Osram <strong>L 32 W C</strong>) misst rund <strong>305 mm</strong> im Durchmesser (T9, Ø 29 mm), Sockel <strong>G10q</strong>. Als LED-Ersatz ist der Typ um <strong>18 W</strong> mit rund <strong>2200 lm</strong> belegt (Datenblatt). Auch hier gilt: <strong>Lumen statt Watt</strong>, Ring-Durchmesser muss in die Leuchte passen, Eignung fürs vorhandene Vorschaltgerät prüfen. <a href="/collections/t9-led-roehren-ringform" class="sock-link">Ring-LED ansehen →</a>',
     0.82],
    ['40 W · Ø ca. 406 mm (T9-C) → LED-Ring ca. 24 W',
     'Die große Ringform (Osram <strong>L 40 W C</strong>) hat rund <strong>406 mm</strong> Außendurchmesser (T9, Ø 29 mm), Sockel <strong>G10q</strong>. LEDVANCE führt als Ersatz den Typ um <strong>24 W</strong> mit rund <strong>2900 lm</strong> (Datenblatt). Messen Sie den Ring im Zweifel nach: Vereinzelt kursieren leicht abweichende Maße — der Wert auf Packung/Datenblatt ist maßgeblich. <a href="/collections/t9-led-roehren-ringform" class="sock-link">Ring-LED ansehen →</a>',
     1]
  ];

  function paint(i) {
    val.textContent = DATA[i][0];
    note.innerHTML = DATA[i][1];
    if (ring) {
      // Dekorativ: Radius zwischen 22 und 58 (von 64er-viewBox) anhand der relativen Groesse.
      var r = 22 + DATA[i][2] * 36;
      ring.setAttribute('r', r.toFixed(1));
    }
  }

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    paint(i);
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0); // Default = erster Button (= statischer Fallback ohne JS)

  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.ringsel-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.textContent = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var rsT;
  window.addEventListener('resize', function () { clearTimeout(rsT); rsT = setTimeout(lock, 150); });
})();

/* ===== BATCH 2331-2335 / Wechsel-Serie (2026-06-18) :: sonsys :: Klick-Grafik HID + Zuendgeraet NAV/SON -> LED :: aus wechsel-nav-son-natriumdampf ===== */
/* ============================================================
   LMM Ratgeber-Modul — Klick-Grafik „Was steckt im NAV/SON-System?“ (id=sonsys)
   Artikel: wie-wechsle-ich-eine-osram-nav-philips-son-natriumdampflampe-mit-einem-led-ersatz

   FOLDER-LOKALES MODUL — nur fuer diesen Ratgeber. shared/ratgeber-modules.js
   bleibt UNBERUEHRT; preview.html laedt zuerst die geteilte Basis
   (../shared/ratgeber-modules.js) und ZUSAETZLICH diese Datei. Im Shopify-Theme
   spaeter als Section-Asset/Snippet uebernehmen. No-op, wenn #sonsys fehlt.

   Form = KLICK-GRAFIK (analog hidsystem / nv-system in der Wechsel-Serie):
   ein SVG der Natriumdampf-Hochdruck-Installation
   Netz -> Drossel/Vorschaltgeraet -> ZUENDGERAET -> Lampe (E27/E40) mit
   DREI anklickbaren Hotspots (.sonsys-hot, role=button, tabindex=0,
   tastaturbedienbar). Klick/Enter/Space -> select(i) schaltet aria-pressed
   + .is-on und schreibt Ueberschrift/Erklaerung in
   #sonsys-val / #sonsys-note (aria-live="polite"). Default = Hotspot 1
   (= ZUENDGERAET, der LED-kritische Teil; = statischer Fallback ohne JS).
   Hoehen-Lock gegen Springen der Ergebnisbox. resize debounced.

   Eigenstaendige IDs/Klassen mit Praefix `sonsys-` -> KEIN Konflikt mit
   hidsystem / nv-system / g23parts / wechselsockel im shared-JS/-CSS.
   Wrapper-ID `sonsys` != Ueberschriften-Anker (H2 nutzt id="sonsys-section").

   DATENEHRLICH (HID/Hochdruck/Hochspannung — hoechste Vorsicht, YMYL):
   rein ERKLAEREND, KEINE erfundenen Watt/Lumen, keine pauschale Kompatibilitaet.
   Belegte Fakten: NAV (Osram, Markenname „Vialox“) = SON (Philips) =
   Natriumdampf-HOCHDRUCKlampe (HPS/HID), warm-oranges Licht, Sockel meist E27/E40.
   KERN-UNTERSCHIED zu HQL/HPL (Quecksilberdampf): Natriumdampf-Hochdruck zuendet
   NUR mit einem separaten ZUENDGERAET (Igniter, Hochspannungsimpuls) ZUSAETZLICH
   zur Drossel. Der Zuendimpuls kann ungeeignete LED-Retrofits beschaedigen.
   Zwei LED-Wege, beide herstellerabhaengig:
   (1) ein ausdruecklich fuer Zuendgeraet-/Vorschaltgeraet-Betrieb FREIGEGEBENER
       NAV-LED-Retrofit (mit Zuendimpuls-/Ueberspannungsschutz) — nicht universell;
   (2) Zuendgeraet UND Drossel entfernen/ueberbruecken, LED an 230 V
       -> Elektrofachkraft, spannungsfrei.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('sonsys');
  if (!box) return;
  var hots = [].slice.call(box.querySelectorAll('.sonsys-hot'));
  var val = document.getElementById('sonsys-val');
  var note = document.getElementById('sonsys-note');
  if (!hots.length || !val || !note) return;

  // Reihenfolge identisch zu den Hotspots im SVG (preview.html):
  // 0 = Drossel/Vorschaltgeraet (magnetisches VG)
  // 1 = Zuendgeraet (der LED-kritische Teil — Default)
  // 2 = Lampe mit Sockel E27/E40
  // [Ergebnis-Ueberschrift (HTML erlaubt), Hinweis-HTML inkl. interner Links mit data-todo]
  var DATA = [
    ['Drossel / Vorschaltger&#228;t &#8212; begrenzt den Strom',
     'Eine NAV/SON-Lampe l&#228;uft <strong>nicht direkt am Netz</strong>: Eine <strong>Drossel</strong> (magnetisches Vorschaltger&#228;t) begrenzt den Strom. Anders als die Quecksilberdampflampe (HQL/HPL) z&#252;ndet die Natriumdampf-Hochdrucklampe damit aber <strong>nicht von allein</strong> &#8211; sie braucht <strong>zus&#228;tzlich</strong> ein Z&#252;ndger&#228;t. Beim LED-Umstieg ist die Drossel daher nur die halbe Miete: F&#252;r den Direktbetrieb muss sie zusammen mit dem Z&#252;ndger&#228;t raus. <a href="/blogs/ratgeber/wechsel-hql-hpl-quecksilberdampf" class="sock-link" data-todo="link-pruefen">Quecksilberdampf (HQL/HPL) &#8211; ohne Z&#252;ndger&#228;t &#8594;</a>'],
    ['Z&#252;ndger&#228;t &#8212; der entscheidende Punkt beim LED-Wechsel',
     'Das <strong>Z&#252;ndger&#228;t</strong> (Igniter) liefert den <strong>Hochspannungs-Z&#252;ndimpuls</strong>, der den Lichtbogen der Natriumdampf-Hochdrucklampe startet. Genau das unterscheidet NAV/SON von der Quecksilberdampflampe. F&#252;r den LED-Umstieg ist es der <strong>kritische Punkt</strong>: Der Z&#252;ndimpuls kann ungeeignete LED-Retrofits <strong>besch&#228;digen</strong>. Es gibt zwei Wege, beide herstellerabh&#228;ngig &#8211; entweder ein <strong>ausdr&#252;cklich daf&#252;r freigegebener</strong> NAV-LED-Retrofit (mit Z&#252;ndimpuls-/&#220;berspannungsschutz) oder <strong>Z&#252;ndger&#228;t und Drossel entfernen</strong> und auf 230&#160;V umverdrahten. Beides geh&#246;rt in die Hand einer <strong>Elektrofachkraft</strong>. <a href="/collections/led-ersatz-entladungslampen" class="sock-link">NAV/SON-Sortiment ansehen &#8594;</a>'],
    ['Lampe &#8212; warm-orange, Sockel meist E27 oder E40',
     'Die Natriumdampf-Hochdrucklampe leuchtet charakteristisch <strong>warm-orange</strong> und sitzt in einem <strong>Schraubsockel E27 oder E40</strong> &#8211; kleinere Wattstufen oft E27, gr&#246;&#223;ere E40. Bauformen sind u.&#160;a. <strong>SON-T/NAV-T</strong> (R&#246;hre) und <strong>SON-E/NAV-E</strong> (Ellipsoid). Die LED muss denselben Sockel und eine passende Bauform haben; w&#228;hlen Sie sie nach der <strong>Helligkeit (Lumen)</strong> der alten Lampe &#8211; den Wert lesen Sie auf der Packung oder im Datenblatt ab, denn er h&#228;ngt von der konkreten Lampe ab. <a href="/blogs/ratgeber/lampensockel-uebersicht" class="sock-link" data-todo="link-pruefen">Lampensockel-&#220;bersicht &#8594;</a>']
  ];

  function select(i) {
    hots.forEach(function (h, j) {
      h.classList.toggle('is-on', j === i);
      h.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.innerHTML = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  hots.forEach(function (h, i) {
    h.addEventListener('click', function () { select(i); });
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); select(i); }
    });
  });
  select(1); // Default = Hotspot 2 (Zuendgeraet, LED-kritisch; = statischer Fallback ohne JS)

  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.sonsys-result');
  function lock() {
    if (!result) return;
    var v = val.innerHTML, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.innerHTML = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.innerHTML = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(lock, 150); });
})();

/* ===== BATCH 2331-2335 / Wechsel-Serie (2026-06-18) :: haloceram :: Sockel-Umschalter B15d <-> E27 Halolux Ceram -> LED :: aus wechsel-osram-halolux-ceram-b15d-e27 ===== */
/* ============================================================
   LMM Ratgeber-Modul — Umschalter „B15d ↔ E27“ (id=haloceram)
   Artikel: wie-wechsle-ich-eine-osram-halolux-ceram-b15d-e27-mit-einem-led-ersatz

   FOLDER-LOKALES Snippet NUR fuer diesen Ratgeber. shared/ratgeber-modules.js
   bleibt unberuehrt; preview.html laedt dieses Snippet ZUSAETZLICH zur Basis.
   Im Shopify-Theme spaeter als Section-Asset/Snippet uebernehmen.

   Form = TOGGLE (zwei echte <button>): „B15d“ / „E27“.
   Je Sockel erscheint der ehrliche LED-Weg in einer aria-live="polite"-Box.
   aria-pressed markiert den gedrueckten Zustand. Hoehen-Lock (beide Modi
   messen -> minHeight) gegen Springen der Box. prefers-reduced-motion via CSS.
   Default = E27 (haeufigerer/einfacherer Fall = statischer Fallback ohne JS).
   No-op, wenn #haloceram fehlt.

   Wrapper-ID #haloceram != Ueberschriften-Anker (#haloceram-section).

   DATENEHRLICH (Hochvolt-Halogen 230 V, KEIN Trafo):
   - E27: LED-Ersatz reichlich verfuegbar -> 1:1-Sockeltausch, nach Lumen waehlen,
     warmweiss. KEIN pauschaler Lumenwert (Datenluecke; Packung/Datenblatt).
   - B15d: seltener Sockel -> LED-Angebot eingeschraenkt, im kompakten Format kein
     1:1-Ersatz fuer hohe Wattstufen. Optionen: passende B15d-LED falls vorhanden /
     Adapter B15d->E27 / Fassungs-/Leuchtentausch. NICHTS pauschal versprechen.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('haloceram');
  if (!box) return;
  var btnB15d = document.getElementById('haloceram-b15d');
  var btnE27 = document.getElementById('haloceram-e27');
  var out = document.getElementById('haloceram-out');
  if (!btnB15d || !btnE27 || !out) return;

  var btns = [btnB15d, btnE27];

  // Reihenfolge: 0 = B15d (Bajonett) · 1 = E27 (Schraube). Index 1 ist Default (einfacher Fall).
  // [Ergebnis-Kennzeile, Hinweis-HTML inkl. interner Links (data-todo)]
  var DATA = [
    ['B15d (Bajonett) → seltener Sockel, LED-Angebot eingeschränkt',
     'Der <strong>B15d-Bajonettsockel</strong> ist heute selten — das <strong>LED-Angebot ist begrenzt</strong>, und im kompakten Format gibt es <strong>für hohe Wattstufen (etwa 150 oder 205 W) keinen 1:1-Ersatz</strong>. Drei Wege: eine <strong>B15d-LED in passender Helligkeit</strong>, falls verfügbar; ein <strong>Adapter B15d&#8594;E27</strong> plus E27-LED, sofern Platz und Bauart der Leuchte das zulassen; oder der <strong>Tausch der Fassung beziehungsweise Leuchte</strong>. Was passt, hängt von Ihrer Leuchte ab. <a href="/collections/b15-led-leuchtmittel" class="sock-link">B15d-LED ansehen &#8594;</a>'],
    ['E27 (Schraube) → LED-Ersatz reichlich, 1:1-Tausch nach Lumen',
     'Mit <strong>E27-Schraubsockel</strong> ist der Wechsel unkompliziert: LED-Ersatz ist <strong>reichlich verfügbar</strong> und wird <strong>1:1 in die Fassung geschraubt</strong>. Wählen Sie nach <strong>Lumen</strong> statt nach Watt und für gewohntes Licht <strong>warmweiß</strong> (rund 2700 K). Den passenden Lumenwert lesen Sie auf der Packung oder im Datenblatt der alten Lampe ab. <a href="/collections/e27-led-leuchtmittel" class="sock-link">E27-LED ansehen &#8594;</a>']
  ];

  function render(i) {
    return '<span class="haloceram-code">' + DATA[i][0] + '</span>' +
      '<p class="finder-note">' + DATA[i][1] + '</p>';
  }

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    out.innerHTML = render(i);
  }
  btnB15d.addEventListener('click', function () { select(0); });
  btnE27.addEventListener('click', function () { select(1); });
  select(1); // Default = E27 (= einfacher Fall = statischer Fallback ohne JS)

  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Umschalten.
  function lock() {
    var cur = out.innerHTML, max = 0;
    out.style.minHeight = '';
    [0, 1].forEach(function (i) {
      out.innerHTML = render(i);
      if (out.offsetHeight > max) max = out.offsetHeight;
    });
    out.innerHTML = cur;
    out.style.minHeight = max + 'px';
  }
  lock();
  var hcT;
  window.addEventListener('resize', function () { clearTimeout(hcT); hcT = setTimeout(lock, 150); });
})();

/* ===== BATCH 2336-2339 / Wechsel-Serie (2026-06-19) :: plfinder :: PL-Familie/Pin-Bestimmer PL-S/C/T/L -> Sockel + Vorschaltgeraet :: aus wechsel-pl-t-gx24q ===== */
/* ============================================================
   LMM Ratgeber-Modul — „PL-Lampen-Bestimmer“ (id=plfinder)
   Artikel: wechsel-pl-t-gx24q

   FOLDER-LOKAL für diesen Ratgeber. NICHT in shared/ratgeber-modules.js
   pflegen — der Haupt-Agent übernimmt diesen Block später ins shared/.
   Im Shopify-Theme als Section-Asset/Snippet umsetzen.

   FORM = ZWEISTUFIGER BESTIMMER (variiert bewusst vom 2-Button-Toggle
   „pinmode“ des G24q-Schwesterartikels):
     Stufe 1 — PL-Familie wählen: PL-S · PL-C · PL-T · PL-L (echte <button>)
     Stufe 2 — Pin-Zahl wählen: 2-Pin · 4-Pin (echte <button>, aria-pressed)
   Aus Familie + Pin-Zahl ergibt sich der belegte Sockel + Vorschaltgerät-Logik
   + der passende Ratgeber-Link. Hilft dem Nutzer, SEINE Lampe einzuordnen.
   Default = PL-T + 4-Pin (= dieser Artikel = statischer Fallback ohne JS).

   A11y: echte <button> (tastaturbedienbar) mit aria-pressed; Ergebnis in
   aria-live="polite"; Höhen-Lock (längster Zustand → minHeight, resize
   debounced); respektiert prefers-reduced-motion (keine Auto-Animation).
   No-op, wenn #plfinder fehlt (if(!box)return-Guard).

   DATENEHRLICH (KLL/Betriebsgerät — höchste Vorsicht): nur belegte Sockel-/
   Pin-/VG-Fakten (GX24q=4-Pin/EVG, GX24d=2-Pin/Starter; G24q/G24d analog für
   PL-C; 2G11 für PL-L; G23 für PL-S). KEINE pauschale Kompatibilität, KEINE
   erfundenen Watt/Lumen. LED-Weg „nur laut Datenblatt/Freigabe; im Zweifel
   Elektrofachkraft“. Quellen siehe keyword-research.md Block 7.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('plfinder');
  if (!box) return;

  var famBtns = [].slice.call(box.querySelectorAll('.plf-fam'));
  var pinBtns = [].slice.call(box.querySelectorAll('.plf-pin'));
  var sockOut = document.getElementById('plf-socket');
  var note = document.getElementById('plf-note');
  var result = box.querySelector('.plf-result');
  if (!famBtns.length || !pinBtns.length || !sockOut || !note) return;

  // Familien-Reihenfolge identisch zu den Buttons im preview.html:
  // 0 = PL-S/Dulux S · 1 = PL-C/Dulux D · 2 = PL-T/Dulux T · 3 = PL-L/Dulux L
  // Je Familie: Anzeigename, Bauform-Kurzbeschreibung,
  //   sowie pro Pin-Variante [Sockel-Kennzahl (HTML), Hinweis-HTML inkl. Link].
  // "has2"/"has4": ob die Familie diese Pin-Variante als Standard führt.
  var FAM = [
    {
      name: 'PL-S / Dulux S',
      shape: 'kurze, einfache Kompaktleuchtstofflampe (eine U-Röhre)',
      has2: true, has4: true,
      p2: ['G23 (2-Pin) → Starter integriert, KVG/VVG',
        'Die <strong>PL-S / Dulux S</strong> mit <strong>G23</strong> hat zwei Pins und einen <strong>im Sockel integrierten Starter</strong>; sie läuft typischerweise am <strong>konventionellen Vorschaltgerät (KVG/VVG)</strong>. Den Umrüst-Weg dafür beschreibt der eigene Ratgeber. <a href="/blogs/ratgeber/wechsel-pl-s-g23" class="plf-link" data-todo="link-pruefen">PL-S / Dulux S (G23) auf LED →</a>'],
      p4: ['2G7 (4-Pin) → kein Starter, am EVG',
        'Die 4-Pin-Variante der kurzen Lampe (<strong>Dulux S/E</strong>) trägt den <strong>2G7</strong>-Sockel und läuft am <strong>elektronischen Vorschaltgerät (EVG)</strong>. Für den LED-Betrieb gilt dieselbe Logik wie bei den anderen 4-Pin-Lampen: nur mit Hersteller-Freigabe oder per Umverdrahtung. <a href="/blogs/ratgeber/lampensockel-uebersicht" class="plf-link" data-todo="link-pruefen">Sockel-Übersicht →</a>']
    },
    {
      name: 'PL-C / Dulux D',
      shape: 'kurze Kompaktleuchtstofflampe mit zwei Röhren (Doppelröhre)',
      has2: true, has4: true,
      p2: ['G24d (2-Pin) → Starter integriert, KVG/VVG',
        'Die <strong>PL-C / Dulux D</strong> mit <strong>G24d</strong> hat zwei Pins, einen <strong>integrierten Starter</strong> und läuft meist am <strong>konventionellen Vorschaltgerät (KVG/VVG)</strong>. Die Codierung (G24d-1/-2/-3) muss zur Fassung passen. <a href="/blogs/ratgeber/wechsel-pl-c-g24d" class="plf-link" data-todo="link-pruefen">PL-C / Dulux D (G24d, 2-Pin) auf LED →</a>'],
      p4: ['G24q (4-Pin) → kein Starter, am EVG',
        'Die <strong>PL-C / Dulux D/E</strong> mit <strong>G24q</strong> hat vier Pins, <strong>keinen integrierten Starter</strong> und läuft am <strong>EVG</strong>. Achtung: Das ist die <strong>2-röhrige</strong> Schwester der hier behandelten 3-röhrigen PL-T — anderer Sockel (G24q statt GX24q). <a href="/blogs/ratgeber/wechsel-pl-c-g24q" class="plf-link" data-todo="link-pruefen">PL-C / Dulux D/E (G24q, 4-Pin) auf LED →</a>']
    },
    {
      name: 'PL-T / Dulux T',
      shape: 'kompakte Kompaktleuchtstofflampe mit drei Röhren (3-Röhren-Technik), größer als die PL-C',
      has2: true, has4: true,
      p2: ['GX24d (2-Pin) → Starter integriert, KVG/VVG',
        'Die <strong>PL-T / Dulux T</strong> mit <strong>GX24d</strong> hat zwei Pins, einen <strong>integrierten Starter</strong> und läuft meist am <strong>konventionellen Vorschaltgerät (KVG/VVG)</strong>. Die Codierung (GX24d-1/-2/-3) muss zur Fassung passen — wie bei der 2-Pin-PL-C, nur dreiröhrig. <a href="/blogs/ratgeber/wechsel-pl-c-g24d" class="plf-link" data-todo="link-pruefen">2-Pin-Umrüstung (Dulux D, G24d) lesen →</a>'],
      p4: ['GX24q (4-Pin) → kein Starter, am EVG &mdash; dieser Ratgeber',
        'Das ist der hier behandelte Fall: <strong>PL-T / Dulux T/E</strong> mit <strong>GX24q</strong>, vier Pins, <strong>kein integrierter Starter</strong>, Betrieb am <strong>elektronischen Vorschaltgerät (EVG)</strong>. Die Subtypen GX24q-1 bis GX24q-5 sind an die Wattstufe gekoppelt (13/18/26+32/42/57 W). Für die LED gibt es zwei Wege — EVG-kompatible LED nur mit Freigabe oder Umverdrahtung auf 230 V. <a href="/collections/gx24q-led-leuchtmittel" class="plf-link">GX24q-LED ansehen →</a>']
    },
    {
      name: 'PL-L / Dulux L',
      shape: 'lange, gestreckte Kompaktleuchtstofflampe (zwei lange Röhren nebeneinander)',
      has2: false, has4: true,
      p2: ['2G11 ist ein 4-Pin-Sockel',
        'Die <strong>PL-L / Dulux L</strong> gibt es nicht als 2-Pin-Lampe: Der <strong>2G11</strong>-Sockel hat vier Pins (in einer Reihe). Wählen Sie oben <strong>4-Pin</strong>.'],
      p4: ['2G11 (4-Pin) → kein integrierter Starter',
        'Die <strong>PL-L / Dulux L</strong> mit <strong>2G11</strong> ist die lange 4-Pin-Lampe ohne integrierten Starter; sie läuft je nach Leuchte am <strong>KVG/VVG oder EVG</strong>. Der Umrüst-Weg hängt vom Vorschaltgerät-Typ ab und wird im eigenen Ratgeber vertieft. <a href="/blogs/ratgeber/wechsel-pl-l-2g11" class="plf-link" data-todo="link-pruefen">PL-L / Dulux L (2G11) auf LED →</a>']
    }
  ];

  var famIdx = 2; // Default = PL-T
  var pin = 4;    // Default = 4-Pin

  function variant(f) { return (pin === 2) ? f.p2 : f.p4; }

  function render() {
    var f = FAM[famIdx];
    var v = variant(f);
    famBtns.forEach(function (b, j) {
      var on = j === famIdx;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    pinBtns.forEach(function (b) {
      var bp = parseInt(b.getAttribute('data-pin'), 10);
      var on = bp === pin;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    sockOut.innerHTML = v[0];
    note.innerHTML = '<span class="plf-shape">' + f.name + ' &middot; ' + f.shape + '.</span> ' + v[1];
  }

  famBtns.forEach(function (b, i) {
    b.addEventListener('click', function () { famIdx = i; render(); });
  });
  pinBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      pin = parseInt(b.getAttribute('data-pin'), 10) === 2 ? 2 : 4;
      render();
    });
  });

  render(); // Default-Zustand (PL-T + 4-Pin) = statischer Fallback

  // Höhen-Lock: Ergebnisbox auf den höchstmöglichen Inhalt aller Kombinationen
  // fixieren -> kein Springen beim Umschalten. Wir messen alle Familie×Pin-Zustände.
  function lock() {
    if (!result) return;
    var savedSock = sockOut.innerHTML, savedNote = note.innerHTML, savedFam = famIdx, savedPin = pin, max = 0;
    result.style.minHeight = '';
    for (var fi = 0; fi < FAM.length; fi++) {
      for (var p = 0; p < 2; p++) {
        famIdx = fi; pin = (p === 0) ? 2 : 4;
        var f = FAM[famIdx], v = variant(f);
        sockOut.innerHTML = v[0];
        note.innerHTML = '<span class="plf-shape">' + f.name + ' &middot; ' + f.shape + '.</span> ' + v[1];
        if (result.offsetHeight > max) max = result.offsetHeight;
      }
    }
    famIdx = savedFam; pin = savedPin;
    sockOut.innerHTML = savedSock; note.innerHTML = savedNote;
    result.style.minHeight = max + 'px';
  }
  lock();

  var plT;
  window.addEventListener('resize', function () { clearTimeout(plT); plT = setTimeout(lock, 150); });
})();

/* ===== BATCH 2336-2339 / Wechsel-Serie (2026-06-19) :: g53beam :: Spannungs-Wegweiser AR111/G53-12V vs ES111/GU10-230V + Abstrahlwinkel :: aus wechsel-halospot-g53 ===== */
/* =====================================================================
   Ratgeber-Modul (folder-lokal) — „g53beam“
   Artikel: Wie wechsle ich eine Philips Masterline / Osram Halospot
            (G53, 12 V) mit einem LED-Ersatz?

   Eigenständiges IIFE, an #g53beam gebunden (if(!box)return) — verändert
   KEINE anderen Module und nichts in shared/. JS folder-lokal; CSS in
   module.snippet.css. Im Theme als Snippet einbinden.

   Form (Variation, KEIN generischer Klick-Finder):
   1) Spannungs-Wegweiser — zwei echte <button> (aria-pressed):
      AR111 / G53 (12 V, Trafo)  vs.  ES111 / GU10 (230 V, Netz).
      Beantwortet die häufigste Verwechslung beim 111-mm-Reflektor.
   2) Abstrahlwinkel-Visualisierung — SVG-Lichtkegel mit vier
      tastaturbedienbaren Marken (role=button, tabindex=0, Enter/Space)
      für die belegten Halospot-111-Bauformen 4° / 6° / 24° / 40°
      (SSP / SP / FL / WFL). Zeigt Spot↔Flood; KEINE erfundenen
      Lumen-/Candela-Werte — der Kegel ist qualitativ, Lumen/cd je
      Produkt = Datenlücke (Datenblatt/Packung).

   Datenehrlichkeit:
   - Sockel/Spannung belegt (G53 = 2 Pins 53 mm, meist 12 V; ES111 = GU10
     230 V); G53/AR111 „meist 12 V“ (vereinzelt Netz-Varianten).
   - Winkelgrade 4/8/24/40 = reale Halospot-111-Bauformen; Lumen-/cd-Werte
     bewusst NICHT beziffert.

   A11y: aria-live="polite" auf der Ergebnisbox; echte <button> + SVG-
   Hotspots role=button/tabindex=0 mit Enter/Space; Fokus sichtbar (CSS);
   prefers-reduced-motion respektiert (CSS); Höhen-Lock gegen Springen.
   ===================================================================== */
(function () {
  'use strict';

  var box = document.getElementById('g53beam');
  if (!box) return;

  /* ---- Teil 1: Spannungs-Wegweiser (echte Buttons) ---- */
  var btnAr = document.getElementById('g53beam-ar111');
  var btnEs = document.getElementById('g53beam-es111');
  var voltOut = document.getElementById('g53beam-volt');
  if (!btnAr || !btnEs || !voltOut) return;

  var voltBtns = [btnAr, btnEs];

  // [Kennzeile, Hinweis-HTML]. Index 0 = AR111/G53 (Thema dieses Artikels) = Default.
  var VOLT = [
    ['AR111 · Sockel G53 · meist 12 V (über Trafo)',
     'Der <strong>G53</strong>-Stiftsockel hat zwei Pins im Abstand von <strong>53 mm</strong> und gehört zur Reflektorlampe <strong>AR111</strong> (Aluminium-Reflektor, rund 111 mm Durchmesser) — etwa Osram Halospot 111 oder Philips Masterline/Aluline. Diese Bauform läuft <strong>meist mit 12 V über einen Trafo</strong>. Beim LED-Wechsel zählt darum die <strong>Trafo-Eignung</strong>: viele elektronische Trafos haben eine Mindestlast, die eine sparsame LED unterschreitet (Flackern/Brummen). Sie brauchen eine <strong>G53-LED in 12 V</strong>.'],
    ['ES111 · Sockel GU10 · 230 V (direkt am Netz)',
     'Sieht fast gleich aus, ist aber etwas anderes: <strong>ES111</strong> ist der <strong>111-mm-Reflektor mit GU10-Sockel</strong> und läuft mit <strong>230 V direkt am Netz</strong> — ohne Trafo, mit eingebautem Treiber. GU10 wird gesteckt und eine Vierteldrehung verriegelt; G53 hat zwei gerade Stifte und sitzt am Trafo. <strong>Nicht verwechseln:</strong> eine 12-V-Lampe gehört nicht in eine 230-V-Fassung und umgekehrt. Hängt Ihre Lampe an einem Trafo, ist es AR111/G53.']
  ];

  function voltMarkup(i) {
    return '<span class="g53beam-code">' + VOLT[i][0] + '</span>' +
      '<p class="finder-note">' + VOLT[i][1] + '</p>';
  }

  function voltSelect(i) {
    voltBtns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    voltOut.innerHTML = voltMarkup(i);
  }

  btnAr.addEventListener('click', function () { voltSelect(0); });
  btnEs.addEventListener('click', function () { voltSelect(1); });

  /* ---- Teil 2: Abstrahlwinkel-Visualisierung (SVG-Hotspots) ---- */
  var hots = Array.prototype.slice.call(box.querySelectorAll('.g53beam-hot'));
  var cone = document.getElementById('g53beam-cone');
  var beamOut = document.getElementById('g53beam-angle');

  // Belegte Halospot-111-Bauformen. half = halber Öffnungswinkel (Grad) für die
  // SVG-Kegelgeometrie; KEINE Lumen-/cd-Angaben (Datenlücke, Datenblatt/Packung).
  var BEAM = [
    { deg: 4,  cls: 'SSP', name: 'Very Narrow Spot',
      note: 'Sehr enger Lichtstrahl (Bauform SSP). Setzt einen scharfen Akzent über große Distanz — etwa auf ein einzelnes Objekt, eine Skulptur oder ein Exponat. Für Flächenlicht ungeeignet.' },
    { deg: 6,  cls: 'SP',  name: 'Spot',
      note: 'Enger Spot (Bauform SP). Betont gezielt ein Bild, eine Vitrine oder eine Theke. Mehrere Spots nötig, um eine größere Fläche abzudecken.' },
    { deg: 24, cls: 'FL',  name: 'Flood',
      note: 'Mittlerer Winkel (Bauform FL). Der verbreitete Allrounder für Akzent und Grundlicht zugleich — gängig in Schienen- und Einbaustrahlern.' },
    { deg: 40, cls: 'WFL', name: 'Wide Flood',
      note: 'Weiter Flutwinkel (Bauform WFL). Leuchtet eine Fläche gleichmäßig aus, etwa eine Wand oder einen größeren Bereich. Wirkt weicher, weniger akzentuiert.' }
  ];
  var beamDefault = 2; // 24° (FL) = häufigste Bauform = statischer Fallback

  if (cone && beamOut && hots.length) {
    var apexX = 60, apexY = 96;        // Strahler-Position (SVG-Koordinaten)
    var reach = 150;                   // Strahllänge nach rechts
    var prefersReduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function conePoints(halfDeg) {
      var rad = halfDeg * Math.PI / 180;
      var dy = Math.tan(rad) * reach;
      return apexX + ',' + apexY + ' ' +
        (apexX + reach) + ',' + (apexY - dy) + ' ' +
        (apexX + reach) + ',' + (apexY + dy);
    }

    function beamMarkup(b) {
      return '<span class="g53beam-code">' + b.deg + '° · ' + b.cls +
        ' (' + b.name + ')</span>' +
        '<p class="finder-note">' + b.note +
        ' <span class="g53beam-data">Konkrete Lumen-/Candela-Werte je Bauform stehen auf der Packung oder im Datenblatt.</span></p>';
    }

    function beamSelect(idx) {
      var b = BEAM[idx];
      cone.setAttribute('points', conePoints(b.deg / 2));
      if (prefersReduced) { cone.style.transition = 'none'; }
      hots.forEach(function (h, j) {
        var on = j === idx;
        h.classList.toggle('is-on', on);
        h.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      beamOut.innerHTML = beamMarkup(b);
    }

    hots.forEach(function (h, j) {
      h.addEventListener('click', function () { beamSelect(j); });
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          beamSelect(j);
        }
      });
    });

    beamSelect(beamDefault);

    // Höhen-Lock für die Winkel-Ergebnisbox — hier definiert, weil beamMarkup/BEAM
    // unter 'use strict' block-scoped sind und außerhalb nicht sichtbar wären.
    var lockBeam = function () {
      lockHeight(beamOut, function (i) { return beamMarkup(BEAM[i]); }, BEAM.length);
    };
    lockBeam();
    var bT;
    window.addEventListener('resize', function () {
      clearTimeout(bT);
      bT = setTimeout(lockBeam, 150);
    });
  }

  /* ---- Defaults + Höhen-Lock (kein Springen beim Umschalten) ---- */
  voltSelect(0); // Default = AR111/G53 (Thema des Artikels)

  // Höhen-Lock: Ergebnis-Box auf den höchsten Inhalt fixieren -> kein Springen.
  // Funktionsdeklaration -> wird gehisst und ist auch im if-Block oben verfügbar.
  function lockHeight(el, renderFn, count) {
    if (!el) return;
    var cur = el.innerHTML, max = 0, i;
    el.style.minHeight = '';
    for (i = 0; i < count; i++) {
      el.innerHTML = renderFn(i);
      if (el.offsetHeight > max) max = el.offsetHeight;
    }
    el.innerHTML = cur;
    el.style.minHeight = max + 'px';
  }

  function lockVolt() {
    lockHeight(voltOut, voltMarkup, VOLT.length);
  }

  lockVolt();
  var rsT;
  window.addEventListener('resize', function () {
    clearTimeout(rsT);
    rsT = setTimeout(lockVolt, 150);
  });
})();

/* ===== BATCH 2336-2339 / Wechsel-Serie (2026-06-19) :: gr8size :: Bauform/Pin-Bestimmer GR8 (2-Pin) vs GR10q (4-Pin) :: aus wechsel-pl-q-gr8 ===== */
/* ============================================================
   LMM Ratgeber-Modul — Bauform- & Sockel-Bestimmer „Habe ich GR8 oder GR10q?“ (id=gr8size)
   Artikel: wechsel-pl-q-gr8

   FOLDER-LOKALES MODUL — nur fuer diesen Ratgeber. shared/ratgeber-modules.js
   bleibt UNBERUEHRT; preview.html laedt zuerst die geteilte Basis
   (../shared/ratgeber-modules.js) und ZUSAETZLICH diese Datei. Im Shopify-Theme
   spaeter als Section-Asset/Snippet uebernehmen. No-op, wenn #gr8size fehlt.

   Form = ZWEISTUFIGER VERZWEIGUNGS-BESTIMMER (bewusst ANDERE Mechanik als der
   flache 3-Button-Ringgroessen-Selektor `ringsel`):
   - Schritt 1 (immer sichtbar): Bauform waehlen — quadratisch (2D) / rund (Ring) /
     laenglich (Stab). Nur „quadratisch“ gehoert zu diesem Ratgeber.
   - Schritt 2 (erscheint NUR bei „quadratisch“): Pin-Zahl — 2 Pins vs. 4 Pins.
     2 Pins -> GR8, 4 Pins -> GR10q (gleiche quadratische 2D-Lampe, anderer Sockel).
   - Bei „rund“/„laenglich“ wird Schritt 2 ausgeblendet und direkt auf den richtigen
     Lampentyp/Ratgeber verwiesen (Fehlkauf-Schutz).
   Ergebnis in aria-live="polite"-Box (#gr8size-out -> .ip-code + .finder-note).
   Dekoratives SVG (#gr8size-art) zeigt die quadratische 2D-Form; Pin-Gruppen
   (#gr8size-pin2 / #gr8size-pin4) werden je Auswahl ein-/ausgeblendet (aria-hidden).
   Hoehen-Lock gegen Springen der Ergebnisbox (laengster Zustand gemessen, resize
   debounced). Default = Bauform „quadratisch“ + Pin „unbestimmt“ (= statischer
   Fallback ohne JS: zeigt die Einstiegsfrage). prefers-reduced-motion: Transitions
   per CSS abgeschaltet.

   Eigenstaendige IDs/Klassen mit Praefix `gr8size-` -> KEIN Konflikt mit ringsel /
   g23parts / pinmode / sonsys im shared-JS/-CSS. Wrapper-ID `gr8size` !=
   Ueberschriften-Anker (H2 nutzt id="gr8size-section").

   DATENEHRLICH (KLL/Betriebsgeraet — hoechste Vorsicht, wie LED-Roehren):
   KEINE pauschale Kompatibilitaet, KEINE erfundenen Schwellen/Werte.
   Belegte Fakten (WebFetch Original + Osram/LEDVANCE/GE-Datenblatt + Haendler-PDPs):
   - CFL Square / PL-Q = quadratische 2D-Kompaktleuchtstofflampe. GR8 = 2-Pin
     (einseitig, Pin-Abstand 8 mm); GR10q = 4-Pin (quadratisch angeordnet).
     Dieselbe Lampe, nur Sockelvariante (Osram „CFL Square GR8/GR10q“).
   - Gaengige Stufen: 16 W (Kantenmass ca. 138 mm) und 28 W; beide in GR8 + GR10q.
   - LED-Ersatz in GR8-2D existiert, aber Sortiment duenn/teils nicht lieferbar
     -> Verfuegbarkeit = Datenluecke, ehrlich benennen. Eignung je Produkt ->
     Datenblatt (am KVG mit Starter / EVG / 230 V nach Umbau).
   Collection-/Ratgeber-Links = data-todo (link-pruefen).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('gr8size');
  if (!box) return;

  var shapeBtns = [].slice.call(box.querySelectorAll('.gr8size-shape'));
  var pinBtns = [].slice.call(box.querySelectorAll('.gr8size-pin'));
  var step2 = document.getElementById('gr8size-step2');
  var val = document.getElementById('gr8size-val');
  var note = document.getElementById('gr8size-note');
  var art = box.querySelector('.gr8size-art');     // dekoratives SVG (optional)
  var pin2 = document.getElementById('gr8size-pin2'); // SVG-Gruppe 2 Pins (optional)
  var pin4 = document.getElementById('gr8size-pin4'); // SVG-Gruppe 4 Pins (optional)
  if (!shapeBtns.length || !val || !note) return;

  // Texte fuer Schritt 1 (Bauform). Nur „quadratisch“ oeffnet Schritt 2.
  // [Kennzeile, Hinweis-HTML, oeffnet-Schritt-2?]
  var SHAPE = {
    quadrat: [
      'Quadratische 2D-Lampe → jetzt die Pins zählen',
      'Gut — eine <strong>quadratische, flache Lampe</strong> (Osram <strong>CFL Square</strong>, Philips <strong>PL-Q</strong>, oft „2D“ genannt) ist genau der Typ aus diesem Ratgeber. Den Sockel unterscheidet jetzt nur noch die <strong>Pin-Zahl</strong>: Zählen Sie die Kontaktstifte unten an der Lampe.',
      true
    ],
    rund: [
      'Runder Ring → anderer Lampentyp',
      'Eine <strong>runde, kreisförmige</strong> Leuchtstofflampe ist keine CFL Square / PL-Q, sondern eine <strong>Ringform</strong> (Circline). Sie hat je nach Rohrstärke den Sockel <strong>G10q</strong> (dickes T9-Rohr) oder <strong>2GX13</strong> (dünnes T5-Rohr) — nicht GR8. Den passenden Weg zeigt der Ratgeber <a href="/blogs/ratgeber/wechsel-ringform-g10q" class="sock-link" data-todo="link-pruefen">Ringform (G10q) auf LED umrüsten →</a>',
      false
    ],
    stab: [
      'Längliche Stäbchen-Lampe → anderer Lampentyp',
      'Eine <strong>längliche</strong> Kompaktleuchtstofflampe mit zwei oder vier Stäbchen (z. B. PL-S, PL-C, PL-L, Dulux) hat einen anderen Sockel — etwa <strong>G23</strong>, <strong>G24</strong> oder <strong>2G11</strong>, nicht GR8. Eine Übersicht aller Stecksockel gibt die <a href="/blogs/ratgeber/lampensockel-uebersicht" class="sock-link" data-todo="link-pruefen">Lampensockel-Übersicht →</a>',
      false
    ]
  };

  // Texte fuer Schritt 2 (Pin-Zahl) — nur bei Bauform „quadratisch“.
  // [Kennzeile, Hinweis-HTML, SVG-Pin-Variante '2'|'4']
  var PIN = {
    p2: [
      'GR8 · 2-Pin — das ist dieser Ratgeber',
      'Zwei Stifte auf einer Seite (Pin-Abstand 8 mm) = Sockel <strong>GR8</strong>. Genau darum geht es hier. Gängig sind <strong>16 W</strong> (Kantenmaß ca. 138 mm) und <strong>28 W</strong>. Als LED-Ersatz führen Hersteller 2D-Module mit GR8 — etwa rund <strong>6,5 W</strong> für die 16-W-Lampe und <strong>13 W</strong> für die 28-W-Lampe (laut Datenblatt). Wählen Sie nach <strong>Kantenmaß und Lumen</strong>, nicht nach Watt, und prüfen Sie die Verfügbarkeit. <a href="/collections/gr8-led-leuchtmittel" class="sock-link" data-todo="link-pruefen">GR8-LED ansehen →</a>',
      '2'
    ],
    p4: [
      'GR10q · 4-Pin — verwandter Sockel, eigener Bereich',
      'Vier Stifte (quadratisch angeordnet) = Sockel <strong>GR10q</strong>. Es ist dieselbe quadratische 2D-Lampe, nur mit Vierstift-Sockel — sie passt <strong>nicht</strong> in eine GR8-Fassung und umgekehrt. Den LED-Ersatz dafür führen Hersteller als GR10q-2D-Modul (laut Datenblatt; Verfügbarkeit prüfen). Das Vorgehen (Bauform, Vorschaltgerät, Umrüstung) entspricht diesem Ratgeber.',
      '4'
    ]
  };

  var curShape = 'quadrat';
  var curPin = null; // null = noch nicht gewaehlt

  function setArtPins(which) {
    // which: '2' | '4' | null  -> dekorative Pin-Gruppen ein/aus
    if (pin2) pin2.style.display = (which === '2') ? '' : 'none';
    if (pin4) pin4.style.display = (which === '4') ? '' : 'none';
    if (art) art.setAttribute('data-pins', which || '0');
  }

  function paintShape(key) {
    var d = SHAPE[key];
    val.textContent = d[0];
    note.innerHTML = d[1];
    if (step2) {
      if (d[2]) {
        step2.hidden = false;
      } else {
        step2.hidden = true;
        // Pin-Auswahl zuruecksetzen, wenn Bauform nicht quadratisch ist
        curPin = null;
        pinBtns.forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
      }
    }
    // Dekoratives SVG: bei quadratisch ohne Pin-Wahl neutral (keine Pins hervorgehoben)
    setArtPins(d[2] ? (curPin === 'p4' ? '4' : (curPin === 'p2' ? '2' : null)) : null);
  }

  function paintPin(key) {
    var d = PIN[key];
    val.textContent = d[0];
    note.innerHTML = d[1];
    setArtPins(d[2]);
  }

  function selectShape(key) {
    curShape = key;
    shapeBtns.forEach(function (b) {
      var on = b.getAttribute('data-shape') === key;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    paintShape(key);
  }

  function selectPin(key) {
    curPin = key;
    pinBtns.forEach(function (b) {
      var on = b.getAttribute('data-pin') === key;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    paintPin(key);
  }

  shapeBtns.forEach(function (b) {
    b.addEventListener('click', function () { selectShape(b.getAttribute('data-shape')); });
  });
  pinBtns.forEach(function (b) {
    b.addEventListener('click', function () { selectPin(b.getAttribute('data-pin')); });
  });

  // Default = Bauform „quadratisch“ (= statischer Fallback: Einstiegsfrage sichtbar, Schritt 2 offen, noch keine Pin-Wahl)
  selectShape('quadrat');

  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.gr8size-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    var states = [];
    var k;
    for (k in SHAPE) { if (SHAPE.hasOwnProperty(k)) states.push(SHAPE[k]); }
    for (k in PIN) { if (PIN.hasOwnProperty(k)) states.push(PIN[k]); }
    states.forEach(function (d) {
      val.textContent = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var rsT;
  window.addEventListener('resize', function () { clearTimeout(rsT); rsT = setTimeout(lock, 150); });
})();

/* ===== BATCH 2336-2339 / Wechsel-Serie (2026-06-19) :: gxdpin :: Codiernase-Locator GX24d-1/-2/-3 :: aus wechsel-pl-t-gx24d ===== */
/* ============================================================
   Folder-lokales Ratgeber-Modul — „GX24d-Codiernase-Locator“ (id gxdpin)
   Artikel: wechsel-pl-t-gx24d (PL-T / Dulux T, GX24d, 2-Pin → LED)

   ZWECK: Der GX24d-Sockel gibt es als GX24d-1/-2/-3. Die kleine Codiernase
   sitzt je Variante an einer anderen Stelle und wirkt wie ein mechanischer
   Schlüssel — eine Fassung nimmt nur die passende Codierung. Das Modul
   zeigt diese Codierung sichtbar: ein Segment-Umschalter (1/2/3) bewegt die
   Nase an der Schemazeichnung und nennt die typische KLL-Wattstufe sowie die
   passende GX24d-LED-Stufe.

   DATENEHRLICH (nur belegte Werte):
   - GX24d-Codierung / Wattstufen-Zuordnung: Osram Dulux T Plus —
     GX24d-1 = 13 W, GX24d-2 = 18 W, GX24d-3 = 26 W (konsistent mit den
     eigenen Shopware-PDP-Slugs osram-dulux-t-13w…-gx24d-1 / …18w…-gx24d-2 /
     …26w…-gx24d-3 und gluehbirne.de / leuchtstark.de). Wattstufe = „typisch“;
     maßgeblich bleibt der Aufdruck auf der Lampe.
   - GX24d-LED-Stufe: LEDVANCE „DULUX LED T EM & AC MAINS“ —
     6 W (GX24d-1) / 7 W (GX24d-2) / 9 W (GX24d-3); Betrieb am KVG/VVG und an
     230 V laut Hersteller. LED-Watt nur als Orientierung; Lumen → Datenblatt.
   - KEINE erfundenen Lumen-Festwerte im Ergebnis.

   TECHNIK: ID-IIFE, if(!box)return → No-op, falls Wrapper fehlt.
   ARIA radiogroup + Pfeiltasten; prefers-reduced-motion respektiert (keine
   Schiebe-Animation); Höhen-Lock über min-height (CSS), Ergebnis aria-live.
   Ohne JS bleibt der statische Default (GX24d-2) im Markup sichtbar (Fallback).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('gxdpin');
  if (!box) return;

  var btns = [].slice.call(box.querySelectorAll('.gxdpin-seg'));
  var out = document.getElementById('gxdpin-out');
  var nase = document.getElementById('gxdpin-nase');     // bewegliche Codiernase (SVG <rect>)
  var codeLbl = document.getElementById('gxdpin-code');  // SVG-Beschriftung am Sockel
  if (btns.length !== 3 || !out) return;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // [Code, Nase-x (SVG-Einheiten), KLL-Wattstufe typisch, GX24d-LED-Stufe (DULUX LED T), Lage-Text]
  var DATA = [
    ['GX24d-1', 86,  '13 Watt', '6 Watt', 'mittig'],
    ['GX24d-2', 119, '18 Watt', '7 Watt', 'seitlich versetzt'],
    ['GX24d-3', 152, '26 Watt', '9 Watt', 'auf der anderen Seite']
  ];

  function render(idx) {
    var d = DATA[idx];
    // Segment-Status
    btns.forEach(function (b, i) {
      var on = i === idx;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      b.tabIndex = on ? 0 : -1;
    });
    // SVG: Nase verschieben (mit/ohne Übergang) + Beschriftung
    if (nase) {
      nase.style.transition = reduce ? 'none' : 'x 220ms ease, transform 220ms ease';
      nase.setAttribute('x', d[1]);
    }
    if (codeLbl) codeLbl.textContent = d[0];
    // Ergebnis-Text — nur belegte Werte, LED-Weg qualitativ „laut Datenblatt“
    out.innerHTML =
      '<p class="gxdpin-line"><span class="gxdpin-tag">' + d[0] + '</span> — Codiernase <strong>' + d[4] + '</strong>.</p>' +
      '<dl class="gxdpin-dl">' +
        '<div><dt>Alte Dulux T (typisch)</dt><dd>' + d[2] + '</dd></div>' +
        '<div><dt>GX24d-LED (DULUX&nbsp;LED&nbsp;T, Orientierung)</dt><dd>' + d[3] + '</dd></div>' +
      '</dl>' +
      '<p class="gxdpin-rule">Die LED muss dieselbe Codierung <strong>' + d[0] + '</strong> tragen wie Ihre alte Lampe. ' +
      'Helligkeit nach <strong>Lumen</strong> wählen (Datenblatt), nicht nach Watt; Betrieb am KVG/VVG oder an 230&nbsp;V je nach Datenblatt.</p>';
  }

  function select(idx, focus) {
    idx = (idx + DATA.length) % DATA.length;
    render(idx);
    if (focus) btns[idx].focus();
  }

  btns.forEach(function (b, i) {
    b.addEventListener('click', function () { select(i, false); });
    b.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowRight' || k === 'ArrowDown') { e.preventDefault(); select(i + 1, true); }
      else if (k === 'ArrowLeft' || k === 'ArrowUp') { e.preventDefault(); select(i - 1, true); }
      else if (k === 'Home') { e.preventDefault(); select(0, true); }
      else if (k === 'End') { e.preventDefault(); select(DATA.length - 1, true); }
    });
  });

  // Default = GX24d-2 (häufige 18-W-Stufe) — deckt sich mit dem statischen Markup-Fallback
  render(1);
})();

/* ===== BLOCK 7 / Hubs+Sammelseiten (2026-06-19) :: probdiag :: Symptom-Diagnose-Raster (Hub) :: aus haeufigste-led-probleme ===== */
/* --- Symptom-Diagnose-Raster (Artikel haeufigste-led-probleme) — Modul-ID: probdiag ---
   Reiner Diagnose-/Routing-HUB (Anti-Kannibalisierung): Symptom anklicken -> kurze
   Schnelldiagnose + Link zum passenden Owner-Ratgeber. KEINE Tiefe (Watt/Lumen/Frequenzen),
   sondern Verweis auf die Zielseite bzw. den hub-eigenen Geraeusche-Abschnitt.
   Ohne JS bleibt das vorbefuellte Standardergebnis (#probdiag-val/#probdiag-note) sichtbar;
   im body.html ersetzt eine statische Symptom->Ursache->Loesung-Tabelle das Modul.
   Buttons = echte <button>-Elemente (tastaturbedienbar), Ergebnis in aria-live="polite".
   Folder-lokal (noch nicht in shared/ratgeber-modules.js) — beim Theme-Einbau dorthin uebernehmen.
   Wrapper-ID 'probdiag' != H2-Anker 'probdiag-section'. */
(function () {
  'use strict';
  var box = document.getElementById('probdiag');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.probdiag-btn'));
  var val = document.getElementById('probdiag-val');
  var note = document.getElementById('probdiag-note');
  if (!btns.length || !val || !note) return;

  // Reihenfolge identisch zu den Buttons in preview.html / body.html.
  // [Ergebnis-Kennzahl (Symptom -> kurze Diagnose), Hinweis-HTML inkl. Routing-Link]
  // Preview nutzt relative /blogs/ratgeber/<ordner>; im Theme-Einbau auf /blogs/ratgeber/<handle> umstellen.
  var DATA = [
    ['Flackern, Glimmen oder Nachleuchten → meist Dimmer, Treiber oder Installation',
     'Flackert das Licht, glimmt es schwach oder leuchtet nach dem Ausschalten nach, liegt es meist am Dimmer, am Treiber im Leuchtmittel oder an der Installation (z. B. Schalter mit Kontrollleuchte). Ursachen und Selbsttests stehen im eigenen Ratgeber. <a href="/blogs/ratgeber/warum-flackern-led" class="sock-link" data-todo="link-pruefen">Warum flackern LED-Lampen? →</a>'],
    ['Wird heiß / starke Wärme am Sockel → Wärmestau prüfen',
     'Etwas Wärme am Sockel ist normal, der LED-Chip selbst muss aber kühl bleiben. Heiß wird es vor allem bei Wärmestau in geschlossenen Leuchten oder bei zu schwacher Wärmeableitung. Was zulässig ist und worauf Sie achten, klärt der Wärme-Ratgeber. <a href="/blogs/ratgeber/led-waermeentwicklung" class="sock-link" data-todo="link-pruefen">LED-Wärmeentwicklung verstehen →</a>'],
    ['Wird dunkler / fällt zu früh aus → Lebensdauer und Wärme',
     'Lässt die Helligkeit über die Zeit nach oder fällt die LED vorzeitig aus, spielen Wärme, Schaltzyklen und Bauteilqualität zusammen. Wie lange LED halten und was die Lebensdauer verkürzt, behandelt der Lebensdauer-Ratgeber. <a href="/blogs/ratgeber/lebensdauer-led-lampen" class="sock-link" data-todo="link-pruefen">Lebensdauer von LED-Lampen →</a>'],
    ['Lässt sich nicht dimmen / flackert beim Dimmen → Dimmer-Kompatibilität',
     'Eine LED lässt sich nur dimmen, wenn sie ausdrücklich als „dimmbar“ gekennzeichnet ist und der Dimmer zu LED passt. Sonst flackert das Licht, brummt oder regelt nicht sauber. Welcher Dimmer passt, erklärt der Dimmer-Ratgeber. <a href="/blogs/ratgeber/dimmer-fur-leuchtmittel" class="sock-link" data-todo="link-pruefen">Den richtigen Dimmer finden →</a>'],
    ['Brummen, Summen oder Pfeifen → Dimmer, Treiber/Trafo oder Montage',
     'Geräusche kommen meist von einem inkompatiblen Dimmer, vom Treiber bzw. Trafo oder von Resonanz durch losen Sitz. Erster Test: Dimmer auf 100 % stellen — verschwindet das Geräusch, ist der Dimmer schuld. Mehr dazu im Abschnitt unten. <a href="#geraeusche" class="sock-link">Zu den Geräusch-Ursachen →</a>'],
    ['Geht gar nicht an / geht ständig kaputt → Checkliste durchgehen',
     'Geht die LED nicht an oder immer wieder kaputt, lohnt eine kurze Checkliste: Fassung und Kontakt, Schalter und Klemmen, dann Trafo- und Dimmer-Kompatibilität. Wiederholt sich der Ausfall, hilft der Lebensdauer-Ratgeber weiter. <a href="#checkliste" class="sock-link">Zur Checkliste →</a>']
  ];

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.textContent = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }

  btns.forEach(function (b, i) {
    b.addEventListener('click', function () { select(i); });
  });
  select(0);

  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.probdiag-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.textContent = d[0];
      note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.textContent = v;
    note.innerHTML = n;
    result.style.minHeight = max + 'px';
  }
  lock();
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(lock, 150);
  });
})();

/* ===== BLOCK 7 / Hubs+Sammelseiten (2026-06-19) :: dblreader :: Datenblatt-/Etikett-Reader (Hub) :: aus produktdatenblatt-lesen ===== */
/* ============================================================
   LMM Ratgeber-Modul — Klick-Etikett „Datenblatt lesen“ (id=dblreader)
   Artikel: produktdatenblatt-lesen (Datenblatt-/Verpackungs-Lese-HUB)

   FOLDER-LOKAL gebaut (NICHT in shared/ratgeber-modules.js, damit die
   geteilte Datei unberührt bleibt). Im Shopify-Theme später als gemeinsames
   Section-Asset/Snippet zu übernehmen — kein externes Skript, rein
   clientseitig, keine Abhängigkeiten, kein Tracking.

   FORM = anklickbares Beispiel-Etikett: die Felder eines Leuchtmittel-
   Datenblatts (Sockel/Bauform · Watt/Lumen · Kelvin · Ra/CRI · Abstrahlwinkel
   · Energieklasse/EPREL · Lebensdauer · Schaltzyklen) sind echte <button>-
   Elemente. Klick/Enter/Space -> select(i) schaltet aria-pressed + .is-on und
   schreibt Kurzdefinition + Tiefenlink zum jeweiligen Wert-Ratgeber in
   #dblreader-val / #dblreader-note (aria-live="polite"). Default = erstes
   Feld (= statischer Fallback ohne JS). Höhen-Lock gegen Springen der
   Ergebnisbox. No-op, wenn #dblreader fehlt.

   ROUTING-CHARAKTER (Anti-Kannibalisierung): Der Hub ERKLÄRT die Einzelwerte
   nur in einem Satz und VERLINKT den jeweiligen Owner-Ratgeber. Die Symbolik
   (CE/WEEE/Energielabel/Lampenbezeichnung) erklärt der Fließtext selbst.

   DATENEHRLICH: KEINE erfundenen Werte. Die im Etikett gezeigten Zahlen
   (806 lm / 7 W, 2700 K, Ra 80, 25.000 h, 100.000 Schaltzyklen) sind
   ausdrücklich als BEISPIEL gekennzeichnet — die echten Werte stehen je
   Produkt auf der Verpackung bzw. im Datenblatt. Interne Ratgeber-Links
   relativ (preview); Collection-Links data-todo (Pass B gegen Shopware-Baum).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('dblreader');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.dblreader-field'));
  var val = document.getElementById('dblreader-val');
  var note = document.getElementById('dblreader-note');
  if (!btns.length || !val || !note) return;

  // Reihenfolge identisch zu den Feld-Buttons in preview.html / body.html.
  // [Ergebnis-Überschrift (Feld -> Bedeutung), Hinweis-HTML „was steht da“ + Tiefenlink zum Owner-Ratgeber]
  var DATA = [
    ['Sockel & Bauform — z. B. „E27 · A60“',
     'Der <strong>Sockel</strong> sagt, in welche Fassung die Lampe passt (z. B. E27, GU10, G9). Die <strong>Bauform</strong> steht als Kürzel daneben: ein Buchstabe für die Form, eine Zahl für den Durchmesser in Millimetern — <strong>A60</strong> ist die klassische Birne mit 60 mm, <strong>G45</strong> eine Kugel mit 45 mm, <strong>C35</strong> eine Kerze mit 35 mm. <a href="/blogs/ratgeber/lampensockel-uebersicht" class="sock-link" data-todo="link-pruefen">Lampensockel erkennen &amp; messen →</a>'],
    ['Helligkeit — Watt &amp; Lumen (Beispiel: 806 lm · 7 W)',
     'Maßgeblich ist heute der <strong>Lichtstrom in Lumen (lm)</strong>, nicht die Watt. <strong>Watt</strong> zeigt nur, wie viel Strom die Lampe zieht. Das gezeigte 806 lm / 7 W ist ein <strong>Beispiel</strong> — die echten Werte stehen auf der Verpackung. <a href="/blogs/ratgeber/umrechnung-watt-lumen" class="sock-link" data-todo="link-pruefen">Watt in Lumen umrechnen →</a> · <a href="/blogs/ratgeber/helligkeit-led-lampen" class="sock-link" data-todo="link-pruefen">richtige Helligkeit finden →</a>'],
    ['Lichtfarbe — Kelvin (Beispiel: 2700 K)',
     'Die <strong>Farbtemperatur in Kelvin (K)</strong> bestimmt die Lichtstimmung: niedrige Werte (rund 2700 K) sind warmweiß, hohe Werte kühl und tageslichtweiß. <a href="/blogs/ratgeber/lichtfarbe" class="sock-link" data-todo="link-pruefen">Lichtfarbe wählen →</a>'],
    ['Farbwiedergabe — Ra / CRI (Beispiel: Ra 80)',
     'Der <strong>Farbwiedergabeindex (Ra bzw. CRI)</strong> sagt, wie natürlich Farben unter dem Licht wirken — je höher, desto natürlicher. Oft steckt er auch im dreistelligen Code (z. B. 827: Ra-Stufe 8, Lichtfarbe 2700 K). <a href="/blogs/ratgeber/farbwiedergabeindex-erklaert" class="sock-link" data-todo="link-pruefen">Farbwiedergabe &amp; den 827-Code verstehen →</a>'],
    ['Abstrahlwinkel — Grad (Beispiel: 200°)',
     'Der <strong>Abstrahlwinkel</strong> sagt, wie breit das Licht austritt: ein enger Winkel bündelt (Spot/Akzent), ein weiter Winkel leuchtet flächig aus. <a href="/blogs/ratgeber/ausstrahlungswinkel" class="sock-link" data-todo="link-pruefen">Abstrahlwinkel erklärt →</a>'],
    ['Energieklasse &amp; EPREL — Label A–G + QR',
     'Das <strong>EU-Energielabel</strong> zeigt seit September 2021 die Klassen <strong>A bis G</strong> (kein A++/A+ mehr). Der <strong>QR-Code</strong> führt in die EU-Datenbank <strong>EPREL</strong> mit dem vollständigen Produktdatenblatt. <a href="/blogs/ratgeber/energieeffizienzklassen-led" class="sock-link" data-todo="link-pruefen">Energieeffizienzklassen verstehen →</a>'],
    ['Lebensdauer — Stunden (Beispiel: 25.000 h)',
     'Die <strong>Lebensdauer in Betriebsstunden</strong> ist eine Herstellerangabe; oft steht dabei, bei wie viel Prozent Restlichtstrom sie gilt. Der Wert im Etikett ist ein <strong>Beispiel</strong>. <a href="/blogs/ratgeber/lebensdauer-led-lampen" class="sock-link" data-todo="link-pruefen">Lebensdauer von LED-Lampen →</a>'],
    ['Schaltzyklen — Anzahl (Beispiel: 100.000)',
     'Die <strong>Schaltzyklen</strong> sagen, wie oft sich die Lampe ein- und ausschalten lässt, ohne dass die Lebensdauer leidet — wichtig an Bewegungsmeldern oder im Treppenhaus. Die konkrete Zahl ist eine Datenblattangabe je Produkt. <a href="/blogs/ratgeber/leuchtmittel-wiki" class="sock-link" data-todo="link-pruefen">Mehr Begriffe im Leuchtmittel-Wiki →</a>']
  ];

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.innerHTML = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) {
    b.addEventListener('click', function () { select(i); });
  });
  select(0); // Default = erstes Feld (= statischer Fallback ohne JS)

  // Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.dblreader-result');
  function lock() {
    if (!result) return;
    var v = val.innerHTML, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.innerHTML = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.innerHTML = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var dblT;
  window.addEventListener('resize', function () { clearTimeout(dblT); dblT = setTimeout(lock, 150); });
})();

/* ===== BLOCK 7 / Hubs+Sammelseiten (2026-06-19) :: tauschcheck :: Austauschbar-Pruefhelfer :: aus sind-led-austauschbar ===== */
/* ============================================================
   LMM Ratgeber-Modul — Prüf-/Entscheidungshelfer „Ist Ihre LED austauschbar?“ (id=tauschcheck)
   Artikel: sind-led-lampen-austauschbar

   FOLDER-LOKAL gebaut (sind-led-austauschbar/module.snippet.js) — NICHT in
   shared/ratgeber-modules.js, damit die geteilte Datei unberührt bleibt. Im
   Shopify-Theme später als gemeinsames Section-Asset/Snippet übernehmen
   (Modul-ID tauschcheck).

   Form = Klick-Auswahl nach ERKENNUNGSMERKMAL (analog erslampe/eref-Finder):
   echte <button>-Elemente (tastaturbedienbar), select(i) schaltet aria-pressed
   + .is-on, Ergebnis (Handlungsempfehlung + Link) in aria-live="polite",
   Höhen-Lock gegen Springen. Default = erster Button (= statischer Fallback
   ohne JS = Merkmal-Tabelle im Body). No-op, wenn #tauschcheck fehlt.

   DATENEHRLICH: nur BELEGTE Erkennungsmerkmale (sichtbarer Standardsockel ->
   wechselbar; flache COB-/Platinen-LED ohne Sockel -> meist fest verbaut;
   Piktogramm/Datenblatt prüfen). KEINE erfundenen Watt-/Lumen-/Stunden-/Maß-
   Werte, kein Scheinrechner. Collection-/Ratgeber-Links = data-todo (Ziele in
   ../link-map-ratgeber.csv, Pass B gegen den echten Shopware-Baum). Interne
   Ratgeber-Links relativ.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('tauschcheck');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.tauschcheck-btn'));
  var val = document.getElementById('tauschcheck-val');
  var note = document.getElementById('tauschcheck-note');
  if (!btns.length || !val || !note) return;

  // Reihenfolge identisch zu den Buttons in preview.html / body.html.
  // [Ergebnis-Kennzahl (Merkmal -> Befund), Hinweis-HTML „Handlungsempfehlung“ + Link (data-todo)]
  var DATA = [
    ['Sichtbarer Standardsockel (E27, E14, GU10, G9 …) → wechselbar',
     '<strong>Befund: wechselbar.</strong> Sehen Sie einen genormten Sockel — Schraubgewinde (E27/E14), Dreh-Stift (GU10), dünne Stifte (G9, G4) — sitzt das Leuchtmittel in einer Fassung und lässt sich herausnehmen. Sie tauschen es selbst gegen eine passende LED. Welche LED passt, klärt <a href="/blogs/ratgeber/welche-ersatz-led" class="sock-link" data-todo="link-pruefen">Welche Ersatz-LED?</a>; den Handgriff je Sockel zeigt <a href="/blogs/ratgeber/led-leuchtmittel-wechseln" class="sock-link" data-todo="link-pruefen">LED-Leuchtmittel wechseln →</a>'],
    ['Flache Platine oder COB-Modul ohne Sockel → meist fest verbaut',
     '<strong>Befund: meist fest verbaut.</strong> Eine flache Leuchtfläche oder ein verklebtes/verschraubtes COB-Modul ohne herausnehmbares Leuchtmittel deutet auf eine <strong>integrierte LED</strong> — typisch für viele Deckenleuchten, Panels und Außenstrahler. Dann gibt es nichts zu schrauben. Bei Defekt: Modul-/Platinentausch nur über den Fachbetrieb, oft ist der Leuchtentausch wirtschaftlicher.'],
    ['Piktogramm auf Verpackung / Leuchte prüfen → nach Kennzeichnung richten',
     '<strong>So lesen Sie es ab:</strong> Verpackung und Leuchten-Datenblatt zeigen oft ein <strong>Piktogramm zur Austauschbarkeit</strong> von Lichtquelle und Betriebsgerät — ein durchgestrichenes Symbol bzw. der Hinweis „Lichtquelle nicht austauschbar“ steht für eine fest verbaute LED. Fehlt eine Angabe, entscheidet das Herstellerdatenblatt. Achten Sie zusätzlich auf einen sichtbaren Sockel (siehe oben). Hintergrund zur Reparierbarkeit: <a href="/blogs/ratgeber/led-lampen-und-garantie" class="sock-link" data-todo="link-pruefen">LED-Garantie →</a>'],
    ['Defektes fest verbautes Modul → was tun?',
     '<strong>Handlungsempfehlung:</strong> Ein einzelnes fest verbautes LED-Modul oder eine Platine zu ersetzen ist möglich, gehört aber an die <strong>Elektrofachkraft</strong> — Ersatzteile sind herstellerspezifisch und nicht immer lieferbar. Häufig ist der <strong>Tausch der ganzen Leuchte</strong> günstiger und schneller als die Reparatur. Prüfen Sie vorab Garantie und Ersatzteilverfügbarkeit beim Hersteller. <a href="/blogs/ratgeber/led-lampen-und-garantie" class="sock-link" data-todo="link-pruefen">Garantie prüfen →</a> · <a href="/blogs/ratgeber/leuchtmittel-entsorgen" class="sock-link" data-todo="link-pruefen">Richtig entsorgen →</a>']
  ];

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.textContent = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0); // Default = erster Button (= statischer Fallback ohne JS)

  // Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.tauschcheck-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.textContent = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var tcT;
  window.addEventListener('resize', function () { clearTimeout(tcT); tcT = setTimeout(lock, 150); });
})();

/* ===== BLOCK 7 / Hubs+Sammelseiten (2026-06-19) :: branchensel :: Branchen-Selektor (Sammel-Hub) :: aus led-beleuchtung-branchen ===== */
/* ============================================================
   LMM Ratgeber-Modul — Branchen-Selektor „LED-Beleuchtung nach Branche“ (id=branchensel)
   Artikel: led-beleuchtung-fuer-geschaefte-und-branchen

   FOLDER-LOKAL (NICHT in shared/ratgeber-modules.js), damit die geteilte Datei
   unberuehrt bleibt. Im Shopify-Theme spaeter als Section-Asset/Snippet uebernehmen.

   FORM: Branche per <button> waehlen -> Empfehlungs-Karte mit Lichtfarbe (Kelvin),
   CRI-Mindestwert und Lux-Richtwert + passende Kategorie-CTAs. Echte <button>-Elemente
   (tastaturbedienbar), select(i) schaltet aria-pressed + .is-on, Ergebnis in
   aria-live="polite", Hoehen-Lock gegen Springen, prefers-reduced-motion respektiert.
   Default = erster Button (= statischer Fallback ohne JS). No-op, wenn #branchensel fehlt.

   DATENEHRLICH: Alle Kelvin-/CRI-/Lux-Angaben sind RICHTWERTE/branchenueblich,
   keine erfundenen Festwerte. Lux-Spannen an DIN EN 12464-1 (Verkaufsraeume 300-750 lx,
   Akzent > 1000 lx; Buero 500 lx; Lager 200 lx) plausibilisiert; branchenspezifische
   Warenpraesentation als „Richtwert“ gekennzeichnet. Collection-Links = data-todo
   (Ziele in ../link-map-ratgeber.csv, Pass B gegen den echten Shopware-Baum).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('branchensel');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.branchensel-btn'));
  var out = document.getElementById('branchensel-result');
  if (!btns.length || !out) return;

  // Reihenfolge identisch zu den Buttons in preview.html / body.html.
  // [Branche, Lichtfarbe (Kelvin, Richtwert), CRI-Min (Richtwert), Lux-Richtwert, Hinweis-HTML + Kategorie-CTA(s) (data-todo)]
  var DATA = [
    ['Lebensmittel & Frische',
     'warmweiß 2700–3000 K',
     'ab Ra 90',
     'Theke ca. 800–1000 lx (Richtwert)',
     'Frische-Theken (Fleisch, Wurst, Käse, Obst) leben von <strong>echter Farbwiedergabe</strong>: ein hoher CRI (ab Ra 90) zeigt rotes Fleisch und buntes Obst natürlich, ohne es zu schönen. Warmweißes, gerichtetes Akzentlicht über der Theke setzt die Ware in Szene. <a href="/collections/led-strahler" class="sock-link">LED-Strahler →</a>'],
    ['Gastronomie & Küche',
     'Gastraum warmweiß 2700–3000 K · Küche neutral- bis tageslichtweiß 4000 K',
     'ab Ra 80',
     'Gastraum ca. 200–300 lx · Küche ca. 500 lx (Richtwert)',
     'Im <strong>Gastraum</strong> sorgt warmes, dimmbares Licht für Atmosphäre; in der <strong>(Groß-)Küche</strong> braucht es helleres, neutral- bis tageslichtweißes Arbeitslicht und reinigungsfreundliche, gegen Feuchte und Fett geschützte Leuchten.'],
    ['Einzelhandel & Schmuck',
     'Mode/Kosmetik neutralweiß ~4000 K · Schmuck/Brillanz bis tageslichtweiß',
     'ab Ra 90',
     'Grundlicht ca. 300–500 lx · Akzent > 1000 lx (Richtwert)',
     'Im Einzelhandel zählt die <strong>Warenpräsentation</strong>: ein hoher CRI zeigt Farben echt, gerichtete Strahler heben die Ware vom Grundlicht ab. Bei <strong>Schmuck</strong> bringt kühleres, brillantes Licht Steine zum Funkeln; Mode wirkt unter neutralweißem Licht stimmig. <a href="/collections/led-strahler" class="sock-link">LED-Strahler →</a>'],
    ['Kunst & Kultur',
     'meist warm- bis neutralweiß; objektabhängig',
     'ab Ra 90',
     'objekt- und nutzungsabhängig (Richtwert)',
     'In Galerie, Museum, Theater oder Foyer steht das <strong>Objekt</strong> im Mittelpunkt: hoher CRI für farbtreue Wirkung, blend- und UV-arm bei empfindlichen Exponaten, gut steuerbar (dimmbar). Akzentstrahler trennen Exponat und Hintergrund. <a href="/collections/led-strahler" class="sock-link">LED-Strahler →</a>'],
    ['Büro & Arbeitsplatz',
     'neutralweiß ~4000 K',
     'ab Ra 80',
     'Schreib-/Bildschirmarbeit ca. 500 lx (DIN EN 12464-1)',
     'Am Arbeitsplatz gilt für Bildschirm- und Schreibarbeit der Richtwert <strong>500 Lux</strong> nach DIN EN 12464-1, dazu eine <strong>begrenzte Blendung (UGR ≤ 19)</strong>. Neutralweißes Licht hält konzentriert; flächige Panels lösen alte Rasterleuchten ab.'],
    ['Industrie & Lager',
     'neutralweiß ~4000 K',
     'ab Ra 80',
     'Lager/Verkehrswege ca. 200 lx · Produktion ca. 300–500 lx (DIN EN 12464-1)',
     'In Lager, Produktion und Parkhaus zählen <strong>robuste, feuchte- und staubgeschützte</strong> Leuchten und gleichmäßiges, neutralweißes Licht. Für feuchte oder staubige Hallen sind <strong>Feuchtraumleuchten (Wannenleuchten)</strong> die typische Lösung. Mehr dazu im Ratgeber <a href="/blogs/ratgeber/feuchtraumleuchten" class="sock-link" data-todo="link-pruefen">Feuchtraumleuchten →</a>'],
    ['Fotostudio',
     'oft ~5000–6500 K (Dauerlicht)',
     'ab Ra 90 (besser Ra 95+)',
     'motiv- und aufbauabhängig (Richtwert)',
     '<strong>Hinweis:</strong> Für die Aufnahme selbst braucht es meist <strong>spezielle Studio-/Dauerlichtleuchten</strong> mit einstellbarer Farbtemperatur und sehr hohem CRI — diese liegen ggf. außerhalb unseres Sortiments. Für die Raum-/Umgebungsbeleuchtung des Studios eignen sich neutral- bis tageslichtweiße LED. <a href="/collections/led-roehren" class="sock-link" data-todo="link-pruefen">LED-Röhren →</a>']
  ];

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function render(i) {
    var d = DATA[i];
    out.innerHTML =
      '<div class="bs-head">' + d[0] + '</div>' +
      '<dl class="bs-specs">' +
        '<div class="bs-spec"><dt>Lichtfarbe</dt><dd>' + d[1] + '</dd></div>' +
        '<div class="bs-spec"><dt>Farbwiedergabe</dt><dd>' + d[2] + '</dd></div>' +
        '<div class="bs-spec"><dt>Beleuchtungsstärke</dt><dd>' + d[3] + '</dd></div>' +
      '</dl>' +
      '<p class="finder-note">' + d[4] + '</p>';
  }

  function select(i) {
    for (var j = 0; j < btns.length; j++) {
      var on = (j === i);
      btns[j].classList.toggle('is-on', on);
      btns[j].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    render(i);
  }

  // Hoehen-Lock: alle Ergebnis-Varianten messen, hoechste als minHeight fixieren.
  function lockHeight() {
    var maxH = 0;
    for (var i = 0; i < DATA.length; i++) {
      render(i);
      if (out.offsetHeight > maxH) maxH = out.offsetHeight;
    }
    if (maxH > 0) out.style.minHeight = maxH + 'px';
  }

  btns.forEach(function (btn, i) {
    btn.addEventListener('click', function () { select(i); });
  });

  // Debounced Re-Lock bei resize (Umbruch aendert Hoehe).
  var t;
  window.addEventListener('resize', function () {
    if (reduceMotion) return;
    clearTimeout(t);
    t = setTimeout(function () {
      out.style.minHeight = '';
      lockHeight();
      var active = 0;
      for (var i = 0; i < btns.length; i++) { if (btns[i].classList.contains('is-on')) { active = i; break; } }
      select(active);
    }, 150);
  });

  lockHeight();
  select(0);
})();

/* ===== BLOCK 7 / Hubs+Sammelseiten (2026-06-19) :: raumsel :: Raum-Selektor (Sammel-Hub) :: aus beleuchtung-zuhause ===== */
/* ============================================================
   LMM Ratgeber-Modul — Raum-Selektor „Welches Licht für welchen Raum?“ (id=raumsel)
   Artikel: beleuchtung-zuhause (Ziel-Handle beleuchtung-zuhause-raumratgeber)

   FOLDER-LOKAL: liegt bewusst NICHT in shared/ratgeber-modules.js, damit die
   geteilte Datei unberührt bleibt. Der Hauptagent integriert das Modul später
   seriell in shared/. Im Shopify-Theme als gemeinsames Section-Asset/Snippet
   einbinden (Modul-ID raumsel).

   Form = Klick-Selektor (Muster identisch zu erslampe/eref): echte
   <button>-Elemente (.raumsel-btn, tastaturbedienbar), select(i) schaltet
   aria-pressed + .is-on und schreibt eine Empfehlungs-Karte (Richt-Lumen,
   Lichtfarbe in Kelvin, Lichtart, Hinweis + Routing) in eine aria-live="polite"-
   Box. Default = erster Button (= statischer Fallback ohne JS). Höhen-Lock
   gegen Springen der Ergebnisbox. No-op, wenn #raumsel fehlt.

   DATENEHRLICH: Es werden NUR belegte/als Richtwert markierte Werte gezeigt.
   - Leselicht ~400–600 lm + warmweiß 2700–3000 K: aus dem Original-Guide belegt.
   - Arbeitsplatz 500 Lux (DIN EN 12464-1) ≈ ausreichend helle Leuchte,
     neutralweiß ~4000 K: Norm + Fachkonsens.
   - „warmweiß beruhigt / kühleres Licht aktiviert“: Original (Stimmungsartikel).
   - Lumen pro Raum hängt stark von Raumgröße/Wandfarbe ab → nur als grober
     Richtwert-Bereich (Quellen 100–300 lm/m²), KEIN harter Festwert je Raum.
   Konkrete Werte je Leuchte → Datenblatt/Verpackung. Collection-/Ratgeber-Links
   = data-todo (Ziele Pass B gegen den echten Shopware-Baum).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('raumsel');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.raumsel-btn'));
  var val = document.getElementById('raumsel-val');
  var card = document.getElementById('raumsel-card');
  if (!btns.length || !val || !card) return;

  // Reihenfolge identisch zu den Buttons in preview.html / body.html.
  // [Kopfzeile (Raum → Lichtkonzept), Karten-HTML (Richt-Lumen · Kelvin · Lichtart + Hinweis + Link)]
  var DATA = [
    ['Wohnzimmer → warmes Grundlicht plus Akzente',
     '<div class="rs-rows">' +
       '<div class="rs-row"><span class="rs-k">Helligkeit</span><span class="rs-v">mehrere Lichtquellen</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtfarbe</span><span class="rs-v">warmweiß, ca. 2700–3000 K</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtart</span><span class="rs-v">Grund- + Stimmungs- + Leselicht</span></div>' +
     '</div>' +
     '<p class="rs-note">Das Wohnzimmer lebt von <strong>mehreren Lichtquellen</strong>: ein flächiges Grundlicht von oben, weiches Stimmungslicht über Steh- oder Tischleuchten und ein gerichtetes Leselicht am Sessel. Warmweiß (Richtwert <strong>ca. 2700–3000 K</strong>) wirkt gemütlich; dimmbar zu sein lohnt sich. Wie viel Lumen Sie brauchen, hängt von Raumgröße und Wandfarbe ab. <a href="/blogs/ratgeber/helligkeit-led-lampen" class="rs-link" data-todo="link-pruefen">Helligkeit planen →</a></p>'],

    ['Schlafzimmer → ruhiges, warmes Licht',
     '<div class="rs-rows">' +
       '<div class="rs-row"><span class="rs-k">Helligkeit</span><span class="rs-v">eher gedämpft, dimmbar</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtfarbe</span><span class="rs-v">warmweiß, ca. 2700 K oder darunter</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtart</span><span class="rs-v">weiches Grundlicht + Nachttischleuchte</span></div>' +
     '</div>' +
     '<p class="rs-note">Im Schlafzimmer zählt Ruhe: <strong>warmweißes Licht</strong> (Richtwert <strong>ca. 2700 K</strong> oder etwas darunter) entspannt am Abend, kühles, bläuliches Licht macht eher wach. Dimmbare Leuchten und eine separate Nachttischleuchte helfen, das Licht herunterzufahren. <a href="/blogs/ratgeber/lichtfarbe" class="rs-link" data-todo="link-pruefen">Lichtfarbe wählen →</a></p>'],

    ['Lesen im Bett / am Sessel → gerichtetes Leselicht',
     '<div class="rs-rows">' +
       '<div class="rs-row"><span class="rs-k">Richt-Lumen</span><span class="rs-v">ca. 400–600 lm (Richtwert)</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtfarbe</span><span class="rs-v">warmweiß, ca. 2700–3000 K</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtart</span><span class="rs-v">gerichtetes Task-/Leselicht</span></div>' +
     '</div>' +
     '<p class="rs-note">Zum Lesen sind nach gängiger Empfehlung <strong>ca. 400–600 Lumen</strong> (Richtwert) angenehm — als <strong>gerichtetes Leselicht</strong> aus einer Lese- oder Klemmleuchte, nicht als Deckenflut. Für entspanntes Lesen am Abend warmweiß (<strong>ca. 2700–3000 K</strong>). Wichtig: blendfrei und so platziert, dass das Licht aufs Buch fällt, nicht ins Auge.</p>'],

    ['Home-Office → helles, aktivierendes Arbeitslicht',
     '<div class="rs-rows">' +
       '<div class="rs-row"><span class="rs-k">Helligkeit</span><span class="rs-v">500 Lux am Schreibtisch (DIN EN 12464-1)</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtfarbe</span><span class="rs-v">neutralweiß, ca. 4000 K</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtart</span><span class="rs-v">Grundlicht + gerichtete Schreibtischleuchte</span></div>' +
     '</div>' +
     '<p class="rs-note">Am Arbeitsplatz empfiehlt die Norm <strong>DIN EN 12464-1</strong> rund <strong>500 Lux</strong> auf der Schreibtischfläche — eine ausreichend helle Schreibtischleuchte plus Grundlicht. <strong>Neutralweiß (ca. 4000 K)</strong> gilt als konzentrationsfördernd und aktivierend. Tageslicht von der Seite ergänzt, Bildschirm blendfrei stellen. <a href="/blogs/ratgeber/led-beleuchtung-fuer-geschaefte-und-branchen" class="rs-link" data-todo="link-pruefen">Licht für Büro &amp; Gewerbe →</a></p>'],

    ['Kinderzimmer → warmes Grundlicht + Nachtlicht',
     '<div class="rs-rows">' +
       '<div class="rs-row"><span class="rs-k">Helligkeit</span><span class="rs-v">helles Grundlicht zum Spielen</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtfarbe</span><span class="rs-v">warmweiß, ca. 2700–3000 K</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtart</span><span class="rs-v">Grundlicht + Hausaufgaben- + Nachtlicht</span></div>' +
     '</div>' +
     '<p class="rs-note">Das Kinderzimmer braucht zwei Stimmungen: helles, <strong>warmweißes</strong> Grundlicht zum Spielen und ein gedämpftes <strong>Nachtlicht</strong> zum Einschlafen. Wird am Schreibtisch gelernt, ergänzt eine eigene, hellere Leuchte (neutralweiß) den Arbeitsbereich. Auf bruchsichere, gut abgedeckte Leuchten achten. <a href="/collections/led-lampen" class="rs-link" data-todo="link-pruefen">LED-Lampen ansehen →</a></p>'],

    ['Flur / Eingang → gleichmäßiges Orientierungslicht',
     '<div class="rs-rows">' +
       '<div class="rs-row"><span class="rs-k">Helligkeit</span><span class="rs-v">gleichmäßig, an Treppen heller</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtfarbe</span><span class="rs-v">warmweiß bis neutralweiß</span></div>' +
       '<div class="rs-row"><span class="rs-k">Lichtart</span><span class="rs-v">Grundlicht, evtl. mit Bewegungsmelder</span></div>' +
     '</div>' +
     '<p class="rs-note">Im Flur geht es um <strong>gleichmäßige Orientierung</strong> ohne dunkle Ecken — gerade an <strong>Treppen</strong> ruhig heller, um Stolperkanten gut zu sehen. Warmweiß wirkt einladend, neutralweiß sachlicher. Ein Bewegungsmelder spart Strom und sorgt für Licht, sobald jemand kommt. <a href="/collections/led-lampen" class="rs-link" data-todo="link-pruefen">LED-Lampen ansehen →</a></p>']
  ];

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.textContent = DATA[i][0];
    card.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0); // Default = erster Button (= statischer Fallback ohne JS)

  // Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.raumsel-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, c = card.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.textContent = d[0]; card.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.textContent = v; card.innerHTML = c; result.style.minHeight = max + 'px';
  }
  lock();
  var raumT;
  window.addEventListener('resize', function () { clearTimeout(raumT); raumT = setTimeout(lock, 150); });
})();


/* ===== BLOCK 8 / Hubs+Beratung (2026-06-20) :: oekosel :: Smart-Home-Oekosystem-Selektor :: aus smart-home-lampen-kaufen-fehler-vermeiden ===== */
/* Ökosystem-Selektor (id=oekosel) — folder-lokal, ID-gebundenes IIFE.
   ARIA: aria-pressed auf <button>, aria-live="polite" auf Ergebnis (im Markup).
   KEINE erfundenen Werte/Modelle — nur qualitative Kaufhinweise. Höhen-Lock via CSS. */
(function () {
  var box = document.getElementById('oekosel');
  if (!box) return;

  var result = document.getElementById('oekosel-result');
  if (!result) return;

  var buttons = box.querySelectorAll('.oekosel-btn');
  if (!buttons.length) return;

  var data = {
    'Amazon Alexa': {
      note: 'Am breitesten kompatibel. Achten Sie auf das Logo <strong>„Works with Alexa“</strong>. WLAN-Lampen lassen sich direkt einbinden; bei Zigbee genügt oft ein Echo-Modell mit eingebautem Hub oder eine separate Bridge. Sprachsteuerung und Routinen funktionieren systemweit.',
      links: '<a href="/collections/led-smart-home" class="sock-link">Smart-Home-Lampen →</a> · <a href="/collections/e27-led-leuchtmittel" class="sock-link">E27 →</a>'
    },
    'Google Home': {
      note: 'Stark im Google-/Android-Umfeld. Achten Sie auf <strong>„Works with Google Home“</strong>. WLAN-Lampen verbinden sich direkt; für Zigbee braucht es eine Bridge. Steuerung per Google-App und Google Assistant, auch in Gruppen und Routinen.',
      links: '<a href="/collections/led-smart-home" class="sock-link">Smart-Home-Lampen →</a> · <a href="/collections/e14-led-leuchtmittel" class="sock-link">E14 →</a>'
    },
    'Apple Home': {
      note: 'Striktester Datenschutz, sehr saubere Einbindung im Apple-Umfeld, aber engere Geräteauswahl. Achten Sie auf <strong>„Works with Apple Home“</strong> bzw. das HomeKit-Logo. Steuerung per Home-App und Siri; für Automationen unterwegs ist oft eine Apple-Zentrale (Home-Hub) nötig.',
      links: '<a href="/collections/led-smart-home" class="sock-link">Smart-Home-Lampen →</a> · <a href="/collections/gu10-led-lampen" class="sock-link" data-todo="link-pruefen">GU10 →</a>'
    },
    'Noch kein System / Matter': {
      note: 'Wer sich offenhalten will, achtet auf das <strong>Matter-Logo</strong>: Matter-fähige Lampen lassen sich systemübergreifend einbinden. So ist die Wahl des Ökosystems später nicht endgültig. Die Übertragung läuft über WLAN oder das Funknetz Thread.',
      links: '<a href="/collections/led-smart-home" class="sock-link">Smart-Home-Lampen →</a> · <a href="/collections/led-lampen" class="sock-link" data-todo="link-pruefen">Alle LED-Lampen →</a>'
    }
  };

  function render(name) {
    var d = data[name];
    if (!d) return;
    result.innerHTML =
      '<div class="os-head">' + name + '</div>' +
      '<p class="finder-note">' + d.note + ' ' + d.links + '</p>';
  }

  function select(btn) {
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', buttons[i] === btn ? 'true' : 'false');
    }
    render(btn.textContent.trim());
  }

  for (var i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener('click', function () { select(this); });
  }

  // Default = erster Button (entspricht statischem Erststand im Markup)
  select(buttons[0]);
})();


/* ===== BLOCK 8 REVISION (2026-06-20) :: interaktive Elemente je Artikel =====
   Vier eigenstaendige, ID-gebundene Module. KEINE erfundenen Mess-/Herstellerwerte —
   nur qualitative Kaufberatung. ARIA (aria-pressed/aria-valuetext/aria-live) im Markup,
   Hoehen-Lock + prefers-reduced-motion in shared/ratgeber-modules.css. */

/* --- 1) dimdemo :: Dimmer-Slider-Demo (led-dimmbar-vs-nicht-dimmbar-unterschied) ---
   Veranschaulicht qualitativ das Dimmverhalten einer dimmbaren LED. Die Prozentzahl ist
   die Reglerstellung, KEIN Lumen-/Watt-Messwert. */
(function () {
  var box = document.getElementById('dimdemo');
  if (!box) return;
  var range = document.getElementById('dim-range');
  var out = document.getElementById('dim-readout');
  if (!range || !out) return;
  var glow = document.getElementById('dim-glow');
  var lit = document.getElementById('dim-lit');
  function label(v) {
    if (v <= 3) return 'nahezu aus';
    if (v <= 30) return 'warm gedämpft';
    if (v <= 70) return 'abgesenkt';
    if (v < 99) return 'fast volle Helligkeit';
    return 'volle Helligkeit';
  }
  function render() {
    var v = parseInt(range.value, 10);
    if (isNaN(v)) v = 100;
    if (glow) glow.style.opacity = (v / 100 * 0.6).toFixed(3);
    if (lit) lit.style.opacity = (0.12 + v / 100 * 0.88).toFixed(3);
    out.innerHTML = 'Reglerstellung: <span class="dim-state">' + v + ' %</span> — ' + label(v);
    range.setAttribute('aria-valuetext', v + ' Prozent, ' + label(v));
  }
  range.addEventListener('input', render);
  render();
})();

/* --- 2) ledmythos :: Mythos/Fakt-Flip-Karten (nachteile-von-led-lampen) ---
   Karteninhalte stehen im Markup (preview.html). Hier nur das Umschalten aria-pressed,
   die Anzeige Mythos<->Fakt loest die CSS. Korrekturen sind belegt/qualitativ. */
(function () {
  var box = document.getElementById('ledmythos');
  if (!box) return;
  var cards = box.querySelectorAll('.mythos-card');
  if (!cards.length) return;
  for (var i = 0; i < cards.length; i++) {
    cards[i].addEventListener('click', function () {
      this.setAttribute('aria-pressed', this.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    });
  }
})();

/* --- 3) ledtoggle :: Profil-Umschalter LED / Glühbirne (led-vs-gluehbirne-vergleich) ---
   Qualitatives Profil aus dem Artikel; Groessenordnung "~5 %" wie im Fliesstext belegt. */
(function () {
  var box = document.getElementById('ledtoggle');
  if (!box) return;
  var buttons = box.querySelectorAll('.ledtoggle-btn');
  var result = document.getElementById('ledtoggle-result');
  if (!buttons.length || !result) return;
  var data = {
    'LED': '<span class="lt-head">LED</span><p class="finder-note">Wandelt einen weit größeren Teil des Stroms in Licht um, hält ein Vielfaches länger, bleibt im Betrieb kühler und ist sofort hell. Erhältlich in allen Lichtfarben von warmweiß bis tageslichtweiß. Etwas höherer Anschaffungspreis — über die Lebensdauer meist klar günstiger.</p>',
    'Glühbirne': '<span class="lt-head">Glühbirne</span><p class="finder-note">Günstig in der Anschaffung und mit sehr natürlichem, lückenlosem Lichtspektrum. Der Großteil der Energie wird aber zu Wärme (Größenordnung: nur etwa fünf Prozent werden zu Licht), die Lebensdauer ist kurz und der Glaskolben wird heiß. Enthält kein Quecksilber.</p>'
  };
  function select(btn) {
    var key = btn.getAttribute('data-key');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', buttons[i] === btn ? 'true' : 'false');
    }
    result.innerHTML = data[key] || '';
  }
  for (var j = 0; j < buttons.length; j++) {
    buttons[j].addEventListener('click', function () { select(this); });
  }
  select(buttons[0]);
})();

/* --- 4) standort :: Standort-Wegweiser Schutzart (indoor-outdoor-leuchtmittel) ---
   IP-Angaben ausdruecklich als Orientierung; maßgeblich bleibt Datenblatt/Schutzzone. */
(function () {
  var box = document.getElementById('standort');
  if (!box) return;
  var buttons = box.querySelectorAll('.standort-btn');
  var result = document.getElementById('standort-result');
  if (!buttons.length || !result) return;
  var data = {
    innen: {
      head: 'Innen, trockener Wohnbereich',
      note: 'Im normalen Wohnraum genügen Innenleuchten ohne besondere Schutzart (Orientierung IP20). Achten Sie eher auf Sockel, Lichtfarbe und Helligkeit. <a href="/collections/led-lampen" class="sock-link" data-todo="link-pruefen">LED-Lampen →</a>'
    },
    bad: {
      head: 'Bad, Dusche, Feuchtraum',
      note: 'Hier zählen die <strong>Schutzzonen</strong> im Bad. Spritz- und Strahlwasser verlangen eine höhere Schutzart — je nach Zone Orientierung ab IP44, im Nahbereich von Dusche und Wanne mehr. Maßgeblich sind Datenblatt und Schutzzone. <a href="/blogs/ratgeber/feuchtraumleuchten" class="sock-link" data-todo="link-pruefen">Feuchtraumleuchten →</a>'
    },
    ueberdacht: {
      head: 'Außen, überdacht',
      note: 'Geschützt vor direktem Regen (Hauseingang, überdachte Terrasse): als Orientierung oft IP44. Auf die ausdrückliche Eignung „für außen“ und die Schutzart auf der Verpackung achten. <a href="/blogs/ratgeber/schutzart-schutzklassen" class="sock-link" data-todo="link-pruefen">Schutzarten erklärt →</a>'
    },
    frei: {
      head: 'Außen, frei bewittert',
      note: 'Direkt Regen und Staub ausgesetzt: höhere Schutzart, Orientierung IP65 (strahlwasser- und staubgeschützt). Den genauen Wert nennt immer das Datenblatt. <a href="/blogs/ratgeber/schutzart-schutzklassen" class="sock-link" data-todo="link-pruefen">Schutzarten erklärt →</a>'
    }
  };
  function select(btn) {
    var key = btn.getAttribute('data-key');
    var d = data[key];
    if (!d) return;
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', buttons[i] === btn ? 'true' : 'false');
    }
    result.innerHTML = '<span class="st-head">' + d.head + '</span><p class="finder-note">' + d.note + '</p>';
  }
  for (var j = 0; j < buttons.length; j++) {
    buttons[j].addEventListener('click', function () { select(this); });
  }
  select(buttons[0]);
})();


/* ===== BLOCK 9 (2026-06-20) :: 2 Neubauten — interaktive Module ===== */

/* --- ftraum :: Farbtemperatur-Finder Raum/Zweck-Selektor (farbtemperatur-finden) ---
   Kelvin-Werte ausdruecklich nur als Orientierung; maßgeblich Eindruck/Datenblatt. */
(function () {
  'use strict';
  var box = document.getElementById('ftraum');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.ftraum-btn'));
  var result = document.getElementById('ftraum-result');
  if (!btns.length || !result) return;

  // [Label, Kelvin-Text, Begründung, loK, hiK] — loK/hiK = Orientierungs-Spanne für die Marker.
  var DATA = {
    wohnen: ['Warmweiß', 'unter 3300 K (oft um 2700 K)', 'Im Wohn- und Schlafzimmer schafft warmes Licht Behaglichkeit und stört den Abend nicht.', 2500, 3300],
    kueche: ['Warmweiß bis neutralweiß', 'rund 3000 bis 4000 K', 'Esstisch warm, Arbeitsfläche eine Stufe kühler (neutralweiß) — so sehen Sie beim Schneiden mehr.', 3000, 4000],
    bad: ['Neutralweiß', 'rund 4000 K', 'Am Spiegel zeigt neutralweißes Licht Hautton und Make-up natürlich; für die Wanne darf es wärmer sein.', 3700, 4300],
    buero: ['Neutralweiß', 'rund 4000 K', 'Beim Lesen und am Bildschirm hält neutralweißes Licht wach, ohne kühl zu wirken.', 3700, 4300],
    werkstatt: ['Tageslichtweiß', 'über 5300 K (oft um 6500 K)', 'In Werkstatt, Lager oder Praxis bringt kühles Licht Kontrast und Details — sachlich, nicht wohnlich.', 5300, 6500],
    aussen: ['Neutralweiß', 'rund 4000 K', 'Eingang und Hof wirken mit neutralweißem Licht sicher und gepflegt; sehr kühles Licht kann ungemütlich aussehen.', 3700, 4300]
  };
  var ORDER = ['wohnen', 'kueche', 'bad', 'buero', 'werkstatt', 'aussen'];

  // Kelvin-Achse der Leiste (warm links -> kühl rechts) — nur Orientierung.
  var AXIS_MIN = 2200, AXIS_MAX = 6500;
  function pos(k) {
    var p = (k - AXIS_MIN) / (AXIS_MAX - AXIS_MIN) * 100;
    return p < 0 ? 0 : (p > 100 ? 100 : p);
  }

  function render(key) {
    var d = DATA[key];
    if (!d) return;
    var l = pos(d[3]), w = Math.max(3, pos(d[4]) - pos(d[3]));
    result.innerHTML =
      '<div class="ft-head"><span class="ft-label">' + d[0] + '</span><span class="ft-kelvin">' + d[1] + '</span></div>' +
      '<div class="ftraum-scale" aria-hidden="true">' +
        '<div class="ftraum-swatch">' +
          '<div class="ftraum-band" style="left:' + l.toFixed(1) + '%;width:' + w.toFixed(1) + '%">' +
            '<span class="ftraum-mk ftraum-mk-l"></span><span class="ftraum-mk ftraum-mk-r"></span>' +
          '</div>' +
        '</div>' +
        '<div class="ftraum-ends"><span>warm · 2200 K</span><span>6500 K · kühl</span></div>' +
      '</div>' +
      '<p class="finder-note">' + d[2] + ' <strong>Orientierung, kein Muss</strong> — maßgeblich sind der eigene Eindruck und das Datenblatt.</p>';
  }
  function select(btn) {
    var key = btn.getAttribute('data-key');
    if (!DATA[key]) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i] === btn ? 'true' : 'false');
      btns[i].classList.toggle('is-on', btns[i] === btn);
    }
    render(key);
  }
  function lock() {
    var active = box.querySelector('.ftraum-btn.is-on');
    var activeKey = active ? active.getAttribute('data-key') : ORDER[0];
    var max = 0;
    result.style.minHeight = '';
    for (var i = 0; i < ORDER.length; i++) { render(ORDER[i]); if (result.offsetHeight > max) max = result.offsetHeight; }
    render(activeKey);
    result.style.minHeight = max + 'px';
  }
  for (var j = 0; j < btns.length; j++) { btns[j].addEventListener('click', function () { select(this); }); }
  select(btns[0]);
  lock();
  var ftT;
  window.addEventListener('resize', function () { clearTimeout(ftT); ftT = setTimeout(lock, 150); });
})();

/* --- ledtime :: interaktiver Zeitstrahl LED-Geschichte (geschichte-der-led) ---
   Nur belegte Meilensteine (WebSearch-verifiziert). textContent (JSON-/HTML-sicher). */
(function () {
  'use strict';
  var box = document.getElementById('ledtime');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.ledtime-btn'));
  var result = box.querySelector('.ledtime-result');
  if (!btns.length || !result) return;
  var era = result.querySelector('.ledtime-era');
  var title = result.querySelector('.ledtime-title');
  var note = result.querySelector('.finder-note');
  if (!era || !title || !note) return;

  var DATA = [
    ['Entdeckung', '1907 — H. J. Round beobachtet Elektrolumineszenz', 'Der britische Forscher Henry Joseph Round bemerkt an einem Siliziumkarbid-Kristall, dass dieser unter Spannung Licht abgibt. Das ist der erste dokumentierte Hinweis auf den Effekt, der später die Leuchtdiode möglich macht — noch ohne praktische Lampe.'],
    ['Grundlagenforschung', '1920er — Oleg Lossew untersucht den Effekt systematisch', 'Der sowjetische Forscher Oleg Lossew studiert die Lichtemission an Kristalldetektoren erstmals systematisch und veröffentlicht dazu. Seine Arbeiten bleiben jahrzehntelang weitgehend unbeachtet — die Datierung wird in den Quellen meist auf die 1920er-Jahre gelegt.'],
    ['Erste sichtbare LED', '1962 — Nick Holonyak baut die erste sichtbare (rote) LED', 'Bei General Electric stellt Nick Holonyak die erste Leuchtdiode her, deren Licht für das menschliche Auge sichtbar ist: ein rotes Bauteil auf Basis von Galliumarsenidphosphid (GaAsP). Damit beginnt die LED als nutzbares Leuchtmittel-Konzept. (Kurz zuvor, 1961, hatten Biard und Pittman die unsichtbare Infrarot-LED beschrieben.)'],
    ['Massenfertigung', '1968 — Monsanto beginnt die Massenproduktion', 'Der Chemiekonzern Monsanto produziert rote LEDs erstmals in großen Stückzahlen — zunächst als kleine Anzeige- und Signalleuchten in Geräten. Aus der Laborkuriosität wird ein industrielles Bauteil.'],
    ['Mehr Farben', '1972 — die erste gelbe LED', 'M. George Craford entwickelt die erste gelbe LED (und hellere rote Varianten). Rot, Grün und Gelb sind damit verfügbar — für echtes weißes Licht fehlt aber noch die blaue Farbe.'],
    ['Durchbruch Blau', 'Anfang/Mitte 1990er — die effiziente blaue LED', 'Isamu Akasaki, Hiroshi Amano und Shuji Nakamura entwickeln auf Basis von Galliumnitrid (GaN/InGaN) die erste effiziente blaue Leuchtdiode. Erst Blau erlaubt — mit einer Leuchtstoff-Konversionsschicht — weißes LED-Licht, die Voraussetzung für die LED-Lampe im Haushalt.'],
    ['Anerkennung', '2014 — Physik-Nobelpreis für die blaue LED', 'Akasaki, Amano und Nakamura erhalten den Physik-Nobelpreis „für die Erfindung effizienter blauer Leuchtdioden, die helle und energiesparende weiße Lichtquellen ermöglicht haben“. Das unterstreicht, wie entscheidend die blaue LED für die heutige Beleuchtung ist.'],
    ['Heute', 'Danach — LED wird zum Standard', 'Mit weißem, immer effizienterem Licht setzt sich die LED durch. Begünstigt durch das EU-weite Aus für klassische Glüh- und die meisten Halogenlampen ist die LED heute das Standard-Leuchtmittel — der Grund, warum bei uns fast jede Lampe eine LED ist.']
  ];
  function select(i) {
    btns.forEach(function (b, j) { var on = (j === i); b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    era.textContent = DATA[i][0]; title.textContent = DATA[i][1]; note.textContent = DATA[i][2];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  function lock() {
    var oe = era.textContent, ot = title.textContent, on = note.textContent, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) { era.textContent = d[0]; title.textContent = d[1]; note.textContent = d[2]; if (result.offsetHeight > max) max = result.offsetHeight; });
    era.textContent = oe; title.textContent = ot; note.textContent = on;
    result.style.minHeight = max + 'px';
  }
  select(2);
  lock();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(lock, 150); });
})();


/* ============================================================
   BLOCK 10 (2026-06-20) :: Betriebsgeraete-Cluster — 3 interaktive Module
   bttabs (Trafo/Treiber/Netzteil-Vergleich) · vgcheck (Vorschaltgeraet-Umruest-
   Entscheidungshilfe) · lastcalc (Trafo-Mindestlast-Rechner).
   Integriert aus den folder-lokalen module.snippet.js der jeweiligen Artikel.
   ============================================================ */
/* ============================================================
   MODUL „bttabs“ — Artikel led-trafo-treiber-netzteil
   3-Segment-Vergleich: Trafo | LED-Treiber | Netzteil
   - Eigenständige id-IIFE, KEINE Abhängigkeit zu shared/ratgeber-modules.js.
   - Buttons .apart-btn mit aria-pressed + Klasse is-on; Ergebnis in role="status"
     aria-live="polite". Höhen-Lock (alle Zustände durchgemessen) + resize-Re-Lock.
   - prefers-reduced-motion wird über die zugehörige shared/ratgeber-modules.css gehandhabt.
   - Nur belegte/generische Aussagen; Nennströme (z. B. 350/700 mA) nur als
     „typisch, laut Datenblatt“. Keine erfundenen Watt-/VA-Listen.
   - Block 10 (integriert 2026-06-20): bei shared-Integration in shared/ratgeber-modules.js übernehmen.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('bttabs');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.bt-btn'));
  var val = document.getElementById('bt-val');
  var note = document.getElementById('bt-note');
  if (!btns.length || !val || !note) return;

  // Reihenfolge identisch zu den Buttons in preview.html / Fallback im body.html.
  // [Kurz-Kennzeichnung, Detailtext]
  var DATA = [
    [
      'Trafo (12 V/24 V) · meist Konstantspannung',
      'Umgangssprachlich „Trafo“: ein Wandler, der die Netzspannung auf eine niedrige Schutzkleinspannung (SELV) bringt — meist 12 V, manchmal 24 V. Für LED braucht es einen elektronischen, ausdrücklich LED-tauglichen Trafo. Typischer Einsatz: 12-V-Niedervolt-Spots (GU5.3/MR16, G4). Worauf achten: Lastbereich des Trafos muss zur Summe der LED-Leistung passen; alte Halogentrafos haben oft eine Mindestlast, die geringe LED-Last unterschreitet (Flackern). Werte laut Datenblatt/Typenschild.'
    ],
    [
      'LED-Treiber · oft Konstantstrom (mA)',
      'Ein LED-Treiber ist ein Betriebsgerät, das speziell auf LED-Module abgestimmt ist — häufig als Konstantstromquelle (CC) mit fester Stromstärke in Milliampere. Typischer Einsatz: einzelne Hochleistungs-LEDs, COB-Module und viele Panels/Downlights, die einen festen Strom verlangen. Worauf achten: Treiber-Strom (z. B. typisch 350 mA oder 700 mA, laut Datenblatt) und Spannungsbereich müssen exakt zum Modul passen — CC und CV sind nicht austauschbar. Manche Treiber sind dimmbar.'
    ],
    [
      'Netzteil · Konstantspannung (12 V/24 V)',
      'Ein Netzteil ist ein Konstantspannungs-Schaltnetzteil (CV) mit fester Ausgangsspannung, meist 12 V oder 24 V Gleichspannung. Typischer Einsatz: LED-Streifen und Module mit eigenem Vorwiderstand, die eine stabile Spannung erwarten. Worauf achten: Ausgangsspannung muss zum Streifen passen; die Leistung (Watt) sollte die Summe der Verbraucher mit Reserve abdecken. Ein etwas größeres Netzteil schadet nicht — es liefert nur so viel, wie die LED zieht.'
    ]
  ];

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.textContent = DATA[i][0];
    note.textContent = DATA[i][1];
  }

  btns.forEach(function (b, i) {
    b.addEventListener('click', function () { select(i); });
  });
  select(0);

  // Höhen-Lock: alle Zustände durchmessen, höchsten als min-height festsetzen,
  // damit die Ergebnis-Karte beim Umschalten nicht springt.
  var result = box.querySelector('.bt-result');
  function lock() {
    if (!result) return;
    var cv = val.textContent, cn = note.textContent, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.textContent = d[0]; note.textContent = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.textContent = cv; note.textContent = cn;
    result.style.minHeight = max + 'px';
  }
  lock();
  var btT;
  window.addEventListener('resize', function () {
    clearTimeout(btT);
    btT = setTimeout(lock, 150);
  });
})();

/* ============================================================
   MODUL: vgcheck — Umrüst-Entscheidungshilfe (Selektor -> Notiz)
   Artikel: vorschaltgeraet-evg-kvg-vvg  (/blogs/ratgeber/vorschaltgeraet-evg-kvg-vvg)
   Block 10 (integriert 2026-06-20): eigenständige id-IIFE im Stil der shared-Module (standort/ftraum).
   Keine Abhängigkeit zu shared/ratgeber-modules.js. Bei der späteren shared-Integration
   wird dieser Block dorthin übernommen; shared/ratgeber-modules.* dann entfernen.

   Konzept: 4 Buttons (KVG mit Starter | VVG mit Starter | EVG | 230 V ohne Vorschaltgerät).
   Ergebnis zeigt je Fall die ALLGEMEINE LED-Röhren-Umrüstlogik + EINEN Datenblatt-/
   Sicherheitshinweis. Keine "immer kompatibel"-Aussage, keine erfundenen Werte.
   Höhen-Lock (alle Zustände durchmessen, Maximum als min-height) + resize-Re-Lock.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('vgcheck');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.vgcheck-btn'));
  var result = document.getElementById('vgcheck-result');
  if (!btns.length || !result) return;

  // [Überschrift, Notiz-HTML] — Notiz nutzt .finder-note (helle Schrift auf Navy).
  var DATA = {
    kvg: [
      'KVG mit Starter',
      'Ein konventionelles Vorschaltgerät (Drossel) arbeitet mit einem externen Starter. ' +
      'Viele LED-Röhren sind für genau diesen Betrieb ausgelegt: Der vorhandene Starter wird ' +
      'gegen den mitgelieferten <strong>LED-/Dummy-Starter</strong> getauscht, oft ohne Umverdrahtung. ' +
      'Ob das für Ihre Röhre gilt und ob sie einseitig oder zweiseitig eingespeist wird, steht im ' +
      '<strong>Datenblatt bzw. der Kompatibilitätsliste des Herstellers</strong> — das entscheidet, nicht die Bauform allein. ' +
      '<a href="/blogs/ratgeber/leuchtstoffroehren-durch-led-roehren-ersetzen" class="vgcheck-link">Schritt-für-Schritt-Umrüstung →</a>'
    ],
    vvg: [
      'VVG mit Starter',
      'Ein verlustarmes Vorschaltgerät (VVG) ist technisch ein KVG mit geringerer Verlustleistung — ' +
      'es arbeitet ebenfalls mit Drossel und externem Starter. Für die LED-Umrüstung gilt daher dieselbe ' +
      'Logik wie beim KVG: meist Starter gegen <strong>LED-/Dummy-Starter</strong> tauschen, wenn die Röhre ' +
      'dafür ausgewiesen ist. <strong>Maßgeblich ist die Hersteller-Kompatibilitätsliste</strong>, nicht eine ' +
      'pauschale Eignung. ' +
      '<a href="/blogs/ratgeber/leuchtstoffroehren-durch-led-roehren-ersetzen" class="vgcheck-link">Schritt-für-Schritt-Umrüstung →</a>'
    ],
    evg: [
      'EVG (elektronisch)',
      'Ein elektronisches Vorschaltgerät (EVG) betreibt die Lampe hochfrequent und hat <strong>keinen ' +
      'klassischen Starter</strong>. Für den LED-Betrieb am EVG brauchen Sie eine Röhre mit ' +
      '<strong>ausdrücklich ausgewiesener EVG-Kompatibilität</strong> laut Hersteller — die passenden EVG-Typen ' +
      'stehen in der Kompatibilitätsliste. Steht Ihr EVG nicht darauf, ist Direktbetrieb nach Umbau eine ' +
      'Alternative (siehe nächster Fall). Eine generelle „EVG-kompatibel“-Aussage gibt es nicht.'
    ],
    direkt: [
      '230 V ohne Vorschaltgerät',
      'Manche LED-Röhren sind für den <strong>direkten 230-V-Netzbetrieb</strong> vorgesehen. Dann werden ' +
      'altes Vorschaltgerät und Starter überbrückt — ein Eingriff in die Leuchtenverdrahtung. ' +
      '<strong>Diese Umverdrahtung gehört in die Hand einer Elektrofachkraft</strong>; ob einseitige oder ' +
      'zweiseitige Einspeisung gefordert ist, legt das Datenblatt fest. Keine pauschale Aussage, keine ' +
      'Eigenmontage an 230 V.'
    ]
  };
  var ORDER = ['kvg', 'vvg', 'evg', 'direkt'];

  function render(key) {
    var d = DATA[key];
    if (!d) return;
    result.innerHTML =
      '<span class="vgcheck-head">' + d[0] + '</span>' +
      '<p class="finder-note">' + d[1] + '</p>';
  }

  function select(btn) {
    var key = btn.getAttribute('data-key');
    if (!DATA[key]) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i] === btn ? 'true' : 'false');
      btns[i].classList.toggle('is-on', btns[i] === btn);
    }
    render(key);
  }

  // Höhen-Lock: alle Zustände durchmessen, größtes offsetHeight als min-height setzen,
  // damit die Ergebnis-Box beim Umschalten nicht springt.
  function lock() {
    var active = box.querySelector('.vgcheck-btn.is-on');
    var activeKey = active ? active.getAttribute('data-key') : ORDER[0];
    var max = 0;
    result.style.minHeight = '';
    for (var i = 0; i < ORDER.length; i++) {
      render(ORDER[i]);
      if (result.offsetHeight > max) max = result.offsetHeight;
    }
    render(activeKey);
    result.style.minHeight = max + 'px';
  }

  for (var j = 0; j < btns.length; j++) {
    btns[j].addEventListener('click', function () { select(this); });
  }
  select(btns[0]);
  lock();

  var vgT;
  window.addEventListener('resize', function () {
    clearTimeout(vgT);
    vgT = setTimeout(lock, 150);
  });
})();

/* ============================================================
   MODUL: lastcalc — Trafo-Mindestlast-Rechner
   Artikel: 12v-niedervolt-led-waehlen (/blogs/ratgeber/12v-niedervolt-led-waehlen)
   Block 10 (integriert 2026-06-20): eigenständige id-IIFE, KEINE Abhängigkeit zu shared/ratgeber-modules.js.
   Bei shared-Integration wandert dieser Block 1:1 in shared (Hauptloop).

   Logik (rechnet AUSSCHLIESSLICH aus Nutzereingaben — keine vorbelegten Produktwerte als Fakt):
   - Gesamtlast = Anzahl LED × Watt je LED
   - Verdict gegen die vom Nutzer eingetragene Mindest-/Maximallast des Trafos:
       Gesamtlast < Mindestlast  -> kann flackern / nicht starten
       Mindestlast ≤ Gesamtlast ≤ Maximallast -> im Arbeitsbereich
       Gesamtlast > Maximallast  -> Trafo überlastet
   - Mindest-/Maximallast laut Datenblatt/Typenschild des Trafos (Hinweis im Ergebnis).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('lastcalc');
  if (!box) return;
  var minIn = document.getElementById('lc-min');
  var maxIn = document.getElementById('lc-max');
  var cntIn = document.getElementById('lc-count');
  var wIn = document.getElementById('lc-watt');
  var out = document.getElementById('lc-result');
  if (!minIn || !maxIn || !cntIn || !wIn || !out) return;

  var f1 = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });

  function render() {
    var min = parseFloat(minIn.value);
    var max = parseFloat(maxIn.value);
    var cnt = parseInt(cntIn.value, 10);
    var w = parseFloat(wIn.value);

    if (!isFinite(cnt) || cnt < 1 || !isFinite(w) || w <= 0) {
      out.innerHTML = '<p class="finder-note">Bitte Anzahl der LED und Watt je LED eingeben. Mindest- und Maximallast finden Sie auf dem Typenschild oder im Datenblatt Ihres Trafos.</p>';
      return;
    }

    var total = cnt * w;
    var verdictTitle, verdictText, cls;

    if (isFinite(min) && min > 0 && total < min) {
      cls = 'is-warn';
      verdictTitle = 'Unter der Mindestlast — kann flackern oder nicht starten.';
      verdictText = 'Die Gesamtlast (' + f1.format(total) + ' W) liegt unter der eingetragenen Mindestlast (' + f1.format(min) + ' W). Viele elektronische Halogentrafos brauchen eine Mindestlast, um sicher anzuschwingen; LED-Last ist dafür oft zu klein. Ein LED-tauglicher Trafo bzw. LED-Treiber ohne Mindestlast schafft Abhilfe.';
    } else if (isFinite(max) && max > 0 && total > max) {
      cls = 'is-warn';
      verdictTitle = 'Über der Maximallast — der Trafo ist überlastet.';
      verdictText = 'Die Gesamtlast (' + f1.format(total) + ' W) übersteigt die eingetragene Maximallast (' + f1.format(max) + ' W). Reduzieren Sie die Anzahl der Leuchtmittel oder wählen Sie einen Trafo mit höherer Leistung. Eine Reserve nach oben verlängert die Lebensdauer.';
    } else if (isFinite(min) && min > 0 && isFinite(max) && max > 0) {
      cls = 'is-ok';
      verdictTitle = 'Im Arbeitsbereich des Trafos.';
      verdictText = 'Die Gesamtlast (' + f1.format(total) + ' W) liegt zwischen der eingetragenen Mindest- (' + f1.format(min) + ' W) und Maximallast (' + f1.format(max) + ' W). Das spricht für einen sicheren Betrieb — entscheidend bleibt, dass Trafo und LED laut Datenblatt zusammenpassen (AC/DC, Dimmbarkeit).';
    } else {
      cls = '';
      verdictTitle = 'Gesamtlast: ' + f1.format(total) + ' W.';
      verdictText = 'Tragen Sie Mindest- und Maximallast Ihres Trafos ein (Typenschild/Datenblatt), um zu prüfen, ob die Last im Arbeitsbereich liegt.';
    }

    out.className = 'lc-result ' + cls;
    out.innerHTML =
      '<span class="lc-total">Gesamtlast: <strong>' + f1.format(total) + ' W</strong> (' + cnt + ' &times; ' + f1.format(w) + ' W)</span>' +
      '<strong class="lc-verdict">' + verdictTitle + '</strong>' +
      '<p class="finder-note">' + verdictText + '</p>';
  }

  [minIn, maxIn, cntIn, wIn].forEach(function (el) { el.addEventListener('input', render); });

  /* Höhen-Lock: alle Verdict-Zustände einmal durchmessen, größte Höhe als min-height
     fixieren, damit das Ergebnis beim Tippen nicht springt. */
  function lock() {
    out.style.minHeight = '';
    var max = 0;
    var states = [
      { cnt: '', w: '' },              // Leer-Hinweis
      { min: '20', max: '60', cnt: '2', w: '4' },   // unter Mindestlast
      { min: '20', max: '60', cnt: '6', w: '12' },  // über Maximallast
      { min: '0', max: '60', cnt: '4', w: '8' }     // im Bereich
    ];
    var sMin = minIn.value, sMax = maxIn.value, sCnt = cntIn.value, sW = wIn.value;
    states.forEach(function (s) {
      minIn.value = s.min != null ? s.min : '';
      maxIn.value = s.max != null ? s.max : '';
      cntIn.value = s.cnt;
      wIn.value = s.w;
      render();
      if (out.offsetHeight > max) max = out.offsetHeight;
    });
    minIn.value = sMin; maxIn.value = sMax; cntIn.value = sCnt; wIn.value = sW;
    render();
    out.style.minHeight = max + 'px';
  }

  render();
  lock();
  var lcT;
  window.addEventListener('resize', function () { clearTimeout(lcT); lcT = setTimeout(lock, 150); });
})();


/* ===================== BLOCK 11 (2026-06-20): naechster Batch — Starter / Bauform / WAGO ===================== */

/* ============================================================
   Block 11 (2026-06-20) — naechster Batch · MODUL startcheck (led-roehre-starter-dummy-starter)
   Integriert aus folder-lokalem module.snippet.js. Starter-Entscheidungshilfe (Selektor): KVG/VVG | EVG | 230 V -> Starter-Aktion + Sicherheitshinweis.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('startcheck');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.startcheck-btn'));
  var val = document.getElementById('startcheck-val');
  var note = document.getElementById('startcheck-note');
  if (!btns.length || !val || !note) return;

  // Reihenfolge identisch zu den Buttons in preview.html / body.
  // [Ergebnis-Kennzeile, Hinweis-HTML inkl. internem Link (data-todo)]
  var DATA = [
    ['KVG/VVG-Leuchte mit Glimmstarter → Glimmstarter raus, mitgelieferten Dummy-/LED-Starter rein',
     'Die häufigste Ausgangslage: Die Leuchte hat ein konventionelles bzw. verlustarmes Vorschaltgerät (KVG/VVG) und einen separaten <strong>Glimmstarter</strong>. Eine dafür ausgewiesene LED-Röhre wird meist mit einem <strong>Dummy- bzw. LED-Starter</strong> geliefert: der alte Glimmstarter kommt heraus, der Dummy-Starter ersetzt ihn. Der Dummy-Starter <strong>zündet nicht</strong> — er schließt nur den Stromkreis (Brücke) und enthält laut Datenblatt oft eine Sicherung. Ob genau diese Röhre für diesen Betrieb freigegeben ist, steht im <strong>Datenblatt</strong>.'],
    ['EVG-Leuchte → ausgewiesene EVG-Kompatibilität nötig, klassischer Starter entfällt',
     'Steckt ein <strong>elektronisches Vorschaltgerät (EVG)</strong> in der Leuchte, gibt es keinen klassischen Glimmstarter zum Tauschen. Hier kommt nur eine LED-Röhre infrage, die der Hersteller <strong>für genau diesen EVG-Betrieb freigegeben</strong> hat (Kompatibilitätsliste/Datenblatt). Das ist nicht universell — verlassen Sie sich nicht ohne Freigabe darauf. Welches EVG verbaut ist, erkennen Sie am Aufdruck des Vorschaltgeräts und am fehlenden Starter. <a href="/blogs/ratgeber/vorschaltgeraet-evg-kvg-vvg" class="sock-link" data-todo="link-pruefen">EVG/KVG/VVG erkennen →</a>'],
    ['Auf 230 V umgebaut → Starter entfällt, Vorschaltgerät überbrückt — Elektrofachkraft',
     'Bei einer auf <strong>230-V-Direktbetrieb</strong> umgebauten Leuchte sind Vorschaltgerät und Starter überbrückt; ein Starter ist dann nicht mehr im Stromkreis. Eine dafür freigegebene LED-Röhre läuft direkt an 230 V (ein- oder zweiseitige Einspeisung ist produktabhängig, siehe Datenblatt). <strong>Diese Umverdrahtung an Netzspannung gehört ausschließlich in die Hand einer Elektrofachkraft</strong> — nicht selbst durchführen. Welche Röhre für den Direktbetrieb zugelassen ist, steht im Datenblatt. <a href="/blogs/ratgeber/leuchtstoffroehren-durch-led-roehren-ersetzen" class="sock-link" data-todo="link-pruefen">Umrüstung im Überblick →</a>']
  ];

  function select(i) {
    btns.forEach(function (b, j) {
      b.classList.toggle('is-on', j === i);
      b.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.textContent = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
  select(0); // Default = erster Button (= statischer Fallback)

  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.startcheck-result');
  function lock() {
    if (!result) return;
    var v = val.textContent, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.textContent = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.textContent = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var scT;
  window.addEventListener('resize', function () { clearTimeout(scT); scT = setTimeout(lock, 150); });
})();

/* ============================================================
   Block 11 (2026-06-20) — naechster Batch · MODUL formcode (led-lampen-bauform-uebersicht)
   Integriert aus folder-lokalem module.snippet.js. Bauform-Code-Entschluessler (Selektor): A | B/C | P | G | T | R/PAR -> Name + Beispielcode + Durchmesser-Hinweis.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('formcode');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.formcode-btn'));
  var result = document.getElementById('formcode-result');
  if (!btns.length || !result) return;

  // [Form-Code (Kennzahl), Klartext-Name, Notiz-HTML] — Notiz nutzt .finder-note (helle Schrift auf Navy).
  var DATA = {
    a: [
      'A · z. B. A60',
      'Klassische Birnen-/Glühlampenform',
      'Die vertraute, leicht bauchige Form der alten Glühlampe — der Allrounder für offene und ' +
      'halboffene Leuchten. <strong>A</strong> steht für diese Bauform, die Zahl für den größten ' +
      'Durchmesser in Millimetern: <strong>A60</strong> entspricht rund 60&nbsp;mm. Häufig mit Sockel ' +
      'E27 oder E14 — der Sockel ist aber eine eigene Eigenschaft.'
    ],
    bc: [
      'B / C · z. B. C35',
      'Kerzenform',
      'Die schlanke, nach oben zulaufende Kerzenform für Kronleuchter, Wand- und Pendelleuchten, ' +
      'bei denen die Lampe sichtbar bleibt. Übliche Kürzel sind <strong>C</strong> (Kerze) und ' +
      '<strong>B</strong> (Windstoß-/Tropfenkerze) — die genaue Buchstabenzuordnung ist eine gängige ' +
      'Konvention, im Zweifel laut Herstellerangabe. <strong>C35</strong> heißt rund 35&nbsp;mm Durchmesser.'
    ],
    p: [
      'P · z. B. P45',
      'Tropfen-/Miniballform',
      'Eine kleine, rundliche Form zwischen Kerze und Globe — kompakter als die A-Birne, oft in ' +
      'Leuchten mit wenig Platz oder dekorativen Fassungen. <strong>P</strong> steht für die ' +
      'Tropfen-/Miniballform, <strong>P45</strong> für rund 45&nbsp;mm Durchmesser.'
    ],
    g: [
      'G · z. B. G80 / G95 / G125',
      'Globe-/Ballform',
      'Die kugelige Globe-Form ist dekorativ und vor allem als sichtbares Gestaltungselement gefragt ' +
      '(offene Fassungen, Filament-Optik). <strong>G</strong> steht für die Ballform, die Zahl für den ' +
      'Durchmesser: <strong>G95</strong> sind rund 95&nbsp;mm. Je größer die Zahl, desto größer die Kugel — ' +
      'prüfen Sie, ob sie in Schirm oder Fassung passt.'
    ],
    t: [
      'T · Stab (z. B. R7s-Stablampe)',
      'Röhren-/Stabform',
      'Eine längliche, gerade Glaskörperform — als Stablampe (z. B. mit R7s-Sockel) oder als Röhre. ' +
      '<strong>Hinweis zur Zahl:</strong> Bei der T-Form steht die Ziffer historisch nicht für Millimeter, ' +
      'sondern für den Durchmesser in Achtel-Zoll (T8 ≈ 26&nbsp;mm, T5 ≈ 16&nbsp;mm) — anders als bei A, B/C, P ' +
      'oder G. Geht es um LED- oder Leuchtstoffröhren als Leuchtmittel-Typ (Längen, Betriebsgerät, ' +
      'Kompatibilität), führt das unser Röhren-Ratgeber weiter.'
    ],
    rpar: [
      'R / PAR · Reflektor',
      'Reflektorform',
      'Bei Reflektorlampen lenkt eine verspiegelte Innenfläche das Licht gebündelt nach vorn — typisch ' +
      'für Spots und Akzentbeleuchtung. <strong>R</strong> steht für die Reflektorform, <strong>PAR</strong> ' +
      'für die robustere Parabolspiegel-Bauart. Wie eng oder breit das Licht abstrahlt, hängt vom ' +
      'Abstrahlwinkel ab — den behandelt unser Ratgeber dazu.'
    ]
  };
  var ORDER = ['a', 'bc', 'p', 'g', 't', 'rpar'];

  function render(key) {
    var d = DATA[key];
    if (!d) return;
    result.innerHTML =
      '<span class="formcode-code">' + d[0] + '</span>' +
      '<span class="formcode-name">' + d[1] + '</span>' +
      '<p class="finder-note">' + d[2] + '</p>';
  }

  function select(btn) {
    var key = btn.getAttribute('data-key');
    if (!DATA[key]) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i] === btn ? 'true' : 'false');
      btns[i].classList.toggle('is-on', btns[i] === btn);
    }
    render(key);
  }

  // Höhen-Lock: alle Zustände durchmessen, größtes offsetHeight als min-height setzen,
  // damit die Ergebnis-Box beim Umschalten nicht springt.
  function lock() {
    var active = box.querySelector('.formcode-btn.is-on');
    var activeKey = active ? active.getAttribute('data-key') : ORDER[0];
    var max = 0;
    result.style.minHeight = '';
    for (var i = 0; i < ORDER.length; i++) {
      render(ORDER[i]);
      if (result.offsetHeight > max) max = result.offsetHeight;
    }
    render(activeKey);
    result.style.minHeight = max + 'px';
  }

  for (var j = 0; j < btns.length; j++) {
    btns[j].addEventListener('click', function () { select(this); });
  }
  select(btns[0]);
  lock();

  var fcT;
  window.addEventListener('resize', function () {
    clearTimeout(fcT);
    fcT = setTimeout(lock, 150);
  });
})();

/* ============================================================
   Block 11 (2026-06-20) — naechster Batch · MODUL klemmpick (wago-klemmen-leuchten-anschliessen)
   Integriert aus folder-lokalem module.snippet.js. Klemmen-Auswahlhilfe (Selektor): starr | flexibel | mischen | Leuchte -> Klemmentyp + Datenblatt-/Fachkraft-Hinweis.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('klemmpick');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.klemmpick-btn'));
  var result = document.getElementById('klemmpick-result');
  if (!btns.length || !result) return;

  // [Überschrift, Notiz-HTML] — Notiz nutzt .finder-note (helle Schrift auf Navy).
  var DATA = {
    starr: [
      'Starre (eindrähtige) Leiter',
      'Für starre, eindrähtige Leiter kommen Sie mit den meisten Verbindungsklemmen zurecht: ' +
      'eine <strong>Hebelklemme</strong> (z. B. WAGO 221) ebenso wie eine <strong>Steck-/Push-in-Klemme</strong> ' +
      '(z. B. WAGO 2273), die häufig genau für eindrähtige Leiter gedacht ist. Die Ader wird auf der ' +
      'aufgedruckten Abisolierlänge abisoliert und bis zum Anschlag eingeführt. ' +
      '<strong>Zulässiger Leiterquerschnitt und Strombelastbarkeit gelten laut Datenblatt der Klemme</strong> — ' +
      'keine pauschalen mm²-Werte annehmen.'
    ],
    flex: [
      'Flexible (feindrähtige) Litze',
      'Feindrähtige Litze gehört in eine Klemme, die <strong>ausdrücklich für flexible Leiter</strong> ' +
      'ausgewiesen ist — die <strong>Hebelklemme</strong> (z. B. WAGO 221) klemmt starre und flexible Leiter. ' +
      'Bei einer klassischen <strong>Lüsterklemme (Schraubklemme)</strong> ist für Litze eine ' +
      '<strong>Aderendhülse</strong> sinnvoll, sonst quetscht die Schraube einzelne Drähte ab. ' +
      'Ob die jeweilige Klemme Litze (mit/ohne Aderendhülse) zulässt, steht im <strong>Datenblatt</strong>.'
    ],
    misch: [
      'Starr + flexibel mischen',
      'Wenn in einer Verbindung <strong>starre und flexible Leiter zusammenkommen</strong>, ist die ' +
      '<strong>Hebelklemme</strong> (z. B. WAGO 221) der naheliegende Typ: Jede Kammer hat einen eigenen ' +
      'Hebel, sodass sich unterschiedliche Leiterarten je Kammer sicher klemmen lassen. Reine ' +
      'Steck-/Push-in-Klemmen sind dagegen oft auf eindrähtige Leiter beschränkt. ' +
      '<strong>Welche Leiterarten und Querschnitte je Kammer erlaubt sind, legt das Datenblatt fest.</strong>'
    ],
    leuchte: [
      'Leuchte anklemmen',
      'Für den Leuchtenanschluss gibt es spezielle <strong>Leuchtenklemmen</strong> (z. B. WAGO 224), die auf ' +
      'die typische Verbindung von eindrähtigem Installations- mit dem Leuchtenanschlussleiter ausgelegt sind. ' +
      'Welche Seite welche Leiterart aufnimmt, steht im Datenblatt. Wichtiger als der Klemmentyp: ' +
      '<strong>Arbeiten an der festen 230-V-Installation gehören in die Hand einer Elektrofachkraft.</strong> ' +
      'Steckbare Leuchten-Stecksysteme erleichtern die Montage, ersetzen die Fachkraft-Regel aber nicht.'
    ]
  };
  var ORDER = ['starr', 'flex', 'misch', 'leuchte'];

  function render(key) {
    var d = DATA[key];
    if (!d) return;
    result.innerHTML =
      '<span class="klemmpick-head">' + d[0] + '</span>' +
      '<p class="finder-note">' + d[1] + '</p>';
  }

  function select(btn) {
    var key = btn.getAttribute('data-key');
    if (!DATA[key]) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i] === btn ? 'true' : 'false');
      btns[i].classList.toggle('is-on', btns[i] === btn);
    }
    render(key);
  }

  // Höhen-Lock: alle Zustände durchmessen, größtes offsetHeight als min-height setzen,
  // damit die Ergebnis-Box beim Umschalten nicht springt.
  function lock() {
    var active = box.querySelector('.klemmpick-btn.is-on');
    var activeKey = active ? active.getAttribute('data-key') : ORDER[0];
    var max = 0;
    result.style.minHeight = '';
    for (var i = 0; i < ORDER.length; i++) {
      render(ORDER[i]);
      if (result.offsetHeight > max) max = result.offsetHeight;
    }
    render(activeKey);
    result.style.minHeight = max + 'px';
  }

  for (var j = 0; j < btns.length; j++) {
    btns[j].addEventListener('click', function () { select(this); });
  }
  select(btns[0]);
  lock();

  var kpT;
  window.addEventListener('resize', function () {
    clearTimeout(kpT);
    kpT = setTimeout(lock, 150);
  });
})();



/* ============================================================
   Block 12 (integriert 2026-06-21) — net-new Batch (Discovery 2026-06-21)
   3 Module: ofencheck (Geraete-Lampe), roehrewechsel (Roehren-Tausch-Mechanik),
   lumenbedarf (Lichtbedarf-Rechner). Eigenstaendige id-IIFE / unter #id gescopte CSS.
   ============================================================ */

/* ============================================================
   MODUL ofencheck (backofen-kuehlschrank-dunstabzug-lampe-waehlen)
   Geräte-Selektor: Backofen | Kühlschrank | Dunstabzug -> typische Sockel +
   Hitze-/Kälte-Hinweis + LED-Eignung. NUR qualitative/belegte Aussagen, keine
   erfundenen °C/Stunden. Unsichere Werte als "laut Herstellerangabe".
   Integriert in shared (Block 12, 2026-06-21).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('ofencheck');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.ofencheck-btn'));
  var result = document.getElementById('ofencheck-result');
  if (!btns.length || !result) return;

  // [Geräte-Label, Sockel-Zeile, Eigenschaft-Tag, Notiz-HTML] — Notiz nutzt .finder-note.
  var DATA = {
    backofen: [
      'Backofen',
      'Typische Sockel: E14, G9, G4',
      'Hitzefest erforderlich',
      'Im Backofen sitzt die Lampe im heißen Garraum. Verwenden Sie nur eine ausdrücklich ' +
      '<strong>hitzefeste Backofenlampe</strong> mit passendem Sockel — gängig sind <strong>E14</strong>, ' +
      '<strong>G9</strong> oder <strong>G4</strong>. Welche Temperatur die Lampe verträgt, steht ' +
      '<strong>laut Herstellerangabe</strong> auf der Verpackung bzw. im Datenblatt; ' +
      'Pyrolyse-Backöfen erreichen während der Selbstreinigung deutlich höhere Temperaturen — hier ' +
      'genau auf die Freigabe achten. <strong>LED ist für den Garraum meist nicht geeignet</strong>: ' +
      'Standard-LED-Lampen sind in der Regel nicht für diese Hitze freigegeben. Nur einsetzen, wenn ' +
      'der Hersteller die LED ausdrücklich für Backöfen freigibt.'
    ],
    kuehlschrank: [
      'Kühl- / Gefrierschrank',
      'Typischer Sockel: E14',
      'Kältetauglich',
      'Im Kühl- und Gefrierschrank kommt es auf eine <strong>kältetaugliche Lampe</strong> an — ' +
      'meist mit Sockel <strong>E14</strong>. Achten Sie auf die Wattangabe der vorhandenen Lampe und ' +
      'auf eine Bauform, die in die Fassung und hinter die Abdeckung passt. Ob eine LED für den ' +
      'Kühlbetrieb (niedrige Temperaturen) freigegeben ist, entnehmen Sie der <strong>Herstellerangabe</strong>. ' +
      'Eine Backofenlampe ist nicht automatisch der passende Ersatz — der Einsatzbereich unterscheidet sich.'
    ],
    dunstabzug: [
      'Dunstabzugshaube',
      'Typische Sockel: E14, G9 (teils Speziallampen)',
      'Modellabhängig',
      'Bei Dunstabzugshauben sitzt die Beleuchtung außerhalb des direkten Garraums, kann aber je nach ' +
      'Modell warm werden. Gängig sind Sockel <strong>E14</strong> oder <strong>G9</strong>, manche Hauben ' +
      'nutzen <strong>Speziallampen</strong>. Maßgeblich ist, was im Handbuch der Haube bzw. ' +
      '<strong>laut Herstellerangabe</strong> vorgesehen ist — Sockel, Wattangabe und ob eine ' +
      'hitzefeste oder eine Standardlampe gefordert ist. Erst prüfen, dann passenden Ersatz wählen.'
    ]
  };
  var ORDER = ['backofen', 'kuehlschrank', 'dunstabzug'];

  function render(key) {
    var d = DATA[key];
    if (!d) return;
    result.innerHTML =
      '<span class="ofencheck-code">' + d[1] + '</span>' +
      '<span class="ofencheck-tag">' + d[2] + '</span>' +
      '<span class="ofencheck-name">' + d[0] + '</span>' +
      '<p class="finder-note">' + d[3] + '</p>';
  }

  function select(btn) {
    var key = btn.getAttribute('data-key');
    if (!DATA[key]) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i] === btn ? 'true' : 'false');
      btns[i].classList.toggle('is-on', btns[i] === btn);
    }
    render(key);
  }

  // Höhen-Lock: alle Zustände durchmessen, größtes offsetHeight als min-height setzen.
  function lock() {
    var active = box.querySelector('.ofencheck-btn.is-on');
    var activeKey = active ? active.getAttribute('data-key') : ORDER[0];
    var max = 0;
    result.style.minHeight = '';
    for (var i = 0; i < ORDER.length; i++) {
      render(ORDER[i]);
      if (result.offsetHeight > max) max = result.offsetHeight;
    }
    render(activeKey);
    result.style.minHeight = max + 'px';
  }

  for (var j = 0; j < btns.length; j++) {
    btns[j].addEventListener('click', function () { select(this); });
  }
  select(btns[0]);
  lock();

  var ocT;
  window.addEventListener('resize', function () {
    clearTimeout(ocT);
    ocT = setTimeout(lock, 150);
  });
})();

/* ============================================================
   MODUL roehrewechsel (leuchtstoffroehre-wechseln-anleitung)
   Sockel-/Mechanik-Finder (Selektor): T8/G13 | T5/G5 | Ring G10q | U-Form
   -> erklärt die Tausch-Mechanik (drehen vs. ziehen) + Hinweis „gleiche Länge/Watt/Sockel“.
   Rein mechanisch/faktisch, keine erfundenen Maße. Integriert in shared (Block 12, 2026-06-21).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('roehrewechsel');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.roehrewechsel-btn'));
  var result = document.getElementById('roehrewechsel-result');
  if (!btns.length || !result) return;

  // [Sockel-Kennzeichnung, Klartext-Mechanik, Notiz-HTML] — Notiz nutzt .finder-note (helle Schrift auf Navy).
  var DATA = {
    t8: [
      'T8 · G13 (Zweistift)',
      'Drehen und herausnehmen',
      'Der häufigste Fall im Büro, Keller und in der Werkstatt: An beiden Enden sitzt ein Sockel mit ' +
      'zwei Stiften (G13). Drehen Sie die Röhre um etwa eine Vierteldrehung (90°), bis die Stifte durch ' +
      'die Schlitze der Fassung passen, und nehmen Sie sie nach unten heraus. Die neue Röhre genauso ' +
      'einsetzen und zurückdrehen, bis sie spürbar einrastet. <strong>Passend ersetzen:</strong> gleiche ' +
      'Länge, gleiche Wattzahl, gleicher Sockel (G13) und gleiche Lichtfarbe wie auf der alten Röhre.'
    ],
    t5: [
      'T5 · G5 (Zweistift, schmal)',
      'Gerade ziehen und stecken',
      'Die T5-Röhre ist dünner und hat den schmaleren G5-Sockel. Hier wird in der Regel <strong>nicht ' +
      'gedreht:</strong> Die Röhre sitzt gesteckt in zwei Fassungen und wird vorsichtig in Längsrichtung ' +
      'leicht zur einen Seite geschoben, bis das andere Ende frei wird, dann gerade herausgenommen. Die ' +
      'neue Röhre ebenso gerade einsetzen. <strong>Passend ersetzen:</strong> gleiche Länge, gleiche ' +
      'Wattzahl, gleicher Sockel (G5) und gleiche Lichtfarbe.'
    ],
    ring: [
      'Ring · G10q (Vierstift)',
      'Stecker lösen, dann herausnehmen',
      'Ringförmige Leuchtstofflampen sitzen meist mit einem vierpoligen Sockel (G10q) in einer ' +
      'Steckverbindung und werden zusätzlich von Haltern/Clips gestützt. Lösen Sie zuerst den Stecker ' +
      'am Sockel, dann die Halteclips, und nehmen Sie den Ring heraus. Einbau in umgekehrter Reihenfolge. ' +
      '<strong>Passend ersetzen:</strong> gleicher Ringdurchmesser, gleiche Wattzahl, gleicher Sockel ' +
      '(G10q) und gleiche Lichtfarbe — die genauen Maße stehen auf der alten Lampe oder im Datenblatt.'
    ],
    uform: [
      'U-Form (G13)',
      'Wie T8 drehen — auf den Stegabstand achten',
      'Die U-förmige Röhre ist im Prinzip eine gebogene T8-Röhre und trägt meist denselben G13-Sockel. ' +
      'Sie wird wie eine gerade T8-Röhre um etwa 90° gedreht und herausgenommen. <strong>Wichtig beim ' +
      'Ersatz:</strong> Neben Wattzahl, Sockel und Lichtfarbe muss auch der Abstand der beiden Schenkel ' +
      '(Stegabstand) passen, sonst sitzt die neue Röhre nicht in beiden Fassungen. Den Abstand entnehmen ' +
      'Sie der alten Lampe oder dem Datenblatt.'
    ]
  };
  var ORDER = ['t8', 't5', 'ring', 'uform'];

  function render(key) {
    var d = DATA[key];
    if (!d) return;
    result.innerHTML =
      '<span class="roehrewechsel-code">' + d[0] + '</span>' +
      '<span class="roehrewechsel-name">' + d[1] + '</span>' +
      '<p class="finder-note">' + d[2] + '</p>';
  }

  function select(btn) {
    var key = btn.getAttribute('data-key');
    if (!DATA[key]) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i] === btn ? 'true' : 'false');
      btns[i].classList.toggle('is-on', btns[i] === btn);
    }
    render(key);
  }

  // Höhen-Lock: alle Zustände durchmessen, größtes offsetHeight als min-height setzen,
  // damit die Ergebnis-Box beim Umschalten nicht springt.
  function lock() {
    var active = box.querySelector('.roehrewechsel-btn.is-on');
    var activeKey = active ? active.getAttribute('data-key') : ORDER[0];
    var max = 0;
    result.style.minHeight = '';
    for (var i = 0; i < ORDER.length; i++) {
      render(ORDER[i]);
      if (result.offsetHeight > max) max = result.offsetHeight;
    }
    render(activeKey);
    result.style.minHeight = max + 'px';
  }

  for (var j = 0; j < btns.length; j++) {
    btns[j].addEventListener('click', function () { select(this); });
  }
  select(btns[0]);
  lock();

  var rwT;
  window.addEventListener('resize', function () {
    clearTimeout(rwT);
    rwT = setTimeout(lock, 150);
  });
})();

/* --- Lichtbedarf-Rechner „lumenbedarf“ (Artikel wie-viel-lumen-pro-qm-raum) ---
   Faustregel: benötigter Gesamt-Lichtstrom (lm) ≈ Lux-Richtwert × Raumfläche (m²).
   Eingabe: Raumfläche (m²) + Nutzung/Raumtyp (Auswahl mit hinterlegtem Lux-Richtwert).
   Ausgabe: benötigte Lumen — ausdrücklich als RICHTWERT/Orientierung gekennzeichnet.

   DATENINTEGRITÄT:
   - Arbeitsplatz-bezogene Lux-Werte sind Richtwerte nach DIN EN 12464-1
     (Beleuchtung von Arbeitsstätten in Innenräumen). Sie werden NUR als „Richtwert
     nach DIN EN 12464-1“ benannt, nicht als exakte Pflichtzahl.
   - DIN EN 12464-1 gilt für Arbeitsstätten, NICHT für Privaträume. Wohnbereich-/
     Allgemeinwerte sind daher als allgemeine Orientierung gekennzeichnet, nicht als Norm.
   - Vereinfachte Durchschnittsrechnung (E = Φ / A). Raumhöhe, Wandfarbe, Möblierung,
     Abstrahlwinkel und direkter/indirekter Anteil bleiben unberücksichtigt → nur Orientierung.
   - role="status" aria-live="polite", Höhen-Lock + prefers-reduced-motion, alles unter #lumenbedarf gescopt.
*/
(function () {
  'use strict';
  var box = document.getElementById('lumenbedarf');
  if (!box) return;

  var areaInput = box.querySelector('#lb-area');
  var useSel = box.querySelector('#lb-use');
  var out = box.querySelector('#lb-result');
  if (!areaInput || !useSel || !out) return;

  var fmt = (window.Intl && Intl.NumberFormat)
    ? new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 })
    : { format: function (n) { return Math.round(n).toString(); } };

  function calc() {
    var lux = parseFloat(useSel.value);
    var area = parseFloat(areaInput.value);
    var opt = useSel.options[useSel.selectedIndex];
    var src = opt ? (opt.getAttribute('data-src') || '') : '';
    if (isFinite(lux) && isFinite(area) && lux > 0 && area > 0) {
      out.innerHTML =
        '<p>Auf der Fläche: <strong>' + fmt.format(lux * area) + ' Lumen</strong></p>' +
        '<p>Lampen gesamt, überschlägig: <strong>' + fmt.format(Math.round(lux * area / 0.48 / 100) * 100) + ' Lumen</strong></p>' +
        '<p class="lb-formula">' + fmt.format(area) + ' m² × ' + fmt.format(lux) + ' lx (' + src + '); ÷ 0,48 = Wirkungsgrad 0,6 × Wartungsfaktor 0,8 (Annahme)</p>';
    } else {
      out.innerHTML = '<p>Bitte Raumfläche eingeben und eine Nutzung wählen.</p>';
    }
  }

  useSel.addEventListener('change', calc);
  areaInput.addEventListener('input', calc);
  calc();

  /* Ergebnis-Box auf den höchstmöglichen Inhalt fixieren -> kein Springen beim Wechsel.
     Alle Auswahl-Zustände bei einer Beispielfläche durchmessen. */
  function lockHeight() {
    var savedArea = areaInput.value;
    var savedIdx = useSel.selectedIndex;
    var max = 0;
    out.style.minHeight = '';
    if (!areaInput.value) areaInput.value = '20';
    for (var i = 0; i < useSel.options.length; i++) {
      useSel.selectedIndex = i;
      calc();
      if (out.offsetHeight > max) max = out.offsetHeight;
    }
    areaInput.value = savedArea;
    useSel.selectedIndex = savedIdx;
    calc();
    out.style.minHeight = max + 'px';
  }
  lockHeight();
  var lbT;
  window.addEventListener('resize', function () { clearTimeout(lbT); lbT = setTimeout(lockHeight, 150); });
})();



/* ============================================================
   Block 13 (integriert 2026-06-21) — net-new Reserve (Discovery 2026-06-21)
   3 Module: mhpick (Metalldampf-Merkmal-Bestimmer), entladfam (Gasentladungs-Familien-Klickgrafik),
   bueroplan (Arbeitsplatz-Lux-Planungshelfer). Eigenstaendige id-IIFE / unter #id gescopte CSS.
   ============================================================ */

/* ============================================================
   MODUL mhpick (metalldampflampe-hqi-cdm-led-ersatz)
   Typ-BESTIMMER: erkennbares Merkmal anklicken -> Modul leitet die Bauart ab
   (Quarz-Metalldampf HQI/HSI/Powerstar  vs.  Keramik-Metalldampf CDM-T/HCI/
   Powerball/MASTERColour) und nennt qualitative Eigenschaften + LED-Ersatz-Hinweis.
   Interaktionsform bewusst ANDERS als ein 1:1-Klick-Selektor: der Nutzer wählt
   ein Merkmal (Bezeichnung/Brenner/Sockel), nicht den Typ direkt -> Bestimmung.
   NUR qualitative/belegte Aussagen, keine erfundenen Werte (Watt/Lumen/CRI/°C/Volt).
   Integriert (Block 13) (Integration in shared/* macht der Hauptloop).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('mhpick');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.mhpick-btn'));
  var result = document.getElementById('mhpick-result');
  if (!btns.length || !result) return;

  // Bauart-Profile (qualitativ). [Bauart-Label, Bezeichnungs-Zeile, Brenner-Tag, Notiz-HTML]
  var TYPES = {
    quarz: [
      'Quarz-Metalldampflampe',
      'Typische Namen: HQI, HSI, Osram Powerstar',
      'Quarzbrenner',
      'Bei der Quarz-Metalldampflampe sitzt der Lichtbogen in einem <strong>Quarzglas-Brenner</strong>. ' +
      'Verbreitet sind die Kürzel <strong>HQI</strong> und <strong>HSI</strong> sowie die Reihe ' +
      '<strong>Osram Powerstar</strong>; gängige Bauformen sind die zweiseitig gesockelte HQI-TS (Sockel RX7s) ' +
      'und einseitige Varianten (z. B. E27/E40). <strong>LED-Ersatz:</strong> Maßgeblich ist das vorhandene ' +
      '<strong>Betriebsgerät</strong> (KVG/EVG) — ob ein LED-Retrofit dafür freigegeben ist, steht ' +
      '<strong>laut Datenblatt</strong>. Sonst Umbau auf einen direkten LED-Strahler (Vorschaltgerät entfällt). ' +
      'Watt-Äquivalent, Lichtstrom und Farbwiedergabe nur nach Herstellerangabe vergleichen.'
    ],
    keramik: [
      'Keramik-Metalldampflampe',
      'Typische Namen: CDM-T, HCI, Powerball, MASTERColour',
      'Keramikbrenner',
      'Bei der Keramik-Metalldampflampe sitzt der Lichtbogen in einem <strong>Keramik-Brenner</strong>. ' +
      'Verbreitet sind <strong>Philips MASTERColour CDM-T</strong> sowie <strong>Osram HCI / Powerball</strong>; ' +
      'kompakte Stecksockel wie <strong>G12</strong> oder <strong>RX7s</strong> sind typisch. Die Keramik-Bauart ' +
      'ist die jüngere Generation der Halogen-Metalldampflampe. <strong>LED-Ersatz:</strong> Wie bei Quarz ' +
      'entscheidet das <strong>Betriebsgerät</strong> über einen Retrofit — Freigabe nur <strong>laut ' +
      'Datenblatt</strong>; alternativ Umbau auf einen LED-Strahler ohne Vorschaltgerät. Lichtfarbe, CRI und ' +
      'Lichtausbeute nur anhand der Herstellerangabe gegenüberstellen.'
    ],
    unklar: [
      'Bauart noch nicht eindeutig',
      'Bezeichnung auf Lampe oder Sockel prüfen',
      'Datenblatt entscheidet',
      'Wenn weder ein eindeutiger Name (HQI/HSI/Powerstar bzw. CDM-T/HCI/Powerball/MASTERColour) noch das ' +
      'Brenner-Material erkennbar ist, hilft die <strong>vollständige Typenbezeichnung</strong> auf der Lampe, ' +
      'am Sockel oder auf der Verpackung — sie verweist auf das <strong>Datenblatt</strong> mit der genauen ' +
      'Bauart, Leistung und dem passenden Betriebsgerät. Für die LED-Umstellung ist ohnehin das vorhandene ' +
      '<strong>Vorschaltgerät</strong> ausschlaggebend, nicht allein die Lampenform.'
    ]
  };

  // Erkennbare Merkmale -> Bauart-Ableitung. [Merkmal-Label, Ziel-Bauart-Key]
  var CLUES = {
    'name-hqi': ['Aufdruck „HQI“, „HSI“ oder „Powerstar“', 'quarz'],
    'name-cdm': ['Aufdruck „CDM-T“, „HCI“, „Powerball“ oder „MASTERColour“', 'keramik'],
    'brenner-quarz': ['Länglicher Quarzglas-Brenner (oft Stab, RX7s)', 'quarz'],
    'brenner-keramik': ['Kompakter Keramik-Brenner (oft Stecksockel G12)', 'keramik'],
    'unklar': ['Kein Aufdruck / nicht erkennbar', 'unklar']
  };

  function render(typeKey) {
    var d = TYPES[typeKey];
    if (!d) return;
    result.innerHTML =
      '<span class="mhpick-code">' + d[1] + '</span>' +
      '<span class="mhpick-tag">' + d[2] + '</span>' +
      '<span class="mhpick-name">Ergebnis: ' + d[0] + '</span>' +
      '<p class="finder-note">' + d[3] + '</p>';
  }

  function select(btn) {
    var clue = btn.getAttribute('data-clue');
    var map = CLUES[clue];
    if (!map) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i] === btn ? 'true' : 'false');
      btns[i].classList.toggle('is-on', btns[i] === btn);
    }
    render(map[1]);
  }

  // Höhen-Lock: alle Bauart-Zustände durchmessen, größtes offsetHeight als min-height.
  function lock() {
    var active = box.querySelector('.mhpick-btn.is-on');
    var activeClue = active ? active.getAttribute('data-clue') : null;
    var activeType = (activeClue && CLUES[activeClue]) ? CLUES[activeClue][1] : 'quarz';
    var keys = ['quarz', 'keramik', 'unklar'];
    var max = 0;
    result.style.minHeight = '';
    for (var i = 0; i < keys.length; i++) {
      render(keys[i]);
      if (result.offsetHeight > max) max = result.offsetHeight;
    }
    render(activeType);
    result.style.minHeight = max + 'px';
  }

  for (var j = 0; j < btns.length; j++) {
    btns[j].addEventListener('click', function () { select(this); });
  }
  select(btns[0]);
  lock();

  var mhT;
  window.addEventListener('resize', function () {
    clearTimeout(mhT);
    mhT = setTimeout(lock, 150);
  });
})();

/* ============================================================
   LMM Ratgeber-Modul — Klick-Grafik „Funktionsprinzip & Familien“ (id=entladfam)
   Artikel: gasentladungslampen-grundlagen-hid

   Integriert in shared/ratgeber-modules.js (Block 13, 2026-06-21).

   Form = KLICK-GRAFIK / Familien-Stammbaum (NICHT identisch zum Bestimmer von
   Artikel 1). Funktionsprinzip-Hotspot (Elektroden -> Gasentladung -> ggf.
   Leuchtstoff) + vier Familien-Knoten. role=button/tabindex=0/aria-pressed;
   Enter/Space; Ergebnis-Box role=status aria-live=polite; Hoehen-Lock gegen
   Springen; prefers-reduced-motion via CSS. No-op, wenn #entladfam fehlt.

   DATENEHRLICH: rein erklaerend/qualitativ. KEINE erfundenen Brennspannungen,
   Zuendspannungen, Lebensdauern, Lichtausbeuten, Lumen, Kelvin, Watt. Familien
   nur 1 Satz + Routing-Link zum Owner-Artikel (Anti-Kannibalisierung).
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('entladfam');
  if (!box) return;
  var hots = [].slice.call(box.querySelectorAll('.entladfam-hot'));
  var val = document.getElementById('entladfam-val');
  var note = document.getElementById('entladfam-note');
  if (!hots.length || !val || !note) return;

  // Reihenfolge identisch zu den Hotspots im SVG (preview.html):
  // 0 = Funktionsprinzip (Elektroden -> Gasentladung -> ggf. Leuchtstoff)
  // 1 = Leuchtstoff- / Kompaktleuchtstofflampe (Niederdruck)
  // 2 = Natriumdampf (NAV / SON, Hochdruck)
  // 3 = Quecksilberdampf (HQL / HPL, Hochdruck)
  // 4 = Metalldampf (HQI / CDM, Hochdruck)
  // [Ergebnis-Ueberschrift, Hinweis-HTML inkl. interner Links mit data-todo]
  var DATA = [
    ['Funktionsprinzip &#8212; Licht aus einer Gasentladung',
     'Eine Gasentladungslampe erzeugt Licht <strong>nicht</strong> durch einen gl&#252;henden Draht, sondern durch eine <strong>elektrische Entladung in einem Gas oder Metalldampf</strong>: Zwischen zwei <strong>Elektroden</strong> bildet sich ein Lichtbogen, der das F&#252;llgas zum Leuchten anregt. Man unterscheidet <strong>Niederdruck</strong> (z.&#8202;B. Leuchtstofflampe) und <strong>Hochdruck</strong> (HID: Natriumdampf, Quecksilberdampf, Metalldampf). Bei der Leuchtstofflampe wandelt zus&#228;tzlich ein <strong>Leuchtstoff</strong> die UV-Strahlung in sichtbares Licht um. Alle Typen brauchen ein <strong>Vorschaltger&#228;t</strong> &#8212; und damit Netzspannung. <a href="/blogs/ratgeber/vorschaltgeraet-evg-kvg-vvg" class="sock-link" data-todo="link-pruefen">Vorschaltger&#228;te (EVG/KVG/VVG) &#8594;</a>'],
    ['Leuchtstoff- / Kompaktleuchtstofflampe &#8212; Niederdruck',
     '<strong>Niederdruck-Entladungslampe</strong>: Eine Quecksilber-Niederdruckentladung erzeugt UV-Strahlung, die ein <strong>Leuchtstoff</strong> an der Rohrinnenseite in sichtbares Licht umsetzt &#8212; als gerade R&#246;hre oder als kompakte Bauform (Energiesparlampe). Enth&#228;lt <strong>Quecksilber</strong>, daher fachgerecht entsorgen. Wie der R&#246;hren-Umstieg auf LED funktioniert, steht im eigenen Ratgeber. <a href="/blogs/ratgeber/leuchtstoffroehren-durch-led-roehren-ersetzen" class="sock-link" data-todo="link-pruefen">Leuchtstoffr&#246;hren durch LED ersetzen &#8594;</a>'],
    ['Natriumdampf (NAV / SON) &#8212; Hochdruck',
     '<strong>Hochdruck-Natriumdampflampe</strong>: typisch f&#252;r Stra&#223;en- und Au&#223;enbeleuchtung, erkennbar am warmen, gelblichen Licht. Sie braucht neben dem Vorschaltger&#228;t in der Regel ein <strong>Z&#252;ndger&#228;t</strong>. Konkrete Kennwerte richten sich nach der jeweiligen Lampe (Datenblatt). Den LED-Umstieg behandelt der eigene Wechsel-Artikel. <a href="/blogs/ratgeber/wechsel-nav-son-natriumdampf" class="sock-link" data-todo="link-pruefen">NAV/SON auf LED wechseln &#8594;</a>'],
    ['Quecksilberdampf (HQL / HPL) &#8212; Hochdruck',
     '<strong>Hochdruck-Quecksilberdampflampe</strong>: l&#228;uft &#252;ber eine <strong>Drossel</strong> (magnetisches Vorschaltger&#228;t/KVG) und z&#252;ndet ohne separates Z&#252;ndger&#228;t. Enth&#228;lt <strong>Quecksilber</strong> &#8212; fachgerecht entsorgen. Diese Familie ist weitgehend abgek&#252;ndigt; den Umstieg zeigt der eigene Wechsel-Artikel. <a href="/blogs/ratgeber/wechsel-hql-hpl-quecksilberdampf" class="sock-link" data-todo="link-pruefen">HQL/HPL auf LED wechseln &#8594;</a>'],
    ['Metalldampf (HQI / CDM) &#8212; Hochdruck',
     '<strong>Halogen-Metalldampflampe</strong>: hohe Lichtqualit&#228;t und kr&#228;ftige Farben, h&#228;ufig in Shops, Hallen und Flutlicht. Sie ben&#246;tigt ein passendes Betriebsger&#228;t; Kennwerte nach Datenblatt. Details zum LED-Ersatz stehen im Geschwister-Artikel. <a href="/blogs/ratgeber/metalldampflampe-hqi-cdm-led-ersatz" class="sock-link" data-todo="link-pruefen">Metalldampf HQI/CDM &#8211; LED-Ersatz &#8594;</a>']
  ];

  function select(i) {
    hots.forEach(function (h, j) {
      h.classList.toggle('is-on', j === i);
      h.setAttribute('aria-pressed', j === i ? 'true' : 'false');
    });
    val.innerHTML = DATA[i][0];
    note.innerHTML = DATA[i][1];
  }
  hots.forEach(function (h, i) {
    h.addEventListener('click', function () { select(i); });
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); select(i); }
    });
  });
  select(0); // Default = Funktionsprinzip (= statischer Fallback ohne JS)

  // Ergebnis-Box auf den hoechstmoeglichen Inhalt fixieren -> kein Springen beim Wechsel.
  var result = box.querySelector('.entladfam-result');
  function lock() {
    if (!result) return;
    var v = val.innerHTML, n = note.innerHTML, max = 0;
    result.style.minHeight = '';
    DATA.forEach(function (d) {
      val.innerHTML = d[0]; note.innerHTML = d[1];
      if (result.offsetHeight > max) max = result.offsetHeight;
    });
    val.innerHTML = v; note.innerHTML = n; result.style.minHeight = max + 'px';
  }
  lock();
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(lock, 150); });
})();

/* ============================================================
   MODUL bueroplan (buero-arbeitsplatz-beleuchtung-richtig-planen)
   Planungshelfer/Selektor: Arbeitsbereich/Tätigkeit -> Lux-Richtwert
   "nach DIN EN 12464-1" + Lichtfarbe-/UGR-Hinweis (Verweis statt Tiefe).
   NUR normbelegte Richtwerte, als Richtwert gekennzeichnet — KEINE
   erfundenen Werte. Bewusst KEIN Zahlenrechner (Abgrenzung zum
   Lumen-Rechner in wie-viel-lumen-pro-qm-raum).
   Integriert (Block 13); Integration in shared/* macht der Hauptloop.
   Pattern: id-IIFE, aria-pressed + .is-on, role=status aria-live,
   Höhen-Lock + Resize-Re-Lock, alle CSS unter #bueroplan gescopt.
   ============================================================ */
(function () {
  'use strict';
  var box = document.getElementById('bueroplan');
  if (!box) return;
  var btns = [].slice.call(box.querySelectorAll('.bueroplan-btn'));
  var result = document.getElementById('bueroplan-result');
  if (!btns.length || !result) return;

  // [Bereich-Label, Lux-Richtwert-Zeile, Eigenschaft-Tag, Notiz-HTML]
  // Lux-Werte = Richtwerte nach DIN EN 12464-1 (Arbeitsstätten/Innenräume),
  // konservativ und als Richtwert ausgewiesen. Lichtfarbe-/UGR-Hinweis = Verweis.
  var DATA = {
    schreibtisch: [
      'Schreibtisch / Bildschirmarbeit',
      'Richtwert: rund 500 lx im Arbeitsbereich',
      'Sehaufgabe: anspruchsvoll',
      'Für Schreib-, Lese- und Bildschirmarbeit liegt der Richtwert der Beleuchtungsstärke ' +
      'im Arbeitsbereich bei <strong>rund 500&nbsp;lx</strong> (Richtwert nach ' +
      '<strong>DIN&nbsp;EN&nbsp;12464-1</strong>); das unmittelbare Umfeld darf darunter liegen. ' +
      'Am Bildschirmarbeitsplatz ist die <strong>Blendungsbegrenzung</strong> entscheidend — ' +
      'als Richtwert gilt <strong>UGR&nbsp;&lt;&nbsp;19</strong> (Hintergründe im ' +
      '<a href="/blogs/ratgeber/ugr19" data-todo="link-pruefen">UGR-Ratgeber</a>). ' +
      'Als Lichtfarbe ist neutralweißes Licht (Größenordnung ~4000&nbsp;K) gängig — Details im ' +
      '<a href="/blogs/ratgeber/lichtfarbe" data-todo="link-pruefen">Lichtfarbe-Ratgeber</a>.'
    ],
    besprechung: [
      'Besprechung / Konferenz',
      'Richtwert: rund 500 lx im Bereich',
      'Sehaufgabe: anspruchsvoll',
      'Besprechungs- und Konferenzbereiche orientieren sich am gleichen Niveau wie der ' +
      'Schreibtisch — <strong>rund 500&nbsp;lx</strong> als Richtwert nach ' +
      '<strong>DIN&nbsp;EN&nbsp;12464-1</strong>, häufig dimmbar ausgelegt, damit sich der ' +
      'Raum an Präsentation oder Gespräch anpassen lässt. Auch hier zählt eine gute ' +
      '<strong>Blendungsbegrenzung</strong> (Richtwert <strong>UGR&nbsp;&lt;&nbsp;19</strong>) ' +
      'und eine einheitliche, eher neutralweiße Lichtfarbe.'
    ],
    flur: [
      'Flur / Verkehrsfläche',
      'Richtwert: deutlich geringer als am Arbeitsplatz',
      'Sehaufgabe: Orientierung',
      'Flure, Treppen und Verkehrsflächen brauchen deutlich weniger Beleuchtungsstärke als der ' +
      'Arbeitsplatz — hier geht es um sichere <strong>Orientierung</strong> und gleichmäßige ' +
      'Ausleuchtung, nicht um anspruchsvolle Sehaufgaben. Maßgeblich ist der jeweilige ' +
      'Richtwert nach <strong>DIN&nbsp;EN&nbsp;12464-1</strong> für die Verkehrsfläche; ' +
      'achten Sie zusätzlich auf einen stimmigen Übergang zu angrenzenden Arbeitsbereichen, ' +
      'damit keine harten Helligkeitssprünge entstehen.'
    ],
    lager: [
      'Lager / Nebenraum',
      'Richtwert: je nach Tätigkeit im Raum',
      'Sehaufgabe: lagern / kommissionieren',
      'Lager- und Nebenräume richten sich nach der Tätigkeit: reine Lagerflächen brauchen ' +
      'weniger Licht als Bereiche, in denen <strong>kommissioniert</strong> oder gelesen wird. ' +
      'Der passende Richtwert ergibt sich aus der jeweiligen Sehaufgabe nach ' +
      '<strong>DIN&nbsp;EN&nbsp;12464-1</strong>. Wichtig sind eine gleichmäßige Ausleuchtung ' +
      'der Gänge und Regale sowie blendfreie Leuchten — den Lichtbedarf je Fläche schätzen Sie ' +
      'im <a href="/blogs/ratgeber/wie-viel-lumen-pro-qm-raum" data-todo="link-pruefen">Lumen-pro-m²-Ratgeber</a> ab.'
    ]
  };
  var ORDER = ['schreibtisch', 'besprechung', 'flur', 'lager'];

  function render(key) {
    var d = DATA[key];
    if (!d) return;
    result.innerHTML =
      '<span class="bueroplan-code">' + d[1] + '</span>' +
      '<span class="bueroplan-tag">' + d[2] + '</span>' +
      '<span class="bueroplan-name">' + d[0] + '</span>' +
      '<p class="finder-note">' + d[3] + '</p>';
  }

  function select(btn) {
    var key = btn.getAttribute('data-key');
    if (!DATA[key]) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i] === btn ? 'true' : 'false');
      btns[i].classList.toggle('is-on', btns[i] === btn);
    }
    render(key);
  }

  // Höhen-Lock: alle Zustände durchmessen, größtes offsetHeight als min-height setzen.
  function lock() {
    var active = box.querySelector('.bueroplan-btn.is-on');
    var activeKey = active ? active.getAttribute('data-key') : ORDER[0];
    var max = 0;
    result.style.minHeight = '';
    for (var i = 0; i < ORDER.length; i++) {
      render(ORDER[i]);
      if (result.offsetHeight > max) max = result.offsetHeight;
    }
    render(activeKey);
    result.style.minHeight = max + 'px';
  }

  for (var j = 0; j < btns.length; j++) {
    btns[j].addEventListener('click', function () { select(this); });
  }
  select(btns[0]);
  lock();

  var bpT;
  window.addEventListener('resize', function () {
    clearTimeout(bpT);
    bpT = setTimeout(lock, 150);
  });
})();

/* ============================================================
   Block WAGO-Serien-Cluster (2026-06-22) — 4 Finder/Entscheidungshelfer:
   wagopick (Hub) · hebelpick (221/222) · dosenpick (273/773 + 2273) · reihenpick (Reihenklemmen).
   Selektoren, KEINE Scheinrechner — konkrete Werte nur datenblatt-belegt (wago-series-facts.md),
   Datenlücken als „laut WAGO-Datenblatt". Reuse generischer Klassen
   (.calc-module/.anatomy-buttons/.apart-btn/.is-on/.calc-result/.ip-code/.finder-note) → keine neue CSS.
   Gemeinsame buildFinder-Fabrik (render = ip-code-Kopf + finder-note; Höhen-Lock + resize-Re-Lock;
   aria-pressed/is-on; role=status liegt am Markup). Module rendern nur in der preview.html
   (body.html nutzt statischen THEME-MODUL-Fallback).
   ============================================================ */
(function () {
  'use strict';
  function buildFinder(id, data, order) {
    var box = document.getElementById(id);
    if (!box) return;
    var btns = [].slice.call(box.querySelectorAll('.apart-btn'));
    var result = document.getElementById(id + '-result');
    if (!btns.length || !result) return;
    function render(key) {
      var d = data[key];
      if (!d) return;
      result.innerHTML = '<span class="finder-head">' + d[0] + '</span><p class="finder-note">' + d[1] + '</p>';
    }
    function select(btn) {
      var key = btn.getAttribute('data-key');
      if (!data[key]) return;
      for (var i = 0; i < btns.length; i++) {
        btns[i].setAttribute('aria-pressed', btns[i] === btn ? 'true' : 'false');
        btns[i].classList.toggle('is-on', btns[i] === btn);
      }
      render(key);
    }
    function lock() {
      var active = box.querySelector('.apart-btn.is-on');
      var activeKey = active ? active.getAttribute('data-key') : order[0];
      var max = 0;
      result.style.minHeight = '';
      for (var i = 0; i < order.length; i++) { render(order[i]); if (result.offsetHeight > max) max = result.offsetHeight; }
      render(activeKey);
      result.style.minHeight = max + 'px';
    }
    for (var j = 0; j < btns.length; j++) {
      btns[j].addEventListener('click', function () { select(this); });
    }
    select(btns[0]);
    lock();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(lock, 150); });
  }

  /* HUB — Serien-Router nach Aufgabe → richtige Serie + Spoke-Link. */
  buildFinder('wagopick', {
    starr: ['Starre Adern in der Dose',
      'Für eindrähtige (starre) Leiter in der Verbindungsdose passen die kompakte <strong>COMPACT-Steckklemme (Serie 2273)</strong> und die klassische <strong>Verbindungsdosenklemme (273/773)</strong> — beide zum Stecken. Auch die <strong>Hebelklemme 221</strong> nimmt starre Leiter. Details: <a class="sock-link" href="/blogs/ratgeber/wago-compact-steckklemme-2273">COMPACT 2273</a> · <a class="sock-link" href="/blogs/ratgeber/wago-verbindungsdosenklemme-273-773">Dosenklemme 273/773</a>. Querschnitt je Artikel laut WAGO-Datenblatt.'],
    flex: ['Flexible oder gemischte Leiter',
      'Sobald flexible Litze oder gemischte Leiterarten zusammenkommen, ist die <strong>Hebelklemme (Serien 221/222)</strong> der naheliegende Typ: je Kammer ein Hebel, klemmt starr und flexibel. Details: <a class="sock-link" href="/blogs/ratgeber/wago-hebelklemme-221-222">Hebelklemme 221/222</a>. Zulässige Leiter je Variante laut Datenblatt.'],
    leuchte: ['Leuchte anschließen',
      'Für den Leuchtenanschluss gibt es spezielle <strong>Leuchtenklemmen (Serie 224)</strong>. Welche Klemme passt und wie das sicher geht, zeigt der Ratgeber <a class="sock-link" href="/blogs/ratgeber/wago-klemmen-leuchten-anschliessen">WAGO &amp; Klemmen: Leuchte anschließen</a>. Arbeiten an der festen 230-V-Installation gehören in die Hand einer Elektrofachkraft.'],
    verteiler: ['Verteiler / Hutschiene',
      'Im Verteiler oder Schaltschrank sitzen <strong>Reihenklemmen</strong> auf der Hutschiene (Durchgangs-, Doppelstock-, Dreistockklemme; z. B. 2002 / TOPJOB® S). Details: <a class="sock-link" href="/blogs/ratgeber/wago-reihenklemmen-2002-topjob">Reihenklemmen 2002</a>.']
  }, ['starr', 'flex', 'leuchte', 'verteiler']);

  /* 221/222 — Hebelklemmen-Vergleich, belegte Querschnitte. */
  buildFinder('hebelpick', {
    bis4: ['Starre Adern bis 4 mm²',
      'Die belegte <strong>221-413</strong> ist laut WAGO-Datenblatt für eindrähtige Leiter <strong>0,2 … 4 mm²</strong> ausgelegt (450 V, 32 A, 3 Klemmstellen) — die kompaktere COMPACT-Bauform. Wer starre Adern bis 4 mm² klemmt, liegt mit der 221 richtig.'],
    bis25: ['Bis 2,5 mm² / 222 vorhanden',
      'Die belegte <strong>222-413</strong> ist für eindrähtige Leiter <strong>0,08 … 2,5 mm²</strong> spezifiziert (400 V, 32 A). Für kleinere Querschnitte oder vorhandene 222-Bestände passt die 222 — funktionsgleich, nur die größere, ältere Bauform.'],
    mischen: ['Starr + flexibel mischen',
      'Beide Serien sind Hebelklemmen: je Kammer ein eigener Hebel, sie klemmen starre <em>und</em> flexible (feindrähtige) Leiter. Welche Leiterarten und Querschnitte je Kammer zulässig sind, legt das WAGO-Datenblatt der Variante fest.'],
    kompakt: ['Kompakt &amp; transparent',
      'Die <strong>221</strong> ist die neuere COMPACT-Bauform: kleiner und transparent (Sichtkontrolle, ob der Leiter bis zum Anschlag sitzt). Die Polzahl steht üblicherweise in der letzten Ziffer der Bestellnummer (z. B. 221-413 = 3 Klemmstellen) — die genaue Zahl je Variante laut Datenblatt.']
  }, ['bis4', 'bis25', 'mischen', 'kompakt']);

  /* 273/773 + 2273 — Dosenklemmen-Bauform. */
  buildFinder('dosenpick', {
    klassisch: ['Klassische Dosenklemme (273)',
      'Die Serie <strong>273</strong> ist die traditionelle WAGO-Verbindungsdosenklemme zum Stecken für die Dose. Spannung, Strom, Klemmstellen und zulässige Leiter gelten <span data-todo="wert-pruefen">laut WAGO-Datenblatt der jeweiligen 273-Variante</span>.'],
    transparent: ['Transparent (773)',
      'Die Serie <strong>773</strong> ist laut WAGO-Produktangabe die Bauform mit transparentem Gehäuse — der Leitersitz ist sichtbar. Belegt: die <strong>773-108</strong> hat 8 Klemmstellen für eindrähtige Leiter 0,75 … 2,5 mm² (mehrdrähtig 1,5 … 2,5 mm²), 400 V, 24 A.'],
    kompakt: ['Besonders kompakt (2273)',
      'Die COMPACT-Serie <strong>2273</strong> ist die kleinste Bauform zum Stecken. Belegt: die <strong>2273-204</strong> nimmt eindrähtige (starre) Leiter 0,5 … 2,5 mm² auf (450 V, 24 A, 4 Klemmstellen). Details: <a class="sock-link" href="/blogs/ratgeber/wago-compact-steckklemme-2273">COMPACT 2273</a>.'],
    leiter: ['Welche Leiter?',
      'Steck-/Push-in-Dosenklemmen sind vor allem für <strong>starre (eindrähtige)</strong> Leiter gedacht; ob feindrähtige Litze zulässig ist, steht im Datenblatt der Variante. Für flexible oder gemischte Leiter ist die <a class="sock-link" href="/blogs/ratgeber/wago-hebelklemme-221-222">Hebelklemme 221/222</a> der passende Typ.']
  }, ['klassisch', 'transparent', 'kompakt', 'leiter']);

  /* Reihenklemmen — Bauform-Finder. */
  buildFinder('reihenpick', {
    durchgang: ['Durchgangsklemme',
      'Die Durchgangsklemme führt ein Potential durch (ankommend → abgehend). 2-, 3- oder 4-Leiter = Zahl der Klemmstellen auf einem Potential. Belegt: die <strong>2002-1201</strong> hat 2 Klemmstellen und 1 Potential (800 V, 24 A; Push-in CAGE CLAMP®, Betätigung per Werkzeug).'],
    doppel: ['Doppelstockklemme',
      'Zwei Etagen übereinander (zwei Potentiale) sparen Platz auf der Schiene. Belegt: die <strong>870-501</strong> ist eine Doppelstockklemme mit 2 Potentialen und 4 Klemmstellen (500 V, 24 A).'],
    drei: ['Dreistockklemme',
      'Drei Etagen für maximale Packungsdichte. Mehr Etagen bedeuten mehr Bauhöhe bei weniger Schienenbreite. Werte je Variante laut WAGO-Datenblatt (z. B. die 280-547).'],
    gross: ['Große Querschnitte',
      'Für größere Leiterquerschnitte gibt es kräftigere Durchgangsklemmen. Belegt: die <strong>285-635</strong> ist laut Datenblatt für 6 … 35 mm² und 125 A ausgelegt (Nennquerschnitt 35 mm²).']
  }, ['durchgang', 'doppel', 'drei', 'gross']);
})();

/* ============================================================
   Block Batterie-Cross-Reference (2026-06-22) — Eingabe -> Aequivalente derselben Zelle
   (andere Marken/Normen) + Verwechslungs-Fallen. ANDERER Interaktionstyp: 1 Auswahl -> Nachschlag-Karte.
   Daten BELEGT recherchiert (Hersteller-Cross-Reference-Charts + IEC/ANSI), adversarial verifiziert
   (siehe _wago-build/battery-crossref-digest.md). Reuse .calc-module/.finder-head/.finder-note.
   ============================================================ */
(function () {
  'use strict';
  var X = {"lr44": {"iec": "LR44 / LR1154", "common": "AG13 / A76", "ansi": "1166A", "volt": "1,5 V", "chem": "Alkali", "brands": ["Duracell 76A / LR44", "Energizer A76", "Varta V13GA", "GP GPA76"], "traps": ["SR44 / 357 ist Silberoxid (1,55 V) — gleiche Bauform, andere Chemie", "A76 / 76A ist Alkali; 357 ist KEINE Alkalizelle"]}, "sr44": {"iec": "SR44 / SR1154", "common": "357 / 303", "ansi": "357 (W) / 303 (SW)", "volt": "1,55 V", "chem": "Silberoxid", "brands": ["Renata 357 (SR44W) / 303 (SR44SW)", "Duracell D357 / D303", "Energizer 357 / 303", "Varta V357", "Maxell SR44 = 357", "Sony/Murata SR44W = 357"], "traps": ["357 (W, High-Drain) ist nicht 303 (SW, Low-Drain)", "A76 / 76A ist Alkali (1,5 V), kein SR44"]}, "lr41": {"iec": "LR41 / LR736", "common": "AG3 / 192", "ansi": "192", "volt": "1,5 V", "chem": "Alkali", "brands": ["GP GP192 / 192", "Varta V3GA", "Energizer LR41 / AG3"], "traps": ["384 / 392 sind Silberoxid (SR41), nicht LR41"]}, "sr41": {"iec": "SR41 / SR736", "common": "384 / 392", "ansi": "384 (SW) / 392 (W)", "volt": "1,55 V", "chem": "Silberoxid", "brands": ["Renata 384 (SR41SW) / 392 (SR41W)", "Maxell SR41W = 392 / SR41SW = 384", "Sony/Murata SR41W = 392", "Varta V384 / V392", "Energizer 384 / 392"], "traps": ["384 (SW, Low-Drain) ist nicht 392 (W, High-Drain)", "192 / AG3 ist Alkali (LR41), kein SR41"]}, "lr43": {"iec": "LR43 / LR1142", "common": "AG12 / 1142", "ansi": "1142", "volt": "1,5 V", "chem": "Alkali", "brands": ["GP GP186", "Varta V12GA", "Vinnic L1142 / G12"], "traps": ["SR43 / 386 ist Silberoxid (1,55 V)", "LR44 ist höher (5,4 vs 4,2 mm) — nicht dasselbe"]}, "sr43": {"iec": "SR43 / SR1142", "common": "386 / 301", "ansi": "386 (W) / 301 (SW)", "volt": "1,55 V", "chem": "Silberoxid", "brands": ["Renata 386 (SR43W) / 301 (SR43SW)", "Duracell D386 / D301", "Maxell SR43 = 386", "Sony/Murata SR43W = 386", "Varta V386 / V301"], "traps": ["386 (W) ist nicht 301 (SW)", "LR43 / AG12 ist Alkali"]}, "cr2032": {"iec": "CR2032", "common": "Knopfzelle 20 mm", "ansi": "5004LC", "volt": "3 V", "chem": "Lithium (Li/MnO2)", "brands": ["Energizer ECR2032", "Duracell DL2032", "Varta CR2032", "Panasonic CR2032", "Renata CR2032", "Maxell CR2032", "GP CR2032", "Sony/Murata CR2032"], "traps": ["BR2032: andere Lithium-Chemie (Li-CFx), nicht für Hochstrom", "LIR2032 / ML2032: wiederaufladbar (LIR ~3,6 V) — nicht statt 3-V-Primärzelle", "CR2025 / CR2016: andere Höhe"]}, "cr2025": {"iec": "CR2025", "common": "Knopfzelle 20 mm", "ansi": "5003LC", "volt": "3 V", "chem": "Lithium (Li/MnO2)", "brands": ["Energizer ECR2025", "Duracell DL2025", "Varta CR2025", "Panasonic CR2025", "Renata CR2025", "Maxell CR2025", "GP CR2025"], "traps": ["CR2032 / CR2016: gleicher Durchmesser, andere Höhe", "BR2025: andere Chemie"]}, "cr2016": {"iec": "CR2016", "common": "Knopfzelle 20 mm", "ansi": "5000LC", "volt": "3 V", "chem": "Lithium (Li/MnO2)", "brands": ["Energizer ECR2016", "Duracell DL2016", "Varta CR2016", "Panasonic CR2016", "Renata CR2016", "Maxell CR2016", "GP CR2016"], "traps": ["BR2016: andere Chemie", "2x CR2016 sind keine CR2032 (nur Notbehelf)"]}, "sr626": {"iec": "SR626SW", "common": "377", "ansi": "377", "volt": "1,55 V", "chem": "Silberoxid", "brands": ["Energizer 377", "Renata 377", "Varta V377", "Duracell D377", "Maxell SR626SW", "Sony/Murata SR626SW"], "traps": ["SR626W (376): High-Drain, nicht SW (377)", "LR626 / AG4 ist Alkali (1,5 V)"]}, "sr621": {"iec": "SR621SW", "common": "364", "ansi": "364", "volt": "1,55 V", "chem": "Silberoxid", "brands": ["Energizer 364", "Renata 364", "Varta V364", "Duracell D364", "Maxell SR621SW", "Sony/Murata SR621SW"], "traps": ["SR621W (380): High-Drain", "LR621 / AG1 ist Alkali"]}, "sr920": {"iec": "SR920SW", "common": "371", "ansi": "371", "volt": "1,55 V", "chem": "Silberoxid", "brands": ["Energizer 371", "Renata 371", "Varta V371", "Maxell SR920SW", "Sony/Murata SR920SW"], "traps": ["370 / SR920W ist nicht 371 (klassische Falle: High- vs Low-Drain)", "SR921 = alte IEC-Bezeichnung derselben Zelle"]}, "sr927": {"iec": "SR927SW", "common": "395", "ansi": "395", "volt": "1,55 V", "chem": "Silberoxid", "brands": ["Energizer 395", "Renata 395", "Varta V395", "Duracell D395", "Maxell SR927SW", "Sony/Murata SR927SW"], "traps": ["399 / SR927W ist nicht 395 (klassische Falle)", "AG7 / LR927 ist Alkali (1,5 V)"]}, "sr516": {"iec": "SR516SW", "common": "317", "ansi": "317", "volt": "1,55 V", "chem": "Silberoxid", "brands": ["Energizer 317", "Renata 317", "Varta V317", "Maxell SR516SW", "Sony/Murata SR516SW"], "traps": ["sehr kleine Zelle (5,8 x 1,65 mm) — nicht mit ähnlichen 3-stelligen Nummern verwechseln"]}, "sr721": {"iec": "SR721SW", "common": "362", "ansi": "362", "volt": "1,55 V", "chem": "Silberoxid", "brands": ["Energizer 362", "Renata 362", "Varta V362", "Duracell D362", "Maxell SR721SW", "Sony/Murata SR721SW"], "traps": ["361 / SR721W ist nicht 362 (High- vs Low-Drain)", "LR721 / AG11 ist Alkali"]}, "cr123a": {"iec": "CR123A (CR17345)", "common": "123", "ansi": "5018LC", "volt": "3 V", "chem": "Lithium (Li/MnO2)", "brands": ["Energizer CR123 / EL123AP", "Duracell DL123A", "Panasonic CR123A", "Varta CR123A / 6205", "GP CR123A"], "traps": ["BR123A: andere Chemie", "16340 / RCR123A: wiederaufladbar, höhere Spannung", "CR17335 / CR123: kürzer (33,5 mm)"]}, "cr2": {"iec": "CR2 (CR15H270)", "common": "CR2", "ansi": "5046LC", "volt": "3 V", "chem": "Lithium (Li/MnO2)", "brands": ["Energizer CR2 / EL1CR2", "Duracell DLCR2", "Panasonic CR2", "Varta CR2 / 6206", "GP CR2"], "traps": ["15270 / 15266: wiederaufladbar (LiFePO4 / Li-Ion), andere Spannung"]}, "2cr5": {"iec": "2CR5", "common": "245", "ansi": "5032LC", "volt": "6 V", "chem": "Lithium (Li/MnO2)", "brands": ["Energizer 2CR5 / EL2CR5", "Duracell DL245 / 245", "Panasonic 2CR5", "Varta 2CR5 / 6203", "GP 2CR5"], "traps": ["CRV3 (3 V) ist KEIN 2CR5", "CR-P2: anderes 6-V-Format, nicht austauschbar"]}, "crp2": {"iec": "CR-P2", "common": "223", "ansi": "5024LC", "volt": "6 V", "chem": "Lithium (Li/MnO2)", "brands": ["Energizer EL223AP / 223", "Duracell DL223A", "Panasonic CR-P2", "Varta CR-P2 / 6204", "GP CR-P2"], "traps": ["BR-P2: andere Chemie", "2CR5: anderes 6-V-Format"]}, "aa": {"iec": "LR6", "common": "AA / Mignon", "ansi": "15A", "volt": "1,5 V", "chem": "Alkali", "brands": ["Duracell MN1500 / Procell PC1500", "Energizer E91 / EN91", "Panasonic AM-3", "Varta 4006 (Industrial)", "Rayovac AL-AA / 815", "Kodak KAA"], "traps": ["FR6 = Lithium-AA (Energizer L91): andere Belastbarkeit", "R6 = Zink-Kohle: deutlich geringere Kapazität"]}, "aaa": {"iec": "LR03", "common": "AAA / Micro", "ansi": "24A", "volt": "1,5 V", "chem": "Alkali", "brands": ["Duracell MN2400 / Procell PC2400", "Energizer E92 / EN92", "Panasonic AM-4", "Varta 4003 (Industrial)", "Rayovac AL-AAA / 824", "Kodak K3A"], "traps": ["FR03 = Lithium-AAA (Energizer L92)", "R03 = Zink-Kohle: geringere Kapazität"]}, "c": {"iec": "LR14", "common": "C / Baby", "ansi": "14A", "volt": "1,5 V", "chem": "Alkali", "brands": ["Duracell MN1400 / Procell PC1400", "Energizer E93 / EN93", "Panasonic AM-2", "Varta 4014 (Industrial)", "Rayovac AL-C / 814"], "traps": ["R14 = Zink-Kohle: geringere Kapazität"]}, "d": {"iec": "LR20", "common": "D / Mono", "ansi": "13A", "volt": "1,5 V", "chem": "Alkali", "brands": ["Duracell MN1300 / Procell PC1300", "Energizer E95 / EN95", "Panasonic AM-1", "Varta 4020 (Industrial)", "Rayovac AL-D / 813"], "traps": ["R20 = Zink-Kohle: geringere Kapazität"]}, "nineV": {"iec": "6LR61", "common": "9V / E-Block / PP3", "ansi": "1604A", "volt": "9 V", "chem": "Alkali (6 Zellen)", "brands": ["Duracell MN1604 / Procell PC1604", "Energizer 522 / A522", "Panasonic 6AM-6", "Rayovac AL-9V / A1604"], "traps": ["6F22 = Zink-Kohle: geringere Kapazität", "Energizer L522 = Lithium-9V: andere Entladekurve"]}};
  function esc(s){ return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"); }
  function card(c){
    if (!c) return '<span class="finder-head">Batterie wählen</span><p class="finder-note">Wähle oben deine Batterie — es erscheinen die gleichwertigen Bezeichnungen anderer Hersteller (gleiche Zelle, anderer Name) und worauf zu achten ist.</p>';
    var h = '<span class="finder-head">' + esc(c.iec) + (c.common ? ' · ' + esc(c.common) : '') + '</span>';
    var meta = '<p class="xref-meta">' + esc(c.volt) + ' · ' + esc(c.chem) + (c.ansi ? ' · ANSI ' + esc(c.ansi) : '') + '</p>';
    var b = '<p class="xref-sub">Gleiche Zelle, andere Namen:</p><ul class="xref-list">';
    for (var i = 0; i < c.brands.length; i++) b += '<li>' + esc(c.brands[i]) + '</li>';
    b += '</ul>';
    var t = '';
    if (c.traps && c.traps.length) { t = '<p class="xref-sub xref-warn">Nicht verwechseln:</p><ul class="xref-list xref-traps">'; for (var j = 0; j < c.traps.length; j++) t += '<li>' + esc(c.traps[j]) + '</li>'; t += '</ul>'; }
    var note = '<p class="finder-note">Marken-Bezeichnungen laut Herstellerangaben (Cross-Reference-Charts / IEC-ANSI); maßgeblich bleibt die Geräteherstellerangabe.</p>';
    return h + meta + b + t + note;
  }
  function init(box){
    var sel = box.querySelector('select'); var res = box.querySelector('.xref-result');
    if (!sel || !res) return;
    var ids = (box.getAttribute('data-cells') || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
    var html = '<option value="">— Batterie wählen —</option>';
    for (var i = 0; i < ids.length; i++){ var c = X[ids[i]]; if (c) html += '<option value="' + ids[i] + '">' + esc(c.iec) + (c.common ? ' (' + esc(c.common) + ')' : '') + '</option>'; }
    sel.innerHTML = html;
    function render(){ res.innerHTML = card(X[sel.value]); }
    sel.addEventListener('change', render); render();
  }
  [].slice.call(document.querySelectorAll('.crossref')).forEach(init);
})();
